var Jp = Object.defineProperty;
var Qp = (n, e, t) => e in n ? Jp(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var ye = (n, e, t) => Qp(n, typeof e != "symbol" ? e + "" : e, t);
import { defineComponent as Fe, ref as W, onUnmounted as jr, createElementBlock as N, openBlock as T, createElementVNode as O, withDirectives as pt, renderSlot as fe, vShow as Ls, mergeModels as Ot, useModel as nn, withModifiers as Qt, normalizeClass as pe, watchEffect as Ol, createBlock as Ne, withCtx as Ae, withKeys as Ha, vModelText as Ss, nextTick as kt, computed as G, resolveDirective as da, createCommentVNode as H, unref as b, createTextVNode as wt, toDisplayString as Ce, vModelDynamic as Xp, createVNode as Qe, watch as $t, Fragment as Ee, renderList as Ye, vModelSelect as ji, useTemplateRef as Ui, KeepAlive as Zp, reactive as Ts, useSlots as Ur, toRef as Js, getCurrentInstance as Cd, onMounted as Pt, mergeProps as Mt, isRef as Ru, createSlots as Ht, normalizeProps as Ct, guardReactiveProps as Xt, resolveDynamicComponent as Ro, Teleport as El, Transition as _n, h as fa, render as $u, normalizeStyle as Zt, useAttrs as em, toValue as tm, getCurrentScope as nm, onScopeDispose as rm, onBeforeUpdate as sm, shallowRef as am, onBeforeUnmount as Ad, markRaw as om, customRef as im } from "vue";
import lm, { sticky as um } from "tippy.js";
import { useEventListener as cm, useTemplateRefsList as dm } from "@vueuse/core";
import fm from "exceljs";
const $a = /* @__PURE__ */ Fe({
  __name: "FloatingMenu",
  props: {
    persistent: { type: Boolean, default: !1 },
    placement: { default: "right-start" },
    theme: { default: "compliance" },
    arrow: { type: Boolean, default: !0 },
    offset: { default: () => [0, 0] },
    trigger: { default: "click" },
    zIndex: { default: 52 },
    sticky: { type: Boolean, default: !1 },
    flip: { type: Boolean, default: !0 }
  },
  emits: ["hide", "show"],
  setup(n, { expose: e, emit: t }) {
    const r = W(), s = W(), a = n, o = t;
    let i = null;
    const l = W(!1), u = W(!1), c = () => {
      var g;
      u.value || !r.value || (i = lm(
        ((g = r.value) == null ? void 0 : g.firstElementChild) ?? r.value,
        {
          zIndex: a.zIndex,
          content: s.value,
          allowHTML: !0,
          trigger: a.trigger === "click" ? "manual" : "mouseenter click focus",
          hideOnClick: !a.persistent,
          popperOptions: {
            modifiers: [
              {
                name: "flip",
                enabled: a.flip
              },
              {
                name: "preventOverflow"
              }
            ]
          },
          appendTo: () => {
            const y = document.querySelector("#app");
            return y || document.body;
          },
          sticky: a.sticky,
          placement: a.placement,
          theme: a.theme,
          interactive: !0,
          animation: "shift-away",
          arrow: a.arrow,
          maxWidth: "none",
          offset: a.offset,
          onHide: () => {
            l.value = !1, o("hide");
          },
          onShow: () => {
            l.value = !0, o("show");
          },
          plugins: [
            um,
            {
              name: "hideOnEsc",
              defaultValue: !0,
              fn({ hide: y }) {
                function v(C) {
                  C.key === "Escape" && y();
                }
                return {
                  onShow() {
                    document.addEventListener("keydown", v);
                  },
                  onHide() {
                    document.removeEventListener("keydown", v);
                  }
                };
              }
            }
          ]
        }
      ), u.value = !0);
    };
    jr(() => {
      i && (i.destroy(), i = null);
    });
    function d() {
      a.trigger === "hover" && (u.value || c());
    }
    function f() {
      a.trigger === "click" && (u.value || c(), i == null || i.show());
    }
    function h() {
      u.value || c(), i == null || i.show();
    }
    function p() {
      i == null || i.hide();
    }
    return e({
      hide: p,
      show: h
    }), (g, y) => (T(), N("div", null, [
      O("div", {
        ref_key: "activator",
        ref: r,
        class: "leading-none h-full",
        onMouseenter: d,
        onClick: f
      }, [
        fe(g.$slots, "activator", {
          show: h,
          isShown: l.value
        })
      ], 544),
      pt(O("div", {
        ref_key: "content",
        ref: s,
        class: "rounded-lg shadow-lg flex-auto overflow-hidden border-none border-mid-neutral-50"
      }, [
        fe(g.$slots, "content", {
          hide: p,
          isShown: l.value
        })
      ], 512), [
        [Ls, u.value]
      ])
    ]));
  }
}), DC = /* @__PURE__ */ Fe({
  __name: "Switch",
  props: /* @__PURE__ */ Ot({
    size: { default: "" }
  }, {
    modelValue: { type: Boolean, default: !1, required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = nn(n, "modelValue");
    return (t, r) => (T(), N("button", {
      class: "flex gap-2 items-center",
      onClick: r[0] || (r[0] = Qt((s) => e.value = !e.value, ["stop"]))
    }, [
      O("div", {
        class: pe(["inline-flex rounded-full relative transition-colors duration-200 ease-in-out border-2 border-transparent focus:ring-2 focus:ring-green-600 focus:ring-offset-2", [
          e.value ? "bg-green-500" : "bg-light-neutral-600",
          {
            "w-11 h-6": t.size === "",
            "w-14 h-8": t.size === "lg"
          }
        ]])
      }, [
        O("div", {
          class: pe(["absolute flex items-center justify-center rounded-full bg-white transition duration-200 ease-in-out shadow-sm pointer-events-none", [
            e.value ? "translate-x-full" : "translate-x-0",
            {
              "w-5 h-5": t.size === "",
              "w-6 h-6 left-1": t.size === "lg"
            }
          ]])
        }, [
          fe(t.$slots, "icon")
        ], 2)
      ], 2),
      fe(t.$slots, "default")
    ]));
  }
}), hm = ["placeholder", "onKeydown"], OC = /* @__PURE__ */ Fe({
  __name: "FloatingTextInput",
  props: {
    value: {},
    placeholder: {}
  },
  emits: ["save"],
  setup(n, { emit: e }) {
    const t = W(), r = n, s = e, a = W("");
    Ol(() => a.value = r.value ?? "");
    function o() {
      setTimeout(() => a.value = r.value ?? "", 300);
    }
    function i() {
      s("save", a.value);
    }
    function l() {
      var u, c;
      (u = t.value) == null || u.focus({
        preventScroll: !0
      }), (c = t.value) == null || c.select();
    }
    return (u, c) => (T(), Ne($a, {
      offset: [0, 10],
      onHide: o
    }, {
      activator: Ae(({ show: d }) => [
        fe(u.$slots, "activator", {
          show: async () => {
            d(), await kt(), l();
          }
        })
      ]),
      content: Ae(({ hide: d }) => [
        pt(O("input", {
          ref_key: "input",
          ref: t,
          "onUpdate:modelValue": c[0] || (c[0] = (f) => a.value = f),
          class: "w-96 px-4 py-2 outline focus:outline-none bg-white text-black rounded-md",
          type: "text",
          placeholder: u.placeholder,
          onKeydown: Ha(
            () => {
              i(), d();
            },
            ["enter"]
          )
        }, null, 40, hm), [
          [Ss, a.value]
        ])
      ]),
      _: 3
    }));
  }
});
function pm(n, e) {
  return T(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
    })
  ]);
}
function mm(n, e) {
  return T(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    }),
    O("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })
  ]);
}
function ds(n, e) {
  return T(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    })
  ]);
}
function Pl(n, e) {
  return T(), N("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    O("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function qr() {
  return crypto.randomUUID();
}
const gm = [
  { name: "Afghanistan", code: "AF" },
  { name: "Åland Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: "Cote D'Ivoire", code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Korea, Democratic People'S Republic of", code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Lao People'S Democratic Republic", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia and Montenegro", code: "CS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" }
];
var Lu;
(function(n) {
  n.EEA = "EEA, Turkey and Northern Ireland";
})(Lu || (Lu = {}));
const ym = { class: "space-y-1" }, vm = ["for"], bm = {
  key: 0,
  class: "text-red-600"
}, wm = { class: "relative" }, km = ["id", "type", "placeholder", "disabled", "tabindex"], xm = ["id", "placeholder", "disabled", "tabindex", "onKeydown"], Mm = {
  tabindex: "-1",
  class: "h-full flex text-black absolute right-4 items-center gap-1 top-0"
}, Sm = ["for"], Bu = "w-full focus:outline-hidden disabled:bg-transparent font-normal text-gray-900 text-sm px-3.5 py-2.5 rounded-md bg-white border border-mid-neutral-50", EC = /* @__PURE__ */ Fe({
  __name: "TextInput",
  props: /* @__PURE__ */ Ot({
    type: { default: "text" },
    label: {},
    labelInside: { type: Boolean },
    clearable: { type: Boolean },
    placeholder: {},
    rules: { default: () => [] },
    disabled: { type: Boolean },
    multiline: { type: Boolean },
    error: {},
    tabindex: { default: 0 },
    inputClasses: {},
    isRequired: { type: Boolean },
    canResize: { type: Boolean },
    canAdd: { type: Boolean },
    infoTooltipText: {}
  }, {
    modelValue: {
      default: ""
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ot(["enter", "blur"], ["update:modelValue"]),
  setup(n, { expose: e, emit: t }) {
    const r = W(), s = qr(), a = n, o = t, i = nn(n, "modelValue"), l = W(!1), u = G(() => ({
      "hover:border-primary-500 focus:border-primary-500 ring-primary-500": !a.disabled && !C.value,
      "bg-black/5": a.disabled,
      "border-red-600 text-red-600": C.value
    })), c = G(() => ({
      "hover:border-primary-500 focus:border-primary-500 border-slate-300": !a.disabled && !C.value,
      "bg-black/5": a.disabled,
      "border-red-600 text-red-600": C.value,
      "resize-none": !a.canResize,
      "w-full": !0
    })), d = G(() => a.type === "password" && !l.value ? "password" : a.type === "email" ? "email" : "text"), f = G(() => a.clearable && i.value), h = G(() => a.type === "password"), p = G(() => !!C.value);
    function g() {
      l.value = !l.value;
    }
    function y() {
      i.value = "";
    }
    const v = W(), C = G(
      () => a.error ? a.error : v.value
    );
    function M() {
      const x = a.rules.map((k) => k(i.value)).filter((k) => typeof k == "string");
      return v.value = x[0] || void 0, x.length === 0;
    }
    function S() {
      var x;
      (x = r.value) == null || x.focus({
        preventScroll: !0
      });
    }
    function D() {
      var x;
      (x = r.value) == null || x.select();
    }
    function I(x) {
      x.shiftKey ? i.value += `
` : o("enter", i.value);
    }
    return e({
      validate: M,
      focus: S,
      select: D
    }), (x, k) => {
      const _ = da("tooltip");
      return T(), N("div", ym, [
        x.label && !x.labelInside ? (T(), N("label", {
          key: 0,
          for: b(s),
          class: "flex gap-0.5 text-sm font-medium items-center leading-5 text-dark-neutral-500"
        }, [
          wt(Ce(x.label) + " ", 1),
          x.isRequired ? (T(), N("span", bm, "*")) : H("", !0),
          a.infoTooltipText ? pt((T(), Ne(b(ds), {
            key: 1,
            class: "w-5 h-5 fill-neutral-400 text-white"
          }, null, 512)), [
            [_, a.infoTooltipText]
          ]) : H("", !0)
        ], 8, vm)) : H("", !0),
        O("div", wm, [
          x.multiline ? pt((T(), N("textarea", {
            key: 1,
            id: b(s),
            ref_key: "input",
            ref: r,
            "onUpdate:modelValue": k[3] || (k[3] = (E) => i.value = E),
            class: pe([Bu, c.value, x.inputClasses]),
            cols: "50",
            rows: "4",
            placeholder: x.placeholder ?? x.label,
            disabled: x.disabled,
            tabindex: x.tabindex,
            onKeydown: Ha(Qt(I, ["prevent"]), ["enter"]),
            onInput: M,
            onBlur: k[4] || (k[4] = (E) => o("blur", i.value))
          }, null, 42, xm)), [
            [Ss, i.value]
          ]) : pt((T(), N("input", {
            key: 0,
            id: b(s),
            ref_key: "input",
            ref: r,
            "onUpdate:modelValue": k[0] || (k[0] = (E) => i.value = E),
            type: d.value,
            class: pe([Bu, u.value, x.inputClasses]),
            placeholder: x.placeholder ?? x.label,
            disabled: x.disabled,
            tabindex: x.tabindex,
            onInput: M,
            onKeydown: k[1] || (k[1] = Ha((E) => o("enter", i.value), ["enter"])),
            onBlur: k[2] || (k[2] = (E) => o("blur", i.value))
          }, null, 42, km)), [
            [Xp, i.value]
          ]),
          O("div", Mm, [
            f.value ? (T(), N("button", {
              key: 0,
              tabindex: "-1",
              onClick: k[5] || (k[5] = (E) => y())
            }, [
              Qe(b(Pl), { class: "w-5 h-5" })
            ])) : H("", !0),
            h.value ? (T(), N("button", {
              key: 1,
              tabindex: "-1",
              onClick: k[6] || (k[6] = Qt((E) => g(), ["prevent"]))
            }, [
              l.value ? (T(), Ne(b(pm), {
                key: 1,
                class: "w-5 h-5 text-primary"
              })) : (T(), Ne(b(mm), {
                key: 0,
                class: "w-5 h-5 text-primary"
              }))
            ])) : H("", !0),
            O("label", {
              tabindex: "-1",
              for: b(s),
              class: "flex items-center"
            }, [
              fe(x.$slots, "suffix", { value: i.value })
            ], 8, Sm),
            p.value ? pt((T(), Ne(b(ds), {
              key: 2,
              class: "w-5 h-5 text-red-600 outline-hidden"
            }, null, 512)), [
              [
                _,
                C.value,
                void 0,
                { error: !0 }
              ]
            ]) : H("", !0)
          ])
        ])
      ]);
    };
  }
}), Tm = { class: "space-y-1" }, Cm = ["for"], Am = {
  key: 0,
  class: "text-red-600"
}, Dm = { class: "relative" }, Om = ["id", "placeholder", "disabled", "tabindex", "rows", "maxlength"], Em = {
  key: 0,
  tabindex: "-1",
  class: "absolute right-4 bottom-2 flex items-center gap-2 text-xs text-mid-neutral-400"
}, Pm = {
  key: 1,
  class: "select-none"
}, _m = "w-full focus:outline-hidden disabled:bg-transparent font-normal text-gray-900 text-sm px-3.5 py-2.5 rounded-md bg-white border border-mid-neutral-50", PC = /* @__PURE__ */ Fe({
  __name: "TextareaInput",
  props: /* @__PURE__ */ Ot({
    label: {},
    labelInside: { type: Boolean },
    placeholder: {},
    rules: { default: () => [] },
    disabled: { type: Boolean },
    tabindex: { default: 0 },
    inputClasses: {},
    isRequired: { type: Boolean },
    canResize: { type: Boolean, default: !1 },
    autoResize: { type: Boolean, default: !1 },
    rows: { default: 4 },
    maxLength: {},
    clearable: { type: Boolean },
    showCounter: { type: Boolean, default: !1 },
    infoTooltipText: {}
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ot(["blur"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const t = W(), r = qr(), s = n, a = e, o = nn(n, "modelValue"), i = W(), l = G(() => ({
      "hover:border-primary-500 focus:border-primary-500": !s.disabled && !i.value,
      "bg-black/5": s.disabled,
      "border-red-600 text-red-600": i.value,
      "resize-none": !s.canResize
    }));
    function u() {
      const h = s.rules.map((p) => p(o.value)).filter((p) => typeof p == "string");
      return i.value = h[0] || void 0, !h.length;
    }
    function c() {
      u(), s.autoResize && f();
    }
    function d() {
      o.value = "", kt(() => u());
    }
    function f() {
      t.value && (t.value.style.height = "auto", t.value.style.height = t.value.scrollHeight + "px");
    }
    return $t(
      () => o.value,
      () => {
        s.autoResize && kt(f);
      }
    ), (h, p) => {
      const g = da("tooltip");
      return T(), N("div", Tm, [
        h.label && !h.labelInside ? (T(), N("label", {
          key: 0,
          for: b(r),
          class: "flex gap-0.5 text-sm font-medium items-center leading-5 text-dark-neutral-500"
        }, [
          wt(Ce(h.label) + " ", 1),
          h.isRequired ? (T(), N("span", Am, "*")) : H("", !0),
          h.infoTooltipText ? pt((T(), Ne(b(ds), {
            key: 1,
            class: "w-5 h-5 fill-neutral-400 text-white"
          }, null, 512)), [
            [g, h.infoTooltipText]
          ]) : H("", !0)
        ], 8, Cm)) : H("", !0),
        O("div", Dm, [
          pt(O("textarea", {
            id: b(r),
            ref_key: "textarea",
            ref: t,
            "onUpdate:modelValue": p[0] || (p[0] = (y) => o.value = y),
            class: pe([_m, l.value, h.inputClasses]),
            placeholder: h.placeholder ?? h.label,
            disabled: h.disabled,
            tabindex: h.tabindex,
            rows: h.rows,
            maxlength: h.maxLength,
            onInput: c,
            onBlur: p[1] || (p[1] = (y) => a("blur", o.value))
          }, null, 42, Om), [
            [Ss, o.value]
          ]),
          h.showCounter || h.clearable ? (T(), N("div", Em, [
            h.clearable && o.value ? (T(), N("button", {
              key: 0,
              tabindex: "-1",
              onClick: d,
              class: "text-dark-neutral-400 hover:text-dark-neutral-500 transition-colors"
            }, [
              Qe(b(Pl), { class: "w-4 h-4" })
            ])) : H("", !0),
            h.showCounter && h.maxLength ? (T(), N("span", Pm, Ce(o.value.length) + "/" + Ce(h.maxLength), 1)) : H("", !0)
          ])) : H("", !0)
        ])
      ]);
    };
  }
}), Nm = { class: "space-y-1" }, Im = ["for"], Rm = {
  key: 0,
  class: "text-red-600"
}, $m = { class: "relative" }, Lm = ["id", "min", "max", "step", "placeholder", "disabled", "tabindex"], Bm = {
  tabindex: "-1",
  class: "h-full flex text-black absolute right-3 items-center gap-1 top-0"
}, Fm = "w-full focus:outline-hidden disabled:bg-transparent font-normal text-gray-900 text-sm px-3.5 py-2.5 rounded-md bg-white border border-mid-neutral-50", _C = /* @__PURE__ */ Fe({
  __name: "NumberInput",
  props: /* @__PURE__ */ Ot({
    label: {},
    placeholder: {},
    disabled: { type: Boolean },
    tabindex: { default: 0 },
    inputClasses: {},
    isRequired: { type: Boolean },
    min: {},
    max: {},
    step: { default: 1 },
    clearable: { type: Boolean },
    infoTooltipText: {},
    integerOnly: { type: Boolean }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ot(["blur"], ["update:modelValue"]),
  setup(n, { expose: e, emit: t }) {
    const r = W(null), s = qr(), a = n, o = t, i = nn(n, "modelValue"), l = G(() => ({
      "hover:border-primary-500 focus:border-primary-500": !a.disabled,
      "bg-black/5": a.disabled
    }));
    function u() {
      var p;
      i.value = null, (p = r.value) == null || p.focus({ preventScroll: !0 });
    }
    function c() {
      var p;
      (p = r.value) == null || p.focus({ preventScroll: !0 });
    }
    function d() {
      var p;
      (p = r.value) == null || p.select();
    }
    function f(p) {
      a.integerOnly && ["e", "E", "+", "-", "."].includes(p.key) && p.preventDefault();
    }
    function h(p) {
      if (!a.integerOnly) return;
      const g = p.target;
      g.value = g.value.replace(/[^0-9]/g, ""), g.value === "" ? i.value = null : i.value = Number(g.value);
    }
    return e({ focus: c, select: d }), (p, g) => {
      const y = da("tooltip");
      return T(), N("div", Nm, [
        p.label ? (T(), N("label", {
          key: 0,
          for: b(s),
          class: "flex gap-0.5 text-sm font-medium items-center leading-5 text-dark-neutral-500"
        }, [
          wt(Ce(p.label) + " ", 1),
          p.isRequired ? (T(), N("span", Rm, "*")) : H("", !0),
          p.infoTooltipText ? pt((T(), Ne(b(ds), {
            key: 1,
            class: "w-5 h-5 fill-neutral-400 text-white"
          }, null, 512)), [
            [y, p.infoTooltipText]
          ]) : H("", !0)
        ], 8, Im)) : H("", !0),
        O("div", $m, [
          pt(O("input", {
            id: b(s),
            ref_key: "input",
            ref: r,
            "onUpdate:modelValue": g[0] || (g[0] = (v) => i.value = v),
            type: "number",
            min: p.min,
            max: p.max,
            step: p.step,
            placeholder: p.placeholder ?? p.label,
            disabled: p.disabled,
            tabindex: p.tabindex,
            class: pe([Fm, l.value, p.inputClasses]),
            onBlur: g[1] || (g[1] = (v) => o("blur", i.value)),
            onKeydown: f,
            onInput: h
          }, null, 42, Lm), [
            [
              Ss,
              i.value,
              void 0,
              { number: !0 }
            ]
          ]),
          O("div", Bm, [
            p.clearable && i.value !== null && i.value !== void 0 ? (T(), N("button", {
              key: 0,
              tabindex: "-1",
              onClick: u
            }, [
              Qe(b(Pl), { class: "w-4 h-4" })
            ])) : H("", !0)
          ])
        ])
      ]);
    };
  }
}), zm = { class: "space-y-1" }, Vm = ["for"], Hm = {
  key: 0,
  class: "text-red-600"
}, Ym = { class: "relative" }, Wm = ["id", "disabled", "tabindex"], jm = {
  key: 0,
  value: ""
}, Um = ["value"], qm = "w-full appearance-none focus:outline-hidden disabled:bg-transparent font-normal text-gray-900 px-4 py-2 text-sm rounded-md bg-white border border-mid-neutral-100", Km = /* @__PURE__ */ Fe({
  __name: "SelectInput",
  props: /* @__PURE__ */ Ot({
    items: {},
    label: {},
    placeholder: {},
    disabled: { type: Boolean },
    tabindex: { default: 0 },
    selectClasses: {},
    isRequired: { type: Boolean },
    infoTooltipText: {}
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ot(["blur"], ["update:modelValue"]),
  setup(n, { expose: e, emit: t }) {
    const r = qr(), s = W(null), a = n, o = t, i = nn(n, "modelValue"), l = G(() => ({
      "hover:border-primary-500 focus:border-primary-500": !a.disabled,
      "bg-black/5": a.disabled
    }));
    function u() {
      var c;
      (c = s.value) == null || c.focus({ preventScroll: !0 });
    }
    return e({ focus: u }), (c, d) => {
      const f = da("tooltip");
      return T(), N("div", zm, [
        c.label ? (T(), N("label", {
          key: 0,
          for: b(r),
          class: "flex gap-0.5 text-sm font-medium items-center leading-5 text-dark-neutral-500"
        }, [
          wt(Ce(c.label) + " ", 1),
          c.isRequired ? (T(), N("span", Hm, "*")) : H("", !0),
          c.infoTooltipText ? pt((T(), Ne(b(ds), {
            key: 1,
            class: "w-5 h-5 fill-neutral-400 text-white"
          }, null, 512)), [
            [f, c.infoTooltipText]
          ]) : H("", !0)
        ], 8, Vm)) : H("", !0),
        O("div", Ym, [
          pt(O("select", {
            id: b(r),
            ref_key: "selectRef",
            ref: s,
            "onUpdate:modelValue": d[0] || (d[0] = (h) => i.value = h),
            disabled: c.disabled,
            tabindex: c.tabindex,
            class: pe([qm, l.value, c.selectClasses]),
            onBlur: d[1] || (d[1] = (h) => o("blur", i.value))
          }, [
            c.placeholder ? (T(), N("option", jm, Ce(c.placeholder), 1)) : H("", !0),
            (T(!0), N(Ee, null, Ye(c.items, (h) => (T(), N("option", {
              key: h,
              value: h
            }, Ce(h), 9, Um))), 128))
          ], 42, Wm), [
            [ji, i.value]
          ]),
          d[2] || (d[2] = O("div", { class: "absolute right-0 top-0 flex items-center h-full w-10 pointer-events-none justify-end pr-4" }, [
            O("span", { class: "material-symbols-outlined text-mid-neutral-500" }, " expand_more ")
          ], -1))
        ])
      ]);
    };
  }
}), _l = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [r, s] of e)
    t[r] = s;
  return t;
}, NC = /* @__PURE__ */ _l(Km, [["__scopeId", "data-v-0e92c8c9"]]), Gm = { class: "w-full h-full min-h-0 overflow-auto bg-light-neutral-300 p-10 grid place-items-center" }, Jm = ["src", "alt"], Qm = {
  key: 1,
  class: "text-sm text-gray-500"
}, IC = /* @__PURE__ */ Fe({
  __name: "ImageAnnotator",
  props: /* @__PURE__ */ Ot({
    image: {},
    alt: {},
    annotations: {}
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ot(["annotation-updated"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const t = nn(n, "modelValue"), r = () => t.value ? n.annotations.find((m) => m.id === t.value) : void 0, s = e, a = W(null);
    let o = null;
    const i = W(null), l = W(null), u = W(null), c = W(null), d = W(null), f = W(null), h = W(!1), p = W(null);
    function g() {
      if (!a.value) return;
      const m = a.value.clientWidth, A = a.value.clientHeight;
      a.value.width !== m && (a.value.width = m), a.value.height !== A && (a.value.height = A);
    }
    function y(m, A) {
      if (!a.value || !l.value || !u.value) return null;
      const j = a.value.width / l.value, ge = a.value.height / u.value;
      return j === 0 || ge === 0 ? null : { x: m / j, y: A / ge };
    }
    function v(m) {
      let A = "";
      for (m += 1; m > 0; )
        m--, A = String.fromCharCode(65 + m % 26) + A, m = Math.floor(m / 26);
      return A;
    }
    function C() {
      return !a.value || !l.value || !u.value ? null : {
        sx: a.value.width / l.value,
        sy: a.value.height / u.value
      };
    }
    function M(m, A, j, ge, z) {
      o && (o.beginPath(), o.fillStyle = ge, o.arc(m, A, j, 0, Math.PI * 2), o.fill(), z != null && (o.fillStyle = "#ffffff", o.font = "600 14px Inter", o.textAlign = "center", o.textBaseline = "middle", o.fillText(z, m, A + 1)));
    }
    function S(m) {
      var A, j, ge;
      return ((A = d.value) == null ? void 0 : A.annotationIndex) === m || ((j = p.value) == null ? void 0 : j.annotationIndex) === m || ((ge = c.value) == null ? void 0 : ge.annotationIndex) === m;
    }
    function D(m, A, j) {
      if (!(!o || !m.length)) {
        o.beginPath();
        for (let ge = 0; ge < m.length; ge++) {
          const z = m[ge], Se = z.x * A, J = z.y * j;
          ge === 0 ? o.moveTo(Se, J) : o.lineTo(Se, J);
        }
        o.stroke();
      }
    }
    function I(m, A, j, ge, z) {
      if (!o || !m.points.length) return;
      if (D(m.points, ge, z), o.save(), o.setLineDash([]), j ? !0 : S(A))
        for (let Z = 0; Z < m.points.length; Z++) {
          const re = m.points[Z], oe = re.x * ge, Pe = re.y * z;
          M(oe, Pe, 4, "#22c55e"), o.lineWidth = 2, o.strokeStyle = "#22c55e", o.beginPath(), o.arc(oe, Pe, 8, 0, Math.PI * 2), o.stroke();
        }
      const J = m.points[m.points.length - 1], se = J.x * ge, w = J.y * z;
      M(
        se,
        w,
        15,
        "#22c55e",
        v(j ? n.annotations.length : A)
      ), o.restore();
    }
    function x() {
      !o || !f.value || (o.save(), o.beginPath(), o.fillStyle = "rgba(34,197,94,0.6)", o.strokeStyle = "#22c55e", o.arc(
        f.value.x,
        f.value.y,
        7,
        0,
        Math.PI * 2
      ), o.fill(), o.lineWidth = 2, o.stroke(), o.restore());
    }
    function k() {
      if (!a.value || (o || (o = a.value.getContext("2d")), !o)) return;
      g();
      const m = C();
      if (!m) return;
      const { sx: A, sy: j } = m;
      o.clearRect(0, 0, a.value.width, a.value.height), o.lineWidth = 1, o.strokeStyle = "#22c55e", o.setLineDash([10, 10]);
      for (let ge = 0; ge < n.annotations.length; ge++)
        I(n.annotations[ge], ge, !1, A, j);
      i.value && I(i.value, n.annotations.length, !0, A, j), x();
    }
    function _(m, A) {
      const j = r();
      if (!j || j.points && j.points.length > 0)
        return;
      const ge = y(m, A);
      ge && (i.value = {
        ...j,
        points: [ge, ge]
      }, t.value = "");
    }
    function E(m, A) {
      if (!i.value) return;
      const j = y(m, A);
      j && (i.value.points[i.value.points.length - 1] = j, k());
    }
    function ne(m, A) {
      if (i.value) {
        const j = y(m, A);
        j && (i.value.points[i.value.points.length - 1] = j), s("annotation-updated", {
          id: i.value.id,
          points: i.value.points
        });
      }
      i.value = null;
    }
    function de(m, A, j, ge) {
      const z = m - j, Se = A - ge;
      return z * z + Se * Se;
    }
    function be(m, A) {
      if (!a.value || !l.value || !u.value) return null;
      const j = a.value.width, ge = a.value.height, z = j / l.value, Se = ge / u.value, J = 10, se = J * J;
      for (let w = 0; w < n.annotations.length; w++) {
        const Z = n.annotations[w].points;
        for (let re = 0; re < Z.length; re++) {
          const oe = Z[re], Pe = oe.x * z, Oe = oe.y * Se;
          if (de(m, A, Pe, Oe) <= se)
            return { annotationIndex: w, pointIndex: re };
        }
      }
      return null;
    }
    function R(m, A) {
      if (!a.value || !l.value || !u.value) return null;
      const j = a.value.width, ge = a.value.height, z = j / l.value, Se = ge / u.value, J = 8;
      for (let se = 0; se < n.annotations.length; se++) {
        const w = n.annotations[se].points;
        for (let Z = 0; Z < w.length - 1; Z++) {
          const re = w[Z], oe = w[Z + 1], Pe = re.x * z, Oe = re.y * Se, ze = oe.x * z, Xe = oe.y * Se, L = ze - Pe, ce = Xe - Oe, Re = m - Pe, nt = A - Oe, Lt = L * L + ce * ce;
          if (Lt === 0) continue;
          const we = (Re * L + nt * ce) / Lt;
          if (we < 0 || we > 1) continue;
          const st = Pe + L * we, ln = Oe + ce * we;
          if (de(m, A, st, ln) <= J * J) return { annotationIndex: se, segmentIndex: Z };
        }
      }
      return null;
    }
    function F(m) {
      h.value = !0, !$(m) && (U() || (ue(m), k()));
    }
    function $(m) {
      const A = be(m.offsetX, m.offsetY);
      return A ? (c.value = A, f.value = null, d.value = null, !0) : !1;
    }
    function U() {
      const m = d.value;
      if (!m || !f.value) return !1;
      const A = y(
        f.value.x,
        f.value.y
      );
      if (!A) return !1;
      const j = n.annotations[m.annotationIndex].points, ge = m.segmentIndex + 1;
      return j.splice(ge, 0, A), c.value = {
        annotationIndex: m.annotationIndex,
        pointIndex: ge
      }, d.value = null, f.value = null, !0;
    }
    function ue(m) {
      i.value ? ne(m.offsetX, m.offsetY) : _(m.offsetX, m.offsetY);
    }
    function q() {
      h.value = !1, c.value = null, i.value && (s("annotation-updated", {
        id: i.value.id,
        points: i.value.points
      }), i.value = null, k());
    }
    function ie(m) {
      if (!c.value) return !1;
      const A = y(m.offsetX, m.offsetY);
      if (A) {
        const { annotationIndex: j, pointIndex: ge } = c.value, z = {
          ...n.annotations[j],
          points: [...n.annotations[j].points]
        };
        z.points[ge] = A, s("annotation-updated", { id: z.id, points: z.points }), k();
      }
      return !0;
    }
    function Y(m) {
      return i.value ? (E(m.offsetX, m.offsetY), !0) : !1;
    }
    function ve(m) {
      p.value = be(m.offsetX, m.offsetY);
    }
    function P(m) {
      const A = R(m.offsetX, m.offsetY);
      if (!A) {
        d.value = null, f.value = null;
        return;
      }
      d.value = A;
      const j = n.annotations[A.annotationIndex], ge = j.points[A.segmentIndex], z = j.points[A.segmentIndex + 1], Se = a.value.width, J = a.value.height, se = Se / l.value, w = J / u.value, Z = ge.x * se, re = ge.y * w, oe = z.x * se, Pe = z.y * w, Oe = oe - Z, ze = Pe - re, Xe = m.offsetX - Z, L = m.offsetY - re, ce = Oe * Oe + ze * ze;
      let Re = (Xe * Oe + L * ze) / ce;
      Re < 0 ? Re = 0 : Re > 1 && (Re = 1);
      const nt = Z + Oe * Re, Lt = re + ze * Re;
      if (f.value = { x: nt, y: Lt }, !h.value) return;
      const we = y(nt, Lt);
      if (!we) return;
      const st = A.segmentIndex + 1;
      j.points.splice(st, 0, we), c.value = {
        annotationIndex: A.annotationIndex,
        pointIndex: st
      }, d.value = null, f.value = null, k();
    }
    function V(m) {
      ie(m) || Y(m) || (ve(m), P(m), k());
    }
    function K(m) {
      const A = be(m.offsetX, m.offsetY);
      if (!A) return;
      m.preventDefault();
      const j = {
        ...n.annotations[A.annotationIndex],
        points: [...n.annotations[A.annotationIndex].points]
      };
      j.points.splice(A.pointIndex, 1), s("annotation-updated", { id: j.id, points: j.points }), c.value = null, d.value = null, f.value = null, p.value = null, k();
    }
    function X(m) {
      const A = m.target;
      A && (l.value = A.naturalWidth, u.value = A.naturalHeight, kt(() => k()));
    }
    return $t(
      () => n.image,
      async () => {
        await kt(), k();
      },
      { immediate: !0 }
    ), $t(
      () => n.annotations,
      () => {
        k();
      },
      { deep: !0 }
    ), cm(window, "resize", k), (m, A) => (T(), N("div", Gm, [
      m.image ? (T(), N("div", {
        key: 0,
        class: pe(["relative drop-shadow max-w-fit", { "cursor-crosshair": t.value }])
      }, [
        O("img", {
          src: m.image,
          alt: m.alt ?? "Image",
          onLoad: X,
          class: "block max-w-full"
        }, null, 40, Jm),
        O("canvas", {
          class: "absolute top-0 left-0 w-full h-full z-10",
          ref_key: "canvas",
          ref: a,
          onMousedown: Qt(F, ["left", "stop"]),
          onMouseup: Qt(q, ["left", "stop"]),
          onMousemove: Qt(V, ["stop"]),
          onContextmenu: Qt(K, ["stop"])
        }, null, 544)
      ], 2)) : (T(), N("div", Qm, "Upload a figure to annotate"))
    ]));
  }
}), Xm = {
  key: 0,
  class: "material-symbols-outlined transition-transform duration-200 bg-light-neutral-200 text-dark-neutral-700 rounded-full w-6 h-6 flex items-center justify-center"
}, Zm = {
  key: 1,
  class: "material-symbols-outlined transition-transform duration-200 bg-light-neutral-200 text-dark-neutral-700 rounded-full w-6 h-6 flex items-center justify-center"
}, eg = {
  key: 0,
  class: "bg-white rounded-b-xl"
}, RC = /* @__PURE__ */ Fe({
  __name: "ExpansionPanel",
  props: {
    modelValue: { default: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(n, { expose: e }) {
    const t = Ui("panelWrapper"), r = nn(n, "modelValue");
    function s() {
      r.value = !r.value;
    }
    function a() {
      var o;
      (o = t.value) == null || o.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
    return e({ scrollIntoView: a }), (o, i) => (T(), N("div", {
      class: pe(["border border-mid-neutral-50", r.value ? "rounded-t-xl" : "rounded-xl"]),
      ref: "panelWrapper"
    }, [
      O("div", {
        class: pe(["flex items-center justify-between gap-2 rounded-xl px-7.5 py-5", r.value ? "rounded-b-none" : ""])
      }, [
        fe(o.$slots, "header", { toggleCollapse: s }),
        O("button", {
          onClick: Qt(s, ["stop"]),
          class: "flex items-center"
        }, [
          r.value ? (T(), N("span", Xm, " expand_less ")) : (T(), N("span", Zm, " expand_more "))
        ])
      ], 2),
      (T(), Ne(Zp, null, [
        r.value ? (T(), N("div", eg, [
          fe(o.$slots, "default")
        ])) : H("", !0)
      ], 1024))
    ], 2));
  }
}), tg = ["for"], ng = ["name", "value", "checked"], rg = { class: "text-base font-medium" }, sg = /* @__PURE__ */ Fe({
  __name: "RadioInput",
  props: {
    name: {},
    value: { type: [String, Boolean] },
    label: {},
    checked: { type: Boolean }
  },
  emits: ["change"],
  setup(n, { emit: e }) {
    const t = qr(), r = e;
    return (s, a) => (T(), N("label", {
      for: b(t),
      class: "flex items-center gap-2 cursor-pointer"
    }, [
      O("input", {
        type: "radio",
        name: s.name,
        value: s.value,
        checked: s.checked,
        onChange: a[0] || (a[0] = (o) => r("change", s.value)),
        class: pe([{
          "border-5 border-red-600": s.checked,
          "border-2 border-mid-neutral-100": !s.checked
        }, "appearance-none h-4 w-4 rounded-full bg-white focus:outline-none focus:ring-2 focus:ring-[#059669] focus:ring-offset-2 focus:ring-offset-white transition"])
      }, null, 42, ng),
      O("span", rg, Ce(s.label), 1)
    ], 8, tg));
  }
}), ag = { class: "flex flex-col gap-2" }, $C = /* @__PURE__ */ Fe({
  __name: "RadioGroup",
  props: /* @__PURE__ */ Ot({
    options: {},
    name: {}
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = nn(n, "modelValue"), t = (r) => {
      e.value = r;
    };
    return (r, s) => (T(), N("div", ag, [
      (T(!0), N(Ee, null, Ye(r.options, (a) => (T(), N("div", {
        key: a.value,
        class: "flex items-center gap-2 cursor-pointer whitespace-nowrap"
      }, [
        Qe(sg, {
          name: r.name,
          value: a.value,
          checked: e.value === a.value,
          label: a.label,
          onChange: t
        }, null, 8, ["name", "value", "checked", "label"])
      ]))), 128))
    ]));
  }
}), Dd = 6048e5, og = 864e5, ig = 6e4, Od = 36e5, lg = 1e3, Fu = Symbol.for("constructDateFrom");
function qe(n, e) {
  return typeof n == "function" ? n(e) : n && typeof n == "object" && Fu in n ? n[Fu](e) : n instanceof Date ? new n.constructor(e) : new Date(e);
}
function De(n, e) {
  return qe(e || n, n);
}
function fn(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in);
  return isNaN(e) ? qe((t == null ? void 0 : t.in) || n, NaN) : (e && r.setDate(r.getDate() + e), r);
}
function wn(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in);
  if (isNaN(e)) return qe(n, NaN);
  if (!e)
    return r;
  const s = r.getDate(), a = qe(n, r.getTime());
  a.setMonth(r.getMonth() + e + 1, 0);
  const o = a.getDate();
  return s >= o ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    s
  ), r);
}
function Ed(n, e, t) {
  const {
    years: r = 0,
    months: s = 0,
    weeks: a = 0,
    days: o = 0,
    hours: i = 0,
    minutes: l = 0,
    seconds: u = 0
  } = e, c = De(n, t == null ? void 0 : t.in), d = s || r ? wn(c, s + r * 12) : c, f = o || a ? fn(d, o + a * 7) : d, h = l + i * 60, g = (u + h * 60) * 1e3;
  return qe(n, +f + g);
}
function ug(n, e, t) {
  return qe(n, +De(n) + e);
}
function cg(n, e, t) {
  return ug(n, e * Od);
}
let dg = {};
function Kr() {
  return dg;
}
function kn(n, e) {
  var i, l, u, c;
  const t = Kr(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (i = e == null ? void 0 : e.locale) == null ? void 0 : i.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = De(n, e == null ? void 0 : e.in), a = s.getDay(), o = (a < r ? 7 : 0) + a - r;
  return s.setDate(s.getDate() - o), s.setHours(0, 0, 0, 0), s;
}
function fs(n, e) {
  return kn(n, { ...e, weekStartsOn: 1 });
}
function Pd(n, e) {
  const t = De(n, e == null ? void 0 : e.in), r = t.getFullYear(), s = qe(t, 0);
  s.setFullYear(r + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const a = fs(s), o = qe(t, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const i = fs(o);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= i.getTime() ? r : r - 1;
}
function Ya(n) {
  const e = De(n), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +n - +t;
}
function ha(n, ...e) {
  const t = qe.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(t);
}
function zu(n, e) {
  const t = De(n, e == null ? void 0 : e.in);
  return t.setHours(0, 0, 0, 0), t;
}
function _d(n, e, t) {
  const [r, s] = ha(
    t == null ? void 0 : t.in,
    n,
    e
  ), a = zu(r), o = zu(s), i = +a - Ya(a), l = +o - Ya(o);
  return Math.round((i - l) / og);
}
function fg(n, e) {
  const t = Pd(n, e), r = qe(n, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), fs(r);
}
function hg(n, e, t) {
  return wn(n, e * 3, t);
}
function Nl(n, e, t) {
  return wn(n, e * 12, t);
}
function Vu(n, e) {
  const t = +De(n) - +De(e);
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function Nd(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function Bs(n) {
  return !(!Nd(n) && typeof n != "number" || isNaN(+De(n)));
}
function Hu(n, e) {
  const t = De(n, e == null ? void 0 : e.in);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function pg(n, e, t) {
  const [r, s] = ha(
    t == null ? void 0 : t.in,
    n,
    e
  );
  return r.getFullYear() - s.getFullYear();
}
function mg(n, e, t) {
  const [r, s] = ha(
    t == null ? void 0 : t.in,
    n,
    e
  ), a = Vu(r, s), o = Math.abs(pg(r, s));
  r.setFullYear(1584), s.setFullYear(1584);
  const i = Vu(r, s) === -a, l = a * (o - +i);
  return l === 0 ? 0 : l;
}
function Id(n, e) {
  const [t, r] = ha(n, e.start, e.end);
  return { start: t, end: r };
}
function Rd(n, e) {
  const { start: t, end: r } = Id(e == null ? void 0 : e.in, n);
  let s = +t > +r;
  const a = s ? +t : +r, o = s ? r : t;
  o.setHours(0, 0, 0, 0);
  let i = 1;
  const l = [];
  for (; +o <= a; )
    l.push(qe(t, o)), o.setDate(o.getDate() + i), o.setHours(0, 0, 0, 0);
  return s ? l.reverse() : l;
}
function Ar(n, e) {
  const t = De(n, e == null ? void 0 : e.in), r = t.getMonth(), s = r - r % 3;
  return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
}
function gg(n, e) {
  const { start: t, end: r } = Id(e == null ? void 0 : e.in, n);
  let s = +t > +r;
  const a = s ? +Ar(t) : +Ar(r);
  let o = Ar(s ? r : t), i = 1;
  const l = [];
  for (; +o <= a; )
    l.push(qe(t, o)), o = hg(o, i);
  return s ? l.reverse() : l;
}
function yg(n, e) {
  const t = De(n, e == null ? void 0 : e.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function $d(n, e) {
  const t = De(n, e == null ? void 0 : e.in), r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Qs(n, e) {
  const t = De(n, e == null ? void 0 : e.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Ld(n, e) {
  var i, l, u, c;
  const t = Kr(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (i = e == null ? void 0 : e.locale) == null ? void 0 : i.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, s = De(n, e == null ? void 0 : e.in), a = s.getDay(), o = (a < r ? -7 : 0) + 6 - (a - r);
  return s.setDate(s.getDate() + o), s.setHours(23, 59, 59, 999), s;
}
function Yu(n, e) {
  const t = De(n, e == null ? void 0 : e.in), r = t.getMonth(), s = r - r % 3 + 3;
  return t.setMonth(s, 0), t.setHours(23, 59, 59, 999), t;
}
const vg = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, bg = (n, e, t) => {
  let r;
  const s = vg[n];
  return typeof s == "string" ? r = s : e === 1 ? r = s.one : r = s.other.replace("{{count}}", e.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ii(n) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
const wg = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, kg = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, xg = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Mg = {
  date: ii({
    formats: wg,
    defaultWidth: "full"
  }),
  time: ii({
    formats: kg,
    defaultWidth: "full"
  }),
  dateTime: ii({
    formats: xg,
    defaultWidth: "full"
  })
}, Sg = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Tg = (n, e, t, r) => Sg[n];
function Ds(n) {
  return (e, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let s;
    if (r === "formatting" && n.formattingValues) {
      const o = n.defaultFormattingWidth || n.defaultWidth, i = t != null && t.width ? String(t.width) : o;
      s = n.formattingValues[i] || n.formattingValues[o];
    } else {
      const o = n.defaultWidth, i = t != null && t.width ? String(t.width) : n.defaultWidth;
      s = n.values[i] || n.values[o];
    }
    const a = n.argumentCallback ? n.argumentCallback(e) : e;
    return s[a];
  };
}
const Cg = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ag = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Dg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Og = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Eg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Pg = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, _g = (n, e) => {
  const t = Number(n), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Ng = {
  ordinalNumber: _g,
  era: Ds({
    values: Cg,
    defaultWidth: "wide"
  }),
  quarter: Ds({
    values: Ag,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: Ds({
    values: Dg,
    defaultWidth: "wide"
  }),
  day: Ds({
    values: Og,
    defaultWidth: "wide"
  }),
  dayPeriod: Ds({
    values: Eg,
    defaultWidth: "wide",
    formattingValues: Pg,
    defaultFormattingWidth: "wide"
  })
};
function Os(n) {
  return (e, t = {}) => {
    const r = t.width, s = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], a = e.match(s);
    if (!a)
      return null;
    const o = a[0], i = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], l = Array.isArray(i) ? Rg(i, (d) => d.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      Ig(i, (d) => d.test(o))
    );
    let u;
    u = n.valueCallback ? n.valueCallback(l) : l, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = e.slice(o.length);
    return { value: u, rest: c };
  };
}
function Ig(n, e) {
  for (const t in n)
    if (Object.prototype.hasOwnProperty.call(n, t) && e(n[t]))
      return t;
}
function Rg(n, e) {
  for (let t = 0; t < n.length; t++)
    if (e(n[t]))
      return t;
}
function $g(n) {
  return (e, t = {}) => {
    const r = e.match(n.matchPattern);
    if (!r) return null;
    const s = r[0], a = e.match(n.parsePattern);
    if (!a) return null;
    let o = n.valueCallback ? n.valueCallback(a[0]) : a[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const i = e.slice(s.length);
    return { value: o, rest: i };
  };
}
const Lg = /^(\d+)(th|st|nd|rd)?/i, Bg = /\d+/i, Fg = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, zg = {
  any: [/^b/i, /^(a|c)/i]
}, Vg = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Hg = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Yg = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Wg = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, jg = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ug = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, qg = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Kg = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Gg = {
  ordinalNumber: $g({
    matchPattern: Lg,
    parsePattern: Bg,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: Os({
    matchPatterns: Fg,
    defaultMatchWidth: "wide",
    parsePatterns: zg,
    defaultParseWidth: "any"
  }),
  quarter: Os({
    matchPatterns: Vg,
    defaultMatchWidth: "wide",
    parsePatterns: Hg,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: Os({
    matchPatterns: Yg,
    defaultMatchWidth: "wide",
    parsePatterns: Wg,
    defaultParseWidth: "any"
  }),
  day: Os({
    matchPatterns: jg,
    defaultMatchWidth: "wide",
    parsePatterns: Ug,
    defaultParseWidth: "any"
  }),
  dayPeriod: Os({
    matchPatterns: qg,
    defaultMatchWidth: "any",
    parsePatterns: Kg,
    defaultParseWidth: "any"
  })
}, Bd = {
  code: "en-US",
  formatDistance: bg,
  formatLong: Mg,
  formatRelative: Tg,
  localize: Ng,
  match: Gg,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Jg(n, e) {
  const t = De(n, e == null ? void 0 : e.in);
  return _d(t, Qs(t)) + 1;
}
function Il(n, e) {
  const t = De(n, e == null ? void 0 : e.in), r = +fs(t) - +fg(t);
  return Math.round(r / Dd) + 1;
}
function Rl(n, e) {
  var c, d, f, h;
  const t = De(n, e == null ? void 0 : e.in), r = t.getFullYear(), s = Kr(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((d = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((h = (f = s.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = qe((e == null ? void 0 : e.in) || n, 0);
  o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
  const i = kn(o, e), l = qe((e == null ? void 0 : e.in) || n, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const u = kn(l, e);
  return +t >= +i ? r + 1 : +t >= +u ? r : r - 1;
}
function Qg(n, e) {
  var i, l, u, c;
  const t = Kr(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (i = e == null ? void 0 : e.locale) == null ? void 0 : i.options) == null ? void 0 : l.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, s = Rl(n, e), a = qe((e == null ? void 0 : e.in) || n, 0);
  return a.setFullYear(s, 0, r), a.setHours(0, 0, 0, 0), kn(a, e);
}
function $l(n, e) {
  const t = De(n, e == null ? void 0 : e.in), r = +kn(t, e) - +Qg(t, e);
  return Math.round(r / Dd) + 1;
}
function Ue(n, e) {
  const t = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(e, "0");
  return t + r;
}
const Gn = {
  // Year
  y(n, e) {
    const t = n.getFullYear(), r = t > 0 ? t : 1 - t;
    return Ue(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(n, e) {
    const t = n.getMonth();
    return e === "M" ? String(t + 1) : Ue(t + 1, 2);
  },
  // Day of the month
  d(n, e) {
    return Ue(n.getDate(), e.length);
  },
  // AM or PM
  a(n, e) {
    const t = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, e) {
    return Ue(n.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(n, e) {
    return Ue(n.getHours(), e.length);
  },
  // Minute
  m(n, e) {
    return Ue(n.getMinutes(), e.length);
  },
  // Second
  s(n, e) {
    return Ue(n.getSeconds(), e.length);
  },
  // Fraction of second
  S(n, e) {
    const t = e.length, r = n.getMilliseconds(), s = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return Ue(s, e.length);
  }
}, Jr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Wu = {
  // Era
  G: function(n, e, t) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, e, t) {
    if (e === "yo") {
      const r = n.getFullYear(), s = r > 0 ? r : 1 - r;
      return t.ordinalNumber(s, { unit: "year" });
    }
    return Gn.y(n, e);
  },
  // Local week-numbering year
  Y: function(n, e, t, r) {
    const s = Rl(n, r), a = s > 0 ? s : 1 - s;
    if (e === "YY") {
      const o = a % 100;
      return Ue(o, 2);
    }
    return e === "Yo" ? t.ordinalNumber(a, { unit: "year" }) : Ue(a, e.length);
  },
  // ISO week-numbering year
  R: function(n, e) {
    const t = Pd(n);
    return Ue(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, e) {
    const t = n.getFullYear();
    return Ue(t, e.length);
  },
  // Quarter
  Q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Ue(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Ue(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Gn.M(n, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ue(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, e, t, r) {
    const s = $l(n, r);
    return e === "wo" ? t.ordinalNumber(s, { unit: "week" }) : Ue(s, e.length);
  },
  // ISO week of year
  I: function(n, e, t) {
    const r = Il(n);
    return e === "Io" ? t.ordinalNumber(r, { unit: "week" }) : Ue(r, e.length);
  },
  // Day of the month
  d: function(n, e, t) {
    return e === "do" ? t.ordinalNumber(n.getDate(), { unit: "date" }) : Gn.d(n, e);
  },
  // Day of year
  D: function(n, e, t) {
    const r = Jg(n);
    return e === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : Ue(r, e.length);
  },
  // Day of week
  E: function(n, e, t) {
    const r = n.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, e, t, r) {
    const s = n.getDay(), a = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return Ue(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(a, { unit: "day" });
      case "eee":
        return t.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, e, t, r) {
    const s = n.getDay(), a = (s - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return Ue(a, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return t.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, e, t) {
    const r = n.getDay(), s = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return Ue(s, e.length);
      // 2nd
      case "io":
        return t.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, e, t) {
    const s = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, e, t) {
    const r = n.getHours();
    let s;
    switch (r === 12 ? s = Jr.noon : r === 0 ? s = Jr.midnight : s = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, e, t) {
    const r = n.getHours();
    let s;
    switch (r >= 17 ? s = Jr.evening : r >= 12 ? s = Jr.afternoon : r >= 4 ? s = Jr.morning : s = Jr.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, e, t) {
    if (e === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return Gn.h(n, e);
  },
  // Hour [0-23]
  H: function(n, e, t) {
    return e === "Ho" ? t.ordinalNumber(n.getHours(), { unit: "hour" }) : Gn.H(n, e);
  },
  // Hour [0-11]
  K: function(n, e, t) {
    const r = n.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : Ue(r, e.length);
  },
  // Hour [1-24]
  k: function(n, e, t) {
    let r = n.getHours();
    return r === 0 && (r = 24), e === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : Ue(r, e.length);
  },
  // Minute
  m: function(n, e, t) {
    return e === "mo" ? t.ordinalNumber(n.getMinutes(), { unit: "minute" }) : Gn.m(n, e);
  },
  // Second
  s: function(n, e, t) {
    return e === "so" ? t.ordinalNumber(n.getSeconds(), { unit: "second" }) : Gn.s(n, e);
  },
  // Fraction of second
  S: function(n, e) {
    return Gn.S(n, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, e, t) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Uu(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Tr(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Tr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Uu(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Tr(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Tr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ju(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Tr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ju(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Tr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, e, t) {
    const r = Math.trunc(+n / 1e3);
    return Ue(r, e.length);
  },
  // Milliseconds timestamp
  T: function(n, e, t) {
    return Ue(+n, e.length);
  }
};
function ju(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), s = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? t + String(s) : t + String(s) + e + Ue(a, 2);
}
function Uu(n, e) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + Ue(Math.abs(n) / 60, 2) : Tr(n, e);
}
function Tr(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), s = Ue(Math.trunc(r / 60), 2), a = Ue(r % 60, 2);
  return t + s + e + a;
}
const qu = (n, e) => {
  switch (n) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Fd = (n, e) => {
  switch (n) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, Xg = (n, e) => {
  const t = n.match(/(P+)(p+)?/) || [], r = t[1], s = t[2];
  if (!s)
    return qu(n, e);
  let a;
  switch (r) {
    case "P":
      a = e.dateTime({ width: "short" });
      break;
    case "PP":
      a = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = e.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", qu(r, e)).replace("{{time}}", Fd(s, e));
}, qi = {
  p: Fd,
  P: Xg
}, Zg = /^D+$/, ey = /^Y+$/, ty = ["D", "DD", "YY", "YYYY"];
function zd(n) {
  return Zg.test(n);
}
function Vd(n) {
  return ey.test(n);
}
function Ki(n, e, t) {
  const r = ny(n, e, t);
  if (console.warn(r), ty.includes(n)) throw new RangeError(r);
}
function ny(n, e, t) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${e}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const ry = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, sy = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ay = /^'([^]*?)'?$/, oy = /''/g, iy = /[a-zA-Z]/;
function Pn(n, e, t) {
  var c, d, f, h, p, g, y, v;
  const r = Kr(), s = (t == null ? void 0 : t.locale) ?? r.locale ?? Bd, a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = (t == null ? void 0 : t.weekStartsOn) ?? ((g = (p = t == null ? void 0 : t.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((v = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : v.weekStartsOn) ?? 0, i = De(n, t == null ? void 0 : t.in);
  if (!Bs(i))
    throw new RangeError("Invalid time value");
  let l = e.match(sy).map((C) => {
    const M = C[0];
    if (M === "p" || M === "P") {
      const S = qi[M];
      return S(C, s.formatLong);
    }
    return C;
  }).join("").match(ry).map((C) => {
    if (C === "''")
      return { isToken: !1, value: "'" };
    const M = C[0];
    if (M === "'")
      return { isToken: !1, value: ly(C) };
    if (Wu[M])
      return { isToken: !0, value: C };
    if (M.match(iy))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + M + "`"
      );
    return { isToken: !1, value: C };
  });
  s.localize.preprocessor && (l = s.localize.preprocessor(i, l));
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: s
  };
  return l.map((C) => {
    if (!C.isToken) return C.value;
    const M = C.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Vd(M) || !(t != null && t.useAdditionalDayOfYearTokens) && zd(M)) && Ki(M, e, String(n));
    const S = Wu[M[0]];
    return S(i, M, s.localize, u);
  }).join("");
}
function ly(n) {
  const e = n.match(ay);
  return e ? e[1].replace(oy, "'") : n;
}
function uy(n, e) {
  return De(n, e == null ? void 0 : e.in).getDay();
}
function cy(n, e) {
  const t = De(n, e == null ? void 0 : e.in), r = t.getFullYear(), s = t.getMonth(), a = qe(t, 0);
  return a.setFullYear(r, s + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function dy() {
  return Object.assign({}, Kr());
}
function Un(n, e) {
  return De(n, e == null ? void 0 : e.in).getHours();
}
function fy(n, e) {
  const t = De(n, e == null ? void 0 : e.in).getDay();
  return t === 0 ? 7 : t;
}
function mr(n, e) {
  return De(n, e == null ? void 0 : e.in).getMinutes();
}
function Ve(n, e) {
  return De(n, e == null ? void 0 : e.in).getMonth();
}
function hs(n) {
  return De(n).getSeconds();
}
function _e(n, e) {
  return De(n, e == null ? void 0 : e.in).getFullYear();
}
function Fr(n, e) {
  return +De(n) > +De(e);
}
function ps(n, e) {
  return +De(n) < +De(e);
}
function as(n, e) {
  return +De(n) == +De(e);
}
function hy(n, e) {
  const t = py(e) ? new e(0) : qe(e, 0);
  return t.setFullYear(n.getFullYear(), n.getMonth(), n.getDate()), t.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), t;
}
function py(n) {
  var e;
  return typeof n == "function" && ((e = n.prototype) == null ? void 0 : e.constructor) === n;
}
const my = 10;
class Hd {
  constructor() {
    ye(this, "subPriority", 0);
  }
  validate(e, t) {
    return !0;
  }
}
class gy extends Hd {
  constructor(e, t, r, s, a) {
    super(), this.value = e, this.validateValue = t, this.setValue = r, this.priority = s, a && (this.subPriority = a);
  }
  validate(e, t) {
    return this.validateValue(e, this.value, t);
  }
  set(e, t, r) {
    return this.setValue(e, t, this.value, r);
  }
}
class yy extends Hd {
  constructor(t, r) {
    super();
    ye(this, "priority", my);
    ye(this, "subPriority", -1);
    this.context = t || ((s) => qe(r, s));
  }
  set(t, r) {
    return r.timestampIsSet ? t : qe(t, hy(t, this.context));
  }
}
class We {
  run(e, t, r, s) {
    const a = this.parse(e, t, r, s);
    return a ? {
      setter: new gy(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(e, t, r) {
    return !0;
  }
}
class vy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 140);
    ye(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(t, { width: "wide" }) || s.era(t, { width: "abbreviated" }) || s.era(t, { width: "narrow" });
    }
  }
  set(t, r, s) {
    return r.era = s, t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const mt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Dn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function gt(n, e) {
  return n && {
    value: e(n.value),
    rest: n.rest
  };
}
function ot(n, e) {
  const t = e.match(n);
  return t ? {
    value: parseInt(t[0], 10),
    rest: e.slice(t[0].length)
  } : null;
}
function On(n, e) {
  const t = e.match(n);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, s = t[2] ? parseInt(t[2], 10) : 0, a = t[3] ? parseInt(t[3], 10) : 0, o = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (s * Od + a * ig + o * lg),
    rest: e.slice(t[0].length)
  };
}
function Yd(n) {
  return ot(mt.anyDigitsSigned, n);
}
function ct(n, e) {
  switch (n) {
    case 1:
      return ot(mt.singleDigit, e);
    case 2:
      return ot(mt.twoDigits, e);
    case 3:
      return ot(mt.threeDigits, e);
    case 4:
      return ot(mt.fourDigits, e);
    default:
      return ot(new RegExp("^\\d{1," + n + "}"), e);
  }
}
function Wa(n, e) {
  switch (n) {
    case 1:
      return ot(mt.singleDigitSigned, e);
    case 2:
      return ot(mt.twoDigitsSigned, e);
    case 3:
      return ot(mt.threeDigitsSigned, e);
    case 4:
      return ot(mt.fourDigitsSigned, e);
    default:
      return ot(new RegExp("^-?\\d{1," + n + "}"), e);
  }
}
function Ll(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Wd(n, e) {
  const t = e > 0, r = t ? e : 1 - e;
  let s;
  if (r <= 50)
    s = n || 100;
  else {
    const a = r + 50, o = Math.trunc(a / 100) * 100, i = n >= a % 100;
    s = n + o - (i ? 100 : 0);
  }
  return t ? s : 1 - s;
}
function jd(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class by extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 130);
    ye(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, s) {
    const a = (o) => ({
      year: o,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return gt(ct(4, t), a);
      case "yo":
        return gt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          a
        );
      default:
        return gt(ct(r.length, t), a);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, s) {
    const a = t.getFullYear();
    if (s.isTwoDigitYear) {
      const i = Wd(
        s.year,
        a
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const o = !("era" in r) || r.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class wy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 130);
    ye(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const a = (o) => ({
      year: o,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return gt(ct(4, t), a);
      case "Yo":
        return gt(
          s.ordinalNumber(t, {
            unit: "year"
          }),
          a
        );
      default:
        return gt(ct(r.length, t), a);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, s, a) {
    const o = Rl(t, a);
    if (s.isTwoDigitYear) {
      const l = Wd(
        s.year,
        o
      );
      return t.setFullYear(
        l,
        0,
        a.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), kn(t, a);
    }
    const i = !("era" in r) || r.era === 1 ? s.year : 1 - s.year;
    return t.setFullYear(i, 0, a.firstWeekContainsDate), t.setHours(0, 0, 0, 0), kn(t, a);
  }
}
class ky extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 130);
    ye(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r) {
    return Wa(r === "R" ? 4 : r.length, t);
  }
  set(t, r, s) {
    const a = qe(t, 0);
    return a.setFullYear(s, 0, 4), a.setHours(0, 0, 0, 0), fs(a);
  }
}
class xy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 130);
    ye(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return Wa(r === "u" ? 4 : r.length, t);
  }
  set(t, r, s) {
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class My extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 120);
    ye(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return ct(r.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Sy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 120);
    ye(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return ct(r.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, s) {
    return t.setMonth((s - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Ty extends We {
  constructor() {
    super(...arguments);
    ye(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    ye(this, "priority", 110);
  }
  parse(t, r, s) {
    const a = (o) => o - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return gt(
          ot(mt.month, t),
          a
        );
      // 01, 02, ..., 12
      case "MM":
        return gt(ct(2, t), a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return gt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(t, { width: "wide", context: "formatting" }) || s.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Cy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 110);
    ye(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const a = (o) => o - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return gt(
          ot(mt.month, t),
          a
        );
      // 01, 02, ..., 12
      case "LL":
        return gt(ct(2, t), a);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return gt(
          s.ordinalNumber(t, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(t, { width: "wide", context: "standalone" }) || s.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Ay(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in), s = $l(r, t) - e;
  return r.setDate(r.getDate() - s * 7), De(r, t == null ? void 0 : t.in);
}
class Dy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 100);
    ye(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "w":
        return ot(mt.week, t);
      case "wo":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, s, a) {
    return kn(Ay(t, s, a), a);
  }
}
function Oy(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in), s = Il(r, t) - e;
  return r.setDate(r.getDate() - s * 7), r;
}
class Ey extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 100);
    ye(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "I":
        return ot(mt.week, t);
      case "Io":
        return s.ordinalNumber(t, { unit: "week" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, s) {
    return fs(Oy(t, s));
  }
}
const Py = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], _y = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Ny extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 90);
    ye(this, "subPriority", 1);
    ye(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "d":
        return ot(mt.date, t);
      case "do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    const s = t.getFullYear(), a = jd(s), o = t.getMonth();
    return a ? r >= 1 && r <= _y[o] : r >= 1 && r <= Py[o];
  }
  set(t, r, s) {
    return t.setDate(s), t.setHours(0, 0, 0, 0), t;
  }
}
class Iy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 90);
    ye(this, "subpriority", 1);
    ye(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    switch (r) {
      case "D":
      case "DD":
        return ot(mt.dayOfYear, t);
      case "Do":
        return s.ordinalNumber(t, { unit: "date" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    const s = t.getFullYear();
    return jd(s) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, s) {
    return t.setMonth(0, s), t.setHours(0, 0, 0, 0), t;
  }
}
function Bl(n, e, t) {
  var d, f, h, p;
  const r = Kr(), s = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((p = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? 0, a = De(n, t == null ? void 0 : t.in), o = a.getDay(), l = (e % 7 + 7) % 7, u = 7 - s, c = e < 0 || e > 6 ? e - (o + u) % 7 : (l + u) % 7 - (o + u) % 7;
  return fn(a, c, t);
}
class Ry extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 90);
    ye(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, a) {
    return t = Bl(t, s, a), t.setHours(0, 0, 0, 0), t;
  }
}
class $y extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 90);
    ye(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s, a) {
    const o = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + a.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return gt(ct(r.length, t), o);
      // 3rd
      case "eo":
        return gt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "eee":
        return s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(t, { width: "wide", context: "formatting" }) || s.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(t, { width: "short", context: "formatting" }) || s.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, a) {
    return t = Bl(t, s, a), t.setHours(0, 0, 0, 0), t;
  }
}
class Ly extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 90);
    ye(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, r, s, a) {
    const o = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + a.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return gt(ct(r.length, t), o);
      // 3rd
      case "co":
        return gt(
          s.ordinalNumber(t, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "ccc":
        return s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(t, { width: "wide", context: "standalone" }) || s.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(t, { width: "short", context: "standalone" }) || s.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, s, a) {
    return t = Bl(t, s, a), t.setHours(0, 0, 0, 0), t;
  }
}
function By(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in), s = fy(r, t), a = e - s;
  return fn(r, a, t);
}
class Fy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 90);
    ye(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, s) {
    const a = (o) => o === 0 ? 7 : o;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return ct(r.length, t);
      // 2nd
      case "io":
        return s.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return gt(
          s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // T
      case "iiiii":
        return gt(
          s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tu
      case "iiiiii":
        return gt(
          s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tuesday
      case "iiii":
      default:
        return gt(
          s.day(t, {
            width: "wide",
            context: "formatting"
          }) || s.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(t, {
            width: "short",
            context: "formatting"
          }) || s.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, s) {
    return t = By(t, s), t.setHours(0, 0, 0, 0), t;
  }
}
class zy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 80);
    ye(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(Ll(s), 0, 0, 0), t;
  }
}
class Vy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 80);
    ye(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(Ll(s), 0, 0, 0), t;
  }
}
class Hy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 80);
    ye(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, s) {
    return t.setHours(Ll(s), 0, 0, 0), t;
  }
}
class Yy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 70);
    ye(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "h":
        return ot(mt.hour12h, t);
      case "ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, s) {
    const a = t.getHours() >= 12;
    return a && s < 12 ? t.setHours(s + 12, 0, 0, 0) : !a && s === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Wy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 70);
    ye(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "H":
        return ot(mt.hour23h, t);
      case "Ho":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, s) {
    return t.setHours(s, 0, 0, 0), t;
  }
}
class jy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 70);
    ye(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "K":
        return ot(mt.hour11h, t);
      case "Ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, s) {
    return t.getHours() >= 12 && s < 12 ? t.setHours(s + 12, 0, 0, 0) : t.setHours(s, 0, 0, 0), t;
  }
}
class Uy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 70);
    ye(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "k":
        return ot(mt.hour24h, t);
      case "ko":
        return s.ordinalNumber(t, { unit: "hour" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, s) {
    const a = s <= 24 ? s % 24 : s;
    return t.setHours(a, 0, 0, 0), t;
  }
}
class qy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 60);
    ye(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "m":
        return ot(mt.minute, t);
      case "mo":
        return s.ordinalNumber(t, { unit: "minute" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, s) {
    return t.setMinutes(s, 0, 0), t;
  }
}
class Ky extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 50);
    ye(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, s) {
    switch (r) {
      case "s":
        return ot(mt.second, t);
      case "so":
        return s.ordinalNumber(t, { unit: "second" });
      default:
        return ct(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, s) {
    return t.setSeconds(s, 0), t;
  }
}
class Gy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 30);
    ye(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    const s = (a) => Math.trunc(a * Math.pow(10, -r.length + 3));
    return gt(ct(r.length, t), s);
  }
  set(t, r, s) {
    return t.setMilliseconds(s), t;
  }
}
class Jy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 10);
    ye(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return On(
          Dn.basicOptionalMinutes,
          t
        );
      case "XX":
        return On(Dn.basic, t);
      case "XXXX":
        return On(
          Dn.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return On(
          Dn.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return On(Dn.extended, t);
    }
  }
  set(t, r, s) {
    return r.timestampIsSet ? t : qe(
      t,
      t.getTime() - Ya(t) - s
    );
  }
}
class Qy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 10);
    ye(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return On(
          Dn.basicOptionalMinutes,
          t
        );
      case "xx":
        return On(Dn.basic, t);
      case "xxxx":
        return On(
          Dn.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return On(
          Dn.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return On(Dn.extended, t);
    }
  }
  set(t, r, s) {
    return r.timestampIsSet ? t : qe(
      t,
      t.getTime() - Ya(t) - s
    );
  }
}
class Xy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 40);
    ye(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Yd(t);
  }
  set(t, r, s) {
    return [qe(t, s * 1e3), { timestampIsSet: !0 }];
  }
}
class Zy extends We {
  constructor() {
    super(...arguments);
    ye(this, "priority", 20);
    ye(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Yd(t);
  }
  set(t, r, s) {
    return [qe(t, s), { timestampIsSet: !0 }];
  }
}
const ev = {
  G: new vy(),
  y: new by(),
  Y: new wy(),
  R: new ky(),
  u: new xy(),
  Q: new My(),
  q: new Sy(),
  M: new Ty(),
  L: new Cy(),
  w: new Dy(),
  I: new Ey(),
  d: new Ny(),
  D: new Iy(),
  E: new Ry(),
  e: new $y(),
  c: new Ly(),
  i: new Fy(),
  a: new zy(),
  b: new Vy(),
  B: new Hy(),
  h: new Yy(),
  H: new Wy(),
  K: new jy(),
  k: new Uy(),
  m: new qy(),
  s: new Ky(),
  S: new Gy(),
  X: new Jy(),
  x: new Qy(),
  t: new Xy(),
  T: new Zy()
}, tv = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, nv = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, rv = /^'([^]*?)'?$/, sv = /''/g, av = /\S/, ov = /[a-zA-Z]/;
function Gi(n, e, t, r) {
  var y, v, C, M, S, D, I, x;
  const s = () => qe((r == null ? void 0 : r.in) || t, NaN), a = dy(), o = (r == null ? void 0 : r.locale) ?? a.locale ?? Bd, i = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((v = (y = r == null ? void 0 : r.locale) == null ? void 0 : y.options) == null ? void 0 : v.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((M = (C = a.locale) == null ? void 0 : C.options) == null ? void 0 : M.firstWeekContainsDate) ?? 1, l = (r == null ? void 0 : r.weekStartsOn) ?? ((D = (S = r == null ? void 0 : r.locale) == null ? void 0 : S.options) == null ? void 0 : D.weekStartsOn) ?? a.weekStartsOn ?? ((x = (I = a.locale) == null ? void 0 : I.options) == null ? void 0 : x.weekStartsOn) ?? 0;
  if (!e)
    return n ? s() : De(t, r == null ? void 0 : r.in);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: l,
    locale: o
  }, c = [new yy(r == null ? void 0 : r.in, t)], d = e.match(nv).map((k) => {
    const _ = k[0];
    if (_ in qi) {
      const E = qi[_];
      return E(k, o.formatLong);
    }
    return k;
  }).join("").match(tv), f = [];
  for (let k of d) {
    !(r != null && r.useAdditionalWeekYearTokens) && Vd(k) && Ki(k, e, n), !(r != null && r.useAdditionalDayOfYearTokens) && zd(k) && Ki(k, e, n);
    const _ = k[0], E = ev[_];
    if (E) {
      const { incompatibleTokens: ne } = E;
      if (Array.isArray(ne)) {
        const be = f.find(
          (R) => ne.includes(R.token) || R.token === _
        );
        if (be)
          throw new RangeError(
            `The format string mustn't contain \`${be.fullToken}\` and \`${k}\` at the same time`
          );
      } else if (E.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${k}\` and any other token at the same time`
        );
      f.push({ token: _, fullToken: k });
      const de = E.run(
        n,
        k,
        o.match,
        u
      );
      if (!de)
        return s();
      c.push(de.setter), n = de.rest;
    } else {
      if (_.match(ov))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + _ + "`"
        );
      if (k === "''" ? k = "'" : _ === "'" && (k = iv(k)), n.indexOf(k) === 0)
        n = n.slice(k.length);
      else
        return s();
    }
  }
  if (n.length > 0 && av.test(n))
    return s();
  const h = c.map((k) => k.priority).sort((k, _) => _ - k).filter((k, _, E) => E.indexOf(k) === _).map(
    (k) => c.filter((_) => _.priority === k).sort((_, E) => E.subPriority - _.subPriority)
  ).map((k) => k[0]);
  let p = De(t, r == null ? void 0 : r.in);
  if (isNaN(+p)) return s();
  const g = {};
  for (const k of h) {
    if (!k.validate(p, u))
      return s();
    const _ = k.set(p, g, u);
    Array.isArray(_) ? (p = _[0], Object.assign(g, _[1])) : p = _;
  }
  return p;
}
function iv(n) {
  return n.match(rv)[1].replace(sv, "'");
}
function Ku(n, e, t) {
  const [r, s] = ha(
    t == null ? void 0 : t.in,
    n,
    e
  );
  return +Ar(r) == +Ar(s);
}
function Ud(n, e, t) {
  return fn(n, -e, t);
}
function qd(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in), s = r.getFullYear(), a = r.getDate(), o = qe(n, 0);
  o.setFullYear(s, e, 15), o.setHours(0, 0, 0, 0);
  const i = cy(o);
  return r.setMonth(e, Math.min(a, i)), r;
}
function Ke(n, e, t) {
  let r = De(n, t == null ? void 0 : t.in);
  return isNaN(+r) ? qe(n, NaN) : (e.year != null && r.setFullYear(e.year), e.month != null && (r = qd(r, e.month)), e.date != null && r.setDate(e.date), e.hours != null && r.setHours(e.hours), e.minutes != null && r.setMinutes(e.minutes), e.seconds != null && r.setSeconds(e.seconds), e.milliseconds != null && r.setMilliseconds(e.milliseconds), r);
}
function lv(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in);
  return r.setHours(e), r;
}
function Kd(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in);
  return r.setMilliseconds(e), r;
}
function uv(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in);
  return r.setMinutes(e), r;
}
function Gd(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in);
  return r.setSeconds(e), r;
}
function En(n, e, t) {
  const r = De(n, t == null ? void 0 : t.in);
  return isNaN(+r) ? qe(n, NaN) : (r.setFullYear(e), r);
}
function ms(n, e, t) {
  return wn(n, -e, t);
}
function cv(n, e, t) {
  const {
    years: r = 0,
    months: s = 0,
    weeks: a = 0,
    days: o = 0,
    hours: i = 0,
    minutes: l = 0,
    seconds: u = 0
  } = e, c = ms(n, s + r * 12, t), d = Ud(c, o + a * 7, t), f = l + i * 60, p = (u + f * 60) * 1e3;
  return qe(n, +d - p);
}
function Jd(n, e, t) {
  return Nl(n, -e, t);
}
function Cs() {
  const n = em();
  return T(), N(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...n
    },
    [
      O("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      O("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      O("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      O("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Cs.compatConfig = {
  MODE: 3
};
function Qd() {
  return T(), N(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      O("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      O("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Qd.compatConfig = {
  MODE: 3
};
function Fl() {
  return T(), N(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      O("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Fl.compatConfig = {
  MODE: 3
};
function zl() {
  return T(), N(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      O("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
zl.compatConfig = {
  MODE: 3
};
function Vl() {
  return T(), N(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      O("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      O("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
Vl.compatConfig = {
  MODE: 3
};
function Hl() {
  return T(), N(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      O("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Hl.compatConfig = {
  MODE: 3
};
function Yl() {
  return T(), N(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      O("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Yl.compatConfig = {
  MODE: 3
};
const en = (n, e) => e ? new Date(n.toLocaleString("en-US", { timeZone: e })) : new Date(n), Wl = (n, e, t) => Ji(n, e, t) || ee(), dv = (n, e, t) => {
  const r = e.dateInTz ? en(new Date(n), e.dateInTz) : ee(n);
  return t ? Et(r, !0) : r;
}, Ji = (n, e, t) => {
  if (!n) return null;
  const r = t ? Et(ee(n), !0) : ee(n);
  return e ? e.exactMatch ? dv(n, e, t) : en(r, e.timezone) : r;
}, fv = (n) => {
  const e = new Date(n.getFullYear(), 0, 1).getTimezoneOffset();
  return n.getTimezoneOffset() < e;
}, hv = (n, e) => {
  if (!n) return 0;
  const t = /* @__PURE__ */ new Date(), r = new Date(t.toLocaleString("en-US", { timeZone: "UTC" })), s = new Date(t.toLocaleString("en-US", { timeZone: n })), a = (fv(e ?? s) ? s : e ?? s).getTimezoneOffset() / 60;
  return (+r - +s) / (1e3 * 60 * 60) - a;
};
var mn = /* @__PURE__ */ ((n) => (n.month = "month", n.year = "year", n))(mn || {}), gn = /* @__PURE__ */ ((n) => (n.top = "top", n.bottom = "bottom", n))(gn || {}), _r = /* @__PURE__ */ ((n) => (n.header = "header", n.calendar = "calendar", n.timePicker = "timePicker", n))(_r || {}), zt = /* @__PURE__ */ ((n) => (n.month = "month", n.year = "year", n.calendar = "calendar", n.time = "time", n.minutes = "minutes", n.hours = "hours", n.seconds = "seconds", n))(zt || {});
const pv = ["timestamp", "date", "iso"];
var Wt = /* @__PURE__ */ ((n) => (n.up = "up", n.down = "down", n.left = "left", n.right = "right", n))(Wt || {}), et = /* @__PURE__ */ ((n) => (n.arrowUp = "ArrowUp", n.arrowDown = "ArrowDown", n.arrowLeft = "ArrowLeft", n.arrowRight = "ArrowRight", n.enter = "Enter", n.space = " ", n.esc = "Escape", n.tab = "Tab", n.home = "Home", n.end = "End", n.pageUp = "PageUp", n.pageDown = "PageDown", n))(et || {}), ls = /* @__PURE__ */ ((n) => (n.MONTH_AND_YEAR = "MM-yyyy", n.YEAR = "yyyy", n.DATE = "dd-MM-yyyy", n))(ls || {});
function Gu(n) {
  return (e) => {
    const t = new Intl.DateTimeFormat(n, {
      weekday: "short",
      timeZone: "UTC"
    }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`));
    return n === "ar" ? t.slice(2, 5) : t.slice(0, 2);
  };
}
function mv(n) {
  return (e) => Pn(en(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: n });
}
const gv = (n, e, t) => {
  const r = [1, 2, 3, 4, 5, 6, 7];
  let s;
  if (n !== null)
    try {
      s = r.map(mv(n));
    } catch {
      s = r.map(Gu(e));
    }
  else
    s = r.map(Gu(e));
  const a = s.slice(0, t), o = s.slice(t + 1, s.length);
  return [s[t]].concat(...o).concat(...a);
}, jl = (n, e, t) => {
  const r = [];
  for (let s = +n[0]; s <= +n[1]; s++)
    r.push({ value: +s, text: tf(s, e) });
  return t ? r.reverse() : r;
}, Xd = (n, e, t) => {
  const r = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((a) => {
    const o = a < 10 ? `0${a}` : a;
    return /* @__PURE__ */ new Date(`2017-${o}-01T00:00:00+00:00`);
  });
  if (n !== null)
    try {
      const a = t === "long" ? "LLLL" : "LLL";
      return r.map((o, i) => {
        const l = Pn(en(o, "UTC"), a, { locale: n });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: i
        };
      });
    } catch {
    }
  const s = new Intl.DateTimeFormat(e, { month: t, timeZone: "UTC" });
  return r.map((a, o) => {
    const i = s.format(a);
    return {
      text: i.charAt(0).toUpperCase() + i.substring(1),
      value: o
    };
  });
}, yv = (n) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][n], vt = (n) => {
  const e = b(n);
  return e != null && e.$el ? e == null ? void 0 : e.$el : e;
}, vv = (n) => ({ type: "dot", ...n ?? {} }), Zd = (n) => Array.isArray(n) ? !!n[0] && !!n[1] : !1, Ul = {
  prop: (n) => `"${n}" prop must be enabled!`,
  dateArr: (n) => `You need to use array as "model-value" binding in order to support "${n}"`
}, St = (n) => n, Ju = (n) => n === 0 ? n : !n || isNaN(+n) ? null : +n, Qu = (n) => n === null, ef = (n) => {
  if (n)
    return [...n.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, bv = (n) => {
  const e = [], t = (r) => r.filter((s) => s);
  for (let r = 0; r < n.length; r += 3) {
    const s = [n[r], n[r + 1], n[r + 2]];
    e.push(t(s));
  }
  return e;
}, Xs = (n, e, t) => {
  const r = t != null, s = e != null;
  if (!r && !s) return !1;
  const a = +t, o = +e;
  return r && s ? +n > a || +n < o : r ? +n > a : s ? +n < o : !1;
}, gs = (n, e) => bv(n).map((t) => t.map((r) => {
  const { active: s, disabled: a, isBetween: o, highlighted: i } = e(r);
  return {
    ...r,
    active: s,
    disabled: a,
    className: {
      dp__overlay_cell_active: s,
      dp__overlay_cell: !s,
      dp__overlay_cell_disabled: a,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: a && s,
      dp__cell_in_between: o,
      "dp--highlighted": i
    }
  };
})), lr = (n, e, t = !1) => {
  n && e.allowStopPropagation && (t && n.stopImmediatePropagation(), n.stopPropagation());
}, wv = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function kv(n, e) {
  let t = [...document.querySelectorAll(wv())];
  t = t.filter((s) => !n.contains(s) || s.hasAttribute("data-datepicker-instance"));
  const r = t.indexOf(n);
  if (r >= 0 && (e ? r - 1 >= 0 : r + 1 <= t.length))
    return t[r + (e ? -1 : 1)];
}
const Qi = (n, e) => n == null ? void 0 : n.querySelector(`[data-dp-element="${e}"]`), tf = (n, e) => new Intl.NumberFormat(e, { useGrouping: !1, style: "decimal" }).format(n), ql = (n, e) => Pn(n, e ?? ls.DATE), li = (n) => Array.isArray(n), ja = (n, e, t) => e.get(ql(n, t)), xv = (n, e) => n ? e ? e instanceof Map ? !!ja(n, e) : e(ee(n)) : !1 : !0, jt = (n, e, t = !1, r) => {
  if (n.key === et.enter || n.key === et.space)
    return t && n.preventDefault(), e();
  if (r) return r(n);
}, Mv = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, nf = (n, e) => n ? ls.MONTH_AND_YEAR : e ? ls.YEAR : ls.DATE, rf = (n) => n < 10 ? `0${n}` : n, Xu = (n, e, t, r, s, a) => {
  const o = Gi(n, e.slice(0, n.length), /* @__PURE__ */ new Date(), { locale: a });
  return Bs(o) && Nd(o) ? r || s ? o : Ke(o, {
    hours: +t.hours,
    minutes: +(t == null ? void 0 : t.minutes),
    seconds: +(t == null ? void 0 : t.seconds),
    milliseconds: 0
  }) : null;
}, Sv = (n, e, t, r, s, a) => {
  const o = Array.isArray(t) ? t[0] : t;
  if (typeof e == "string")
    return Xu(n, e, o, r, s, a);
  if (Array.isArray(e)) {
    let i = null;
    for (const l of e)
      if (i = Xu(n, l, o, r, s, a), i)
        break;
    return i;
  }
  return typeof e == "function" ? e(n) : null;
}, ee = (n) => n ? new Date(n) : /* @__PURE__ */ new Date(), Tv = (n, e, t) => {
  if (e) {
    const s = (n.getMonth() + 1).toString().padStart(2, "0"), a = n.getDate().toString().padStart(2, "0"), o = n.getHours().toString().padStart(2, "0"), i = n.getMinutes().toString().padStart(2, "0"), l = t ? n.getSeconds().toString().padStart(2, "0") : "00";
    return `${n.getFullYear()}-${s}-${a}T${o}:${i}:${l}.000Z`;
  }
  const r = Date.UTC(
    n.getUTCFullYear(),
    n.getUTCMonth(),
    n.getUTCDate(),
    n.getUTCHours(),
    n.getUTCMinutes(),
    n.getUTCSeconds()
  );
  return new Date(r).toISOString();
}, Et = (n, e) => {
  const t = ee(JSON.parse(JSON.stringify(n))), r = Ke(t, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return e ? yg(r) : r;
}, ur = (n, e, t, r) => {
  let s = n ? ee(n) : ee();
  return (e || e === 0) && (s = lv(s, +e)), (t || t === 0) && (s = uv(s, +t)), (r || r === 0) && (s = Gd(s, +r)), Kd(s, 0);
}, lt = (n, e) => !n || !e ? !1 : ps(Et(n), Et(e)), He = (n, e) => !n || !e ? !1 : as(Et(n), Et(e)), ht = (n, e) => !n || !e ? !1 : Fr(Et(n), Et(e)), Zs = (n, e, t) => n != null && n[0] && n != null && n[1] ? ht(t, n[0]) && lt(t, n[1]) : n != null && n[0] && e ? ht(t, n[0]) && lt(t, e) || lt(t, n[0]) && ht(t, e) : !1, yn = (n) => {
  const e = Ke(new Date(n), { date: 1 });
  return Et(e);
}, ui = (n, e, t) => e && (t || t === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((r) => r === e ? [r, t] : [r, isNaN(+n[r]) ? void 0 : +n[r]])
) : {
  hours: isNaN(+n.hours) ? void 0 : +n.hours,
  minutes: isNaN(+n.minutes) ? void 0 : +n.minutes,
  seconds: isNaN(+n.seconds) ? void 0 : +n.seconds
}, Nr = (n) => ({
  hours: Un(n),
  minutes: mr(n),
  seconds: hs(n)
}), sf = (n, e) => {
  if (e) {
    const t = _e(ee(e));
    if (t > n) return 12;
    if (t === n) return Ve(ee(e));
  }
}, af = (n, e) => {
  if (e) {
    const t = _e(ee(e));
    return t < n ? -1 : t === n ? Ve(ee(e)) : void 0;
  }
}, ys = (n) => {
  if (n) return _e(ee(n));
}, of = (n, e) => {
  const t = ht(n, e) ? e : n, r = ht(e, n) ? e : n;
  return Rd({ start: t, end: r });
}, Cv = (n) => {
  const e = wn(n, 1);
  return { month: Ve(e), year: _e(e) };
}, Vn = (n, e) => {
  const t = kn(n, { weekStartsOn: +e }), r = Ld(n, { weekStartsOn: +e });
  return [t, r];
}, lf = (n, e) => {
  const t = {
    hours: Un(ee()),
    minutes: mr(ee()),
    seconds: e ? hs(ee()) : 0
  };
  return Object.assign(t, n);
}, sr = (n, e, t) => [Ke(ee(n), { date: 1 }), Ke(ee(), { month: e, year: t, date: 1 })], Hn = (n, e, t) => {
  let r = n ? ee(n) : ee();
  return (e || e === 0) && (r = qd(r, e)), t && (r = En(r, t)), r;
}, uf = (n, e, t, r, s) => {
  if (!r || s && !e || !s && !t) return !1;
  const a = s ? wn(n, 1) : ms(n, 1), o = [Ve(a), _e(a)];
  return s ? !Dv(...o, e) : !Av(...o, t);
}, Av = (n, e, t) => lt(...sr(t, n, e)) || He(...sr(t, n, e)), Dv = (n, e, t) => ht(...sr(t, n, e)) || He(...sr(t, n, e)), cf = (n, e, t, r, s, a, o) => {
  if (typeof e == "function" && !o) return e(n);
  const i = t ? { locale: t } : void 0;
  return Array.isArray(n) ? `${Pn(n[0], a, i)}${s && !n[1] ? "" : r}${n[1] ? Pn(n[1], a, i) : ""}` : Pn(n, a, i);
}, Qr = (n) => {
  if (n) return null;
  throw new Error(Ul.prop("partial-range"));
}, Ma = (n, e) => {
  if (e) return n();
  throw new Error(Ul.prop("range"));
}, Xi = (n) => Array.isArray(n) ? Bs(n[0]) && (n[1] ? Bs(n[1]) : !0) : n ? Bs(n) : !1, Ov = (n, e) => Ke(e ?? ee(), {
  hours: +n.hours || 0,
  minutes: +n.minutes || 0,
  seconds: +n.seconds || 0
}), ci = (n, e, t, r) => {
  if (!n) return !0;
  if (r) {
    const s = t === "max" ? ps(n, e) : Fr(n, e), a = { seconds: 0, milliseconds: 0 };
    return s || as(Ke(n, a), Ke(e, a));
  }
  return t === "max" ? n.getTime() <= e.getTime() : n.getTime() >= e.getTime();
}, di = (n, e, t) => n ? Ov(n, e) : ee(t ?? e), Zu = (n, e, t, r, s) => {
  if (Array.isArray(r)) {
    const o = di(n, r[0], e), i = di(n, r[1], e);
    return ci(r[0], o, t, !!e) && ci(r[1], i, t, !!e) && s;
  }
  const a = di(n, r, e);
  return ci(r, a, t, !!e) && s;
}, fi = (n) => Ke(ee(), Nr(n)), Ev = (n, e, t) => {
  if (n instanceof Map) {
    const r = `${rf(t + 1)}-${e}`;
    return n.size ? n.has(r) : !1;
  }
  return typeof n == "function" ? n(Et(Ke(ee(), { month: t, year: e }), !0)) : !1;
}, Pv = (n, e, t) => {
  if (n instanceof Map) {
    const r = `${rf(t + 1)}-${e}`;
    return n.size ? n.has(r) : !0;
  }
  return !0;
}, df = (n, e, t) => typeof n == "function" ? n({ month: e, year: t }) : !!n.months.find((r) => r.month === e && r.year === t), Kl = (n, e) => typeof n == "function" ? n(e) : n.years.includes(e), Zi = (n) => `dp-${Pn(n, "yyyy-MM-dd")}`, ec = (n, e) => {
  const t = Ud(Et(e), n), r = fn(Et(e), n);
  return { before: t, after: r };
}, Es = Ts({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), ff = () => {
  const n = (t) => {
    Es.menuFocused = t;
  }, e = (t) => {
    Es.shiftKeyInMenu !== t && (Es.shiftKeyInMenu = t);
  };
  return {
    control: G(() => ({ shiftKeyInMenu: Es.shiftKeyInMenu, menuFocused: Es.menuFocused })),
    setMenuFocused: n,
    setShiftKey: e
  };
}, Ze = Ts({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), hi = W(null), Sa = W(!1), pi = W(!1), mi = W(!1), gi = W(!1), Bt = W(0), ft = W(0), vr = () => {
  const n = G(() => Sa.value ? [...Ze.selectionGrid, Ze.actionRow].filter((d) => d.length) : pi.value ? [
    ...Ze.timePicker[0],
    ...Ze.timePicker[1],
    gi.value ? [] : [hi.value],
    Ze.actionRow
  ].filter((d) => d.length) : mi.value ? [...Ze.monthPicker, Ze.actionRow] : [Ze.monthYear, ...Ze.calendar, Ze.time, Ze.actionRow].filter((d) => d.length)), e = (d) => {
    Bt.value = d ? Bt.value + 1 : Bt.value - 1;
    let f = null;
    n.value[ft.value] && (f = n.value[ft.value][Bt.value]), !f && n.value[ft.value + (d ? 1 : -1)] ? (ft.value = ft.value + (d ? 1 : -1), Bt.value = d ? 0 : n.value[ft.value].length - 1) : f || (Bt.value = d ? Bt.value - 1 : Bt.value + 1);
  }, t = (d) => {
    ft.value === 0 && !d || ft.value === n.value.length && d || (ft.value = d ? ft.value + 1 : ft.value - 1, n.value[ft.value] ? n.value[ft.value] && !n.value[ft.value][Bt.value] && Bt.value !== 0 && (Bt.value = n.value[ft.value].length - 1) : ft.value = d ? ft.value - 1 : ft.value + 1);
  }, r = (d) => {
    let f = null;
    n.value[ft.value] && (f = n.value[ft.value][Bt.value]), f ? f.focus({ preventScroll: !Sa.value }) : Bt.value = d ? Bt.value - 1 : Bt.value + 1;
  }, s = () => {
    e(!0), r(!0);
  }, a = () => {
    e(!1), r(!1);
  }, o = () => {
    t(!1), r(!0);
  }, i = () => {
    t(!0), r(!0);
  }, l = (d, f) => {
    Ze[f] = d;
  }, u = (d, f) => {
    Ze[f] = d;
  }, c = () => {
    Bt.value = 0, ft.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (d) => {
      hi.value = d;
    },
    setSelectionGrid: (d) => {
      Sa.value = d, c(), d || (Ze.selectionGrid = []);
    },
    setTimePicker: (d, f = !1) => {
      pi.value = d, gi.value = f, c(), d || (Ze.timePicker[0] = [], Ze.timePicker[1] = []);
    },
    setTimePickerElements: (d, f = 0) => {
      Ze.timePicker[f] = d;
    },
    arrowRight: s,
    arrowLeft: a,
    arrowUp: o,
    arrowDown: i,
    clearArrowNav: () => {
      Ze.monthYear = [], Ze.calendar = [], Ze.time = [], Ze.actionRow = [], Ze.selectionGrid = [], Ze.timePicker[0] = [], Ze.timePicker[1] = [], Sa.value = !1, pi.value = !1, gi.value = !1, mi.value = !1, c(), hi.value = null;
    },
    setMonthPicker: (d) => {
      mi.value = d, c();
    },
    refSets: Ze
    // exposed for testing
  };
}, tc = (n) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...n ?? {}
}), _v = (n) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`,
  ...n ?? {}
}), nc = (n) => n ? typeof n == "boolean" ? n ? 2 : 0 : +n >= 2 ? +n : 2 : 0, Nv = (n) => {
  const e = typeof n == "object" && n, t = {
    static: !0,
    solo: !1
  };
  if (!n) return { ...t, count: nc(!1) };
  const r = e ? n : {}, s = e ? r.count ?? !0 : n, a = nc(s);
  return Object.assign(t, r, { count: a });
}, Iv = (n, e, t) => n || (typeof t == "string" ? t : e), Rv = (n) => typeof n == "boolean" ? n ? tc({}) : !1 : tc(n), $v = (n) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - ",
    escClose: !0
  };
  return typeof n == "object" ? { ...e, ...n ?? {}, enabled: !0 } : { ...e, enabled: n };
}, Lv = (n) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...n ?? {}
}), Bv = (n) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...n ?? {}
}), Fv = (n) => {
  const e = { input: !1 };
  return typeof n == "object" ? { ...e, ...n ?? {}, enabled: !0 } : {
    enabled: n,
    ...e
  };
}, zv = (n) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...n ?? {} }), Vv = (n) => {
  const e = {
    dates: Array.isArray(n) ? n.map((t) => ee(t)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof n == "function" ? n : { ...e, ...n ?? {} };
}, Hv = (n) => typeof n == "object" ? {
  type: (n == null ? void 0 : n.type) ?? "local",
  hideOnOffsetDates: (n == null ? void 0 : n.hideOnOffsetDates) ?? !1
} : {
  type: n,
  hideOnOffsetDates: !1
}, Yv = (n) => {
  const e = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof n == "object" ? { enabled: !0, ...e, ...n } : {
    enabled: n,
    ...e
  };
}, Wv = (n) => n ? typeof n == "string" ? {
  timezone: n,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: n.timezone,
  exactMatch: n.exactMatch ?? !1,
  dateInTz: n.dateInTz ?? void 0,
  emitTimezone: n.emitTimezone ?? void 0,
  convertModel: n.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, yi = (n, e, t, r) => new Map(
  n.map((s) => {
    const a = Wl(s, e, r);
    return [ql(a, t), a];
  })
), jv = (n, e) => n.length ? new Map(
  n.map((t) => {
    const r = Wl(t.date, e);
    return [ql(r, ls.DATE), t];
  })
) : null, Uv = (n) => {
  var e;
  const t = nf(n.isMonthPicker, n.isYearPicker);
  return {
    minDate: Ji(n.minDate, n.timezone, n.isSpecific),
    maxDate: Ji(n.maxDate, n.timezone, n.isSpecific),
    disabledDates: li(n.disabledDates) ? yi(n.disabledDates, n.timezone, t, n.isSpecific) : n.disabledDates,
    allowedDates: li(n.allowedDates) ? yi(n.allowedDates, n.timezone, t, n.isSpecific) : null,
    highlight: typeof n.highlight == "object" && li((e = n.highlight) == null ? void 0 : e.dates) ? yi(n.highlight.dates, n.timezone, t) : n.highlight,
    markers: jv(n.markers, n.timezone)
  };
}, qv = (n) => typeof n == "boolean" ? { enabled: n, dragSelect: !0, limit: null } : {
  enabled: !!n,
  limit: n.limit ? +n.limit : null,
  dragSelect: n.dragSelect ?? !0
}, Kv = (n) => ({
  ...Object.fromEntries(
    Object.keys(n).map((e) => {
      const t = e, r = n[t], s = typeof n[t] == "string" ? { [r]: !0 } : Object.fromEntries(r.map((a) => [a, !0]));
      return [e, s];
    })
  )
}), rt = (n) => {
  const e = () => {
    const I = n.enableSeconds ? ":ss" : "", x = n.enableMinutes ? ":mm" : "";
    return n.is24 ? `HH${x}${I}` : `hh${x}${I} aa`;
  }, t = () => {
    var I;
    return n.format ? n.format : n.monthPicker ? "MM/yyyy" : n.timePicker ? e() : n.weekPicker ? `${((I = y.value) == null ? void 0 : I.type) === "iso" ? "II" : "ww"}-RR` : n.yearPicker ? "yyyy" : n.quarterPicker ? "QQQ/yyyy" : n.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy";
  }, r = (I) => lf(I, n.enableSeconds), s = () => S.value.enabled ? n.startTime && Array.isArray(n.startTime) ? [r(n.startTime[0]), r(n.startTime[1])] : null : n.startTime && !Array.isArray(n.startTime) ? r(n.startTime) : null, a = G(() => Nv(n.multiCalendars)), o = G(() => s()), i = G(() => _v(n.ariaLabels)), l = G(() => Lv(n.filters)), u = G(() => Rv(n.transitions)), c = G(() => Bv(n.actionRow)), d = G(
    () => Iv(n.previewFormat, n.format, t())
  ), f = G(() => $v(n.textInput)), h = G(() => Fv(n.inline)), p = G(() => zv(n.config)), g = G(() => Vv(n.highlight)), y = G(() => Hv(n.weekNumbers)), v = G(() => Wv(n.timezone)), C = G(() => qv(n.multiDates)), M = G(
    () => Uv({
      minDate: n.minDate,
      maxDate: n.maxDate,
      disabledDates: n.disabledDates,
      allowedDates: n.allowedDates,
      highlight: g.value,
      markers: n.markers,
      timezone: v.value,
      isSpecific: n.monthPicker || n.yearPicker || n.quarterPicker,
      isMonthPicker: n.monthPicker,
      isYearPicker: n.yearPicker
    })
  ), S = G(() => Yv(n.range)), D = G(() => Kv(n.ui));
  return {
    defaultedTransitions: u,
    defaultedMultiCalendars: a,
    defaultedStartTime: o,
    defaultedAriaLabels: i,
    defaultedFilters: l,
    defaultedActionRow: c,
    defaultedPreviewFormat: d,
    defaultedTextInput: f,
    defaultedInline: h,
    defaultedConfig: p,
    defaultedHighlight: g,
    defaultedWeekNumbers: y,
    defaultedRange: S,
    propDates: M,
    defaultedTz: v,
    defaultedMultiDates: C,
    defaultedUI: D,
    getDefaultPattern: t,
    getDefaultStartTime: s,
    handleEventPropagation: (I) => {
      p.value.allowStopPropagation && I.stopPropagation(), p.value.allowPreventDefault && I.preventDefault();
    }
  };
}, Gv = (n, e, t) => {
  const r = W(), { defaultedTextInput: s, defaultedRange: a, defaultedTz: o, defaultedMultiDates: i, getDefaultPattern: l } = rt(e), u = W(""), c = Js(e, "format"), d = Js(e, "formatLocale");
  $t(
    r,
    () => {
      typeof e.onInternalModelChange == "function" && n("internal-model-change", r.value, X(!0));
    },
    { deep: !0 }
  ), $t(a, (m, A) => {
    m.enabled !== A.enabled && (r.value = null);
  }), $t(c, () => {
    ue();
  });
  const f = (m) => o.value.timezone && o.value.convertModel ? en(m, o.value.timezone) : m, h = (m) => {
    if (o.value.timezone && o.value.convertModel) {
      const A = hv(o.value.timezone, m);
      return cg(m, A);
    }
    return m;
  }, p = (m, A, j = !1) => cf(
    m,
    e.format,
    e.formatLocale,
    s.value.rangeSeparator,
    e.modelAuto,
    A ?? l(),
    j
  ), g = (m) => m ? e.modelType ? ie(m) : {
    hours: Un(m),
    minutes: mr(m),
    seconds: e.enableSeconds ? hs(m) : 0
  } : null, y = (m) => e.modelType ? ie(m) : { month: Ve(m), year: _e(m) }, v = (m) => Array.isArray(m) ? i.value.enabled ? m.map((A) => C(A, En(ee(), A))) : Ma(
    () => [
      En(ee(), m[0]),
      m[1] ? En(ee(), m[1]) : Qr(a.value.partialRange)
    ],
    a.value.enabled
  ) : En(ee(), +m), C = (m, A) => (typeof m == "string" || typeof m == "number") && e.modelType ? q(m) : A, M = (m) => Array.isArray(m) ? [
    C(
      m[0],
      ur(null, +m[0].hours, +m[0].minutes, m[0].seconds)
    ),
    C(
      m[1],
      ur(null, +m[1].hours, +m[1].minutes, m[1].seconds)
    )
  ] : C(m, ur(null, m.hours, m.minutes, m.seconds)), S = (m) => {
    const A = Ke(ee(), { date: 1 });
    return Array.isArray(m) ? i.value.enabled ? m.map((j) => C(j, Hn(A, +j.month, +j.year))) : Ma(
      () => [
        C(m[0], Hn(A, +m[0].month, +m[0].year)),
        C(
          m[1],
          m[1] ? Hn(A, +m[1].month, +m[1].year) : Qr(a.value.partialRange)
        )
      ],
      a.value.enabled
    ) : C(m, Hn(A, +m.month, +m.year));
  }, D = (m) => {
    if (Array.isArray(m))
      return m.map((A) => q(A));
    throw new Error(Ul.dateArr("multi-dates"));
  }, I = (m) => {
    if (Array.isArray(m) && a.value.enabled) {
      const A = m[0], j = m[1];
      return [
        ee(Array.isArray(A) ? A[0] : null),
        Array.isArray(j) && j.length ? ee(j[0]) : null
      ];
    }
    return ee(m[0]);
  }, x = (m) => e.modelAuto ? Array.isArray(m) ? [q(m[0]), q(m[1])] : e.autoApply ? [q(m)] : [q(m), null] : Array.isArray(m) ? Ma(
    () => m[1] ? [
      q(m[0]),
      m[1] ? q(m[1]) : Qr(a.value.partialRange)
    ] : [q(m[0])],
    a.value.enabled
  ) : q(m), k = () => {
    Array.isArray(r.value) && a.value.enabled && r.value.length === 1 && r.value.push(Qr(a.value.partialRange));
  }, _ = () => {
    const m = r.value;
    return [
      ie(m[0]),
      m[1] ? ie(m[1]) : Qr(a.value.partialRange)
    ];
  }, E = () => Array.isArray(r.value) ? r.value[1] ? _() : ie(St(r.value[0])) : [], ne = () => (r.value || []).map((m) => ie(m)), de = (m = !1) => (m || k(), e.modelAuto ? E() : i.value.enabled ? ne() : Array.isArray(r.value) ? Ma(() => _(), a.value.enabled) : ie(St(r.value))), be = (m) => !m || Array.isArray(m) && !m.length ? null : e.timePicker ? M(St(m)) : e.monthPicker ? S(St(m)) : e.yearPicker ? v(St(m)) : i.value.enabled ? D(St(m)) : e.weekPicker ? I(St(m)) : x(St(m)), R = (m) => {
    const A = be(m);
    Xi(St(A)) ? (r.value = St(A), ue()) : (r.value = null, u.value = "");
  }, F = () => {
    const m = (A) => Pn(A, s.value.format);
    return `${m(r.value[0])} ${s.value.rangeSeparator} ${r.value[1] ? m(r.value[1]) : ""}`;
  }, $ = () => t.value && r.value ? Array.isArray(r.value) ? F() : Pn(r.value, s.value.format) : p(r.value), U = () => r.value ? i.value.enabled ? r.value.map((m) => p(m)).join("; ") : s.value.enabled && typeof s.value.format == "string" ? $() : p(r.value) : "", ue = () => {
    !e.format || typeof e.format == "string" || s.value.enabled && typeof s.value.format == "string" ? u.value = U() : u.value = e.format(r.value);
  }, q = (m) => {
    if (e.utc) {
      const A = new Date(m);
      return e.utc === "preserve" ? new Date(A.getTime() + A.getTimezoneOffset() * 6e4) : A;
    }
    return e.modelType ? pv.includes(e.modelType) ? f(new Date(m)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? f(
      Gi(m, l(), /* @__PURE__ */ new Date(), { locale: d.value })
    ) : f(
      Gi(m, e.modelType, /* @__PURE__ */ new Date(), { locale: d.value })
    ) : f(new Date(m));
  }, ie = (m) => m ? e.utc ? Tv(m, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +h(m) : e.modelType === "iso" ? h(m).toISOString() : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? p(h(m)) : p(h(m), e.modelType, !0) : h(m) : "", Y = (m, A = !1, j = !1) => {
    if (j) return m;
    if (n("update:model-value", m), o.value.emitTimezone && A) {
      const ge = Array.isArray(m) ? m.map((z) => en(St(z), o.value.emitTimezone)) : en(St(m), o.value.emitTimezone);
      n("update:model-timezone-value", ge);
    }
  }, ve = (m) => Array.isArray(r.value) ? i.value.enabled ? r.value.map((A) => m(A)) : [
    m(r.value[0]),
    r.value[1] ? m(r.value[1]) : Qr(a.value.partialRange)
  ] : m(St(r.value)), P = () => {
    if (Array.isArray(r.value)) {
      const m = Vn(r.value[0], e.weekStart), A = r.value[1] ? Vn(r.value[1], e.weekStart) : [];
      return [m.map((j) => ee(j)), A.map((j) => ee(j))];
    }
    return Vn(r.value, e.weekStart).map((m) => ee(m));
  }, V = (m, A) => Y(St(ve(m)), !1, A), K = (m) => {
    const A = P();
    return m ? A : n("update:model-value", P());
  }, X = (m = !1) => (m || ue(), e.monthPicker ? V(y, m) : e.timePicker ? V(g, m) : e.yearPicker ? V(_e, m) : e.weekPicker ? K(m) : Y(de(m), !0, m));
  return {
    inputValue: u,
    internalModelValue: r,
    checkBeforeEmit: () => r.value ? a.value.enabled ? a.value.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
    parseExternalModelValue: R,
    formatInputValue: ue,
    emitModelValue: X
  };
}, Jv = (n, e) => {
  const { defaultedFilters: t, propDates: r } = rt(n), { validateMonthYearInRange: s } = br(n), a = (c, d) => {
    let f = c;
    return t.value.months.includes(Ve(f)) ? (f = d ? wn(c, 1) : ms(c, 1), a(f, d)) : f;
  }, o = (c, d) => {
    let f = c;
    return t.value.years.includes(_e(f)) ? (f = d ? Nl(c, 1) : Jd(c, 1), o(f, d)) : f;
  }, i = (c, d = !1) => {
    const f = Ke(ee(), { month: n.month, year: n.year });
    let h = c ? wn(f, 1) : ms(f, 1);
    n.disableYearSelect && (h = En(h, n.year));
    let p = Ve(h), g = _e(h);
    t.value.months.includes(p) && (h = a(h, c), p = Ve(h), g = _e(h)), t.value.years.includes(g) && (h = o(h, c), g = _e(h)), s(p, g, c, n.preventMinMaxNavigation) && l(p, g, d);
  }, l = (c, d, f) => {
    e("update-month-year", { month: c, year: d, fromNav: f });
  }, u = G(() => (c) => uf(
    Ke(ee(), { month: n.month, year: n.year }),
    r.value.maxDate,
    r.value.minDate,
    n.preventMinMaxNavigation,
    c
  ));
  return { handleMonthYearChange: i, isDisabled: u, updateMonthYear: l };
}, $o = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  alwaysClearable: { type: Boolean, default: !1 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, Mn = {
  ...$o,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, Qv = ["title"], Xv = ["disabled"], Zv = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...Mn
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(n, { emit: e }) {
    const t = e, r = n, {
      defaultedActionRow: s,
      defaultedPreviewFormat: a,
      defaultedMultiCalendars: o,
      defaultedTextInput: i,
      defaultedInline: l,
      defaultedRange: u,
      defaultedMultiDates: c
    } = rt(r), { isTimeValid: d, isMonthValid: f } = br(r), { buildMatrix: h } = vr(), p = W(null), g = W(null), y = W(!1), v = W({}), C = W(null), M = W(null);
    Pt(() => {
      r.arrowNavigation && h([vt(p), vt(g)], "actionRow"), S(), window.addEventListener("resize", S);
    }), jr(() => {
      window.removeEventListener("resize", S);
    });
    const S = () => {
      y.value = !1, setTimeout(() => {
        var R, F;
        const $ = (R = C.value) == null ? void 0 : R.getBoundingClientRect(), U = (F = M.value) == null ? void 0 : F.getBoundingClientRect();
        $ && U && (v.value.maxWidth = `${U.width - $.width - 20}px`), y.value = !0;
      }, 0);
    }, D = G(() => u.value.enabled && !u.value.partialRange && r.internalModelValue ? r.internalModelValue.length === 2 : !0), I = G(
      () => !d.value(r.internalModelValue) || !f.value(r.internalModelValue) || !D.value
    ), x = () => {
      const R = a.value;
      return r.timePicker || r.monthPicker, R(St(r.internalModelValue));
    }, k = () => {
      const R = r.internalModelValue;
      return o.value.count > 0 ? `${_(R[0])} - ${_(R[1])}` : [_(R[0]), _(R[1])];
    }, _ = (R) => cf(
      R,
      a.value,
      r.formatLocale,
      i.value.rangeSeparator,
      r.modelAuto,
      a.value
    ), E = G(() => !r.internalModelValue || !r.menuMount ? "" : typeof a.value == "string" ? Array.isArray(r.internalModelValue) ? r.internalModelValue.length === 2 && r.internalModelValue[1] ? k() : c.value.enabled ? r.internalModelValue.map((R) => `${_(R)}`) : r.modelAuto ? `${_(r.internalModelValue[0])}` : `${_(r.internalModelValue[0])} -` : _(r.internalModelValue) : x()), ne = () => c.value.enabled ? "; " : " - ", de = G(
      () => Array.isArray(E.value) ? E.value.join(ne()) : E.value
    ), be = () => {
      d.value(r.internalModelValue) && f.value(r.internalModelValue) && D.value ? t("select-date") : t("invalid-select");
    };
    return (R, F) => (T(), N("div", {
      ref_key: "actionRowRef",
      ref: M,
      class: "dp__action_row"
    }, [
      R.$slots["action-row"] ? fe(R.$slots, "action-row", Ct(Mt({ key: 0 }, {
        internalModelValue: R.internalModelValue,
        disabled: I.value,
        selectDate: () => R.$emit("select-date"),
        closePicker: () => R.$emit("close-picker")
      }))) : (T(), N(Ee, { key: 1 }, [
        b(s).showPreview ? (T(), N("div", {
          key: 0,
          class: "dp__selection_preview",
          title: de.value,
          style: Zt(v.value)
        }, [
          R.$slots["action-preview"] && y.value ? fe(R.$slots, "action-preview", {
            key: 0,
            value: R.internalModelValue
          }) : H("", !0),
          !R.$slots["action-preview"] && y.value ? (T(), N(Ee, { key: 1 }, [
            wt(Ce(de.value), 1)
          ], 64)) : H("", !0)
        ], 12, Qv)) : H("", !0),
        O("div", {
          ref_key: "actionBtnContainer",
          ref: C,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          R.$slots["action-buttons"] ? fe(R.$slots, "action-buttons", {
            key: 0,
            value: R.internalModelValue
          }) : H("", !0),
          R.$slots["action-buttons"] ? H("", !0) : (T(), N(Ee, { key: 1 }, [
            !b(l).enabled && b(s).showCancel ? (T(), N("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: p,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: F[0] || (F[0] = ($) => R.$emit("close-picker")),
              onKeydown: F[1] || (F[1] = ($) => b(jt)($, () => R.$emit("close-picker")))
            }, Ce(R.cancelText), 545)) : H("", !0),
            b(s).showNow ? (T(), N("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: F[2] || (F[2] = ($) => R.$emit("select-now")),
              onKeydown: F[3] || (F[3] = ($) => b(jt)($, () => R.$emit("select-now")))
            }, Ce(R.nowButtonLabel), 33)) : H("", !0),
            b(s).showSelect ? (T(), N("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: g,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: I.value,
              "data-test-id": "select-button",
              onKeydown: F[4] || (F[4] = ($) => b(jt)($, () => be())),
              onClick: be
            }, Ce(R.selectText), 41, Xv)) : H("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), e0 = ["role", "aria-label", "tabindex"], t0 = { class: "dp__selection_grid_header" }, n0 = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], r0 = ["aria-label"], pa = /* @__PURE__ */ Fe({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(n, { expose: e, emit: t }) {
    const { setSelectionGrid: r, buildMultiLevelMatrix: s, setMonthPicker: a } = vr(), o = t, i = n, { defaultedAriaLabels: l, defaultedTextInput: u, defaultedConfig: c, handleEventPropagation: d } = rt(
      i
    ), { hideNavigationButtons: f } = Fo(), h = W(!1), p = W(null), g = W(null), y = W([]), v = W(), C = W(null), M = W(0), S = W(null);
    sm(() => {
      p.value = null;
    }), Pt(() => {
      kt().then(() => de()), i.noOverlayFocus || I(), D(!0);
    }), jr(() => D(!1));
    const D = (P) => {
      var V;
      i.arrowNavigation && ((V = i.headerRefs) != null && V.length ? a(P) : r(P));
    }, I = () => {
      var P;
      const V = vt(g);
      V && (u.value.enabled || (p.value ? (P = p.value) == null || P.focus({ preventScroll: !0 }) : V.focus({ preventScroll: !0 })), h.value = V.clientHeight < V.scrollHeight);
    }, x = G(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !i.useRelative,
        "dp--overlay-relative": i.useRelative
      })
    ), k = G(
      () => i.useRelative ? { height: `${i.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), _ = G(() => ({
      dp__overlay_col: !0
    })), E = G(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: h.value,
        dp__button_bottom: i.isLast
      })
    ), ne = G(() => {
      var P, V;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((P = i.items) == null ? void 0 : P.length) <= 6,
        dp__container_block: ((V = i.items) == null ? void 0 : V.length) > 6
      };
    });
    $t(
      () => i.items,
      () => de(!1),
      { deep: !0 }
    );
    const de = (P = !0) => {
      kt().then(() => {
        const V = vt(p), K = vt(g), X = vt(C), m = vt(S), A = X ? X.getBoundingClientRect().height : 0;
        K && (K.getBoundingClientRect().height ? M.value = K.getBoundingClientRect().height - A : M.value = c.value.modeHeight - A), V && m && P && (m.scrollTop = V.offsetTop - m.offsetTop - (M.value / 2 - V.getBoundingClientRect().height) - A);
      });
    }, be = (P) => {
      P.disabled || o("selected", P.value);
    }, R = () => {
      o("toggle"), o("reset-flow");
    }, F = (P) => {
      i.escClose && (R(), d(P));
    }, $ = (P, V, K, X) => {
      P && ((V.active || V.value === i.focusValue) && (p.value = P), i.arrowNavigation && (Array.isArray(y.value[K]) ? y.value[K][X] = P : y.value[K] = [P], U()));
    }, U = () => {
      var P, V;
      const K = (P = i.headerRefs) != null && P.length ? [i.headerRefs].concat(y.value) : y.value.concat([i.skipButtonRef ? [] : [C.value]]);
      s(St(K), (V = i.headerRefs) != null && V.length ? "monthPicker" : "selectionGrid");
    }, ue = (P) => {
      i.arrowNavigation || lr(P, c.value, !0);
    }, q = (P) => {
      v.value = P, o("hover-value", P);
    }, ie = () => {
      if (R(), !i.isLast) {
        const P = Qi(i.menuWrapRef ?? null, "action-row");
        if (P) {
          const V = ef(P);
          V == null || V.focus();
        }
      }
    }, Y = (P) => {
      switch (P.key) {
        case et.esc:
          return F(P);
        case et.arrowLeft:
          return ue(P);
        case et.arrowRight:
          return ue(P);
        case et.arrowUp:
          return ue(P);
        case et.arrowDown:
          return ue(P);
        default:
          return;
      }
    }, ve = (P) => {
      if (P.key === et.enter) return R();
      if (P.key === et.tab) return ie();
    };
    return e({ focusGrid: I }), (P, V) => {
      var K;
      return T(), N("div", {
        ref_key: "gridWrapRef",
        ref: g,
        class: pe(x.value),
        style: Zt(k.value),
        role: P.useRelative ? void 0 : "dialog",
        "aria-label": P.overlayLabel,
        tabindex: P.useRelative ? void 0 : "0",
        onKeydown: Y,
        onClick: V[0] || (V[0] = Qt(() => {
        }, ["prevent"]))
      }, [
        O("div", {
          ref_key: "containerRef",
          ref: S,
          class: pe(ne.value),
          style: Zt({ "--dp-overlay-height": `${M.value}px` }),
          role: "grid"
        }, [
          O("div", t0, [
            fe(P.$slots, "header")
          ]),
          P.$slots.overlay ? fe(P.$slots, "overlay", { key: 0 }) : (T(!0), N(Ee, { key: 1 }, Ye(P.items, (X, m) => (T(), N("div", {
            key: m,
            class: pe(["dp__overlay_row", { dp__flex_row: P.items.length >= 3 }]),
            role: "row"
          }, [
            (T(!0), N(Ee, null, Ye(X, (A, j) => (T(), N("div", {
              key: A.value,
              ref_for: !0,
              ref: (ge) => $(ge, A, m, j),
              role: "gridcell",
              class: pe(_.value),
              "aria-selected": A.active || void 0,
              "aria-disabled": A.disabled || void 0,
              tabindex: "0",
              "data-test-id": A.text,
              onClick: Qt((ge) => be(A), ["prevent"]),
              onKeydown: (ge) => b(jt)(ge, () => be(A), !0),
              onMouseover: (ge) => q(A.value)
            }, [
              O("div", {
                class: pe(A.className)
              }, [
                P.$slots.item ? fe(P.$slots, "item", {
                  key: 0,
                  item: A
                }) : H("", !0),
                P.$slots.item ? H("", !0) : (T(), N(Ee, { key: 1 }, [
                  wt(Ce(A.text), 1)
                ], 64))
              ], 2)
            ], 42, n0))), 128))
          ], 2))), 128))
        ], 6),
        P.$slots["button-icon"] ? pt((T(), N("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: C,
          type: "button",
          "aria-label": (K = b(l)) == null ? void 0 : K.toggleOverlay,
          class: pe(E.value),
          tabindex: "0",
          onClick: R,
          onKeydown: ve
        }, [
          fe(P.$slots, "button-icon")
        ], 42, r0)), [
          [Ls, !b(f)(P.hideNavigation, P.type)]
        ]) : H("", !0)
      ], 46, e0);
    };
  }
}), s0 = ["data-dp-mobile"], Lo = /* @__PURE__ */ Fe({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(n) {
    const e = n, t = G(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), r = G(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (s, a) => (T(), N("div", {
      class: pe({
        dp__menu_inner: !s.stretch,
        "dp--menu--inner-stretched": s.stretch,
        dp__flex_display: s.multiCalendars > 0,
        "dp--flex-display-collapsed": s.collapse
      }),
      "data-dp-mobile": s.isMobile
    }, [
      (T(!0), N(Ee, null, Ye(t.value, (o, i) => (T(), N("div", {
        key: o,
        class: pe(r.value)
      }, [
        fe(s.$slots, "default", {
          instance: o,
          index: i
        })
      ], 2))), 128))
    ], 10, s0));
  }
}), a0 = ["data-dp-element", "aria-label", "aria-disabled"], Fs = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(n, { emit: e }) {
    const t = e, r = W(null);
    return Pt(() => t("set-ref", r)), (s, a) => (T(), N("button", {
      ref_key: "elRef",
      ref: r,
      type: "button",
      "data-dp-element": s.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": s.ariaLabel,
      "aria-disabled": s.disabled || void 0,
      onClick: a[0] || (a[0] = (o) => s.$emit("activate")),
      onKeydown: a[1] || (a[1] = (o) => b(jt)(o, () => s.$emit("activate"), !0))
    }, [
      O("span", {
        class: pe(["dp__inner_nav", { dp__inner_nav_disabled: s.disabled }])
      }, [
        fe(s.$slots, "default")
      ], 2)
    ], 40, a0));
  }
}), o0 = ["aria-label", "data-test-id"], hf = /* @__PURE__ */ Fe({
  __name: "YearModePicker",
  props: {
    ...Mn,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(n, { emit: e }) {
    const t = e, r = n, { showRightIcon: s, showLeftIcon: a } = Fo(), { defaultedConfig: o, defaultedMultiCalendars: i, defaultedAriaLabels: l, defaultedTransitions: u, defaultedUI: c } = rt(r), { showTransition: d, transitionName: f } = ma(u), h = W(!1), p = (v = !1, C) => {
      h.value = !h.value, t("toggle-year-picker", { flow: v, show: C });
    }, g = (v) => {
      h.value = !1, t("year-select", v);
    }, y = (v = !1) => {
      t("handle-year", v);
    };
    return (v, C) => {
      var M, S, D, I, x;
      return T(), N(Ee, null, [
        O("div", {
          class: pe(["dp--year-mode-picker", { "dp--hidden-el": h.value }])
        }, [
          b(a)(b(i), n.instance) ? (T(), Ne(Fs, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (M = b(l)) == null ? void 0 : M.prevYear,
            disabled: n.isDisabled(!1),
            class: pe((S = b(c)) == null ? void 0 : S.navBtnPrev),
            onActivate: C[0] || (C[0] = (k) => y(!1))
          }, {
            default: Ae(() => [
              v.$slots["arrow-left"] ? fe(v.$slots, "arrow-left", { key: 0 }) : H("", !0),
              v.$slots["arrow-left"] ? H("", !0) : (T(), Ne(b(Fl), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : H("", !0),
          O("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${n.year}-${(D = b(l)) == null ? void 0 : D.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${n.instance}`,
            onClick: C[1] || (C[1] = () => p(!1)),
            onKeydown: C[2] || (C[2] = Ha(() => p(!1), ["enter"]))
          }, [
            v.$slots.year ? fe(v.$slots, "year", {
              key: 0,
              year: n.year
            }) : H("", !0),
            v.$slots.year ? H("", !0) : (T(), N(Ee, { key: 1 }, [
              wt(Ce(n.year), 1)
            ], 64))
          ], 40, o0),
          b(s)(b(i), n.instance) ? (T(), Ne(Fs, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (I = b(l)) == null ? void 0 : I.nextYear,
            disabled: n.isDisabled(!0),
            class: pe((x = b(c)) == null ? void 0 : x.navBtnNext),
            onActivate: C[3] || (C[3] = (k) => y(!0))
          }, {
            default: Ae(() => [
              v.$slots["arrow-right"] ? fe(v.$slots, "arrow-right", { key: 0 }) : H("", !0),
              v.$slots["arrow-right"] ? H("", !0) : (T(), Ne(b(zl), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : H("", !0)
        ], 2),
        Qe(_n, {
          name: b(f)(n.showYearPicker),
          css: b(d)
        }, {
          default: Ae(() => {
            var k, _;
            return [
              n.showYearPicker ? (T(), Ne(pa, {
                key: 0,
                items: n.items,
                "text-input": v.textInput,
                "esc-close": v.escClose,
                config: v.config,
                "is-last": v.autoApply && !b(o).keepActionRow,
                "hide-navigation": v.hideNavigation,
                "aria-labels": v.ariaLabels,
                "overlay-label": (_ = (k = b(l)) == null ? void 0 : k.yearPicker) == null ? void 0 : _.call(k, !0),
                type: "year",
                onToggle: p,
                onSelected: C[4] || (C[4] = (E) => g(E))
              }, Ht({
                "button-icon": Ae(() => [
                  v.$slots["calendar-icon"] ? fe(v.$slots, "calendar-icon", { key: 0 }) : H("", !0),
                  v.$slots["calendar-icon"] ? H("", !0) : (T(), Ne(b(Cs), { key: 1 }))
                ]),
                _: 2
              }, [
                v.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: Ae(({ item: E }) => [
                    fe(v.$slots, "year-overlay-value", {
                      text: E.text,
                      value: E.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : H("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Gl = (n, e, t) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((r) => He(n, r))) {
      const r = e.value.filter((s) => !He(s, n));
      e.value = r.length ? r : null;
    } else (t && +t > e.value.length || !t) && e.value.push(n);
  else
    e.value = [n];
}, Jl = (n, e, t) => {
  let r = n.value ? n.value.slice() : [];
  return r.length === 2 && r[1] !== null && (r = []), r.length ? (lt(e, r[0]) ? r.unshift(e) : r[1] = e, t("range-end", e)) : (r = [e], t("range-start", e)), r;
}, Bo = (n, e, t, r) => {
  n && (n[0] && n[1] && t && e("auto-apply"), n[0] && !n[1] && r && t && e("auto-apply"));
}, pf = (n) => {
  Array.isArray(n.value) && n.value.length <= 2 && n.range ? n.modelValue.value = n.value.map((e) => en(ee(e), n.timezone)) : Array.isArray(n.value) || (n.modelValue.value = en(ee(n.value), n.timezone));
}, mf = (n, e, t, r) => Array.isArray(e.value) && (e.value.length === 2 || e.value.length === 1 && r.value.partialRange) ? r.value.fixedStart && (ht(n, e.value[0]) || He(n, e.value[0])) ? [e.value[0], n] : r.value.fixedEnd && (lt(n, e.value[1]) || He(n, e.value[1])) ? [n, e.value[1]] : (t("invalid-fixed-range", n), e.value) : [], gf = ({
  multiCalendars: n,
  range: e,
  highlight: t,
  propDates: r,
  calendars: s,
  modelValue: a,
  props: o,
  filters: i,
  year: l,
  month: u,
  emit: c
}) => {
  const d = G(() => jl(o.yearRange, o.locale, o.reverseYears)), f = W([!1]), h = G(() => (E, ne) => {
    const de = Ke(yn(/* @__PURE__ */ new Date()), {
      month: u.value(E),
      year: l.value(E)
    }), be = ne ? $d(de) : Qs(de);
    return uf(
      be,
      r.value.maxDate,
      r.value.minDate,
      o.preventMinMaxNavigation,
      ne
    );
  }), p = () => Array.isArray(a.value) && n.value.solo && a.value[1], g = () => {
    for (let E = 0; E < n.value.count; E++)
      if (E === 0)
        s.value[E] = s.value[0];
      else if (E === n.value.count - 1 && p())
        s.value[E] = {
          month: Ve(a.value[1]),
          year: _e(a.value[1])
        };
      else {
        const ne = Ke(ee(), s.value[E - 1]);
        s.value[E] = { month: Ve(ne), year: _e(Nl(ne, 1)) };
      }
  }, y = (E) => {
    if (!E) return g();
    const ne = Ke(ee(), s.value[E]);
    return s.value[0].year = _e(Jd(ne, n.value.count - 1)), g();
  }, v = (E, ne) => {
    const de = mg(ne, E);
    return e.value.showLastInRange && de > 1 ? ne : E;
  }, C = (E) => o.focusStartDate || n.value.solo ? E[0] : E[1] ? v(E[0], E[1]) : E[0], M = () => {
    if (a.value) {
      const E = Array.isArray(a.value) ? C(a.value) : a.value;
      s.value[0] = { month: Ve(E), year: _e(E) };
    }
  }, S = () => {
    M(), n.value.count && g();
  };
  $t(a, (E, ne) => {
    o.isTextInputDate && JSON.stringify(E ?? {}) !== JSON.stringify(ne ?? {}) && S();
  }), Pt(() => {
    S();
  });
  const D = (E, ne) => {
    s.value[ne].year = E, c("update-month-year", { instance: ne, year: E, month: s.value[ne].month }), n.value.count && !n.value.solo && y(ne);
  }, I = G(() => (E) => gs(d.value, (ne) => {
    var de;
    const be = l.value(E) === ne.value, R = Xs(
      ne.value,
      ys(r.value.minDate),
      ys(r.value.maxDate)
    ) || ((de = i.value.years) == null ? void 0 : de.includes(l.value(E))), F = Kl(t.value, ne.value);
    return { active: be, disabled: R, highlighted: F };
  })), x = (E, ne) => {
    D(E, ne), _(ne);
  }, k = (E, ne = !1) => {
    if (!h.value(E, ne)) {
      const de = ne ? l.value(E) + 1 : l.value(E) - 1;
      D(de, E);
    }
  }, _ = (E, ne = !1, de) => {
    ne || c("reset-flow"), de !== void 0 ? f.value[E] = de : f.value[E] = !f.value[E], f.value[E] ? c("overlay-toggle", { open: !0, overlay: zt.year }) : (c("overlay-closed"), c("overlay-toggle", { open: !1, overlay: zt.year }));
  };
  return {
    isDisabled: h,
    groupedYears: I,
    showYearPicker: f,
    selectYear: D,
    toggleYearPicker: _,
    handleYearSelect: x,
    handleYear: k
  };
}, i0 = (n, e) => {
  const {
    defaultedMultiCalendars: t,
    defaultedAriaLabels: r,
    defaultedTransitions: s,
    defaultedConfig: a,
    defaultedRange: o,
    defaultedHighlight: i,
    propDates: l,
    defaultedTz: u,
    defaultedFilters: c,
    defaultedMultiDates: d
  } = rt(n), f = () => {
    n.isTextInputDate && S(_e(ee(n.startDate)), 0);
  }, { modelValue: h, year: p, month: g, calendars: y } = ga(n, e, f), v = G(() => Xd(n.formatLocale, n.locale, n.monthNameFormat)), C = W(null), { checkMinMaxRange: M } = br(n), {
    selectYear: S,
    groupedYears: D,
    showYearPicker: I,
    toggleYearPicker: x,
    handleYearSelect: k,
    handleYear: _,
    isDisabled: E
  } = gf({
    modelValue: h,
    multiCalendars: t,
    range: o,
    highlight: i,
    calendars: y,
    year: p,
    propDates: l,
    month: g,
    filters: c,
    props: n,
    emit: e
  });
  Pt(() => {
    n.startDate && (h.value && n.focusStartDate || !h.value) && S(_e(ee(n.startDate)), 0);
  });
  const ne = (V) => V ? { month: Ve(V), year: _e(V) } : { month: null, year: null }, de = () => h.value ? Array.isArray(h.value) ? h.value.map((V) => ne(V)) : ne(h.value) : ne(), be = (V, K) => {
    const X = y.value[V], m = de();
    return Array.isArray(m) ? m.some((A) => A.year === (X == null ? void 0 : X.year) && A.month === K) : (X == null ? void 0 : X.year) === m.year && K === m.month;
  }, R = (V, K, X) => {
    var m, A;
    const j = de();
    return Array.isArray(j) ? p.value(K) === ((m = j[X]) == null ? void 0 : m.year) && V === ((A = j[X]) == null ? void 0 : A.month) : !1;
  }, F = (V, K) => {
    if (o.value.enabled) {
      const X = de();
      if (Array.isArray(h.value) && Array.isArray(X)) {
        const m = R(V, K, 0) || R(V, K, 1), A = Hn(yn(ee()), V, p.value(K));
        return Zs(h.value, C.value, A) && !m;
      }
      return !1;
    }
    return !1;
  }, $ = G(() => (V) => gs(v.value, (K) => {
    var X;
    const m = be(V, K.value), A = Xs(
      K.value,
      sf(p.value(V), l.value.minDate),
      af(p.value(V), l.value.maxDate)
    ) || Ev(l.value.disabledDates, p.value(V), K.value) || ((X = c.value.months) == null ? void 0 : X.includes(K.value)) || !Pv(l.value.allowedDates, p.value(V), K.value), j = F(K.value, V), ge = df(i.value, K.value, p.value(V));
    return { active: m, disabled: A, isBetween: j, highlighted: ge };
  })), U = (V, K) => Hn(yn(ee()), V, p.value(K)), ue = (V, K) => {
    const X = h.value ? h.value : yn(/* @__PURE__ */ new Date());
    h.value = Hn(X, V, p.value(K)), e("auto-apply"), e("update-flow-step");
  }, q = (V, K) => {
    const X = U(V, K);
    o.value.fixedEnd || o.value.fixedStart ? h.value = mf(X, h, e, o) : h.value ? M(X, h.value) && (h.value = Jl(h, U(V, K), e)) : h.value = [U(V, K)], kt().then(() => {
      Bo(h.value, e, n.autoApply, n.modelAuto);
    });
  }, ie = (V, K) => {
    Gl(U(V, K), h, d.value.limit), e("auto-apply", !0);
  }, Y = (V, K) => (y.value[K].month = V, P(K, y.value[K].year, V), d.value.enabled ? ie(V, K) : o.value.enabled ? q(V, K) : ue(V, K)), ve = (V, K) => {
    S(V, K), P(K, V, null);
  }, P = (V, K, X) => {
    let m = X;
    if (!m && m !== 0) {
      const A = de();
      m = Array.isArray(A) ? A[V].month : A.month;
    }
    e("update-month-year", { instance: V, year: K, month: m });
  };
  return {
    groupedMonths: $,
    groupedYears: D,
    year: p,
    isDisabled: E,
    defaultedMultiCalendars: t,
    defaultedAriaLabels: r,
    defaultedTransitions: s,
    defaultedConfig: a,
    showYearPicker: I,
    modelValue: h,
    presetDate: (V, K) => {
      pf({
        value: V,
        modelValue: h,
        range: o.value.enabled,
        timezone: K ? void 0 : u.value.timezone
      }), e("auto-apply");
    },
    setHoverDate: (V, K) => {
      C.value = U(V, K);
    },
    selectMonth: Y,
    selectYear: ve,
    toggleYearPicker: x,
    handleYearSelect: k,
    handleYear: _,
    getModelMonthYear: de
  };
}, l0 = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...Mn
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = Ur(), a = sn(s, "yearMode"), o = n;
    Pt(() => {
      o.shadow || r("mount", null);
    });
    const {
      groupedMonths: i,
      groupedYears: l,
      year: u,
      isDisabled: c,
      defaultedMultiCalendars: d,
      defaultedConfig: f,
      showYearPicker: h,
      modelValue: p,
      presetDate: g,
      setHoverDate: y,
      selectMonth: v,
      selectYear: C,
      toggleYearPicker: M,
      handleYearSelect: S,
      handleYear: D,
      getModelMonthYear: I
    } = i0(o, r);
    return e({ getSidebarProps: () => ({
      modelValue: p,
      year: u,
      getModelMonthYear: I,
      selectMonth: v,
      selectYear: C,
      handleYear: D
    }), presetDate: g, toggleYearPicker: (x) => M(0, x) }), (x, k) => (T(), Ne(Lo, {
      "multi-calendars": b(d).count,
      collapse: x.collapse,
      stretch: "",
      "is-mobile": x.isMobile
    }, {
      default: Ae(({ instance: _ }) => [
        x.$slots["top-extra"] ? fe(x.$slots, "top-extra", {
          key: 0,
          value: x.internalModelValue
        }) : H("", !0),
        x.$slots["month-year"] ? fe(x.$slots, "month-year", Ct(Mt({ key: 1 }, {
          year: b(u),
          months: b(i)(_),
          years: b(l)(_),
          selectMonth: b(v),
          selectYear: b(C),
          instance: _
        }))) : (T(), Ne(pa, {
          key: 2,
          items: b(i)(_),
          "arrow-navigation": x.arrowNavigation,
          "is-last": x.autoApply && !b(f).keepActionRow,
          "esc-close": x.escClose,
          height: b(f).modeHeight,
          config: x.config,
          "no-overlay-focus": !!(x.noOverlayFocus || x.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (E) => b(v)(E, _),
          onHoverValue: (E) => b(y)(E, _)
        }, Ht({
          header: Ae(() => [
            Qe(hf, Mt(x.$props, {
              items: b(l)(_),
              instance: _,
              "show-year-picker": b(h)[_],
              year: b(u)(_),
              "is-disabled": (E) => b(c)(_, E),
              onHandleYear: (E) => b(D)(_, E),
              onYearSelect: (E) => b(S)(E, _),
              onToggleYearPicker: (E) => b(M)(_, E == null ? void 0 : E.flow, E == null ? void 0 : E.show)
            }), Ht({ _: 2 }, [
              Ye(b(a), (E, ne) => ({
                name: E,
                fn: Ae((de) => [
                  fe(x.$slots, E, Ct(Xt(de)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          x.$slots["month-overlay-value"] ? {
            name: "item",
            fn: Ae(({ item: E }) => [
              fe(x.$slots, "month-overlay-value", {
                text: E.text,
                value: E.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), u0 = (n, e) => {
  const t = () => {
    n.isTextInputDate && (c.value = _e(ee(n.startDate)));
  }, { modelValue: r } = ga(n, e, t), s = W(null), { defaultedHighlight: a, defaultedMultiDates: o, defaultedFilters: i, defaultedRange: l, propDates: u } = rt(n), c = W();
  Pt(() => {
    n.startDate && (r.value && n.focusStartDate || !r.value) && (c.value = _e(ee(n.startDate)));
  });
  const d = (v) => Array.isArray(r.value) ? r.value.some((C) => _e(C) === v) : r.value ? _e(r.value) === v : !1, f = (v) => l.value.enabled && Array.isArray(r.value) ? Zs(r.value, s.value, y(v)) : !1, h = (v) => u.value.allowedDates instanceof Map ? u.value.allowedDates.size ? u.value.allowedDates.has(`${v}`) : !1 : !0, p = (v) => u.value.disabledDates instanceof Map ? u.value.disabledDates.size ? u.value.disabledDates.has(`${v}`) : !1 : !0, g = G(() => gs(jl(n.yearRange, n.locale, n.reverseYears), (v) => {
    const C = d(v.value), M = Xs(
      v.value,
      ys(u.value.minDate),
      ys(u.value.maxDate)
    ) || i.value.years.includes(v.value) || !h(v.value) || p(v.value), S = f(v.value) && !C, D = Kl(a.value, v.value);
    return { active: C, disabled: M, isBetween: S, highlighted: D };
  })), y = (v) => En(yn(Qs(/* @__PURE__ */ new Date())), v);
  return {
    groupedYears: g,
    modelValue: r,
    focusYear: c,
    setHoverValue: (v) => {
      s.value = En(yn(/* @__PURE__ */ new Date()), v);
    },
    selectYear: (v) => {
      var C;
      if (e("update-month-year", { instance: 0, year: v }), o.value.enabled)
        return r.value ? Array.isArray(r.value) && (((C = r.value) == null ? void 0 : C.map((M) => _e(M))).includes(v) ? r.value = r.value.filter((M) => _e(M) !== v) : r.value.push(En(Et(ee()), v))) : r.value = [En(Et(Qs(ee())), v)], e("auto-apply", !0);
      l.value.enabled ? (r.value = Jl(r, y(v), e), kt().then(() => {
        Bo(r.value, e, n.autoApply, n.modelAuto);
      })) : (r.value = y(v), e("auto-apply"));
    }
  };
}, c0 = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...Mn
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, { groupedYears: a, modelValue: o, focusYear: i, selectYear: l, setHoverValue: u } = u0(s, r), { defaultedConfig: c } = rt(s);
    return e({ getSidebarProps: () => ({
      modelValue: o,
      selectYear: l
    }) }), (d, f) => (T(), N("div", null, [
      d.$slots["top-extra"] ? fe(d.$slots, "top-extra", {
        key: 0,
        value: d.internalModelValue
      }) : H("", !0),
      d.$slots["month-year"] ? fe(d.$slots, "month-year", Ct(Mt({ key: 1 }, {
        years: b(a),
        selectYear: b(l)
      }))) : (T(), Ne(pa, {
        key: 2,
        items: b(a),
        "is-last": d.autoApply && !b(c).keepActionRow,
        height: b(c).modeHeight,
        config: d.config,
        "no-overlay-focus": !!(d.noOverlayFocus || d.textInput),
        "focus-value": b(i),
        type: "year",
        "use-relative": "",
        onSelected: b(l),
        onHoverValue: b(u)
      }, Ht({ _: 2 }, [
        d.$slots["year-overlay-value"] ? {
          name: "item",
          fn: Ae(({ item: h }) => [
            fe(d.$slots, "year-overlay-value", {
              text: h.text,
              value: h.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), d0 = {
  key: 0,
  class: "dp__time_input"
}, f0 = ["data-compact", "data-collapsed"], h0 = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], p0 = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], m0 = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], g0 = { key: 0 }, y0 = ["aria-label", "data-compact"], v0 = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...Mn
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, { setTimePickerElements: a, setTimePickerBackRef: o } = vr(), {
      defaultedAriaLabels: i,
      defaultedTransitions: l,
      defaultedFilters: u,
      defaultedConfig: c,
      defaultedRange: d,
      defaultedMultiCalendars: f
    } = rt(s), { transitionName: h, showTransition: p } = ma(l), g = Ts({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), y = W("AM"), v = W(null), C = W([]), M = W(), S = W(!1);
    Pt(() => {
      r("mounted");
    });
    const D = (w) => Ke(/* @__PURE__ */ new Date(), {
      hours: w.hours,
      minutes: w.minutes,
      seconds: s.enableSeconds ? w.seconds : 0,
      milliseconds: 0
    }), I = G(
      () => (w) => q(w, s[w]) || k(w, s[w])
    ), x = G(() => ({ hours: s.hours, minutes: s.minutes, seconds: s.seconds })), k = (w, Z) => d.value.enabled && !d.value.disableTimeRangeValidation ? !s.validateTime(w, Z) : !1, _ = (w, Z) => {
      if (d.value.enabled && !d.value.disableTimeRangeValidation) {
        const re = Z ? +s[`${w}Increment`] : -+s[`${w}Increment`], oe = s[w] + re;
        return !s.validateTime(w, oe);
      }
      return !1;
    }, E = G(() => (w) => !V(+s[w] + +s[`${w}Increment`], w) || _(w, !0)), ne = G(() => (w) => !V(+s[w] - +s[`${w}Increment`], w) || _(w, !1)), de = (w, Z) => Ed(Ke(ee(), w), Z), be = (w, Z) => cv(Ke(ee(), w), Z), R = G(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !s.timePickerInline,
        dp__time_col_reg_block: !s.enableSeconds && s.is24 && !s.timePickerInline,
        dp__time_col_reg_inline: !s.enableSeconds && s.is24 && s.timePickerInline,
        dp__time_col_reg_with_button: !s.enableSeconds && !s.is24,
        dp__time_col_sec: s.enableSeconds && s.is24,
        dp__time_col_sec_with_button: s.enableSeconds && !s.is24
      })
    ), F = G(
      () => s.timePickerInline && d.value.enabled && !f.value.count
    ), $ = G(() => {
      const w = [{ type: "hours" }];
      return s.enableMinutes && w.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), s.enableSeconds && w.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), w;
    }), U = G(() => $.value.filter((w) => !w.separator)), ue = G(() => (w) => {
      if (w === "hours") {
        const Z = ge(+s.hours);
        return { text: Z < 10 ? `0${Z}` : `${Z}`, value: Z };
      }
      return { text: s[w] < 10 ? `0${s[w]}` : `${s[w]}`, value: s[w] };
    }), q = (w, Z) => {
      var re;
      if (!s.disabledTimesConfig) return !1;
      const oe = s.disabledTimesConfig(s.order, w === "hours" ? Z : void 0);
      return oe[w] ? !!((re = oe[w]) != null && re.includes(Z)) : !0;
    }, ie = (w, Z) => Z !== "hours" || y.value === "AM" ? w : w + 12, Y = (w) => {
      const Z = s.is24 ? 24 : 12, re = w === "hours" ? Z : 60, oe = +s[`${w}GridIncrement`], Pe = w === "hours" && !s.is24 ? oe : 0, Oe = [];
      for (let ze = Pe; ze < re; ze += oe)
        Oe.push({ value: s.is24 ? ze : ie(ze, w), text: ze < 10 ? `0${ze}` : `${ze}` });
      return w === "hours" && !s.is24 && Oe.unshift({ value: y.value === "PM" ? 12 : 0, text: "12" }), gs(Oe, (ze) => ({ active: !1, disabled: u.value.times[w].includes(ze.value) || !V(ze.value, w) || q(w, ze.value) || k(w, ze.value) }));
    }, ve = (w) => w >= 0 ? w : 59, P = (w) => w >= 0 ? w : 23, V = (w, Z) => {
      const re = s.minTime ? D(ui(s.minTime)) : null, oe = s.maxTime ? D(ui(s.maxTime)) : null, Pe = D(
        ui(
          x.value,
          Z,
          Z === "minutes" || Z === "seconds" ? ve(w) : P(w)
        )
      );
      return re && oe ? (ps(Pe, oe) || as(Pe, oe)) && (Fr(Pe, re) || as(Pe, re)) : re ? Fr(Pe, re) || as(Pe, re) : oe ? ps(Pe, oe) || as(Pe, oe) : !0;
    }, K = (w) => s[`no${w[0].toUpperCase() + w.slice(1)}Overlay`], X = (w) => {
      K(w) || (g[w] = !g[w], g[w] ? (S.value = !0, r("overlay-opened", w)) : (S.value = !1, r("overlay-closed", w)));
    }, m = (w) => w === "hours" ? Un : w === "minutes" ? mr : hs, A = () => {
      M.value && clearTimeout(M.value);
    }, j = (w, Z = !0, re) => {
      const oe = Z ? de : be, Pe = Z ? +s[`${w}Increment`] : -+s[`${w}Increment`];
      V(+s[w] + Pe, w) && r(
        `update:${w}`,
        m(w)(oe({ [w]: +s[w] }, { [w]: +s[`${w}Increment`] }))
      ), !(re != null && re.keyboard) && c.value.timeArrowHoldThreshold && (M.value = setTimeout(() => {
        j(w, Z);
      }, c.value.timeArrowHoldThreshold));
    }, ge = (w) => s.is24 ? w : (w >= 12 ? y.value = "PM" : y.value = "AM", yv(w)), z = () => {
      y.value === "PM" ? (y.value = "AM", r("update:hours", s.hours - 12)) : (y.value = "PM", r("update:hours", s.hours + 12)), r("am-pm-change", y.value);
    }, Se = (w) => {
      g[w] = !0;
    }, J = (w, Z, re) => {
      if (w && s.arrowNavigation) {
        Array.isArray(C.value[Z]) ? C.value[Z][re] = w : C.value[Z] = [w];
        const oe = C.value.reduce(
          (Pe, Oe) => Oe.map((ze, Xe) => [...Pe[Xe] || [], Oe[Xe]]),
          []
        );
        o(s.closeTimePickerBtn), v.value && (oe[1] = oe[1].concat(v.value)), a(oe, s.order);
      }
    }, se = (w, Z) => (X(w), r(`update:${w}`, Z));
    return e({ openChildCmp: Se }), (w, Z) => {
      var re;
      return w.disabled ? H("", !0) : (T(), N("div", d0, [
        (T(!0), N(Ee, null, Ye($.value, (oe, Pe) => {
          var Oe, ze, Xe;
          return T(), N("div", {
            key: Pe,
            class: pe(R.value),
            "data-compact": F.value && !w.enableSeconds,
            "data-collapsed": F.value && w.enableSeconds
          }, [
            oe.separator ? (T(), N(Ee, { key: 0 }, [
              S.value ? H("", !0) : (T(), N(Ee, { key: 0 }, [
                wt(":")
              ], 64))
            ], 64)) : (T(), N(Ee, { key: 1 }, [
              O("button", {
                ref_for: !0,
                ref: (L) => J(L, Pe, 0),
                type: "button",
                class: pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !w.timePickerInline,
                  dp__inc_dec_button_inline: w.timePickerInline,
                  dp__tp_inline_btn_top: w.timePickerInline,
                  dp__inc_dec_button_disabled: E.value(oe.type),
                  "dp--hidden-el": S.value
                }),
                "data-test-id": `${oe.type}-time-inc-btn-${s.order}`,
                "aria-label": (Oe = b(i)) == null ? void 0 : Oe.incrementValue(oe.type),
                tabindex: "0",
                onKeydown: (L) => b(jt)(L, () => j(oe.type, !0, { keyboard: !0 }), !0),
                onClick: (L) => b(c).timeArrowHoldThreshold ? void 0 : j(oe.type, !0),
                onMousedown: (L) => b(c).timeArrowHoldThreshold ? j(oe.type, !0) : void 0,
                onMouseup: A
              }, [
                s.timePickerInline ? (T(), N(Ee, { key: 1 }, [
                  w.$slots["tp-inline-arrow-up"] ? fe(w.$slots, "tp-inline-arrow-up", { key: 0 }) : (T(), N(Ee, { key: 1 }, [
                    Z[2] || (Z[2] = O("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    Z[3] || (Z[3] = O("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (T(), N(Ee, { key: 0 }, [
                  w.$slots["arrow-up"] ? fe(w.$slots, "arrow-up", { key: 0 }) : H("", !0),
                  w.$slots["arrow-up"] ? H("", !0) : (T(), Ne(b(Hl), { key: 1 }))
                ], 64))
              ], 42, h0),
              O("button", {
                ref_for: !0,
                ref: (L) => J(L, Pe, 1),
                type: "button",
                "aria-label": `${ue.value(oe.type).text}-${(ze = b(i)) == null ? void 0 : ze.openTpOverlay(oe.type)}`,
                class: pe({
                  dp__time_display: !0,
                  dp__time_display_block: !w.timePickerInline,
                  dp__time_display_inline: w.timePickerInline,
                  "dp--time-invalid": I.value(oe.type),
                  "dp--time-overlay-btn": !I.value(oe.type),
                  "dp--hidden-el": S.value
                }),
                disabled: K(oe.type),
                tabindex: "0",
                "data-test-id": `${oe.type}-toggle-overlay-btn-${s.order}`,
                onKeydown: (L) => b(jt)(L, () => X(oe.type), !0),
                onClick: (L) => X(oe.type)
              }, [
                w.$slots[oe.type] ? fe(w.$slots, oe.type, {
                  key: 0,
                  text: ue.value(oe.type).text,
                  value: ue.value(oe.type).value
                }) : H("", !0),
                w.$slots[oe.type] ? H("", !0) : (T(), N(Ee, { key: 1 }, [
                  wt(Ce(ue.value(oe.type).text), 1)
                ], 64))
              ], 42, p0),
              O("button", {
                ref_for: !0,
                ref: (L) => J(L, Pe, 2),
                type: "button",
                class: pe({
                  dp__btn: !0,
                  dp__inc_dec_button: !w.timePickerInline,
                  dp__inc_dec_button_inline: w.timePickerInline,
                  dp__tp_inline_btn_bottom: w.timePickerInline,
                  dp__inc_dec_button_disabled: ne.value(oe.type),
                  "dp--hidden-el": S.value
                }),
                "data-test-id": `${oe.type}-time-dec-btn-${s.order}`,
                "aria-label": (Xe = b(i)) == null ? void 0 : Xe.decrementValue(oe.type),
                tabindex: "0",
                onKeydown: (L) => b(jt)(L, () => j(oe.type, !1, { keyboard: !0 }), !0),
                onClick: (L) => b(c).timeArrowHoldThreshold ? void 0 : j(oe.type, !1),
                onMousedown: (L) => b(c).timeArrowHoldThreshold ? j(oe.type, !1) : void 0,
                onMouseup: A
              }, [
                s.timePickerInline ? (T(), N(Ee, { key: 1 }, [
                  w.$slots["tp-inline-arrow-down"] ? fe(w.$slots, "tp-inline-arrow-down", { key: 0 }) : (T(), N(Ee, { key: 1 }, [
                    Z[4] || (Z[4] = O("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    Z[5] || (Z[5] = O("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (T(), N(Ee, { key: 0 }, [
                  w.$slots["arrow-down"] ? fe(w.$slots, "arrow-down", { key: 0 }) : H("", !0),
                  w.$slots["arrow-down"] ? H("", !0) : (T(), Ne(b(Yl), { key: 1 }))
                ], 64))
              ], 42, m0)
            ], 64))
          ], 10, f0);
        }), 128)),
        w.is24 ? H("", !0) : (T(), N("div", g0, [
          w.$slots["am-pm-button"] ? fe(w.$slots, "am-pm-button", {
            key: 0,
            toggle: z,
            value: y.value
          }) : H("", !0),
          w.$slots["am-pm-button"] ? H("", !0) : (T(), N("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: v,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (re = b(i)) == null ? void 0 : re.amPmButton,
            tabindex: "0",
            "data-compact": F.value,
            onClick: z,
            onKeydown: Z[0] || (Z[0] = (oe) => b(jt)(oe, () => z(), !0))
          }, Ce(y.value), 41, y0))
        ])),
        (T(!0), N(Ee, null, Ye(U.value, (oe, Pe) => (T(), Ne(_n, {
          key: Pe,
          name: b(h)(g[oe.type]),
          css: b(p)
        }, {
          default: Ae(() => {
            var Oe, ze;
            return [
              g[oe.type] ? (T(), Ne(pa, {
                key: 0,
                items: Y(oe.type),
                "is-last": w.autoApply && !b(c).keepActionRow,
                "esc-close": w.escClose,
                type: oe.type,
                "text-input": w.textInput,
                config: w.config,
                "arrow-navigation": w.arrowNavigation,
                "aria-labels": w.ariaLabels,
                "overlay-label": (ze = (Oe = b(i)).timeOverlay) == null ? void 0 : ze.call(Oe, oe.type),
                onSelected: (Xe) => se(oe.type, Xe),
                onToggle: (Xe) => X(oe.type),
                onResetFlow: Z[1] || (Z[1] = (Xe) => w.$emit("reset-flow"))
              }, Ht({
                "button-icon": Ae(() => [
                  w.$slots["clock-icon"] ? fe(w.$slots, "clock-icon", { key: 0 }) : H("", !0),
                  w.$slots["clock-icon"] ? H("", !0) : (T(), Ne(Ro(w.timePickerInline ? b(Cs) : b(Vl)), { key: 1 }))
                ]),
                _: 2
              }, [
                w.$slots[`${oe.type}-overlay-value`] ? {
                  name: "item",
                  fn: Ae(({ item: Xe }) => [
                    fe(w.$slots, `${oe.type}-overlay-value`, {
                      text: Xe.text,
                      value: Xe.value
                    })
                  ]),
                  key: "0"
                } : void 0,
                w.$slots[`${oe.type}-overlay-header`] ? {
                  name: "header",
                  fn: Ae(() => [
                    fe(w.$slots, `${oe.type}-overlay-header`, {
                      toggle: () => X(oe.type)
                    })
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : H("", !0)
            ];
          }),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), b0 = ["data-dp-mobile"], w0 = ["aria-label", "tabindex"], k0 = ["role", "aria-label", "tabindex"], x0 = ["aria-label"], yf = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...Mn
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, { buildMatrix: a, setTimePicker: o } = vr(), i = Ur(), { defaultedTransitions: l, defaultedAriaLabels: u, defaultedTextInput: c, defaultedConfig: d, defaultedRange: f } = rt(s), { transitionName: h, showTransition: p } = ma(l), { hideNavigationButtons: g } = Fo(), y = W(null), v = W(null), C = W([]), M = W(null), S = W(!1);
    Pt(() => {
      r("mount"), !s.timePicker && s.arrowNavigation ? a([vt(y.value)], "time") : o(!0, s.timePicker);
    });
    const D = G(() => f.value.enabled && s.modelAuto ? Zd(s.internalModelValue) : !0), I = W(!1), x = (q) => ({
      hours: Array.isArray(s.hours) ? s.hours[q] : s.hours,
      minutes: Array.isArray(s.minutes) ? s.minutes[q] : s.minutes,
      seconds: Array.isArray(s.seconds) ? s.seconds[q] : s.seconds
    }), k = G(() => {
      const q = [];
      if (f.value.enabled)
        for (let ie = 0; ie < 2; ie++)
          q.push(x(ie));
      else
        q.push(x(0));
      return q;
    }), _ = (q, ie = !1, Y = "") => {
      ie || r("reset-flow"), I.value = q, r(q ? "overlay-opened" : "overlay-closed", zt.time), s.arrowNavigation && o(q), kt(() => {
        Y !== "" && C.value[0] && C.value[0].openChildCmp(Y);
      });
    }, E = G(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: s.autoApply && !d.value.keepActionRow
    })), ne = sn(i, "timePicker"), de = (q, ie, Y) => f.value.enabled ? ie === 0 ? [q, k.value[1][Y]] : [k.value[0][Y], q] : q, be = (q) => {
      r("update:hours", q);
    }, R = (q) => {
      r("update:minutes", q);
    }, F = (q) => {
      r("update:seconds", q);
    }, $ = () => {
      if (M.value && !c.value.enabled && !s.noOverlayFocus) {
        const q = ef(M.value);
        q && q.focus({ preventScroll: !0 });
      }
    }, U = (q) => {
      S.value = !1, r("overlay-closed", q);
    }, ue = (q) => {
      S.value = !0, r("overlay-opened", q);
    };
    return e({ toggleTimePicker: _ }), (q, ie) => {
      var Y;
      return T(), N("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": q.isMobile
      }, [
        !q.timePicker && !q.timePickerInline ? pt((T(), N("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: y,
          type: "button",
          class: pe({ ...E.value, "dp--hidden-el": I.value }),
          "aria-label": (Y = b(u)) == null ? void 0 : Y.openTimePicker,
          tabindex: q.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: ie[0] || (ie[0] = (ve) => b(jt)(ve, () => _(!0))),
          onClick: ie[1] || (ie[1] = (ve) => _(!0))
        }, [
          q.$slots["clock-icon"] ? fe(q.$slots, "clock-icon", { key: 0 }) : H("", !0),
          q.$slots["clock-icon"] ? H("", !0) : (T(), Ne(b(Vl), { key: 1 }))
        ], 42, w0)), [
          [Ls, !b(g)(q.hideNavigation, "time")]
        ]) : H("", !0),
        Qe(_n, {
          name: b(h)(I.value),
          css: b(p) && !q.timePickerInline
        }, {
          default: Ae(() => {
            var ve, P;
            return [
              I.value || q.timePicker || q.timePickerInline ? (T(), N("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: M,
                role: q.timePickerInline ? void 0 : "dialog",
                class: pe({
                  dp__overlay: !q.timePickerInline,
                  "dp--overlay-absolute": !s.timePicker && !q.timePickerInline,
                  "dp--overlay-relative": s.timePicker
                }),
                style: Zt(q.timePicker ? { height: `${b(d).modeHeight}px` } : void 0),
                "aria-label": (ve = b(u)) == null ? void 0 : ve.timePicker,
                tabindex: q.timePickerInline ? void 0 : 0
              }, [
                O("div", {
                  class: pe(
                    q.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  q.$slots["time-picker-overlay"] ? fe(q.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: n.hours,
                    minutes: n.minutes,
                    seconds: n.seconds,
                    setHours: be,
                    setMinutes: R,
                    setSeconds: F
                  }) : H("", !0),
                  q.$slots["time-picker-overlay"] ? H("", !0) : (T(), N("div", {
                    key: 1,
                    class: pe(q.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (T(!0), N(Ee, null, Ye(k.value, (V, K) => pt((T(), Ne(v0, Mt({
                      key: K,
                      ref_for: !0
                    }, {
                      ...q.$props,
                      order: K,
                      hours: V.hours,
                      minutes: V.minutes,
                      seconds: V.seconds,
                      closeTimePickerBtn: v.value,
                      disabledTimesConfig: n.disabledTimesConfig,
                      disabled: K === 0 ? b(f).fixedStart : b(f).fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: C,
                      "validate-time": (X, m) => n.validateTime(X, de(m, K, X)),
                      "onUpdate:hours": (X) => be(de(X, K, "hours")),
                      "onUpdate:minutes": (X) => R(de(X, K, "minutes")),
                      "onUpdate:seconds": (X) => F(de(X, K, "seconds")),
                      onMounted: $,
                      onOverlayClosed: U,
                      onOverlayOpened: ue,
                      onAmPmChange: ie[2] || (ie[2] = (X) => q.$emit("am-pm-change", X))
                    }), Ht({ _: 2 }, [
                      Ye(b(ne), (X, m) => ({
                        name: X,
                        fn: Ae((A) => [
                          fe(q.$slots, X, Mt({ ref_for: !0 }, A))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Ls, K === 0 ? !0 : D.value]
                    ])), 128))
                  ], 2)),
                  !q.timePicker && !q.timePickerInline ? pt((T(), N("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: v,
                    type: "button",
                    class: pe({ ...E.value, "dp--hidden-el": S.value }),
                    "aria-label": (P = b(u)) == null ? void 0 : P.closeTimePicker,
                    tabindex: "0",
                    onKeydown: ie[3] || (ie[3] = (V) => b(jt)(V, () => _(!1))),
                    onClick: ie[4] || (ie[4] = (V) => _(!1))
                  }, [
                    q.$slots["calendar-icon"] ? fe(q.$slots, "calendar-icon", { key: 0 }) : H("", !0),
                    q.$slots["calendar-icon"] ? H("", !0) : (T(), Ne(b(Cs), { key: 1 }))
                  ], 42, x0)), [
                    [Ls, !b(g)(q.hideNavigation, "time")]
                  ]) : H("", !0)
                ], 2)
              ], 14, k0)) : H("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, b0);
    };
  }
}), vf = (n, e, t, r) => {
  const { defaultedRange: s } = rt(n), a = (M, S) => Array.isArray(e[M]) ? e[M][S] : e[M], o = (M) => n.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[M] : e.seconds : 0, i = (M, S) => M ? S !== void 0 ? ur(M, a("hours", S), a("minutes", S), o(S)) : ur(M, e.hours, e.minutes, o()) : Gd(ee(), o(S)), l = (M, S) => {
    e[M] = S;
  }, u = G(() => n.modelAuto && s.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : s.value.enabled), c = (M, S) => {
    const D = Object.fromEntries(
      Object.keys(e).map((I) => I === M ? [I, S] : [I, e[I]].slice())
    );
    if (u.value && !s.value.disableTimeRangeValidation) {
      const I = (k) => t.value ? ur(
        t.value[k],
        D.hours[k],
        D.minutes[k],
        D.seconds[k]
      ) : null, x = (k) => Kd(t.value[k], 0);
      return !(He(I(0), I(1)) && (Fr(I(0), x(1)) || ps(I(1), x(0))));
    }
    return !0;
  }, d = (M, S) => {
    c(M, S) && (l(M, S), r && r());
  }, f = (M) => {
    d("hours", M);
  }, h = (M) => {
    d("minutes", M);
  }, p = (M) => {
    d("seconds", M);
  }, g = (M, S, D, I) => {
    S && f(M), !S && !D && h(M), D && p(M), t.value && I(t.value);
  }, y = (M) => {
    if (M) {
      const S = Array.isArray(M), D = S ? [+M[0].hours, +M[1].hours] : +M.hours, I = S ? [+M[0].minutes, +M[1].minutes] : +M.minutes, x = S ? [+M[0].seconds, +M[1].seconds] : +M.seconds;
      l("hours", D), l("minutes", I), n.enableSeconds && l("seconds", x);
    }
  }, v = (M, S) => {
    const D = {
      hours: Array.isArray(e.hours) ? e.hours[M] : e.hours,
      disabledArr: []
    };
    return (S || S === 0) && (D.hours = S), Array.isArray(n.disabledTimes) && (D.disabledArr = s.value.enabled && Array.isArray(n.disabledTimes[M]) ? n.disabledTimes[M] : n.disabledTimes), D;
  }, C = G(() => (M, S) => {
    var D;
    if (Array.isArray(n.disabledTimes)) {
      const { disabledArr: I, hours: x } = v(M, S), k = I.filter((_) => +_.hours === x);
      return ((D = k[0]) == null ? void 0 : D.minutes) === "*" ? { hours: [x], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (k == null ? void 0 : k.map((_) => +_.minutes)) ?? [],
        seconds: (k == null ? void 0 : k.map((_) => _.seconds ? +_.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: f,
    updateMinutes: h,
    updateSeconds: p,
    getSetDateTime: i,
    updateTimeValues: g,
    getSecondsValue: o,
    assignStartTime: y,
    validateTime: c,
    disabledTimesConfig: C
  };
}, M0 = (n, e) => {
  const t = () => {
    n.isTextInputDate && S();
  }, { modelValue: r, time: s } = ga(n, e, t), { defaultedStartTime: a, defaultedRange: o, defaultedTz: i } = rt(n), { updateTimeValues: l, getSetDateTime: u, setTime: c, assignStartTime: d, disabledTimesConfig: f, validateTime: h } = vf(n, s, r, p);
  function p() {
    e("update-flow-step");
  }
  const g = (I) => {
    const { hours: x, minutes: k, seconds: _ } = I;
    return { hours: +x, minutes: +k, seconds: _ ? +_ : 0 };
  }, y = () => {
    if (n.startTime) {
      if (Array.isArray(n.startTime)) {
        const x = g(n.startTime[0]), k = g(n.startTime[1]);
        return [Ke(ee(), x), Ke(ee(), k)];
      }
      const I = g(n.startTime);
      return Ke(ee(), I);
    }
    return o.value.enabled ? [null, null] : null;
  }, v = () => {
    if (o.value.enabled) {
      const [I, x] = y();
      r.value = [
        en(u(I, 0), i.value.timezone),
        en(u(x, 1), i.value.timezone)
      ];
    } else
      r.value = en(u(y()), i.value.timezone);
  }, C = (I) => Array.isArray(I) ? [Nr(ee(I[0])), Nr(ee(I[1]))] : [Nr(I ?? ee())], M = (I, x, k) => {
    c("hours", I), c("minutes", x), c("seconds", n.enableSeconds ? k : 0);
  }, S = () => {
    const [I, x] = C(r.value);
    return o.value.enabled ? M(
      [I.hours, x.hours],
      [I.minutes, x.minutes],
      [I.seconds, x.seconds]
    ) : M(I.hours, I.minutes, I.seconds);
  };
  Pt(() => {
    if (!n.shadow)
      return d(a.value), r.value ? S() : v();
  });
  const D = () => {
    Array.isArray(r.value) ? r.value = r.value.map((I, x) => I && u(I, x)) : r.value = u(r.value), e("time-update");
  };
  return {
    modelValue: r,
    time: s,
    disabledTimesConfig: f,
    updateTime: (I, x = !0, k = !1) => {
      l(I, x, k, D);
    },
    validateTime: h
  };
}, S0 = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...Mn
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, a = Ur(), o = sn(a, "timePicker"), i = W(null), { time: l, modelValue: u, disabledTimesConfig: c, updateTime: d, validateTime: f } = M0(s, r);
    return Pt(() => {
      s.shadow || r("mount", null);
    }), e({ getSidebarProps: () => ({
      modelValue: u,
      time: l,
      updateTime: d
    }), toggleTimePicker: (h, p = !1, g = "") => {
      var y;
      (y = i.value) == null || y.toggleTimePicker(h, p, g);
    } }), (h, p) => (T(), Ne(Lo, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": h.isMobile
    }, {
      default: Ae(() => [
        Qe(yf, Mt({
          ref_key: "tpRef",
          ref: i
        }, h.$props, {
          hours: b(l).hours,
          minutes: b(l).minutes,
          seconds: b(l).seconds,
          "internal-model-value": h.internalModelValue,
          "disabled-times-config": b(c),
          "validate-time": b(f),
          "onUpdate:hours": p[0] || (p[0] = (g) => b(d)(g)),
          "onUpdate:minutes": p[1] || (p[1] = (g) => b(d)(g, !1)),
          "onUpdate:seconds": p[2] || (p[2] = (g) => b(d)(g, !1, !0)),
          onAmPmChange: p[3] || (p[3] = (g) => h.$emit("am-pm-change", g)),
          onResetFlow: p[4] || (p[4] = (g) => h.$emit("reset-flow")),
          onOverlayClosed: p[5] || (p[5] = (g) => h.$emit("overlay-toggle", { open: !1, overlay: g })),
          onOverlayOpened: p[6] || (p[6] = (g) => h.$emit("overlay-toggle", { open: !0, overlay: g }))
        }), Ht({ _: 2 }, [
          Ye(b(o), (g, y) => ({
            name: g,
            fn: Ae((v) => [
              fe(h.$slots, g, Ct(Xt(v)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), T0 = { class: "dp--header-wrap" }, C0 = {
  key: 0,
  class: "dp__month_year_wrap"
}, A0 = { key: 0 }, D0 = { class: "dp__month_year_wrap" }, O0 = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], E0 = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...Mn
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, {
      defaultedTransitions: a,
      defaultedAriaLabels: o,
      defaultedMultiCalendars: i,
      defaultedFilters: l,
      defaultedConfig: u,
      defaultedHighlight: c,
      propDates: d,
      defaultedUI: f
    } = rt(s), { transitionName: h, showTransition: p } = ma(a), { buildMatrix: g } = vr(), { handleMonthYearChange: y, isDisabled: v, updateMonthYear: C } = Jv(s, r), { showLeftIcon: M, showRightIcon: S } = Fo(), D = W(!1), I = W(!1), x = W(!1), k = W([null, null, null, null]);
    Pt(() => {
      r("mount");
    });
    const _ = (P) => ({
      get: () => s[P],
      set: (V) => {
        const K = P === mn.month ? mn.year : mn.month;
        r("update-month-year", { [P]: V, [K]: s[K] }), P === mn.month ? U(!0) : ue(!0);
      }
    }), E = G(_(mn.month)), ne = G(_(mn.year)), de = G(() => (P) => ({
      month: s.month,
      year: s.year,
      items: P === mn.month ? s.months : s.years,
      instance: s.instance,
      updateMonthYear: C,
      toggle: P === mn.month ? U : ue
    })), be = G(() => s.months.find((V) => V.value === s.month) || { text: "", value: 0 }), R = G(() => gs(s.months, (P) => {
      const V = s.month === P.value, K = Xs(
        P.value,
        sf(s.year, d.value.minDate),
        af(s.year, d.value.maxDate)
      ) || l.value.months.includes(P.value), X = df(c.value, P.value, s.year);
      return { active: V, disabled: K, highlighted: X };
    })), F = G(() => gs(s.years, (P) => {
      const V = s.year === P.value, K = Xs(
        P.value,
        ys(d.value.minDate),
        ys(d.value.maxDate)
      ) || l.value.years.includes(P.value), X = Kl(c.value, P.value);
      return { active: V, disabled: K, highlighted: X };
    })), $ = (P, V, K) => {
      K !== void 0 ? P.value = K : P.value = !P.value, P.value ? (x.value = !0, r("overlay-opened", V)) : (x.value = !1, r("overlay-closed", V));
    }, U = (P = !1, V) => {
      q(P), $(D, zt.month, V);
    }, ue = (P = !1, V) => {
      q(P), $(I, zt.year, V);
    }, q = (P) => {
      P || r("reset-flow");
    }, ie = (P, V) => {
      s.arrowNavigation && (k.value[V] = vt(P), g(k.value, "monthYear"));
    }, Y = G(() => {
      var P, V, K, X, m, A;
      return [
        {
          type: mn.month,
          index: 1,
          toggle: U,
          modelValue: E.value,
          updateModelValue: (j) => E.value = j,
          text: be.value.text,
          showSelectionGrid: D.value,
          items: R.value,
          ariaLabel: (P = o.value) == null ? void 0 : P.openMonthsOverlay,
          overlayLabel: ((K = (V = o.value).monthPicker) == null ? void 0 : K.call(V, !0)) ?? void 0
        },
        {
          type: mn.year,
          index: 2,
          toggle: ue,
          modelValue: ne.value,
          updateModelValue: (j) => ne.value = j,
          text: tf(s.year, s.locale),
          showSelectionGrid: I.value,
          items: F.value,
          ariaLabel: (X = o.value) == null ? void 0 : X.openYearsOverlay,
          overlayLabel: ((A = (m = o.value).yearPicker) == null ? void 0 : A.call(m, !0)) ?? void 0
        }
      ];
    }), ve = G(() => s.disableYearSelect ? [Y.value[0]] : s.yearFirst ? [...Y.value].reverse() : Y.value);
    return e({
      toggleMonthPicker: U,
      toggleYearPicker: ue,
      handleMonthYearChange: y
    }), (P, V) => {
      var K, X, m, A, j, ge;
      return T(), N("div", T0, [
        P.$slots["month-year"] ? (T(), N("div", C0, [
          fe(P.$slots, "month-year", Ct(Xt({
            month: n.month,
            year: n.year,
            months: n.months,
            years: n.years,
            updateMonthYear: b(C),
            handleMonthYearChange: b(y),
            instance: n.instance,
            isDisabled: b(v)
          })))
        ])) : (T(), N(Ee, { key: 1 }, [
          P.$slots["top-extra"] ? (T(), N("div", A0, [
            fe(P.$slots, "top-extra", { value: P.internalModelValue })
          ])) : H("", !0),
          O("div", D0, [
            b(M)(b(i), n.instance) && !P.vertical ? (T(), Ne(Fs, {
              key: 0,
              "aria-label": (K = b(o)) == null ? void 0 : K.prevMonth,
              disabled: b(v)(!1),
              class: pe((X = b(f)) == null ? void 0 : X.navBtnPrev),
              "el-name": "action-prev",
              onActivate: V[0] || (V[0] = (z) => b(y)(!1, !0)),
              onSetRef: V[1] || (V[1] = (z) => ie(z, 0))
            }, {
              default: Ae(() => [
                P.$slots["arrow-left"] ? fe(P.$slots, "arrow-left", { key: 0 }) : H("", !0),
                P.$slots["arrow-left"] ? H("", !0) : (T(), Ne(b(Fl), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : H("", !0),
            O("div", {
              class: pe(["dp__month_year_wrap", {
                dp__year_disable_select: P.disableYearSelect
              }])
            }, [
              (T(!0), N(Ee, null, Ye(ve.value, (z, Se) => (T(), N(Ee, {
                key: z.type
              }, [
                O("button", {
                  ref_for: !0,
                  ref: (J) => ie(J, Se + 1),
                  type: "button",
                  "data-dp-element": `overlay-${z.type}`,
                  class: pe(["dp__btn dp__month_year_select", { "dp--hidden-el": x.value }]),
                  "aria-label": `${z.text}-${z.ariaLabel}`,
                  "data-test-id": `${z.type}-toggle-overlay-${n.instance}`,
                  onClick: z.toggle,
                  onKeydown: (J) => b(jt)(J, () => z.toggle(), !0)
                }, [
                  P.$slots[z.type] ? fe(P.$slots, z.type, {
                    key: 0,
                    text: z.text,
                    value: s[z.type]
                  }) : H("", !0),
                  P.$slots[z.type] ? H("", !0) : (T(), N(Ee, { key: 1 }, [
                    wt(Ce(z.text), 1)
                  ], 64))
                ], 42, O0),
                Qe(_n, {
                  name: b(h)(z.showSelectionGrid),
                  css: b(p)
                }, {
                  default: Ae(() => [
                    z.showSelectionGrid ? (T(), Ne(pa, {
                      key: 0,
                      items: z.items,
                      "arrow-navigation": P.arrowNavigation,
                      "hide-navigation": P.hideNavigation,
                      "is-last": P.autoApply && !b(u).keepActionRow,
                      "skip-button-ref": !1,
                      config: P.config,
                      type: z.type,
                      "header-refs": [],
                      "esc-close": P.escClose,
                      "menu-wrap-ref": P.menuWrapRef,
                      "text-input": P.textInput,
                      "aria-labels": P.ariaLabels,
                      "overlay-label": z.overlayLabel,
                      onSelected: z.updateModelValue,
                      onToggle: z.toggle
                    }, Ht({
                      "button-icon": Ae(() => [
                        P.$slots["calendar-icon"] ? fe(P.$slots, "calendar-icon", { key: 0 }) : H("", !0),
                        P.$slots["calendar-icon"] ? H("", !0) : (T(), Ne(b(Cs), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      P.$slots[`${z.type}-overlay-value`] ? {
                        name: "item",
                        fn: Ae(({ item: J }) => [
                          fe(P.$slots, `${z.type}-overlay-value`, {
                            text: J.text,
                            value: J.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      P.$slots[`${z.type}-overlay`] ? {
                        name: "overlay",
                        fn: Ae(() => [
                          fe(P.$slots, `${z.type}-overlay`, Mt({ ref_for: !0 }, de.value(z.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      P.$slots[`${z.type}-overlay-header`] ? {
                        name: "header",
                        fn: Ae(() => [
                          fe(P.$slots, `${z.type}-overlay-header`, {
                            toggle: z.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : H("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            b(M)(b(i), n.instance) && P.vertical ? (T(), Ne(Fs, {
              key: 1,
              "aria-label": (m = b(o)) == null ? void 0 : m.prevMonth,
              "el-name": "action-prev",
              disabled: b(v)(!1),
              class: pe((A = b(f)) == null ? void 0 : A.navBtnPrev),
              onActivate: V[2] || (V[2] = (z) => b(y)(!1, !0))
            }, {
              default: Ae(() => [
                P.$slots["arrow-up"] ? fe(P.$slots, "arrow-up", { key: 0 }) : H("", !0),
                P.$slots["arrow-up"] ? H("", !0) : (T(), Ne(b(Hl), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : H("", !0),
            b(S)(b(i), n.instance) ? (T(), Ne(Fs, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: b(v)(!0),
              "aria-label": (j = b(o)) == null ? void 0 : j.nextMonth,
              class: pe((ge = b(f)) == null ? void 0 : ge.navBtnNext),
              onActivate: V[3] || (V[3] = (z) => b(y)(!0, !0)),
              onSetRef: V[4] || (V[4] = (z) => ie(z, P.disableYearSelect ? 2 : 3))
            }, {
              default: Ae(() => [
                P.$slots[P.vertical ? "arrow-down" : "arrow-right"] ? fe(P.$slots, P.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : H("", !0),
                P.$slots[P.vertical ? "arrow-down" : "arrow-right"] ? H("", !0) : (T(), Ne(Ro(P.vertical ? b(Yl) : b(zl)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : H("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), P0 = {
  class: "dp__calendar_header",
  role: "row"
}, _0 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, N0 = ["aria-label"], I0 = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, R0 = { class: "dp__cell_inner" }, $0 = ["id", "aria-pressed", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], L0 = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...Mn
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, { buildMultiLevelMatrix: a } = vr(), {
      defaultedTransitions: o,
      defaultedConfig: i,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: u,
      defaultedWeekNumbers: c,
      defaultedMultiDates: d,
      defaultedUI: f
    } = rt(s), h = W(null), p = W({
      bottom: "",
      left: "",
      transform: ""
    }), g = W([]), y = W(null), v = W(!0), C = W(""), M = W({ startX: 0, endX: 0, startY: 0, endY: 0 }), S = W([]), D = W({ left: "50%" }), I = W(!1), x = G(() => s.calendar ? s.calendar(s.mappedDates) : s.mappedDates), k = G(() => s.dayNames ? Array.isArray(s.dayNames) ? s.dayNames : s.dayNames(s.locale, +s.weekStart) : gv(s.formatLocale, s.locale, +s.weekStart));
    Pt(() => {
      r("mount", { cmp: "calendar", refs: g }), i.value.noSwipe || y.value && (y.value.addEventListener("touchstart", ie, { passive: !1 }), y.value.addEventListener("touchend", Y, { passive: !1 }), y.value.addEventListener("touchmove", ve, { passive: !1 })), s.monthChangeOnScroll && y.value && y.value.addEventListener("wheel", K, { passive: !1 });
    }), jr(() => {
      i.value.noSwipe || y.value && (y.value.removeEventListener("touchstart", ie), y.value.removeEventListener("touchend", Y), y.value.removeEventListener("touchmove", ve)), s.monthChangeOnScroll && y.value && y.value.removeEventListener("wheel", K);
    });
    const _ = (z) => z ? s.vertical ? "vNext" : "next" : s.vertical ? "vPrevious" : "previous", E = (z, Se) => {
      if (s.transitions) {
        const J = Et(Hn(ee(), s.month, s.year));
        C.value = ht(Et(Hn(ee(), z, Se)), J) ? o.value[_(!0)] : o.value[_(!1)], v.value = !1, kt(() => {
          v.value = !0;
        });
      }
    }, ne = G(
      () => ({
        ...f.value.calendar ?? {}
      })
    ), de = G(() => (z) => {
      const Se = vv(z);
      return {
        dp__marker_dot: Se.type === "dot",
        dp__marker_line: Se.type === "line"
      };
    }), be = G(() => (z) => He(z, h.value)), R = G(() => ({
      dp__calendar: !0,
      dp__calendar_next: u.value.count > 0 && s.instance !== 0
    })), F = G(() => (z) => s.hideOffsetDates ? z.current : !0), $ = async (z, Se) => {
      const { width: J, height: se } = z.getBoundingClientRect();
      h.value = Se.value;
      let w = { left: `${J / 2}px` }, Z = -50;
      if (await kt(), S.value[0]) {
        const { left: re, width: oe } = S.value[0].getBoundingClientRect();
        re < 0 && (w = { left: "0" }, Z = 0, D.value.left = `${J / 2}px`), window.innerWidth < re + oe && (w = { right: "0" }, Z = 0, D.value.left = `${oe - J / 2}px`);
      }
      p.value = {
        bottom: `${se}px`,
        ...w,
        transform: `translateX(${Z}%)`
      };
    }, U = async (z, Se, J) => {
      var se, w, Z;
      const re = vt(g.value[Se][J]);
      re && ((se = z.marker) != null && se.customPosition && (Z = (w = z.marker) == null ? void 0 : w.tooltip) != null && Z.length ? p.value = z.marker.customPosition(re) : await $(re, z), r("tooltip-open", z.marker));
    }, ue = async (z, Se, J) => {
      var se, w;
      if (I.value && d.value.enabled && d.value.dragSelect)
        return r("select-date", z);
      if (r("set-hover-date", z), (w = (se = z.marker) == null ? void 0 : se.tooltip) != null && w.length) {
        if (s.hideOffsetDates && !z.current) return;
        await U(z, Se, J);
      }
    }, q = (z) => {
      h.value && (h.value = null, p.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), r("tooltip-close", z.marker));
    }, ie = (z) => {
      M.value.startX = z.changedTouches[0].screenX, M.value.startY = z.changedTouches[0].screenY;
    }, Y = (z) => {
      M.value.endX = z.changedTouches[0].screenX, M.value.endY = z.changedTouches[0].screenY, P();
    }, ve = (z) => {
      s.vertical && !s.inline && z.preventDefault();
    }, P = () => {
      const z = s.vertical ? "Y" : "X";
      Math.abs(M.value[`start${z}`] - M.value[`end${z}`]) > 10 && r("handle-swipe", M.value[`start${z}`] > M.value[`end${z}`] ? "right" : "left");
    }, V = (z, Se, J) => {
      z && (Array.isArray(g.value[Se]) ? g.value[Se][J] = z : g.value[Se] = [z]), s.arrowNavigation && a(g.value, "calendar");
    }, K = (z) => {
      s.monthChangeOnScroll && (z.preventDefault(), r("handle-scroll", z));
    }, X = (z) => c.value.type === "local" ? $l(z.value, { weekStartsOn: +s.weekStart }) : c.value.type === "iso" ? Il(z.value) : typeof c.value.type == "function" ? c.value.type(z.value) : "", m = (z) => {
      const Se = z[0];
      return c.value.hideOnOffsetDates ? z.some((J) => J.current) ? X(Se) : "" : X(Se);
    }, A = (z, Se, J = !0) => {
      !J && Mv() || (!d.value.enabled || i.value.allowPreventDefault) && (lr(z, i.value), r("select-date", Se));
    }, j = (z) => {
      lr(z, i.value);
    }, ge = (z) => {
      d.value.enabled && d.value.dragSelect ? (I.value = !0, r("select-date", z)) : d.value.enabled && r("select-date", z);
    };
    return e({ triggerTransition: E }), (z, Se) => (T(), N("div", {
      class: pe(R.value)
    }, [
      O("div", {
        ref_key: "calendarWrapRef",
        ref: y,
        class: pe(ne.value),
        role: "grid"
      }, [
        O("div", P0, [
          z.weekNumbers ? (T(), N("div", _0, Ce(z.weekNumName), 1)) : H("", !0),
          (T(!0), N(Ee, null, Ye(k.value, (J, se) => {
            var w, Z;
            return T(), N("div", {
              key: se,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (Z = (w = b(l)) == null ? void 0 : w.weekDay) == null ? void 0 : Z.call(w, se)
            }, [
              z.$slots["calendar-header"] ? fe(z.$slots, "calendar-header", {
                key: 0,
                day: J,
                index: se
              }) : H("", !0),
              z.$slots["calendar-header"] ? H("", !0) : (T(), N(Ee, { key: 1 }, [
                wt(Ce(J), 1)
              ], 64))
            ], 8, N0);
          }), 128))
        ]),
        Se[2] || (Se[2] = O("div", { class: "dp__calendar_header_separator" }, null, -1)),
        Qe(_n, {
          name: C.value,
          css: !!z.transitions
        }, {
          default: Ae(() => [
            v.value ? (T(), N("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: Se[1] || (Se[1] = (J) => I.value = !1)
            }, [
              (T(!0), N(Ee, null, Ye(x.value, (J, se) => (T(), N("div", {
                key: se,
                class: "dp__calendar_row",
                role: "row"
              }, [
                z.weekNumbers ? (T(), N("div", I0, [
                  O("div", R0, Ce(m(J.days)), 1)
                ])) : H("", !0),
                (T(!0), N(Ee, null, Ye(J.days, (w, Z) => {
                  var re, oe, Pe;
                  return T(), N("div", {
                    id: b(Zi)(w.value),
                    ref_for: !0,
                    ref: (Oe) => V(Oe, se, Z),
                    key: Z + se,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-pressed": (w.classData.dp__active_date || w.classData.dp__range_start || w.classData.dp__range_start) ?? void 0,
                    "aria-disabled": w.classData.dp__cell_disabled || void 0,
                    "aria-label": (oe = (re = b(l)) == null ? void 0 : re.day) == null ? void 0 : oe.call(re, w),
                    tabindex: !w.current && z.hideOffsetDates ? void 0 : 0,
                    "data-test-id": b(Zi)(w.value),
                    onClick: Qt((Oe) => A(Oe, w), ["prevent"]),
                    onTouchend: (Oe) => A(Oe, w, !1),
                    onKeydown: (Oe) => b(jt)(Oe, () => z.$emit("select-date", w)),
                    onMouseenter: (Oe) => ue(w, se, Z),
                    onMouseleave: (Oe) => q(w),
                    onMousedown: (Oe) => ge(w),
                    onMouseup: Se[0] || (Se[0] = (Oe) => I.value = !1)
                  }, [
                    O("div", {
                      class: pe(["dp__cell_inner", w.classData])
                    }, [
                      z.$slots.day && F.value(w) ? fe(z.$slots, "day", {
                        key: 0,
                        day: +w.text,
                        date: w.value
                      }) : H("", !0),
                      z.$slots.day ? H("", !0) : (T(), N(Ee, { key: 1 }, [
                        wt(Ce(w.text), 1)
                      ], 64)),
                      w.marker && F.value(w) ? (T(), N(Ee, { key: 2 }, [
                        z.$slots.marker ? fe(z.$slots, "marker", {
                          key: 0,
                          marker: w.marker,
                          day: +w.text,
                          date: w.value
                        }) : (T(), N("div", {
                          key: 1,
                          class: pe(de.value(w.marker)),
                          style: Zt(w.marker.color ? { backgroundColor: w.marker.color } : {})
                        }, null, 6))
                      ], 64)) : H("", !0),
                      be.value(w.value) ? (T(), N("div", {
                        key: 3,
                        ref_for: !0,
                        ref_key: "activeTooltip",
                        ref: S,
                        class: "dp__marker_tooltip",
                        style: Zt(p.value)
                      }, [
                        (Pe = w.marker) != null && Pe.tooltip ? (T(), N("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: j
                        }, [
                          (T(!0), N(Ee, null, Ye(w.marker.tooltip, (Oe, ze) => (T(), N("div", {
                            key: ze,
                            class: "dp__tooltip_text"
                          }, [
                            z.$slots["marker-tooltip"] ? fe(z.$slots, "marker-tooltip", {
                              key: 0,
                              tooltip: Oe,
                              day: w.value
                            }) : H("", !0),
                            z.$slots["marker-tooltip"] ? H("", !0) : (T(), N(Ee, { key: 1 }, [
                              O("div", {
                                class: "dp__tooltip_mark",
                                style: Zt(Oe.color ? { backgroundColor: Oe.color } : {})
                              }, null, 4),
                              O("div", null, Ce(Oe.text), 1)
                            ], 64))
                          ]))), 128)),
                          O("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Zt(D.value)
                          }, null, 4)
                        ])) : H("", !0)
                      ], 4)) : H("", !0)
                    ], 2)
                  ], 40, $0);
                }), 128))
              ]))), 128))
            ], 32)) : H("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), rc = (n) => Array.isArray(n), B0 = (n, e, t, r) => {
  const s = W([]), a = W(/* @__PURE__ */ new Date()), o = W(), i = () => Y(n.isTextInputDate), { modelValue: l, calendars: u, time: c, today: d } = ga(n, e, i), {
    defaultedMultiCalendars: f,
    defaultedStartTime: h,
    defaultedRange: p,
    defaultedConfig: g,
    defaultedTz: y,
    propDates: v,
    defaultedMultiDates: C
  } = rt(n), { validateMonthYearInRange: M, isDisabled: S, isDateRangeAllowed: D, checkMinMaxRange: I } = br(n), { updateTimeValues: x, getSetDateTime: k, setTime: _, assignStartTime: E, validateTime: ne, disabledTimesConfig: de } = vf(n, c, l, r), be = G(
    () => (B) => u.value[B] ? u.value[B].month : 0
  ), R = G(
    () => (B) => u.value[B] ? u.value[B].year : 0
  ), F = (B) => !g.value.keepViewOnOffsetClick || B ? !0 : !o.value, $ = (B, le, Te, Be = !1) => {
    var Q, he;
    F(Be) && (u.value[B] || (u.value[B] = { month: 0, year: 0 }), u.value[B].month = Qu(le) ? (Q = u.value[B]) == null ? void 0 : Q.month : le, u.value[B].year = Qu(Te) ? (he = u.value[B]) == null ? void 0 : he.year : Te);
  }, U = () => {
    n.autoApply && e("select-date");
  }, ue = () => {
    h.value && E(h.value);
  };
  Pt(() => {
    n.shadow || (l.value || (Se(), ue()), Y(!0), n.focusStartDate && n.startDate && Se());
  });
  const q = G(() => {
    var B;
    return (B = n.flow) != null && B.length && !n.partialFlow ? n.flowStep === n.flow.length : !0;
  }), ie = () => {
    n.autoApply && q.value && e("auto-apply", n.partialFlow ? n.flowStep !== n.flow.length : !1);
  }, Y = (B = !1) => {
    if (l.value)
      return Array.isArray(l.value) ? (s.value = l.value, A(B)) : V(l.value, B);
    if (f.value.count && B && !n.startDate)
      return P(ee(), B);
  }, ve = () => Array.isArray(l.value) && p.value.enabled ? Ve(l.value[0]) === Ve(l.value[1] ?? l.value[0]) : !1, P = (B = /* @__PURE__ */ new Date(), le = !1) => {
    if ((!f.value.count || !f.value.static || le) && $(0, Ve(B), _e(B)), f.value.count && (!l.value || ve() || !f.value.solo) && (!f.value.solo || le))
      for (let Te = 1; Te < f.value.count; Te++) {
        const Be = Ke(ee(), { month: be.value(Te - 1), year: R.value(Te - 1) }), Q = Ed(Be, { months: 1 });
        u.value[Te] = { month: Ve(Q), year: _e(Q) };
      }
  }, V = (B, le) => {
    P(B), _("hours", Un(B)), _("minutes", mr(B)), _("seconds", hs(B)), f.value.count && le && z();
  }, K = (B) => {
    if (f.value.count) {
      if (f.value.solo) return 0;
      const le = Ve(B[0]), Te = Ve(B[1]);
      return Math.abs(Te - le) < f.value.count ? 0 : 1;
    }
    return 1;
  }, X = (B, le) => {
    B[1] && p.value.showLastInRange ? P(B[K(B)], le) : P(B[0], le);
    const Te = (Be, Q) => [
      Be(B[0]),
      B[1] ? Be(B[1]) : c[Q][1]
    ];
    _("hours", Te(Un, "hours")), _("minutes", Te(mr, "minutes")), _("seconds", Te(hs, "seconds"));
  }, m = (B, le) => {
    if ((p.value.enabled || n.weekPicker) && !C.value.enabled)
      return X(B, le);
    if (C.value.enabled && le) {
      const Te = B[B.length - 1];
      return V(Te, le);
    }
  }, A = (B) => {
    const le = l.value;
    m(le, B), f.value.count && f.value.solo && z();
  }, j = (B, le) => {
    const Te = Ke(ee(), { month: be.value(le), year: R.value(le) }), Be = B < 0 ? wn(Te, 1) : ms(Te, 1);
    M(Ve(Be), _e(Be), B < 0, n.preventMinMaxNavigation) && ($(le, Ve(Be), _e(Be)), e("update-month-year", { instance: le, month: Ve(Be), year: _e(Be) }), f.value.count && !f.value.solo && ge(le), t());
  }, ge = (B) => {
    for (let le = B - 1; le >= 0; le--) {
      const Te = ms(Ke(ee(), { month: be.value(le + 1), year: R.value(le + 1) }), 1);
      $(le, Ve(Te), _e(Te));
    }
    for (let le = B + 1; le <= f.value.count - 1; le++) {
      const Te = wn(Ke(ee(), { month: be.value(le - 1), year: R.value(le - 1) }), 1);
      $(le, Ve(Te), _e(Te));
    }
  }, z = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const B = ee(
        ee(l.value[1] ? l.value[1] : wn(l.value[0], 1))
      ), [le, Te] = [Ve(l.value[0]), _e(l.value[0])], [Be, Q] = [Ve(l.value[1]), _e(l.value[1])];
      (le !== Be || le === Be && Te !== Q) && f.value.solo && $(1, Ve(B), _e(B));
    } else l.value && !Array.isArray(l.value) && ($(0, Ve(l.value), _e(l.value)), P(ee()));
  }, Se = () => {
    n.startDate && ($(0, Ve(ee(n.startDate)), _e(ee(n.startDate))), f.value.count && ge(0));
  }, J = (B, le) => {
    if (n.monthChangeOnScroll) {
      const Te = (/* @__PURE__ */ new Date()).getTime() - a.value.getTime(), Be = Math.abs(B.deltaY);
      let Q = 500;
      Be > 1 && (Q = 100), Be > 100 && (Q = 0), Te > Q && (a.value = /* @__PURE__ */ new Date(), j(n.monthChangeOnScroll !== "inverse" ? -B.deltaY : B.deltaY, le));
    }
  }, se = (B, le, Te = !1) => {
    n.monthChangeOnArrows && n.vertical === Te && w(B, le);
  }, w = (B, le) => {
    j(B === "right" ? -1 : 1, le);
  }, Z = (B) => {
    if (v.value.markers)
      return ja(B.value, v.value.markers);
  }, re = (B, le) => {
    switch (n.sixWeeks === !0 ? "append" : n.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [B == 0, !0];
      case "fair":
        return [B == 0 || le > B, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, oe = (B, le, Te, Be) => {
    if (n.sixWeeks && B.length < 6) {
      const Q = 6 - B.length, he = (le.getDay() + 7 - Be) % 7, ke = 6 - (Te.getDay() + 7 - Be) % 7, [Rn, Sn] = re(he, ke);
      for (let Mr = 1; Mr <= Q; Mr++)
        if (Sn ? !!(Mr % 2) == Rn : Rn) {
          const Kn = B[0].days[0], oi = Pe(fn(Kn.value, -7), Ve(le));
          B.unshift({ days: oi });
        } else {
          const Kn = B[B.length - 1], oi = Kn.days[Kn.days.length - 1], Gp = Pe(fn(oi.value, 1), Ve(le));
          B.push({ days: Gp });
        }
    }
    return B;
  }, Pe = (B, le) => {
    const Te = ee(B), Be = [];
    for (let Q = 0; Q < 7; Q++) {
      const he = fn(Te, Q), ke = Ve(he) !== le;
      Be.push({
        text: n.hideOffsetDates && ke ? "" : he.getDate(),
        value: he,
        current: !ke,
        classData: {}
      });
    }
    return Be;
  }, Oe = (B, le) => {
    const Te = [], Be = new Date(le, B), Q = new Date(le, B + 1, 0), he = n.weekStart, ke = kn(Be, { weekStartsOn: he }), Rn = (Sn) => {
      const Mr = Pe(Sn, B);
      if (Te.push({ days: Mr }), !Te[Te.length - 1].days.some(
        (Kn) => He(Et(Kn.value), Et(Q))
      )) {
        const Kn = fn(Sn, 7);
        Rn(Kn);
      }
    };
    return Rn(ke), oe(Te, Be, Q, he);
  }, ze = (B) => {
    const le = ur(ee(B.value), c.hours, c.minutes, we());
    e("date-update", le), C.value.enabled ? Gl(le, l, C.value.limit) : l.value = le, r(), kt().then(() => {
      ie();
    });
  }, Xe = (B) => p.value.noDisabledRange ? of(s.value[0], B).some((le) => S(le)) : !1, L = () => {
    s.value = l.value ? l.value.slice() : [], s.value.length === 2 && !(p.value.fixedStart || p.value.fixedEnd) && (s.value = []);
  }, ce = (B, le) => {
    const Te = [
      ee(B.value),
      fn(ee(B.value), +p.value.autoRange)
    ];
    D(Te) ? (le && Re(B.value), s.value = Te) : e("invalid-date", B.value);
  }, Re = (B) => {
    const le = Ve(ee(B)), Te = _e(ee(B));
    if ($(0, le, Te), f.value.count > 0)
      for (let Be = 1; Be < f.value.count; Be++) {
        const Q = Cv(
          Ke(ee(B), { year: R.value(Be - 1), month: be.value(Be - 1) })
        );
        $(Be, Q.month, Q.year);
      }
  }, nt = (B) => {
    if (Xe(B.value) || !I(B.value, l.value, p.value.fixedStart ? 0 : 1))
      return e("invalid-date", B.value);
    s.value = mf(ee(B.value), l, e, p);
  }, Lt = (B, le) => {
    if (L(), p.value.autoRange) return ce(B, le);
    if (p.value.fixedStart || p.value.fixedEnd) return nt(B);
    s.value[0] ? I(ee(B.value), l.value) && !Xe(B.value) ? lt(ee(B.value), ee(s.value[0])) ? (s.value.unshift(ee(B.value)), e("range-end", s.value[0])) : (s.value[1] = ee(B.value), e("range-end", s.value[1])) : (n.autoApply && e("auto-apply-invalid", B.value), e("invalid-date", B.value)) : (s.value[0] = ee(B.value), e("range-start", s.value[0]));
  }, we = (B = !0) => n.enableSeconds ? Array.isArray(c.seconds) ? B ? c.seconds[0] : c.seconds[1] : c.seconds : 0, st = (B) => {
    s.value[B] = ur(
      s.value[B],
      c.hours[B],
      c.minutes[B],
      we(B !== 1)
    );
  }, ln = () => {
    var B, le;
    s.value[0] && s.value[1] && +((B = s.value) == null ? void 0 : B[0]) > +((le = s.value) == null ? void 0 : le[1]) && (s.value.reverse(), e("range-start", s.value[0]), e("range-end", s.value[1]));
  }, ka = () => {
    s.value.length && (s.value[0] && !s.value[1] ? st(0) : (st(0), st(1), r()), ln(), l.value = s.value.slice(), Bo(s.value, e, n.autoApply, n.modelAuto));
  }, xa = (B, le = !1) => {
    if (S(B.value) || !B.current && n.hideOffsetDates) return e("invalid-date", B.value);
    if (o.value = JSON.parse(JSON.stringify(B)), !p.value.enabled) return ze(B);
    rc(c.hours) && rc(c.minutes) && !C.value.enabled && (Lt(B, le), ka());
  }, ti = (B, le) => {
    var Te;
    $(B, le.month, le.year, !0), f.value.count && !f.value.solo && ge(B), e("update-month-year", { instance: B, month: le.month, year: le.year }), t(f.value.solo ? B : void 0);
    const Be = (Te = n.flow) != null && Te.length ? n.flow[n.flowStep] : void 0;
    !le.fromNav && (Be === zt.month || Be === zt.year) && r();
  }, ni = (B, le) => {
    pf({
      value: B,
      modelValue: l,
      range: p.value.enabled,
      timezone: le ? void 0 : y.value.timezone
    }), U(), n.multiCalendars && kt().then(() => Y(!0));
  }, ri = () => {
    const B = Wl(ee(), y.value);
    !p.value.enabled && !C.value.enabled ? l.value = B : l.value && Array.isArray(l.value) && l.value[0] ? C.value.enabled ? l.value = [...l.value, B] : l.value = lt(B, l.value[0]) ? [B, l.value[0]] : [l.value[0], B] : l.value = [B], U();
  }, si = () => {
    if (Array.isArray(l.value))
      if (C.value.enabled) {
        const B = ai();
        l.value[l.value.length - 1] = k(B);
      } else
        l.value = l.value.map((B, le) => B && k(B, le));
    else
      l.value = k(l.value);
    e("time-update");
  }, ai = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;
  return {
    calendars: u,
    modelValue: l,
    month: be,
    year: R,
    time: c,
    disabledTimesConfig: de,
    today: d,
    validateTime: ne,
    getCalendarDays: Oe,
    getMarker: Z,
    handleScroll: J,
    handleSwipe: w,
    handleArrow: se,
    selectDate: xa,
    updateMonthYear: ti,
    presetDate: ni,
    selectCurrentDate: ri,
    updateTime: (B, le = !0, Te = !1) => {
      x(B, le, Te, si);
    },
    assignMonthAndYear: P,
    setStartTime: ue
  };
}, F0 = { key: 0 }, z0 = /* @__PURE__ */ Fe({
  __name: "DatePicker",
  props: {
    ...Mn
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, {
      calendars: a,
      month: o,
      year: i,
      modelValue: l,
      time: u,
      disabledTimesConfig: c,
      today: d,
      validateTime: f,
      getCalendarDays: h,
      getMarker: p,
      handleArrow: g,
      handleScroll: y,
      handleSwipe: v,
      selectDate: C,
      updateMonthYear: M,
      presetDate: S,
      selectCurrentDate: D,
      updateTime: I,
      assignMonthAndYear: x,
      setStartTime: k
    } = B0(s, r, ve, P), _ = Ur(), { setHoverDate: E, getDayClassData: ne, clearHoverDate: de } = rb(l, s), { defaultedMultiCalendars: be } = rt(s), R = W([]), F = W([]), $ = W(null), U = sn(_, "calendar"), ue = sn(_, "monthYear"), q = sn(_, "timePicker"), ie = (J) => {
      s.shadow || r("mount", J);
    };
    $t(
      a,
      () => {
        s.shadow || setTimeout(() => {
          r("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), $t(
      be,
      (J, se) => {
        J.count - se.count > 0 && x();
      },
      { deep: !0 }
    );
    const Y = G(() => (J) => h(o.value(J), i.value(J)).map((se) => ({
      ...se,
      days: se.days.map((w) => (w.marker = p(w), w.classData = ne(w), w))
    })));
    function ve(J) {
      var se;
      J || J === 0 ? (se = F.value[J]) == null || se.triggerTransition(o.value(J), i.value(J)) : F.value.forEach((w, Z) => w.triggerTransition(o.value(Z), i.value(Z)));
    }
    function P() {
      r("update-flow-step");
    }
    const V = (J, se = !1) => {
      C(J, se), s.spaceConfirm && r("select-date");
    }, K = (J, se, w = 0) => {
      var Z;
      (Z = R.value[w]) == null || Z.toggleMonthPicker(J, se);
    }, X = (J, se, w = 0) => {
      var Z;
      (Z = R.value[w]) == null || Z.toggleYearPicker(J, se);
    }, m = (J, se, w) => {
      var Z;
      (Z = $.value) == null || Z.toggleTimePicker(J, se, w);
    }, A = (J, se) => {
      var w;
      if (!s.range) {
        const Z = l.value ? l.value : d, re = se ? new Date(se) : Z, oe = J ? kn(re, { weekStartsOn: 1 }) : Ld(re, { weekStartsOn: 1 });
        C({
          value: oe,
          current: Ve(re) === o.value(0),
          text: "",
          classData: {}
        }), (w = document.getElementById(Zi(oe))) == null || w.focus();
      }
    }, j = (J) => {
      var se;
      (se = R.value[0]) == null || se.handleMonthYearChange(J, !0);
    }, ge = (J) => {
      M(0, { month: o.value(0), year: i.value(0) + (J ? 1 : -1), fromNav: !0 });
    }, z = (J, se) => {
      J === zt.time && r(`time-picker-${se ? "open" : "close"}`), r("overlay-toggle", { open: se, overlay: J });
    }, Se = (J) => {
      r("overlay-toggle", { open: !1, overlay: J }), r("focus-menu");
    };
    return e({
      clearHoverDate: de,
      presetDate: S,
      selectCurrentDate: D,
      toggleMonthPicker: K,
      toggleYearPicker: X,
      toggleTimePicker: m,
      handleArrow: g,
      updateMonthYear: M,
      getSidebarProps: () => ({
        modelValue: l,
        month: o,
        year: i,
        time: u,
        updateTime: I,
        updateMonthYear: M,
        selectDate: C,
        presetDate: S
      }),
      changeMonth: j,
      changeYear: ge,
      selectWeekDate: A,
      setStartTime: k
    }), (J, se) => (T(), N(Ee, null, [
      Qe(Lo, {
        "multi-calendars": b(be).count,
        collapse: J.collapse,
        "is-mobile": J.isMobile
      }, {
        default: Ae(({ instance: w, index: Z }) => [
          J.disableMonthYearSelect ? H("", !0) : (T(), Ne(E0, Mt({
            key: 0,
            ref: (re) => {
              re && (R.value[Z] = re);
            },
            months: b(Xd)(J.formatLocale, J.locale, J.monthNameFormat),
            years: b(jl)(J.yearRange, J.locale, J.reverseYears),
            month: b(o)(w),
            year: b(i)(w),
            instance: w
          }, J.$props, {
            onMount: se[0] || (se[0] = (re) => ie(b(_r).header)),
            onResetFlow: se[1] || (se[1] = (re) => J.$emit("reset-flow")),
            onUpdateMonthYear: (re) => b(M)(w, re),
            onOverlayClosed: Se,
            onOverlayOpened: se[2] || (se[2] = (re) => J.$emit("overlay-toggle", { open: !0, overlay: re }))
          }), Ht({ _: 2 }, [
            Ye(b(ue), (re, oe) => ({
              name: re,
              fn: Ae((Pe) => [
                fe(J.$slots, re, Ct(Xt(Pe)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Qe(L0, Mt({
            ref: (re) => {
              re && (F.value[Z] = re);
            },
            "mapped-dates": Y.value(w),
            month: b(o)(w),
            year: b(i)(w),
            instance: w
          }, J.$props, {
            onSelectDate: (re) => b(C)(re, w !== 1),
            onHandleSpace: (re) => V(re, w !== 1),
            onSetHoverDate: se[3] || (se[3] = (re) => b(E)(re)),
            onHandleScroll: (re) => b(y)(re, w),
            onHandleSwipe: (re) => b(v)(re, w),
            onMount: se[4] || (se[4] = (re) => ie(b(_r).calendar)),
            onResetFlow: se[5] || (se[5] = (re) => J.$emit("reset-flow")),
            onTooltipOpen: se[6] || (se[6] = (re) => J.$emit("tooltip-open", re)),
            onTooltipClose: se[7] || (se[7] = (re) => J.$emit("tooltip-close", re))
          }), Ht({ _: 2 }, [
            Ye(b(U), (re, oe) => ({
              name: re,
              fn: Ae((Pe) => [
                fe(J.$slots, re, Ct(Xt({ ...Pe })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      J.enableTimePicker ? (T(), N("div", F0, [
        J.$slots["time-picker"] ? fe(J.$slots, "time-picker", Ct(Mt({ key: 0 }, { time: b(u), updateTime: b(I) }))) : (T(), Ne(yf, Mt({
          key: 1,
          ref_key: "timePickerRef",
          ref: $
        }, J.$props, {
          hours: b(u).hours,
          minutes: b(u).minutes,
          seconds: b(u).seconds,
          "internal-model-value": J.internalModelValue,
          "disabled-times-config": b(c),
          "validate-time": b(f),
          onMount: se[8] || (se[8] = (w) => ie(b(_r).timePicker)),
          "onUpdate:hours": se[9] || (se[9] = (w) => b(I)(w)),
          "onUpdate:minutes": se[10] || (se[10] = (w) => b(I)(w, !1)),
          "onUpdate:seconds": se[11] || (se[11] = (w) => b(I)(w, !1, !0)),
          onResetFlow: se[12] || (se[12] = (w) => J.$emit("reset-flow")),
          onOverlayClosed: se[13] || (se[13] = (w) => z(w, !1)),
          onOverlayOpened: se[14] || (se[14] = (w) => z(w, !0)),
          onAmPmChange: se[15] || (se[15] = (w) => J.$emit("am-pm-change", w))
        }), Ht({ _: 2 }, [
          Ye(b(q), (w, Z) => ({
            name: w,
            fn: Ae((re) => [
              fe(J.$slots, w, Ct(Xt(re)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : H("", !0)
    ], 64));
  }
}), V0 = (n, e) => {
  const t = W(), {
    defaultedMultiCalendars: r,
    defaultedConfig: s,
    defaultedHighlight: a,
    defaultedRange: o,
    propDates: i,
    defaultedFilters: l,
    defaultedMultiDates: u
  } = rt(n), { modelValue: c, year: d, month: f, calendars: h } = ga(n, e), { isDisabled: p } = br(n), { selectYear: g, groupedYears: y, showYearPicker: v, isDisabled: C, toggleYearPicker: M, handleYearSelect: S, handleYear: D } = gf({
    modelValue: c,
    multiCalendars: r,
    range: o,
    highlight: a,
    calendars: h,
    propDates: i,
    month: f,
    year: d,
    filters: l,
    props: n,
    emit: e
  }), I = (F, $) => [F, $].map((U) => Pn(U, "MMMM", { locale: n.formatLocale })).join("-"), x = G(() => (F) => c.value ? Array.isArray(c.value) ? c.value.some(($) => Ku(F, $)) : Ku(c.value, F) : !1), k = (F) => {
    if (o.value.enabled) {
      if (Array.isArray(c.value)) {
        const $ = He(F, c.value[0]) || He(F, c.value[1]);
        return Zs(c.value, t.value, F) && !$;
      }
      return !1;
    }
    return !1;
  }, _ = (F, $) => F.quarter === Hu($) && F.year === _e($), E = (F) => typeof a.value == "function" ? a.value({ quarter: Hu(F), year: _e(F) }) : !!a.value.quarters.find(($) => _($, F)), ne = G(() => (F) => {
    const $ = Ke(/* @__PURE__ */ new Date(), { year: d.value(F) });
    return gg({
      start: Qs($),
      end: $d($)
    }).map((U) => {
      const ue = Ar(U), q = Yu(U), ie = p(U), Y = k(ue), ve = E(ue);
      return {
        text: I(ue, q),
        value: ue,
        active: x.value(ue),
        highlighted: ve,
        disabled: ie,
        isBetween: Y
      };
    });
  }), de = (F) => {
    Gl(F, c, u.value.limit), e("auto-apply", !0);
  }, be = (F) => {
    c.value = Jl(c, F, e), Bo(c.value, e, n.autoApply, n.modelAuto);
  }, R = (F) => {
    c.value = F, e("auto-apply");
  };
  return {
    defaultedConfig: s,
    defaultedMultiCalendars: r,
    groupedYears: y,
    year: d,
    isDisabled: C,
    quarters: ne,
    showYearPicker: v,
    modelValue: c,
    setHoverDate: (F) => {
      t.value = F;
    },
    selectYear: g,
    selectQuarter: (F, $, U) => {
      if (!U)
        return h.value[$].month = Ve(Yu(F)), u.value.enabled ? de(F) : o.value.enabled ? be(F) : R(F);
    },
    toggleYearPicker: M,
    handleYearSelect: S,
    handleYear: D
  };
}, H0 = { class: "dp--quarter-items" }, Y0 = ["data-test-id", "disabled", "onClick", "onMouseover"], W0 = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...Mn
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, a = Ur(), o = sn(a, "yearMode"), {
      defaultedMultiCalendars: i,
      defaultedConfig: l,
      groupedYears: u,
      year: c,
      isDisabled: d,
      quarters: f,
      modelValue: h,
      showYearPicker: p,
      setHoverDate: g,
      selectQuarter: y,
      toggleYearPicker: v,
      handleYearSelect: C,
      handleYear: M
    } = V0(s, r);
    return e({ getSidebarProps: () => ({
      modelValue: h,
      year: c,
      selectQuarter: y,
      handleYearSelect: C,
      handleYear: M
    }) }), (S, D) => (T(), Ne(Lo, {
      "multi-calendars": b(i).count,
      collapse: S.collapse,
      stretch: "",
      "is-mobile": S.isMobile
    }, {
      default: Ae(({ instance: I }) => [
        O("div", {
          class: "dp-quarter-picker-wrap",
          style: Zt({ minHeight: `${b(l).modeHeight}px` })
        }, [
          S.$slots["top-extra"] ? fe(S.$slots, "top-extra", {
            key: 0,
            value: S.internalModelValue
          }) : H("", !0),
          O("div", null, [
            Qe(hf, Mt(S.$props, {
              items: b(u)(I),
              instance: I,
              "show-year-picker": b(p)[I],
              year: b(c)(I),
              "is-disabled": (x) => b(d)(I, x),
              onHandleYear: (x) => b(M)(I, x),
              onYearSelect: (x) => b(C)(x, I),
              onToggleYearPicker: (x) => b(v)(I, x == null ? void 0 : x.flow, x == null ? void 0 : x.show)
            }), Ht({ _: 2 }, [
              Ye(b(o), (x, k) => ({
                name: x,
                fn: Ae((_) => [
                  fe(S.$slots, x, Ct(Xt(_)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          O("div", H0, [
            (T(!0), N(Ee, null, Ye(b(f)(I), (x, k) => (T(), N("div", { key: k }, [
              O("button", {
                type: "button",
                class: pe(["dp--qr-btn", {
                  "dp--qr-btn-active": x.active,
                  "dp--qr-btn-between": x.isBetween,
                  "dp--qr-btn-disabled": x.disabled,
                  "dp--highlighted": x.highlighted
                }]),
                "data-test-id": x.value,
                disabled: x.disabled,
                onClick: (_) => b(y)(x.value, I, x.disabled),
                onMouseover: (_) => b(g)(x.value)
              }, [
                S.$slots.quarter ? fe(S.$slots, "quarter", {
                  key: 0,
                  value: x.value,
                  text: x.text
                }) : (T(), N(Ee, { key: 1 }, [
                  wt(Ce(x.text), 1)
                ], 64))
              ], 42, Y0)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), bf = (n, e) => {
  const t = W(0);
  Pt(() => {
    r(), window.addEventListener("resize", r, { passive: !0 });
  }), jr(() => {
    window.removeEventListener("resize", r);
  });
  const r = () => {
    t.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: G(
      () => t.value <= n.value.mobileBreakpoint && !e ? !0 : void 0
    )
  };
}, j0 = ["id", "tabindex", "role", "aria-label"], U0 = {
  key: 0,
  class: "dp--menu-load-container"
}, q0 = {
  key: 1,
  class: "dp--menu-header"
}, K0 = ["data-dp-mobile"], G0 = {
  key: 0,
  class: "dp__sidebar_left"
}, J0 = ["data-dp-mobile"], Q0 = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], X0 = {
  key: 2,
  class: "dp__sidebar_right"
}, Z0 = {
  key: 3,
  class: "dp__action_extra"
}, sc = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...$o,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, a = W(null), o = G(() => {
      const { openOnTop: L, ...ce } = s;
      return {
        ...ce,
        isMobile: y.value,
        flowStep: be.value,
        menuWrapRef: a.value
      };
    }), { setMenuFocused: i, setShiftKey: l, control: u } = ff(), c = Ur(), { defaultedTextInput: d, defaultedInline: f, defaultedConfig: h, defaultedUI: p, handleEventPropagation: g } = rt(s), { isMobile: y } = bf(h, s.shadow), v = W(null), C = W(0), M = W(null), S = W(!1), D = W(null), I = W(!1), x = (L) => {
      I.value = !0, h.value.allowPreventDefault && L.preventDefault(), lr(L, h.value, !0);
    };
    Pt(() => {
      if (!s.shadow) {
        S.value = !0, k(), window.addEventListener("resize", k);
        const L = vt(a);
        L && !d.value.enabled && !f.value.enabled && (i(!0), ie()), L && (L.addEventListener("pointerdown", x), L.addEventListener("mousedown", x));
      }
      document.addEventListener("mousedown", Xe);
    }), jr(() => {
      window.removeEventListener("resize", k), document.removeEventListener("mousedown", Xe);
      const L = vt(a);
      L && (L.removeEventListener("pointerdown", x), L.removeEventListener("mousedown", x));
    });
    const k = () => {
      const L = vt(M);
      L && (C.value = L.getBoundingClientRect().width);
    }, { arrowRight: _, arrowLeft: E, arrowDown: ne, arrowUp: de } = vr(), { flowStep: be, updateFlowStep: R, childMount: F, resetFlow: $, handleFlow: U } = sb(s, r, D), ue = G(() => s.monthPicker ? l0 : s.yearPicker ? c0 : s.timePicker ? S0 : s.quarterPicker ? W0 : z0), q = G(() => {
      var L;
      if (h.value.arrowLeft) return h.value.arrowLeft;
      const ce = (L = a.value) == null ? void 0 : L.getBoundingClientRect(), Re = s.getInputRect();
      return (Re == null ? void 0 : Re.width) < (C == null ? void 0 : C.value) && (Re == null ? void 0 : Re.left) <= ((ce == null ? void 0 : ce.left) ?? 0) ? `${(Re == null ? void 0 : Re.width) / 2}px` : (Re == null ? void 0 : Re.right) >= ((ce == null ? void 0 : ce.right) ?? 0) && (Re == null ? void 0 : Re.width) < (C == null ? void 0 : C.value) ? `${(C == null ? void 0 : C.value) - (Re == null ? void 0 : Re.width) / 2}px` : "50%";
    }), ie = () => {
      const L = vt(a);
      L && L.focus({ preventScroll: !0 });
    }, Y = G(() => {
      var L;
      return ((L = D.value) == null ? void 0 : L.getSidebarProps()) || {};
    }), ve = () => {
      s.openOnTop && r("recalculate-position");
    }, P = sn(c, "action"), V = G(() => s.monthPicker || s.yearPicker ? sn(c, "monthYear") : s.timePicker ? sn(c, "timePicker") : sn(c, "shared")), K = G(() => s.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), X = G(() => ({
      dp__menu_disabled: s.disabled,
      dp__menu_readonly: s.readonly,
      "dp-menu-loading": s.loading
    })), m = G(
      () => ({
        dp__menu: !0,
        dp__menu_index: !f.value.enabled,
        dp__relative: f.value.enabled,
        ...p.value.menu ?? {}
      })
    ), A = (L) => {
      lr(L, h.value, !0);
    }, j = (L) => {
      s.escClose && (r("close-picker"), g(L));
    }, ge = (L) => {
      if (s.arrowNavigation) {
        if (L === Wt.up) return de();
        if (L === Wt.down) return ne();
        if (L === Wt.left) return E();
        if (L === Wt.right) return _();
      } else L === Wt.left || L === Wt.up ? w("handleArrow", Wt.left, 0, L === Wt.up) : w("handleArrow", Wt.right, 0, L === Wt.down);
    }, z = (L) => {
      l(L.shiftKey), !s.disableMonthYearSelect && L.code === et.tab && L.target.classList.contains("dp__menu") && u.value.shiftKeyInMenu && (L.preventDefault(), lr(L, h.value, !0), r("close-picker"));
    }, Se = () => {
      ie(), r("time-picker-close");
    }, J = (L) => {
      var ce, Re, nt;
      (ce = D.value) == null || ce.toggleTimePicker(!1, !1), (Re = D.value) == null || Re.toggleMonthPicker(!1, !1, L), (nt = D.value) == null || nt.toggleYearPicker(!1, !1, L);
    }, se = (L, ce = 0) => {
      var Re, nt, Lt;
      return L === "month" ? (Re = D.value) == null ? void 0 : Re.toggleMonthPicker(!1, !0, ce) : L === "year" ? (nt = D.value) == null ? void 0 : nt.toggleYearPicker(!1, !0, ce) : L === "time" ? (Lt = D.value) == null ? void 0 : Lt.toggleTimePicker(!0, !1) : J(ce);
    }, w = (L, ...ce) => {
      var Re, nt;
      (Re = D.value) != null && Re[L] && ((nt = D.value) == null || nt[L](...ce));
    }, Z = () => {
      w("selectCurrentDate");
    }, re = (L, ce) => {
      w("presetDate", tm(L), ce);
    }, oe = () => {
      w("clearHoverDate");
    }, Pe = (L, ce) => {
      w("updateMonthYear", L, ce);
    }, Oe = (L, ce) => {
      L.preventDefault(), ge(ce);
    }, ze = (L) => {
      var ce, Re, nt;
      if (z(L), L.key === et.home || L.key === et.end)
        return w(
          "selectWeekDate",
          L.key === et.home,
          L.target.getAttribute("id")
        );
      switch ((L.key === et.pageUp || L.key === et.pageDown) && (L.shiftKey ? (w("changeYear", L.key === et.pageUp), (ce = Qi(a.value, "overlay-year")) == null || ce.focus()) : (w("changeMonth", L.key === et.pageUp), (Re = Qi(a.value, L.key === et.pageUp ? "action-prev" : "action-next")) == null || Re.focus()), L.target.getAttribute("id") && ((nt = a.value) == null || nt.focus({ preventScroll: !0 }))), L.key) {
        case et.esc:
          return j(L);
        case et.arrowLeft:
          return Oe(L, Wt.left);
        case et.arrowRight:
          return Oe(L, Wt.right);
        case et.arrowUp:
          return Oe(L, Wt.up);
        case et.arrowDown:
          return Oe(L, Wt.down);
        default:
          return;
      }
    }, Xe = (L) => {
      var ce;
      f.value.enabled && !f.value.input && !((ce = a.value) != null && ce.contains(L.target)) && I.value && (I.value = !1, r("menu-blur"));
    };
    return e({
      updateMonthYear: Pe,
      switchView: se,
      handleFlow: U,
      onValueCleared: () => {
        var L, ce;
        (ce = (L = D.value) == null ? void 0 : L.setStartTime) == null || ce.call(L);
      }
    }), (L, ce) => {
      var Re, nt, Lt;
      return T(), N("div", {
        id: L.uid ? `dp-menu-${L.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: a,
        tabindex: b(f).enabled ? void 0 : "0",
        role: b(f).enabled ? void 0 : "dialog",
        "aria-label": (Re = L.ariaLabels) == null ? void 0 : Re.menu,
        class: pe(m.value),
        style: Zt({ "--dp-arrow-left": q.value }),
        onMouseleave: oe,
        onClick: A,
        onKeydown: ze
      }, [
        (L.disabled || L.readonly) && b(f).enabled || L.loading ? (T(), N("div", {
          key: 0,
          class: pe(X.value)
        }, [
          L.loading ? (T(), N("div", U0, ce[19] || (ce[19] = [
            O("span", { class: "dp--menu-loader" }, null, -1)
          ]))) : H("", !0)
        ], 2)) : H("", !0),
        L.$slots["menu-header"] ? (T(), N("div", q0, [
          fe(L.$slots, "menu-header")
        ])) : H("", !0),
        !b(f).enabled && !L.teleportCenter ? (T(), N("div", {
          key: 2,
          class: pe(K.value)
        }, null, 2)) : H("", !0),
        O("div", {
          ref_key: "innerMenuRef",
          ref: M,
          class: pe({
            dp__menu_content_wrapper: ((nt = L.presetDates) == null ? void 0 : nt.length) || !!L.$slots["left-sidebar"] || !!L.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": n.collapse && (((Lt = L.presetDates) == null ? void 0 : Lt.length) || !!L.$slots["left-sidebar"] || !!L.$slots["right-sidebar"])
          }),
          "data-dp-mobile": b(y),
          style: Zt({ "--dp-menu-width": `${C.value}px` })
        }, [
          L.$slots["left-sidebar"] ? (T(), N("div", G0, [
            fe(L.$slots, "left-sidebar", Ct(Xt(Y.value)))
          ])) : H("", !0),
          L.presetDates.length ? (T(), N("div", {
            key: 1,
            class: pe({ "dp--preset-dates-collapsed": n.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": b(y)
          }, [
            (T(!0), N(Ee, null, Ye(L.presetDates, (we, st) => (T(), N(Ee, { key: st }, [
              we.slot ? fe(L.$slots, we.slot, {
                key: 0,
                presetDate: re,
                label: we.label,
                value: we.value
              }) : (T(), N("button", {
                key: 1,
                type: "button",
                style: Zt(we.style || {}),
                class: pe(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": n.collapse }]),
                "data-test-id": we.testId ?? void 0,
                "data-dp-mobile": b(y),
                onClick: Qt((ln) => re(we.value, we.noTz), ["prevent"]),
                onKeydown: (ln) => b(jt)(ln, () => re(we.value, we.noTz), !0)
              }, Ce(we.label), 47, Q0))
            ], 64))), 128))
          ], 10, J0)) : H("", !0),
          O("div", {
            ref_key: "calendarWrapperRef",
            ref: v,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (T(), Ne(Ro(ue.value), Mt({
              ref_key: "dynCmpRef",
              ref: D
            }, o.value, {
              "flow-step": b(be),
              onMount: b(F),
              onUpdateFlowStep: b(R),
              onResetFlow: b($),
              onFocusMenu: ie,
              onSelectDate: ce[0] || (ce[0] = (we) => L.$emit("select-date")),
              onDateUpdate: ce[1] || (ce[1] = (we) => L.$emit("date-update", we)),
              onTooltipOpen: ce[2] || (ce[2] = (we) => L.$emit("tooltip-open", we)),
              onTooltipClose: ce[3] || (ce[3] = (we) => L.$emit("tooltip-close", we)),
              onAutoApply: ce[4] || (ce[4] = (we) => L.$emit("auto-apply", we)),
              onRangeStart: ce[5] || (ce[5] = (we) => L.$emit("range-start", we)),
              onRangeEnd: ce[6] || (ce[6] = (we) => L.$emit("range-end", we)),
              onInvalidFixedRange: ce[7] || (ce[7] = (we) => L.$emit("invalid-fixed-range", we)),
              onTimeUpdate: ce[8] || (ce[8] = (we) => L.$emit("time-update")),
              onAmPmChange: ce[9] || (ce[9] = (we) => L.$emit("am-pm-change", we)),
              onTimePickerOpen: ce[10] || (ce[10] = (we) => L.$emit("time-picker-open", we)),
              onTimePickerClose: Se,
              onRecalculatePosition: ve,
              onUpdateMonthYear: ce[11] || (ce[11] = (we) => L.$emit("update-month-year", we)),
              onAutoApplyInvalid: ce[12] || (ce[12] = (we) => L.$emit("auto-apply-invalid", we)),
              onInvalidDate: ce[13] || (ce[13] = (we) => L.$emit("invalid-date", we)),
              onOverlayToggle: ce[14] || (ce[14] = (we) => L.$emit("overlay-toggle", we)),
              "onUpdate:internalModelValue": ce[15] || (ce[15] = (we) => L.$emit("update:internal-model-value", we))
            }), Ht({ _: 2 }, [
              Ye(V.value, (we, st) => ({
                name: we,
                fn: Ae((ln) => [
                  fe(L.$slots, we, Ct(Xt({ ...ln })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          L.$slots["right-sidebar"] ? (T(), N("div", X0, [
            fe(L.$slots, "right-sidebar", Ct(Xt(Y.value)))
          ])) : H("", !0),
          L.$slots["action-extra"] ? (T(), N("div", Z0, [
            L.$slots["action-extra"] ? fe(L.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: Z
            }) : H("", !0)
          ])) : H("", !0)
        ], 14, K0),
        !L.autoApply || b(h).keepActionRow ? (T(), Ne(Zv, Mt({
          key: 3,
          "menu-mount": S.value
        }, o.value, {
          "calendar-width": C.value,
          onClosePicker: ce[16] || (ce[16] = (we) => L.$emit("close-picker")),
          onSelectDate: ce[17] || (ce[17] = (we) => L.$emit("select-date")),
          onInvalidSelect: ce[18] || (ce[18] = (we) => L.$emit("invalid-select")),
          onSelectNow: Z
        }), Ht({ _: 2 }, [
          Ye(b(P), (we, st) => ({
            name: we,
            fn: Ae((ln) => [
              fe(L.$slots, we, Ct(Xt({ ...ln })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : H("", !0)
      ], 46, j0);
    };
  }
});
var es = /* @__PURE__ */ ((n) => (n.center = "center", n.left = "left", n.right = "right", n))(es || {});
const eb = ({
  menuRef: n,
  menuRefInner: e,
  inputRef: t,
  pickerWrapperRef: r,
  inline: s,
  emit: a,
  props: o,
  slots: i
}) => {
  const { defaultedConfig: l } = rt(o), u = W({}), c = W(!1), d = W({
    top: "0",
    left: "0"
  }), f = W(!1), h = Js(o, "teleportCenter");
  $t(h, () => {
    d.value = JSON.parse(JSON.stringify({})), D();
  });
  const p = ($) => {
    if (o.teleport) {
      const U = $.getBoundingClientRect();
      return {
        left: U.left + window.scrollX,
        top: U.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, g = ($, U) => {
    d.value.left = `${$ + U - u.value.width}px`;
  }, y = ($) => {
    d.value.left = `${$}px`;
  }, v = ($, U) => {
    o.position === es.left && y($), o.position === es.right && g($, U), o.position === es.center && (d.value.left = `${$ + U / 2 - u.value.width / 2}px`);
  }, C = ($) => {
    const { width: U, height: ue } = $.getBoundingClientRect(), { top: q, left: ie } = p($);
    return { top: +q, left: +ie, width: U, height: ue };
  }, M = () => {
    d.value.left = "50%", d.value.top = "50%", d.value.transform = "translate(-50%, -50%)", d.value.position = "fixed", delete d.value.opacity;
  }, S = () => {
    const $ = vt(t);
    d.value = o.altPosition($);
  }, D = ($ = !0) => {
    var U;
    if (!s.value.enabled) {
      if (h.value) return M();
      if (o.altPosition !== null) return S();
      if ($) {
        const ue = o.teleport ? (U = e.value) == null ? void 0 : U.$el : n.value;
        ue && (u.value = ue.getBoundingClientRect()), a("recalculate-position");
      }
      return de();
    }
  }, I = ({ inputEl: $, left: U, width: ue }) => {
    window.screen.width > 768 && !c.value && v(U, ue), _($);
  }, x = ($) => {
    const { top: U, left: ue, height: q, width: ie } = C($);
    d.value.top = `${q + U + +o.offset}px`, f.value = !1, c.value || (d.value.left = `${ue + ie / 2 - u.value.width / 2}px`), I({ inputEl: $, left: ue, width: ie });
  }, k = ($) => {
    const { top: U, left: ue, width: q } = C($);
    d.value.top = `${U - +o.offset - u.value.height}px`, f.value = !0, I({ inputEl: $, left: ue, width: q });
  }, _ = ($) => {
    if (o.autoPosition) {
      const { left: U, width: ue } = C($), { left: q, right: ie } = u.value;
      if (!c.value) {
        if (Math.abs(q) !== Math.abs(ie)) {
          if (q <= 0)
            return c.value = !0, y(U);
          if (ie >= document.documentElement.clientWidth)
            return c.value = !0, g(U, ue);
        }
        return v(U, ue);
      }
    }
  }, E = () => {
    const $ = vt(t);
    if ($) {
      if (o.autoPosition === gn.top) return gn.top;
      if (o.autoPosition === gn.bottom) return gn.bottom;
      const { height: U } = u.value, { top: ue, height: q } = $.getBoundingClientRect(), ie = window.innerHeight - ue - q, Y = ue;
      return U <= ie ? gn.bottom : U > ie && U <= Y ? gn.top : ie >= Y ? gn.bottom : gn.top;
    }
    return gn.bottom;
  }, ne = ($) => E() === gn.bottom ? x($) : k($), de = () => {
    const $ = vt(t);
    if ($)
      return o.autoPosition ? ne($) : x($);
  }, be = function($) {
    if ($) {
      const U = $.scrollHeight > $.clientHeight, ue = window.getComputedStyle($).overflowY.indexOf("hidden") !== -1;
      return U && !ue;
    }
    return !0;
  }, R = function($) {
    return !$ || $ === document.body || $.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : be($) ? $ : R(
      $.assignedSlot && l.value.shadowDom ? $.assignedSlot.parentNode : $.parentNode
    );
  }, F = ($) => {
    if ($)
      switch (o.position) {
        case es.left:
          return { left: 0, transform: "translateX(0)" };
        case es.right:
          return { left: `${$.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${$.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: f,
    menuStyle: d,
    xCorrect: c,
    setMenuPosition: D,
    getScrollableParent: R,
    shadowRender: ($, U, ue) => {
      var q, ie, Y;
      const ve = document.createElement("div"), P = (q = vt(t)) == null ? void 0 : q.getBoundingClientRect();
      ve.setAttribute("id", "dp--temp-container");
      const V = (ie = r.value) != null && ie.clientWidth ? r.value : document.body;
      V.append(ve);
      const K = F(P), X = l.value.shadowDom ? Object.keys(i).filter(
        (A) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(A)
      ) : Object.keys(i), m = fa(
        U,
        {
          ...ue,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...K }
        },
        Object.fromEntries(X.map((A) => [A, i[A]]))
      );
      $ != null && (m.appContext = $.appContext), $u(m, ve), u.value = (Y = m.el) == null ? void 0 : Y.getBoundingClientRect(), $u(null, ve), V.removeChild(ve);
    }
  };
}, Jn = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], tb = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], nb = {
  all: () => Jn,
  monthYear: () => Jn.filter((n) => n.use.includes("month-year")),
  input: () => tb,
  timePicker: () => Jn.filter((n) => n.use.includes("time")),
  action: () => Jn.filter((n) => n.use.includes("action")),
  calendar: () => Jn.filter((n) => n.use.includes("calendar")),
  menu: () => Jn.filter((n) => n.use.includes("menu")),
  shared: () => Jn.filter((n) => n.use.includes("shared")),
  yearMode: () => Jn.filter((n) => n.use.includes("year-mode"))
}, sn = (n, e, t) => {
  const r = [];
  return nb[e]().forEach((s) => {
    n[s.name] && r.push(s.name);
  }), t != null && t.length && t.forEach((s) => {
    s.slot && r.push(s.slot);
  }), r;
}, ma = (n) => {
  const e = G(() => (r) => n.value ? r ? n.value.open : n.value.close : ""), t = G(() => (r) => n.value ? r ? n.value.menuAppearTop : n.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!n.value, menuTransition: t };
}, ga = (n, e, t) => {
  const { defaultedRange: r, defaultedTz: s } = rt(n), a = ee(en(ee(), s.value.timezone)), o = W([{ month: Ve(a), year: _e(a) }]), i = (f) => {
    const h = {
      hours: Un(a),
      minutes: mr(a),
      seconds: 0
    };
    return r.value.enabled ? [h[f], h[f]] : h[f];
  }, l = Ts({
    hours: i("hours"),
    minutes: i("minutes"),
    seconds: i("seconds")
  });
  $t(
    r,
    (f, h) => {
      f.enabled !== h.enabled && (l.hours = i("hours"), l.minutes = i("minutes"), l.seconds = i("seconds"));
    },
    { deep: !0 }
  );
  const u = G({
    get: () => n.internalModelValue,
    set: (f) => {
      !n.readonly && !n.disabled && e("update:internal-model-value", f);
    }
  }), c = G(
    () => (f) => o.value[f] ? o.value[f].month : 0
  ), d = G(
    () => (f) => o.value[f] ? o.value[f].year : 0
  );
  return $t(
    u,
    (f, h) => {
      t && JSON.stringify(f ?? {}) !== JSON.stringify(h ?? {}) && t();
    },
    { deep: !0 }
  ), {
    calendars: o,
    time: l,
    modelValue: u,
    month: c,
    year: d,
    today: a
  };
}, rb = (n, e) => {
  const {
    defaultedMultiCalendars: t,
    defaultedMultiDates: r,
    defaultedUI: s,
    defaultedHighlight: a,
    defaultedTz: o,
    propDates: i,
    defaultedRange: l
  } = rt(e), { isDisabled: u } = br(e), c = W(null), d = W(en(/* @__PURE__ */ new Date(), o.value.timezone)), f = (m) => {
    !m.current && e.hideOffsetDates || (c.value = m.value);
  }, h = () => {
    c.value = null;
  }, p = (m) => Array.isArray(n.value) && l.value.enabled && n.value[0] && c.value ? m ? ht(c.value, n.value[0]) : lt(c.value, n.value[0]) : !0, g = (m, A) => {
    const j = () => n.value ? A ? n.value[0] || null : n.value[1] : null, ge = n.value && Array.isArray(n.value) ? j() : null;
    return He(ee(m.value), ge);
  }, y = (m) => {
    const A = Array.isArray(n.value) ? n.value[0] : null;
    return m ? !lt(c.value ?? null, A) : !0;
  }, v = (m, A = !0) => (l.value.enabled || e.weekPicker) && Array.isArray(n.value) && n.value.length === 2 ? e.hideOffsetDates && !m.current ? !1 : He(ee(m.value), n.value[A ? 0 : 1]) : l.value.enabled ? g(m, A) && y(A) || He(m.value, Array.isArray(n.value) ? n.value[0] : null) && p(A) : !1, C = (m, A) => {
    if (Array.isArray(n.value) && n.value[0] && n.value.length === 1) {
      const j = He(m.value, c.value);
      return A ? ht(n.value[0], m.value) && j : lt(n.value[0], m.value) && j;
    }
    return !1;
  }, M = (m) => !n.value || e.hideOffsetDates && !m.current ? !1 : l.value.enabled ? e.modelAuto && Array.isArray(n.value) ? He(m.value, n.value[0] ? n.value[0] : d.value) : !1 : r.value.enabled && Array.isArray(n.value) ? n.value.some((A) => He(A, m.value)) : He(m.value, n.value ? n.value : d.value), S = (m) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        if (e.hideOffsetDates && !m.current) return !1;
        const A = fn(c.value, +l.value.autoRange), j = Vn(ee(c.value), e.weekStart);
        return e.weekPicker ? He(j[1], ee(m.value)) : He(A, ee(m.value));
      }
      return !1;
    }
    return !1;
  }, D = (m) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        const A = fn(c.value, +l.value.autoRange);
        if (e.hideOffsetDates && !m.current) return !1;
        const j = Vn(ee(c.value), e.weekStart);
        return e.weekPicker ? ht(m.value, j[0]) && lt(m.value, j[1]) : ht(m.value, c.value) && lt(m.value, A);
      }
      return !1;
    }
    return !1;
  }, I = (m) => {
    if (l.value.autoRange || e.weekPicker) {
      if (c.value) {
        if (e.hideOffsetDates && !m.current) return !1;
        const A = Vn(ee(c.value), e.weekStart);
        return e.weekPicker ? He(A[0], m.value) : He(c.value, m.value);
      }
      return !1;
    }
    return !1;
  }, x = (m) => Zs(n.value, c.value, m.value), k = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, _ = () => e.modelAuto ? Zd(e.internalModelValue) : !0, E = (m) => {
    if (e.weekPicker) return !1;
    const A = l.value.enabled ? !v(m) && !v(m, !1) : !0;
    return !u(m.value) && !M(m) && !(!m.current && e.hideOffsetDates) && A;
  }, ne = (m) => l.value.enabled ? e.modelAuto ? k() && M(m) : !1 : M(m), de = (m) => a.value ? xv(m.value, i.value.highlight) : !1, be = (m) => {
    const A = u(m.value);
    return A && (typeof a.value == "function" ? !a.value(m.value, A) : !a.value.options.highlightDisabled);
  }, R = (m) => {
    var A;
    return typeof a.value == "function" ? a.value(m.value) : (A = a.value.weekdays) == null ? void 0 : A.includes(m.value.getDay());
  }, F = (m) => (l.value.enabled || e.weekPicker) && (!(t.value.count > 0) || m.current) && _() && !(!m.current && e.hideOffsetDates) && !M(m) ? x(m) : !1, $ = (m) => {
    if (Array.isArray(n.value) && n.value.length === 1) {
      const { before: A, after: j } = ec(+l.value.maxRange, n.value[0]);
      return ps(m.value, A) || Fr(m.value, j);
    }
    return !1;
  }, U = (m) => {
    if (Array.isArray(n.value) && n.value.length === 1) {
      const { before: A, after: j } = ec(+l.value.minRange, n.value[0]);
      return Zs([A, j], n.value[0], m.value);
    }
    return !1;
  }, ue = (m) => l.value.enabled && (l.value.maxRange || l.value.minRange) ? l.value.maxRange && l.value.minRange ? $(m) || U(m) : l.value.maxRange ? $(m) : U(m) : !1, q = (m) => {
    const { isRangeStart: A, isRangeEnd: j } = P(m), ge = l.value.enabled ? A || j : !1;
    return {
      dp__cell_offset: !m.current,
      dp__pointer: !e.disabled && !(!m.current && e.hideOffsetDates) && !u(m.value) && !ue(m),
      dp__cell_disabled: u(m.value) || ue(m),
      dp__cell_highlight: !be(m) && (de(m) || R(m)) && !ne(m) && !ge && !I(m) && !(F(m) && e.weekPicker) && !j,
      dp__cell_highlight_active: !be(m) && (de(m) || R(m)) && ne(m),
      dp__today: !e.noToday && He(m.value, d.value) && m.current,
      "dp--past": lt(m.value, d.value),
      "dp--future": ht(m.value, d.value)
    };
  }, ie = (m) => ({
    dp__active_date: ne(m),
    dp__date_hover: E(m)
  }), Y = (m) => {
    if (n.value && !Array.isArray(n.value)) {
      const A = Vn(n.value, e.weekStart);
      return {
        ...K(m),
        dp__range_start: He(A[0], m.value),
        dp__range_end: He(A[1], m.value),
        dp__range_between_week: ht(m.value, A[0]) && lt(m.value, A[1])
      };
    }
    return {
      ...K(m)
    };
  }, ve = (m) => {
    if (n.value && Array.isArray(n.value)) {
      const A = Vn(n.value[0], e.weekStart), j = n.value[1] ? Vn(n.value[1], e.weekStart) : [];
      return {
        ...K(m),
        dp__range_start: He(A[0], m.value) || He(j[0], m.value),
        dp__range_end: He(A[1], m.value) || He(j[1], m.value),
        dp__range_between_week: ht(m.value, A[0]) && lt(m.value, A[1]) || ht(m.value, j[0]) && lt(m.value, j[1]),
        dp__range_between: ht(m.value, A[1]) && lt(m.value, j[0])
      };
    }
    return {
      ...K(m)
    };
  }, P = (m) => {
    const A = t.value.count > 0 ? m.current && v(m) && _() : v(m) && _(), j = t.value.count > 0 ? m.current && v(m, !1) && _() : v(m, !1) && _();
    return { isRangeStart: A, isRangeEnd: j };
  }, V = (m) => {
    const { isRangeStart: A, isRangeEnd: j } = P(m);
    return {
      dp__range_start: A,
      dp__range_end: j,
      dp__range_between: F(m),
      dp__date_hover: He(m.value, c.value) && !A && !j && !e.weekPicker,
      dp__date_hover_start: C(m, !0),
      dp__date_hover_end: C(m, !1)
    };
  }, K = (m) => ({
    ...V(m),
    dp__cell_auto_range: D(m),
    dp__cell_auto_range_start: I(m),
    dp__cell_auto_range_end: S(m)
  }), X = (m) => l.value.enabled ? l.value.autoRange ? K(m) : e.modelAuto ? { ...ie(m), ...V(m) } : e.weekPicker ? ve(m) : V(m) : e.weekPicker ? Y(m) : ie(m);
  return {
    setHoverDate: f,
    clearHoverDate: h,
    getDayClassData: (m) => e.hideOffsetDates && !m.current ? {} : {
      ...q(m),
      ...X(m),
      [e.dayClass ? e.dayClass(m.value, e.internalModelValue) : ""]: !0,
      ...s.value.calendarCell ?? {}
    }
  };
}, br = (n) => {
  const { defaultedFilters: e, defaultedRange: t, propDates: r, defaultedMultiDates: s } = rt(n), a = (R) => r.value.disabledDates ? typeof r.value.disabledDates == "function" ? r.value.disabledDates(ee(R)) : !!ja(R, r.value.disabledDates) : !1, o = (R) => r.value.maxDate ? n.yearPicker ? _e(R) > _e(r.value.maxDate) : ht(R, r.value.maxDate) : !1, i = (R) => r.value.minDate ? n.yearPicker ? _e(R) < _e(r.value.minDate) : lt(R, r.value.minDate) : !1, l = (R) => {
    const F = o(R), $ = i(R), U = a(R), ue = e.value.months.map((P) => +P).includes(Ve(R)), q = n.disabledWeekDays.length ? n.disabledWeekDays.some((P) => +P === uy(R)) : !1, ie = h(R), Y = _e(R), ve = Y < +n.yearRange[0] || Y > +n.yearRange[1];
    return !(F || $ || U || ue || ve || q || ie);
  }, u = (R, F) => lt(...sr(r.value.minDate, R, F)) || He(...sr(r.value.minDate, R, F)), c = (R, F) => ht(...sr(r.value.maxDate, R, F)) || He(...sr(r.value.maxDate, R, F)), d = (R, F, $) => {
    let U = !1;
    return r.value.maxDate && $ && c(R, F) && (U = !0), r.value.minDate && !$ && u(R, F) && (U = !0), U;
  }, f = (R, F, $, U) => {
    let ue = !1;
    return U && (r.value.minDate || r.value.maxDate) ? r.value.minDate && r.value.maxDate ? ue = d(R, F, $) : (r.value.minDate && u(R, F) || r.value.maxDate && c(R, F)) && (ue = !0) : ue = !0, ue;
  }, h = (R) => Array.isArray(r.value.allowedDates) && !r.value.allowedDates.length ? !0 : r.value.allowedDates ? !ja(R, r.value.allowedDates, nf(n.monthPicker, n.yearPicker)) : !1, p = (R) => !l(R), g = (R) => t.value.noDisabledRange ? !Rd({ start: R[0], end: R[1] }).some((F) => p(F)) : !0, y = (R) => {
    if (R) {
      const F = _e(R);
      return F >= +n.yearRange[0] && F <= n.yearRange[1];
    }
    return !0;
  }, v = (R, F) => !!(Array.isArray(R) && R[F] && (t.value.maxRange || t.value.minRange) && y(R[F])), C = (R, F, $ = 0) => {
    if (v(F, $) && y(R)) {
      const U = _d(R, F[$]), ue = of(F[$], R), q = ue.length === 1 ? 0 : ue.filter((Y) => p(Y)).length, ie = Math.abs(U) - (t.value.minMaxRawRange ? 0 : q);
      if (t.value.minRange && t.value.maxRange)
        return ie >= +t.value.minRange && ie <= +t.value.maxRange;
      if (t.value.minRange) return ie >= +t.value.minRange;
      if (t.value.maxRange) return ie <= +t.value.maxRange;
    }
    return !0;
  }, M = () => !n.enableTimePicker || n.monthPicker || n.yearPicker || n.ignoreTimeValidation, S = (R) => Array.isArray(R) ? [R[0] ? fi(R[0]) : null, R[1] ? fi(R[1]) : null] : fi(R), D = (R, F, $) => R.find(
    (U) => +U.hours === Un(F) && U.minutes === "*" ? !0 : +U.minutes === mr(F) && +U.hours === Un(F)
  ) && $, I = (R, F, $) => {
    const [U, ue] = R, [q, ie] = F;
    return !D(U, q, $) && !D(ue, ie, $) && $;
  }, x = (R, F) => {
    const $ = Array.isArray(F) ? F : [F];
    return Array.isArray(n.disabledTimes) ? Array.isArray(n.disabledTimes[0]) ? I(n.disabledTimes, $, R) : !$.some((U) => D(n.disabledTimes, U, R)) : R;
  }, k = (R, F) => {
    const $ = Array.isArray(F) ? [Nr(F[0]), F[1] ? Nr(F[1]) : void 0] : Nr(F), U = !n.disabledTimes($);
    return R && U;
  }, _ = (R, F) => n.disabledTimes ? Array.isArray(n.disabledTimes) ? x(F, R) : k(F, R) : F, E = (R) => {
    let F = !0;
    if (!R || M()) return !0;
    const $ = !r.value.minDate && !r.value.maxDate ? S(R) : R;
    return (n.maxTime || r.value.maxDate) && (F = Zu(
      n.maxTime,
      r.value.maxDate,
      "max",
      St($),
      F
    )), (n.minTime || r.value.minDate) && (F = Zu(
      n.minTime,
      r.value.minDate,
      "min",
      St($),
      F
    )), _(R, F);
  }, ne = (R) => {
    if (!n.monthPicker) return !0;
    let F = !0;
    const $ = ee(yn(R));
    if (r.value.minDate && r.value.maxDate) {
      const U = ee(yn(r.value.minDate)), ue = ee(yn(r.value.maxDate));
      return ht($, U) && lt($, ue) || He($, U) || He($, ue);
    }
    if (r.value.minDate) {
      const U = ee(yn(r.value.minDate));
      F = ht($, U) || He($, U);
    }
    if (r.value.maxDate) {
      const U = ee(yn(r.value.maxDate));
      F = lt($, U) || He($, U);
    }
    return F;
  }, de = G(() => (R) => !n.enableTimePicker || n.ignoreTimeValidation ? !0 : E(R)), be = G(() => (R) => n.monthPicker ? Array.isArray(R) && (t.value.enabled || s.value.enabled) ? !R.filter((F) => !ne(F)).length : ne(R) : !0);
  return {
    isDisabled: p,
    validateDate: l,
    validateMonthYearInRange: f,
    isDateRangeAllowed: g,
    checkMinMaxRange: C,
    isValidTime: E,
    isTimeValid: de,
    isMonthValid: be
  };
}, Fo = () => {
  const n = G(() => (r, s) => r == null ? void 0 : r.includes(s)), e = G(() => (r, s) => r.count ? r.solo ? !0 : s === 0 : !0), t = G(() => (r, s) => r.count ? r.solo ? !0 : s === r.count - 1 : !0);
  return { hideNavigationButtons: n, showLeftIcon: e, showRightIcon: t };
}, sb = (n, e, t) => {
  const r = W(0), s = Ts({
    [_r.timePicker]: !n.enableTimePicker || n.timePicker || n.monthPicker,
    [_r.calendar]: !1,
    [_r.header]: !1
  }), a = G(() => n.monthPicker || n.timePicker), o = (d) => {
    var f;
    if ((f = n.flow) != null && f.length) {
      if (!d && a.value) return c();
      s[d] = !0, Object.keys(s).filter((h) => !s[h]).length || c();
    }
  }, i = () => {
    var d, f;
    (d = n.flow) != null && d.length && r.value !== -1 && (r.value += 1, e("flow-step", r.value), c()), ((f = n.flow) == null ? void 0 : f.length) === r.value && kt().then(() => l());
  }, l = () => {
    r.value = -1;
  }, u = (d, f, ...h) => {
    var p, g;
    n.flow[r.value] === d && t.value && ((g = (p = t.value)[f]) == null || g.call(p, ...h));
  }, c = (d = 0) => {
    d && (r.value += d), u(zt.month, "toggleMonthPicker", !0), u(zt.year, "toggleYearPicker", !0), u(zt.calendar, "toggleTimePicker", !1, !0), u(zt.time, "toggleTimePicker", !0, !0);
    const f = n.flow[r.value];
    (f === zt.hours || f === zt.minutes || f === zt.seconds) && u(f, "toggleTimePicker", !0, !0, f);
  };
  return { childMount: o, updateFlowStep: i, resetFlow: l, handleFlow: c, flowStep: r };
}, ab = {
  key: 1,
  class: "dp__input_wrap"
}, ob = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], ib = {
  key: 2,
  class: "dp--clear-btn"
}, lb = ["aria-label"], ub = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...$o
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, {
      defaultedTextInput: a,
      defaultedAriaLabels: o,
      defaultedInline: i,
      defaultedConfig: l,
      defaultedRange: u,
      defaultedMultiDates: c,
      defaultedUI: d,
      getDefaultPattern: f,
      getDefaultStartTime: h
    } = rt(s), { checkMinMaxRange: p } = br(s), g = W(), y = W(null), v = W(!1), C = W(!1), M = G(
      () => ({
        dp__pointer: !s.disabled && !s.readonly && !a.value.enabled,
        dp__disabled: s.disabled,
        dp__input_readonly: !a.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !s.hideInputIcon,
        dp__input_valid: typeof s.state == "boolean" ? s.state : !1,
        dp__input_invalid: typeof s.state == "boolean" ? !s.state : !1,
        dp__input_focus: v.value || s.isMenuOpen,
        dp__input_reg: !a.value.enabled,
        ...d.value.input ?? {}
      })
    ), S = () => {
      r("set-input-date", null), s.clearable && s.autoApply && (r("set-empty-date"), g.value = null);
    }, D = (Y) => {
      const ve = h();
      return Sv(
        Y,
        a.value.format ?? f(),
        ve ?? lf({}, s.enableSeconds),
        s.inputValue,
        C.value,
        s.formatLocale
      );
    }, I = (Y) => {
      const { rangeSeparator: ve } = a.value, [P, V] = Y.split(`${ve}`);
      if (P) {
        const K = D(P.trim()), X = V ? D(V.trim()) : void 0;
        if (Fr(K, X)) return;
        const m = K && X ? [K, X] : [K];
        p(X, m, 0) && (g.value = K ? m : null);
      }
    }, x = () => {
      C.value = !0;
    }, k = (Y) => {
      if (u.value.enabled)
        I(Y);
      else if (c.value.enabled) {
        const ve = Y.split(";");
        g.value = ve.map((P) => D(P.trim())).filter((P) => P);
      } else
        g.value = D(Y);
    }, _ = (Y) => {
      var ve;
      const P = typeof Y == "string" ? Y : (ve = Y.target) == null ? void 0 : ve.value;
      P !== "" ? (a.value.openMenu && !s.isMenuOpen && r("open"), k(P), r("set-input-date", g.value)) : S(), C.value = !1, r("update:input-value", P), r("text-input", Y, g.value);
    }, E = (Y) => {
      a.value.enabled ? (k(Y.target.value), a.value.enterSubmit && Xi(g.value) && s.inputValue !== "" ? (r("set-input-date", g.value, !0), g.value = null) : a.value.enterSubmit && s.inputValue === "" && (g.value = null, r("clear"))) : be(Y);
    }, ne = (Y, ve) => {
      a.value.enabled && a.value.tabSubmit && !ve && k(Y.target.value), a.value.tabSubmit && Xi(g.value) && s.inputValue !== "" ? (r("set-input-date", g.value, !0, !0), g.value = null) : a.value.tabSubmit && s.inputValue === "" && (g.value = null, r("clear", !0));
    }, de = () => {
      v.value = !0, r("focus"), kt().then(() => {
        var Y;
        a.value.enabled && a.value.selectOnFocus && ((Y = y.value) == null || Y.select());
      });
    }, be = (Y) => {
      if (lr(Y, l.value, !0), a.value.enabled && a.value.openMenu && !i.value.input) {
        if (a.value.openMenu === "open" && !s.isMenuOpen) return r("open");
        if (a.value.openMenu === "toggle") return r("toggle");
      } else a.value.enabled || r("toggle");
    }, R = () => {
      r("real-blur"), v.value = !1, (!s.isMenuOpen || i.value.enabled && i.value.input) && r("blur"), s.autoApply && a.value.enabled && g.value && !s.isMenuOpen && (r("set-input-date", g.value), r("select-date"), g.value = null);
    }, F = (Y) => {
      lr(Y, l.value, !0), r("clear");
    }, $ = () => {
      r("close");
    }, U = (Y) => {
      if (Y.key === "Tab" && ne(Y), Y.key === "Enter" && E(Y), Y.key === "Escape" && a.value.escClose && $(), !a.value.enabled) {
        if (Y.code === "Tab") return;
        Y.preventDefault();
      }
    }, ue = () => {
      var Y;
      (Y = y.value) == null || Y.focus({ preventScroll: !0 });
    }, q = (Y) => {
      g.value = Y;
    }, ie = (Y) => {
      Y.key === et.tab && ne(Y, !0);
    };
    return e({
      focusInput: ue,
      setParsedDate: q
    }), (Y, ve) => {
      var P, V, K;
      return T(), N("div", { onClick: be }, [
        Y.$slots.trigger && !Y.$slots["dp-input"] && !b(i).enabled ? fe(Y.$slots, "trigger", { key: 0 }) : H("", !0),
        !Y.$slots.trigger && (!b(i).enabled || b(i).input) ? (T(), N("div", ab, [
          Y.$slots["dp-input"] && !Y.$slots.trigger && (!b(i).enabled || b(i).enabled && b(i).input) ? fe(Y.$slots, "dp-input", {
            key: 0,
            value: n.inputValue,
            isMenuOpen: n.isMenuOpen,
            onInput: _,
            onEnter: E,
            onTab: ne,
            onClear: F,
            onBlur: R,
            onKeypress: U,
            onPaste: x,
            onFocus: de,
            openMenu: () => Y.$emit("open"),
            closeMenu: () => Y.$emit("close"),
            toggleMenu: () => Y.$emit("toggle")
          }) : H("", !0),
          Y.$slots["dp-input"] ? H("", !0) : (T(), N("input", {
            key: 1,
            id: Y.uid ? `dp-input-${Y.uid}` : void 0,
            ref_key: "inputRef",
            ref: y,
            "data-test-id": "dp-input",
            name: Y.name,
            class: pe(M.value),
            inputmode: b(a).enabled ? "text" : "none",
            placeholder: Y.placeholder,
            disabled: Y.disabled,
            readonly: Y.readonly,
            required: Y.required,
            value: n.inputValue,
            autocomplete: Y.autocomplete,
            "aria-label": (P = b(o)) == null ? void 0 : P.input,
            "aria-disabled": Y.disabled || void 0,
            "aria-invalid": Y.state === !1 ? !0 : void 0,
            onInput: _,
            onBlur: R,
            onFocus: de,
            onKeypress: U,
            onKeydown: ve[0] || (ve[0] = (X) => U(X)),
            onPaste: x
          }, null, 42, ob)),
          O("div", {
            onClick: ve[3] || (ve[3] = (X) => r("toggle"))
          }, [
            Y.$slots["input-icon"] && !Y.hideInputIcon ? (T(), N("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: ve[1] || (ve[1] = (X) => r("toggle"))
            }, [
              fe(Y.$slots, "input-icon")
            ])) : H("", !0),
            !Y.$slots["input-icon"] && !Y.hideInputIcon && !Y.$slots["dp-input"] ? (T(), Ne(b(Cs), {
              key: 1,
              "aria-label": (V = b(o)) == null ? void 0 : V.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: ve[2] || (ve[2] = (X) => r("toggle"))
            }, null, 8, ["aria-label"])) : H("", !0)
          ]),
          Y.$slots["clear-icon"] && (Y.alwaysClearable || n.inputValue && Y.clearable && !Y.disabled && !Y.readonly) ? (T(), N("span", ib, [
            fe(Y.$slots, "clear-icon", { clear: F })
          ])) : H("", !0),
          !Y.$slots["clear-icon"] && (Y.alwaysClearable || Y.clearable && n.inputValue && !Y.disabled && !Y.readonly) ? (T(), N("button", {
            key: 3,
            "aria-label": (K = b(o)) == null ? void 0 : K.clearInput,
            class: "dp--clear-btn",
            type: "button",
            onKeydown: ve[4] || (ve[4] = (X) => b(jt)(X, () => F(X), !0, ie)),
            onClick: ve[5] || (ve[5] = Qt((X) => F(X), ["prevent"]))
          }, [
            Qe(b(Qd), {
              class: "dp__input_icons",
              "data-test-id": "clear-icon"
            })
          ], 40, lb)) : H("", !0)
        ])) : H("", !0)
      ]);
    };
  }
}), cb = typeof window < "u" ? window : void 0, vi = () => {
}, db = (n) => nm() ? (rm(n), !0) : !1, fb = (n, e, t, r) => {
  if (!n) return vi;
  let s = vi;
  const a = $t(
    () => b(n),
    (i) => {
      s(), i && (i.removeEventListener(e, t), i.addEventListener(e, t, r), s = () => {
        i.removeEventListener(e, t, r), s = vi;
      });
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    a(), s();
  };
  return db(o), o;
}, hb = (n, e, t, r = {}) => {
  const { window: s = cb, event: a = "pointerdown" } = r;
  return s ? fb(s, a, (o) => {
    const i = vt(n), l = vt(e);
    !i || !l || i === o.target || o.composedPath().includes(i) || o.composedPath().includes(l) || t(o);
  }, { passive: !0 }) : void 0;
}, pb = ["data-dp-mobile"], mb = /* @__PURE__ */ Fe({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...$o
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(n, { expose: e, emit: t }) {
    const r = t, s = n, a = Ur(), o = W(!1), i = Js(s, "modelValue"), l = Js(s, "timezone"), u = W(null), c = W(null), d = W(null), f = W(!1), h = W(null), p = W(!1), g = W(!1), y = W(!1), v = W(!1), { setMenuFocused: C, setShiftKey: M } = ff(), { clearArrowNav: S } = vr(), { validateDate: D, isValidTime: I } = br(s), {
      defaultedTransitions: x,
      defaultedTextInput: k,
      defaultedInline: _,
      defaultedConfig: E,
      defaultedRange: ne,
      defaultedMultiDates: de
    } = rt(s), { menuTransition: be, showTransition: R } = ma(x), { isMobile: F } = bf(E), $ = Cd();
    Pt(() => {
      m(s.modelValue), kt().then(() => {
        if (!_.value.enabled) {
          const Q = P(h.value);
          Q == null || Q.addEventListener("scroll", re), window == null || window.addEventListener("resize", oe);
        }
      }), _.value.enabled && (o.value = !0), window == null || window.addEventListener("keyup", Pe), window == null || window.addEventListener("keydown", Oe);
    }), jr(() => {
      if (!_.value.enabled) {
        const Q = P(h.value);
        Q == null || Q.removeEventListener("scroll", re), window == null || window.removeEventListener("resize", oe);
      }
      window == null || window.removeEventListener("keyup", Pe), window == null || window.removeEventListener("keydown", Oe);
    });
    const U = sn(a, "all", s.presetDates), ue = sn(a, "input");
    $t(
      [i, l],
      () => {
        m(i.value);
      },
      { deep: !0 }
    );
    const { openOnTop: q, menuStyle: ie, xCorrect: Y, setMenuPosition: ve, getScrollableParent: P, shadowRender: V } = eb({
      menuRef: u,
      menuRefInner: c,
      inputRef: d,
      pickerWrapperRef: h,
      inline: _,
      emit: r,
      props: s,
      slots: a
    }), {
      inputValue: K,
      internalModelValue: X,
      parseExternalModelValue: m,
      emitModelValue: A,
      formatInputValue: j,
      checkBeforeEmit: ge
    } = Gv(r, s, f), z = G(
      () => ({
        dp__main: !0,
        dp__theme_dark: s.dark,
        dp__theme_light: !s.dark,
        dp__flex_display: _.value.enabled,
        "dp--flex-display-collapsed": y.value,
        dp__flex_display_with_input: _.value.input
      })
    ), Se = G(() => s.dark ? "dp__theme_dark" : "dp__theme_light"), J = G(() => s.teleport ? {
      to: typeof s.teleport == "boolean" ? "body" : s.teleport,
      disabled: !s.teleport || _.value.enabled
    } : {}), se = G(() => ({ class: "dp__outer_menu_wrap" })), w = G(() => _.value.enabled && (s.timePicker || s.monthPicker || s.yearPicker || s.quarterPicker)), Z = () => {
      var Q, he;
      return ((he = (Q = d.value) == null ? void 0 : Q.$el) == null ? void 0 : he.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, re = () => {
      o.value && (E.value.closeOnScroll ? st() : ve());
    }, oe = () => {
      var Q;
      o.value && ve();
      const he = ((Q = c.value) == null ? void 0 : Q.$el.getBoundingClientRect().width) ?? 0;
      y.value = document.body.offsetWidth <= he;
    }, Pe = (Q) => {
      Q.key === "Tab" && !_.value.enabled && !s.teleport && E.value.tabOutClosesMenu && (h.value.contains(document.activeElement) || st()), g.value = Q.shiftKey;
    }, Oe = (Q) => {
      g.value = Q.shiftKey;
    }, ze = () => {
      !s.disabled && !s.readonly && (V($, sc, s), ve(!1), o.value = !0, o.value && r("open"), o.value || we(), m(s.modelValue));
    }, Xe = () => {
      var Q, he;
      K.value = "", we(), (Q = c.value) == null || Q.onValueCleared(), (he = d.value) == null || he.setParsedDate(null), r("update:model-value", null), r("update:model-timezone-value", null), r("cleared"), E.value.closeOnClearValue && st();
    }, L = () => {
      const Q = X.value;
      return !Q || !Array.isArray(Q) && D(Q) ? !0 : Array.isArray(Q) ? de.value.enabled || Q.length === 2 && D(Q[0]) && D(Q[1]) ? !0 : ne.value.partialRange && !s.timePicker ? D(Q[0]) : !1 : !1;
    }, ce = () => {
      ge() && L() ? (A(), st()) : r("invalid-select", X.value);
    }, Re = (Q) => {
      nt(), A(), E.value.closeOnAutoApply && !Q && st();
    }, nt = () => {
      d.value && k.value.enabled && d.value.setParsedDate(X.value);
    }, Lt = (Q = !1) => {
      s.autoApply && I(X.value) && L() && (ne.value.enabled && Array.isArray(X.value) ? (ne.value.partialRange || X.value.length === 2) && Re(Q) : Re(Q));
    }, we = () => {
      k.value.enabled || (X.value = null);
    }, st = (Q = !1) => {
      var he, ke;
      Q && X.value && E.value.setDateOnMenuClose && ce(), _.value.enabled || (o.value && (o.value = !1, Y.value = !1, C(!1), M(!1), S(), r("closed"), K.value && m(i.value)), we(), r("blur"), (ke = (he = c.value) == null ? void 0 : he.$el) == null || ke.remove());
    }, ln = (Q, he, ke = !1) => {
      if (!Q) {
        X.value = null;
        return;
      }
      const Rn = Array.isArray(Q) ? !Q.some((Mr) => !D(Mr)) : D(Q), Sn = I(Q);
      Rn && Sn ? (v.value = !0, X.value = Q, he ? (p.value = ke, ce(), r("text-submit")) : s.autoApply && Lt(), kt().then(() => {
        v.value = !1;
      })) : r("invalid-date", Q);
    }, ka = () => {
      s.autoApply && I(X.value) && A(), nt();
    }, xa = () => o.value ? st() : ze(), ti = (Q) => {
      X.value = Q;
    }, ni = () => {
      k.value.enabled && (f.value = !0, j()), r("focus");
    }, ri = () => {
      if (k.value.enabled && (f.value = !1, m(s.modelValue), p.value)) {
        const Q = kv(h.value, g.value);
        Q == null || Q.focus();
      }
      r("blur");
    }, si = (Q) => {
      c.value && c.value.updateMonthYear(0, {
        month: Ju(Q.month),
        year: Ju(Q.year)
      });
    }, ai = (Q) => {
      m(Q ?? s.modelValue);
    }, B = (Q, he) => {
      var ke;
      (ke = c.value) == null || ke.switchView(Q, he);
    }, le = (Q, he) => E.value.onClickOutside ? E.value.onClickOutside(Q, he) : st(!0), Te = (Q = 0) => {
      var he;
      (he = c.value) == null || he.handleFlow(Q);
    }, Be = () => u;
    return hb(
      u,
      d,
      (Q) => le(L, Q)
    ), e({
      closeMenu: st,
      selectDate: ce,
      clearValue: Xe,
      openMenu: ze,
      onScroll: re,
      formatInputValue: j,
      // exposed for testing purposes
      updateInternalModelValue: ti,
      // modify internal modelValue
      setMonthYear: si,
      parseModel: ai,
      switchView: B,
      toggleMenu: xa,
      handleFlow: Te,
      getDpWrapMenuRef: Be
    }), (Q, he) => (T(), N("div", {
      ref_key: "pickerWrapperRef",
      ref: h,
      class: pe(z.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": b(F)
    }, [
      Qe(ub, Mt({
        ref_key: "inputRef",
        ref: d,
        "input-value": b(K),
        "onUpdate:inputValue": he[0] || (he[0] = (ke) => Ru(K) ? K.value = ke : null),
        "is-menu-open": o.value
      }, Q.$props, {
        onClear: Xe,
        onOpen: ze,
        onSetInputDate: ln,
        onSetEmptyDate: b(A),
        onSelectDate: ce,
        onToggle: xa,
        onClose: st,
        onFocus: ni,
        onBlur: ri,
        onRealBlur: he[1] || (he[1] = (ke) => f.value = !1),
        onTextInput: he[2] || (he[2] = (ke) => Q.$emit("text-input", ke))
      }), Ht({ _: 2 }, [
        Ye(b(ue), (ke, Rn) => ({
          name: ke,
          fn: Ae((Sn) => [
            fe(Q.$slots, ke, Ct(Xt(Sn)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (T(), Ne(Ro(Q.teleport ? El : "div"), Ct(Xt(J.value)), {
        default: Ae(() => [
          Qe(_n, {
            name: b(be)(b(q)),
            css: b(R) && !b(_).enabled
          }, {
            default: Ae(() => [
              o.value ? (T(), N("div", Mt({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: u
              }, se.value, {
                class: { "dp--menu-wrapper": !b(_).enabled },
                style: b(_).enabled ? void 0 : b(ie)
              }), [
                Qe(sc, Mt({
                  ref_key: "dpMenuRef",
                  ref: c
                }, Q.$props, {
                  "internal-model-value": b(X),
                  "onUpdate:internalModelValue": he[3] || (he[3] = (ke) => Ru(X) ? X.value = ke : null),
                  class: { [Se.value]: !0, "dp--menu-wrapper": Q.teleport },
                  "open-on-top": b(q),
                  "no-overlay-focus": w.value,
                  collapse: y.value,
                  "get-input-rect": Z,
                  "is-text-input-date": v.value,
                  onClosePicker: st,
                  onSelectDate: ce,
                  onAutoApply: Lt,
                  onTimeUpdate: ka,
                  onFlowStep: he[4] || (he[4] = (ke) => Q.$emit("flow-step", ke)),
                  onUpdateMonthYear: he[5] || (he[5] = (ke) => Q.$emit("update-month-year", ke)),
                  onInvalidSelect: he[6] || (he[6] = (ke) => Q.$emit("invalid-select", b(X))),
                  onAutoApplyInvalid: he[7] || (he[7] = (ke) => Q.$emit("invalid-select", ke)),
                  onInvalidFixedRange: he[8] || (he[8] = (ke) => Q.$emit("invalid-fixed-range", ke)),
                  onRecalculatePosition: b(ve),
                  onTooltipOpen: he[9] || (he[9] = (ke) => Q.$emit("tooltip-open", ke)),
                  onTooltipClose: he[10] || (he[10] = (ke) => Q.$emit("tooltip-close", ke)),
                  onTimePickerOpen: he[11] || (he[11] = (ke) => Q.$emit("time-picker-open", ke)),
                  onTimePickerClose: he[12] || (he[12] = (ke) => Q.$emit("time-picker-close", ke)),
                  onAmPmChange: he[13] || (he[13] = (ke) => Q.$emit("am-pm-change", ke)),
                  onRangeStart: he[14] || (he[14] = (ke) => Q.$emit("range-start", ke)),
                  onRangeEnd: he[15] || (he[15] = (ke) => Q.$emit("range-end", ke)),
                  onDateUpdate: he[16] || (he[16] = (ke) => Q.$emit("date-update", ke)),
                  onInvalidDate: he[17] || (he[17] = (ke) => Q.$emit("invalid-date", ke)),
                  onOverlayToggle: he[18] || (he[18] = (ke) => Q.$emit("overlay-toggle", ke)),
                  onMenuBlur: he[19] || (he[19] = (ke) => Q.$emit("blur"))
                }), Ht({ _: 2 }, [
                  Ye(b(U), (ke, Rn) => ({
                    name: ke,
                    fn: Ae((Sn) => [
                      fe(Q.$slots, ke, Ct(Xt({ ...Sn })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : H("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, pb));
  }
}), Ql = /* @__PURE__ */ (() => {
  const n = mb;
  return n.install = (e) => {
    e.component("Vue3DatePicker", n);
  }, n;
})(), gb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ql
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(gb).forEach(([n, e]) => {
  n !== "default" && (Ql[n] = e);
});
const yb = { class: "space-y-1" }, vb = {
  key: 0,
  class: "flex gap-0.5 text-sm font-medium items-center leading-5 text-dark-neutral-500"
}, bb = {
  key: 0,
  class: "text-red-600"
}, LC = /* @__PURE__ */ Fe({
  __name: "DateTimeInput",
  props: /* @__PURE__ */ Ot({
    label: {},
    placeholder: {},
    disabled: { type: Boolean },
    isRequired: { type: Boolean },
    pickerType: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = nn(n, "modelValue"), t = n, r = G(() => t.pickerType === "year" ? { yearPicker: !0 } : t.pickerType === "month" ? { monthPicker: !0 } : { timePickerInline: !0 });
    return (s, a) => (T(), N("div", yb, [
      s.label ? (T(), N("label", vb, [
        wt(Ce(s.label) + " ", 1),
        s.isRequired ? (T(), N("span", bb, "*")) : H("", !0)
      ])) : H("", !0),
      Qe(b(Ql), Mt({
        modelValue: e.value,
        "onUpdate:modelValue": a[0] || (a[0] = (o) => e.value = o),
        placeholder: s.placeholder,
        disabled: s.disabled
      }, r.value), null, 16, ["modelValue", "placeholder", "disabled"])
    ]));
  }
});
function Nt(n) {
  this.content = n;
}
Nt.prototype = {
  constructor: Nt,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var r = t && t != n ? this.remove(t) : this, s = r.find(n), a = r.content.slice();
    return s == -1 ? a.push(t || n, e) : (a[s + 1] = e, t && (a[s] = t)), new Nt(a);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Nt(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new Nt([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Nt(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var r = this.remove(e), s = r.content.slice(), a = r.find(n);
    return s.splice(a == -1 ? s.length : a, 0, e, t), new Nt(s);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = Nt.from(n), n.size ? new Nt(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = Nt.from(n), n.size ? new Nt(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = Nt.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Nt.from = function(n) {
  if (n instanceof Nt) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new Nt(e);
};
function wf(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let s = n.child(r), a = e.child(r);
    if (s == a) {
      t += s.nodeSize;
      continue;
    }
    if (!s.sameMarkup(a))
      return t;
    if (s.isText && s.text != a.text) {
      for (let o = 0; s.text[o] == a.text[o]; o++)
        t++;
      return t;
    }
    if (s.content.size || a.content.size) {
      let o = wf(s.content, a.content, t + 1);
      if (o != null)
        return o;
    }
    t += s.nodeSize;
  }
}
function kf(n, e, t, r) {
  for (let s = n.childCount, a = e.childCount; ; ) {
    if (s == 0 || a == 0)
      return s == a ? null : { a: t, b: r };
    let o = n.child(--s), i = e.child(--a), l = o.nodeSize;
    if (o == i) {
      t -= l, r -= l;
      continue;
    }
    if (!o.sameMarkup(i))
      return { a: t, b: r };
    if (o.isText && o.text != i.text) {
      let u = 0, c = Math.min(o.text.length, i.text.length);
      for (; u < c && o.text[o.text.length - u - 1] == i.text[i.text.length - u - 1]; )
        u++, t--, r--;
      return { a: t, b: r };
    }
    if (o.content.size || i.content.size) {
      let u = kf(o.content, i.content, t - 1, r - 1);
      if (u)
        return u;
    }
    t -= l, r -= l;
  }
}
class te {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, r, s = 0, a) {
    for (let o = 0, i = 0; i < t; o++) {
      let l = this.content[o], u = i + l.nodeSize;
      if (u > e && r(l, s + i, a || null, o) !== !1 && l.content.size) {
        let c = i + 1;
        l.nodesBetween(Math.max(0, e - c), Math.min(l.content.size, t - c), r, s + c);
      }
      i = u;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, r, s) {
    let a = "", o = !0;
    return this.nodesBetween(e, t, (i, l) => {
      let u = i.isText ? i.text.slice(Math.max(e, l) - l, t - l) : i.isLeaf ? s ? typeof s == "function" ? s(i) : s : i.type.spec.leafText ? i.type.spec.leafText(i) : "" : "";
      i.isBlock && (i.isLeaf && u || i.isTextblock) && r && (o ? o = !1 : a += r), a += u;
    }, 0), a;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, s = this.content.slice(), a = 0;
    for (t.isText && t.sameMarkup(r) && (s[s.length - 1] = t.withText(t.text + r.text), a = 1); a < e.content.length; a++)
      s.push(e.content[a]);
    return new te(s, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], s = 0;
    if (t > e)
      for (let a = 0, o = 0; o < t; a++) {
        let i = this.content[a], l = o + i.nodeSize;
        l > e && ((o < e || l > t) && (i.isText ? i = i.cut(Math.max(0, e - o), Math.min(i.text.length, t - o)) : i = i.cut(Math.max(0, e - o - 1), Math.min(i.content.size, t - o - 1))), r.push(i), s += i.nodeSize), o = l;
      }
    return new te(r, s);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? te.empty : e == 0 && t == this.content.length ? this : new te(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let s = this.content.slice(), a = this.size + t.nodeSize - r.nodeSize;
    return s[e] = t, new te(s, a);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new te([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new te(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let s = this.content[t];
      e(s, r, t), r += s.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return wf(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, r = e.size) {
    return kf(this, e, t, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return Ta(0, e);
    if (e == this.size)
      return Ta(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, r = 0; ; t++) {
      let s = this.child(t), a = r + s.nodeSize;
      if (a >= e)
        return a == e ? Ta(t + 1, a) : Ta(t, r);
      r = a;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return te.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new te(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return te.empty;
    let t, r = 0;
    for (let s = 0; s < e.length; s++) {
      let a = e[s];
      r += a.nodeSize, s && a.isText && e[s - 1].sameMarkup(a) ? (t || (t = e.slice(0, s)), t[t.length - 1] = a.withText(t[t.length - 1].text + a.text)) : t && t.push(a);
    }
    return new te(t || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return te.empty;
    if (e instanceof te)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new te([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
te.empty = new te([], 0);
const bi = { index: 0, offset: 0 };
function Ta(n, e) {
  return bi.index = n, bi.offset = e, bi;
}
function Ua(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Ua(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Ua(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
let Ge = class el {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, r = !1;
    for (let s = 0; s < e.length; s++) {
      let a = e[s];
      if (this.eq(a))
        return e;
      if (this.type.excludes(a.type))
        t || (t = e.slice(0, s));
      else {
        if (a.type.excludes(this.type))
          return e;
        !r && a.type.rank > this.type.rank && (t || (t = e.slice(0, s)), t.push(this), r = !0), t && t.push(a);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Ua(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let s = r.create(t.attrs);
    return r.checkAttrs(s.attrs), s;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return el.none;
    if (e instanceof el)
      return [e];
    let t = e.slice();
    return t.sort((r, s) => r.type.rank - s.type.rank), t;
  }
};
Ge.none = [];
class qa extends Error {
}
class me {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let r = Mf(this.content, e + this.openStart, t);
    return r && new me(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new me(xf(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return me.empty;
    let r = t.openStart || 0, s = t.openEnd || 0;
    if (typeof r != "number" || typeof s != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new me(te.fromJSON(e, t.content), r, s);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let r = 0, s = 0;
    for (let a = e.firstChild; a && !a.isLeaf && (t || !a.type.spec.isolating); a = a.firstChild)
      r++;
    for (let a = e.lastChild; a && !a.isLeaf && (t || !a.type.spec.isolating); a = a.lastChild)
      s++;
    return new me(e, r, s);
  }
}
me.empty = new me(te.empty, 0, 0);
function xf(n, e, t) {
  let { index: r, offset: s } = n.findIndex(e), a = n.maybeChild(r), { index: o, offset: i } = n.findIndex(t);
  if (s == e || a.isText) {
    if (i != t && !n.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, a.copy(xf(a.content, e - s - 1, t - s - 1)));
}
function Mf(n, e, t, r) {
  let { index: s, offset: a } = n.findIndex(e), o = n.maybeChild(s);
  if (a == e || o.isText)
    return r && !r.canReplace(s, s, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let i = Mf(o.content, e - a - 1, t, o);
  return i && n.replaceChild(s, o.copy(i));
}
function wb(n, e, t) {
  if (t.openStart > n.depth)
    throw new qa("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new qa("Inconsistent open depths");
  return Sf(n, e, t, 0);
}
function Sf(n, e, t, r) {
  let s = n.index(r), a = n.node(r);
  if (s == e.index(r) && r < n.depth - t.openStart) {
    let o = Sf(n, e, t, r + 1);
    return a.copy(a.content.replaceChild(s, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == r && e.depth == r) {
      let o = n.parent, i = o.content;
      return Rr(o, i.cut(0, n.parentOffset).append(t.content).append(i.cut(e.parentOffset)));
    } else {
      let { start: o, end: i } = kb(t, n);
      return Rr(a, Cf(n, o, i, e, r));
    }
  else return Rr(a, Ka(n, e, r));
}
function Tf(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new qa("Cannot join " + e.type.name + " onto " + n.type.name);
}
function tl(n, e, t) {
  let r = n.node(t);
  return Tf(r, e.node(t)), r;
}
function Ir(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function zs(n, e, t, r) {
  let s = (e || n).node(t), a = 0, o = e ? e.index(t) : s.childCount;
  n && (a = n.index(t), n.depth > t ? a++ : n.textOffset && (Ir(n.nodeAfter, r), a++));
  for (let i = a; i < o; i++)
    Ir(s.child(i), r);
  e && e.depth == t && e.textOffset && Ir(e.nodeBefore, r);
}
function Rr(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function Cf(n, e, t, r, s) {
  let a = n.depth > s && tl(n, e, s + 1), o = r.depth > s && tl(t, r, s + 1), i = [];
  return zs(null, n, s, i), a && o && e.index(s) == t.index(s) ? (Tf(a, o), Ir(Rr(a, Cf(n, e, t, r, s + 1)), i)) : (a && Ir(Rr(a, Ka(n, e, s + 1)), i), zs(e, t, s, i), o && Ir(Rr(o, Ka(t, r, s + 1)), i)), zs(r, null, s, i), new te(i);
}
function Ka(n, e, t) {
  let r = [];
  if (zs(null, n, t, r), n.depth > t) {
    let s = tl(n, e, t + 1);
    Ir(Rr(s, Ka(n, e, t + 1)), r);
  }
  return zs(e, null, t, r), new te(r);
}
function kb(n, e) {
  let t = e.depth - n.openStart, s = e.node(t).copy(n.content);
  for (let a = t - 1; a >= 0; a--)
    s = e.node(a).copy(te.from(s));
  return {
    start: s.resolveNoCache(n.openStart + t),
    end: s.resolveNoCache(s.content.size - n.openEnd - t)
  };
}
class ea {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.path = t, this.parentOffset = r, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], s = e.child(t);
    return r ? e.child(t).cut(r) : s;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let r = this.path[t * 3], s = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let a = 0; a < e; a++)
      s += r.child(a).nodeSize;
    return s;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return Ge.none;
    if (this.textOffset)
      return e.child(t).marks;
    let r = e.maybeChild(t - 1), s = e.maybeChild(t);
    if (!r) {
      let i = r;
      r = s, s = i;
    }
    let a = r.marks;
    for (var o = 0; o < a.length; o++)
      a[o].type.spec.inclusive === !1 && (!s || !a[o].isInSet(s.marks)) && (a = a[o--].removeFromSet(a));
    return a;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let r = t.marks, s = e.parent.maybeChild(e.index());
    for (var a = 0; a < r.length; a++)
      r[a].type.spec.inclusive === !1 && (!s || !r[a].isInSet(s.marks)) && (r = r[a--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!t || t(this.node(r))))
        return new Ga(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let r = [], s = 0, a = t;
    for (let o = e; ; ) {
      let { index: i, offset: l } = o.content.findIndex(a), u = a - l;
      if (r.push(o, i, s + l), !u || (o = o.child(i), o.isText))
        break;
      a = u - 1, s += l + 1;
    }
    return new ea(t, r, a);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let r = ac.get(e);
    if (r)
      for (let a = 0; a < r.elts.length; a++) {
        let o = r.elts[a];
        if (o.pos == t)
          return o;
      }
    else
      ac.set(e, r = new xb());
    let s = r.elts[r.i] = ea.resolve(e, t);
    return r.i = (r.i + 1) % Mb, s;
  }
}
class xb {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const Mb = 12, ac = /* @__PURE__ */ new WeakMap();
class Ga {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const Sb = /* @__PURE__ */ Object.create(null);
let cr = class nl {
  /**
  @internal
  */
  constructor(e, t, r, s = Ge.none) {
    this.type = e, this.attrs = t, this.marks = s, this.content = r || te.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, r, s = 0) {
    this.content.nodesBetween(e, t, r, s, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, t, r, s) {
    return this.content.textBetween(e, t, r, s);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, r) {
    return this.type == e && Ua(this.attrs, t || e.defaultAttrs || Sb) && Ge.sameSet(this.marks, r || Ge.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new nl(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new nl(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, r = !1) {
    if (e == t)
      return me.empty;
    let s = this.resolve(e), a = this.resolve(t), o = r ? 0 : s.sharedDepth(t), i = s.start(o), u = s.node(o).content.cut(s.pos - i, a.pos - i);
    return new me(u, s.depth - o, a.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, r) {
    return wb(this.resolve(e), this.resolve(t), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: r, offset: s } = t.content.findIndex(e);
      if (t = t.maybeChild(r), !t)
        return null;
      if (s == e || t.isText)
        return t;
      e -= s + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(t), index: t, offset: r };
    let s = this.content.child(t - 1);
    return { node: s, index: t - 1, offset: r - s.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return ea.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return ea.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, r) {
    let s = !1;
    return t > e && this.nodesBetween(e, t, (a) => (r.isInSet(a.marks) && (s = !0), !s)), s;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), Af(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, r = te.empty, s = 0, a = r.childCount) {
    let o = this.contentMatchAt(e).matchFragment(r, s, a), i = o && o.matchFragment(this.content, t);
    if (!i || !i.validEnd)
      return !1;
    for (let l = s; l < a; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, r, s) {
    if (s && !this.type.allowsMarks(s))
      return !1;
    let a = this.contentMatchAt(e).matchType(r), o = a && a.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = Ge.none;
    for (let t = 0; t < this.marks.length; t++) {
      let r = this.marks[t];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!Ge.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, r);
    }
    let s = te.fromJSON(e, t.content), a = e.nodeType(t.type).create(t.attrs, s, r);
    return a.type.checkAttrs(a.attrs), a;
  }
};
cr.prototype.text = void 0;
class Ja extends cr {
  /**
  @internal
  */
  constructor(e, t, r, s) {
    if (super(e, t, null, s), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Af(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Ja(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Ja(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function Af(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class zr {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let r = new Tb(e, t);
    if (r.next == null)
      return zr.empty;
    let s = Df(r);
    r.next && r.err("Unexpected trailing text");
    let a = _b(Pb(s));
    return Nb(a, r), a;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, r = e.childCount) {
    let s = this;
    for (let a = t; s && a < r; a++)
      s = s.matchType(e.child(a).type);
    return s;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[t].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, r = 0) {
    let s = [this];
    function a(o, i) {
      let l = o.matchFragment(e, r);
      if (l && (!t || l.validEnd))
        return te.from(i.map((u) => u.createAndFill()));
      for (let u = 0; u < o.next.length; u++) {
        let { type: c, next: d } = o.next[u];
        if (!(c.isText || c.hasRequiredAttrs()) && s.indexOf(d) == -1) {
          s.push(d);
          let f = a(d, i.concat(c));
          if (f)
            return f;
        }
      }
      return null;
    }
    return a(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let s = r.shift(), a = s.match;
      if (a.matchType(e)) {
        let o = [];
        for (let i = s; i.type; i = i.via)
          o.push(i.type);
        return o.reverse();
      }
      for (let o = 0; o < a.next.length; o++) {
        let { type: i, next: l } = a.next[o];
        !i.isLeaf && !i.hasRequiredAttrs() && !(i.name in t) && (!s.type || l.validEnd) && (r.push({ match: i.contentMatch, type: i, via: s }), t[i.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(r) {
      e.push(r);
      for (let s = 0; s < r.next.length; s++)
        e.indexOf(r.next[s].next) == -1 && t(r.next[s].next);
    }
    return t(this), e.map((r, s) => {
      let a = s + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        a += (o ? ", " : "") + r.next[o].type.name + "->" + e.indexOf(r.next[o].next);
      return a;
    }).join(`
`);
  }
}
zr.empty = new zr(!0);
class Tb {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function Df(n) {
  let e = [];
  do
    e.push(Cb(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function Cb(n) {
  let e = [];
  do
    e.push(Ab(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function Ab(n) {
  let e = Eb(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = Db(n, e);
    else
      break;
  return e;
}
function oc(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function Db(n, e) {
  let t = oc(n), r = t;
  return n.eat(",") && (n.next != "}" ? r = oc(n) : r = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: r, expr: e };
}
function Ob(n, e) {
  let t = n.nodeTypes, r = t[e];
  if (r)
    return [r];
  let s = [];
  for (let a in t) {
    let o = t[a];
    o.isInGroup(e) && s.push(o);
  }
  return s.length == 0 && n.err("No node type or group '" + e + "' found"), s;
}
function Eb(n) {
  if (n.eat("(")) {
    let e = Df(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = Ob(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function Pb(n) {
  let e = [[]];
  return s(a(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function r(o, i, l) {
    let u = { term: l, to: i };
    return e[o].push(u), u;
  }
  function s(o, i) {
    o.forEach((l) => l.to = i);
  }
  function a(o, i) {
    if (o.type == "choice")
      return o.exprs.reduce((l, u) => l.concat(a(u, i)), []);
    if (o.type == "seq")
      for (let l = 0; ; l++) {
        let u = a(o.exprs[l], i);
        if (l == o.exprs.length - 1)
          return u;
        s(u, i = t());
      }
    else if (o.type == "star") {
      let l = t();
      return r(i, l), s(a(o.expr, l), l), [r(l)];
    } else if (o.type == "plus") {
      let l = t();
      return s(a(o.expr, i), l), s(a(o.expr, l), l), [r(l)];
    } else {
      if (o.type == "opt")
        return [r(i)].concat(a(o.expr, i));
      if (o.type == "range") {
        let l = i;
        for (let u = 0; u < o.min; u++) {
          let c = t();
          s(a(o.expr, l), c), l = c;
        }
        if (o.max == -1)
          s(a(o.expr, l), l);
        else
          for (let u = o.min; u < o.max; u++) {
            let c = t();
            r(l, c), s(a(o.expr, l), c), l = c;
          }
        return [r(l)];
      } else {
        if (o.type == "name")
          return [r(i, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Of(n, e) {
  return e - n;
}
function ic(n, e) {
  let t = [];
  return r(e), t.sort(Of);
  function r(s) {
    let a = n[s];
    if (a.length == 1 && !a[0].term)
      return r(a[0].to);
    t.push(s);
    for (let o = 0; o < a.length; o++) {
      let { term: i, to: l } = a[o];
      !i && t.indexOf(l) == -1 && r(l);
    }
  }
}
function _b(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(ic(n, 0));
  function t(r) {
    let s = [];
    r.forEach((o) => {
      n[o].forEach(({ term: i, to: l }) => {
        if (!i)
          return;
        let u;
        for (let c = 0; c < s.length; c++)
          s[c][0] == i && (u = s[c][1]);
        ic(n, l).forEach((c) => {
          u || s.push([i, u = []]), u.indexOf(c) == -1 && u.push(c);
        });
      });
    });
    let a = e[r.join(",")] = new zr(r.indexOf(n.length - 1) > -1);
    for (let o = 0; o < s.length; o++) {
      let i = s[o][1].sort(Of);
      a.next.push({ type: s[o][0], next: e[i.join(",")] || t(i) });
    }
    return a;
  }
}
function Nb(n, e) {
  for (let t = 0, r = [n]; t < r.length; t++) {
    let s = r[t], a = !s.validEnd, o = [];
    for (let i = 0; i < s.next.length; i++) {
      let { type: l, next: u } = s.next[i];
      o.push(l.name), a && !(l.isText || l.hasRequiredAttrs()) && (a = !1), r.indexOf(u) == -1 && r.push(u);
    }
    a && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Ef(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    if (!r.hasDefault)
      return null;
    e[t] = r.default;
  }
  return e;
}
function Pf(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in n) {
    let s = e && e[r];
    if (s === void 0) {
      let a = n[r];
      if (a.hasDefault)
        s = a.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    t[r] = s;
  }
  return t;
}
function _f(n, e, t, r) {
  for (let s in e)
    if (!(s in n))
      throw new RangeError(`Unsupported attribute ${s} for ${t} of type ${s}`);
  for (let s in n) {
    let a = n[s];
    a.validate && a.validate(e[s]);
  }
}
function Nf(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      t[r] = new Rb(n, r, e[r]);
  return t;
}
let lc = class If {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.name = e, this.schema = t, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = Nf(e, r.attrs), this.defaultAttrs = Ef(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == zr.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Pf(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new cr(this, this.computeAttrs(e), te.from(t), Ge.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, r) {
    return t = te.from(t), this.checkContent(t), new cr(this, this.computeAttrs(e), t, Ge.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, r) {
    if (e = this.computeAttrs(e), t = te.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let s = this.contentMatch.matchFragment(t), a = s && s.fillBefore(te.empty, !0);
    return a ? new cr(this, e, t.append(a), Ge.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    _f(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? t && t.push(e[r]) : t || (t = e.slice(0, r));
    return t ? t.length ? t : Ge.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((a, o) => r[a] = new If(a, t, o));
    let s = t.spec.topNode || "doc";
    if (!r[s])
      throw new RangeError("Schema is missing its top node type ('" + s + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let a in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function Ib(n, e, t) {
  let r = t.split("|");
  return (s) => {
    let a = s === null ? "null" : typeof s;
    if (r.indexOf(a) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${n}, got ${a}`);
  };
}
class Rb {
  constructor(e, t, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? Ib(e, t, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class zo {
  /**
  @internal
  */
  constructor(e, t, r, s) {
    this.name = e, this.rank = t, this.schema = r, this.spec = s, this.attrs = Nf(e, s.attrs), this.excluded = null;
    let a = Ef(this.attrs);
    this.instance = a ? new Ge(this, a) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new Ge(this, Pf(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null), s = 0;
    return e.forEach((a, o) => r[a] = new zo(a, s++, t, o)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    _f(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Rf {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let s in e)
      t[s] = e[s];
    t.nodes = Nt.from(e.nodes), t.marks = Nt.from(e.marks || {}), this.nodes = lc.compile(this.spec.nodes, this), this.marks = zo.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let s in this.nodes) {
      if (s in this.marks)
        throw new RangeError(s + " can not be both a node and a mark");
      let a = this.nodes[s], o = a.spec.content || "", i = a.spec.marks;
      if (a.contentMatch = r[o] || (r[o] = zr.parse(o, this.nodes)), a.inlineContent = a.contentMatch.inlineContent, a.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!a.isInline || !a.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = a;
      }
      a.markSet = i == "_" ? null : i ? uc(this, i.split(" ")) : i == "" || !a.inlineContent ? [] : null;
    }
    for (let s in this.marks) {
      let a = this.marks[s], o = a.spec.excludes;
      a.excluded = o == null ? [a] : o == "" ? [] : uc(this, o.split(" "));
    }
    this.nodeFromJSON = (s) => cr.fromJSON(this, s), this.markFromJSON = (s) => Ge.fromJSON(this, s), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, r, s) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof lc) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, r, s);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let r = this.nodes.text;
    return new Ja(r, r.defaultAttrs, e, Ge.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function uc(n, e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    let s = e[r], a = n.marks[s], o = a;
    if (a)
      t.push(a);
    else
      for (let i in n.marks) {
        let l = n.marks[i];
        (s == "_" || l.spec.group && l.spec.group.split(" ").indexOf(s) > -1) && t.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return t;
}
function $b(n) {
  return n.tag != null;
}
function Lb(n) {
  return n.style != null;
}
class dr {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    t.forEach((s) => {
      if ($b(s))
        this.tags.push(s);
      else if (Lb(s)) {
        let a = /[^=]*/.exec(s.style)[0];
        r.indexOf(a) < 0 && r.push(a), this.styles.push(s);
      }
    }), this.normalizeLists = !this.tags.some((s) => {
      if (!/^(ul|ol)\b/.test(s.tag) || !s.node)
        return !1;
      let a = e.nodes[s.node];
      return a.contentMatch.matchType(a);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let r = new dc(this, t, !1);
    return r.addAll(e, Ge.none, t.from, t.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let r = new dc(this, t, !0);
    return r.addAll(e, Ge.none, t.from, t.to), me.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, r) {
    for (let s = r ? this.tags.indexOf(r) + 1 : 0; s < this.tags.length; s++) {
      let a = this.tags[s];
      if (zb(e, a.tag) && (a.namespace === void 0 || e.namespaceURI == a.namespace) && (!a.context || t.matchesContext(a.context))) {
        if (a.getAttrs) {
          let o = a.getAttrs(e);
          if (o === !1)
            continue;
          a.attrs = o || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, r, s) {
    for (let a = s ? this.styles.indexOf(s) + 1 : 0; a < this.styles.length; a++) {
      let o = this.styles[a], i = o.style;
      if (!(i.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      i.length > e.length && (i.charCodeAt(e.length) != 61 || i.slice(e.length + 1) != t))) {
        if (o.getAttrs) {
          let l = o.getAttrs(t);
          if (l === !1)
            continue;
          o.attrs = l || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function r(s) {
      let a = s.priority == null ? 50 : s.priority, o = 0;
      for (; o < t.length; o++) {
        let i = t[o];
        if ((i.priority == null ? 50 : i.priority) < a)
          break;
      }
      t.splice(o, 0, s);
    }
    for (let s in e.marks) {
      let a = e.marks[s].spec.parseDOM;
      a && a.forEach((o) => {
        r(o = fc(o)), o.mark || o.ignore || o.clearMark || (o.mark = s);
      });
    }
    for (let s in e.nodes) {
      let a = e.nodes[s].spec.parseDOM;
      a && a.forEach((o) => {
        r(o = fc(o)), o.node || o.ignore || o.mark || (o.node = s);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new dr(e, dr.schemaRules(e)));
  }
}
const $f = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, Bb = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Lf = { ol: !0, ul: !0 }, ta = 1, rl = 2, Vs = 4;
function cc(n, e, t) {
  return e != null ? (e ? ta : 0) | (e === "full" ? rl : 0) : n && n.whitespace == "pre" ? ta | rl : t & ~Vs;
}
class Ca {
  constructor(e, t, r, s, a, o) {
    this.type = e, this.attrs = t, this.marks = r, this.solid = s, this.options = o, this.content = [], this.activeMarks = Ge.none, this.match = a || (o & Vs ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(te.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, s;
        return (s = r.findWrapping(e.type)) ? (this.match = r, s) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & ta)) {
      let r = this.content[this.content.length - 1], s;
      if (r && r.isText && (s = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let a = r;
        r.text.length == s[0].length ? this.content.pop() : this.content[this.content.length - 1] = a.withText(a.text.slice(0, a.text.length - s[0].length));
      }
    }
    let t = te.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(te.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !$f.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class dc {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let s = t.topNode, a, o = cc(null, t.preserveWhitespace, 0) | (r ? Vs : 0);
    s ? a = new Ca(s.type, s.attrs, Ge.none, !0, t.topMatch || s.type.contentMatch, o) : r ? a = new Ca(null, null, Ge.none, !0, null, o) : a = new Ca(e.schema.topNodeType, null, Ge.none, !0, null, o), this.nodes = [a], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let r = e.nodeValue, s = this.top, a = s.options & rl ? "full" : this.localPreserveWS || (s.options & ta) > 0;
    if (a === "full" || s.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (a)
        a !== "full" ? r = r.replace(/\r?\n|\r/g, " ") : r = r.replace(/\r\n?/g, `
`);
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let o = s.content[s.content.length - 1], i = e.previousSibling;
        (!o || i && i.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (r = r.slice(1));
      }
      r && this.insertNode(this.parser.schema.text(r), t, !/\S/.test(r)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, r) {
    let s = this.localPreserveWS, a = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), i;
    Lf.hasOwnProperty(o) && this.parser.normalizeLists && Fb(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (i = this.parser.matchTag(e, this, r));
    e: if (l ? l.ignore : Bb.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let u, c = this.needsBlock;
      if ($f.hasOwnProperty(o))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), u = !0, a.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let d = l && l.skip ? t : this.readStyles(e, t);
      d && this.addAll(e, d), u && this.sync(a), this.needsBlock = c;
    } else {
      let u = this.readStyles(e, t);
      u && this.addElementByRule(e, l, u, l.consuming === !1 ? i : void 0);
    }
    this.localPreserveWS = s;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let r = e.style;
    if (r && r.length)
      for (let s = 0; s < this.parser.matchedStyles.length; s++) {
        let a = this.parser.matchedStyles[s], o = r.getPropertyValue(a);
        if (o)
          for (let i = void 0; ; ) {
            let l = this.parser.matchStyle(a, o, this, i);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? t = t.filter((u) => !l.clearMark(u)) : t = t.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              i = l;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, r, s) {
    let a, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), r, e.nodeName == "BR") || this.leafFallback(e, r);
      else {
        let l = this.enter(o, t.attrs || null, r, t.preserveWhitespace);
        l && (a = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[t.mark];
      r = r.concat(l.create(t.attrs));
    }
    let i = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (s)
      this.addElement(e, r, s);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, r, !1));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l, r), this.findAround(e, l, !1);
    }
    a && this.sync(i) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, r, s) {
    let a = r || 0;
    for (let o = r ? e.childNodes[r] : e.firstChild, i = s == null ? null : e.childNodes[s]; o != i; o = o.nextSibling, ++a)
      this.findAtPoint(e, a), this.addDOM(o, t);
    this.findAtPoint(e, a);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t, r) {
    let s, a;
    for (let o = this.open, i = 0; o >= 0; o--) {
      let l = this.nodes[o], u = l.findWrapping(e);
      if (u && (!s || s.length > u.length + i) && (s = u, a = l, !u.length))
        break;
      if (l.solid) {
        if (r)
          break;
        i += 2;
      }
    }
    if (!s)
      return null;
    this.sync(a);
    for (let o = 0; o < s.length; o++)
      t = this.enterInner(s[o], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let a = this.textblockFromContext();
      a && (t = this.enterInner(a, null, t));
    }
    let s = this.findPlace(e, t, r);
    if (s) {
      this.closeExtra();
      let a = this.top;
      a.match && (a.match = a.match.matchType(e.type));
      let o = Ge.none;
      for (let i of s.concat(e.marks))
        (a.type ? a.type.allowsMarkType(i.type) : hc(i.type, e.type)) && (o = i.addToSet(o));
      return a.content.push(e.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, r, s) {
    let a = this.findPlace(e.create(t), r, !1);
    return a && (a = this.enterInner(e, t, r, !0, s)), a;
  }
  // Open a node of the given type
  enterInner(e, t, r, s = !1, a) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let i = cc(e, a, o.options);
    o.options & Vs && o.content.length == 0 && (i |= Vs);
    let l = Ge.none;
    return r = r.filter((u) => (o.type ? o.type.allowsMarkType(u.type) : hc(u.type, e)) ? (l = u.addToSet(l), !1) : !0), this.nodes.push(new Ca(e, t, l, s, null, i)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= ta);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let s = r.length - 1; s >= 0; s--)
        e += r[s].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let s = 0; s < this.find.length; s++)
        this.find[s].pos == null && e.nodeType == 1 && e.contains(this.find[s].node) && t.compareDocumentPosition(this.find[s].node) & (r ? 2 : 4) && (this.find[s].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, s = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), a = -(r ? r.depth + 1 : 0) + (s ? 0 : 1), o = (i, l) => {
      for (; i >= 0; i--) {
        let u = t[i];
        if (u == "") {
          if (i == t.length - 1 || i == 0)
            continue;
          for (; l >= a; l--)
            if (o(i - 1, l))
              return !0;
          return !1;
        } else {
          let c = l > 0 || l == 0 && s ? this.nodes[l].type : r && l >= a ? r.node(l - a).type : null;
          if (!c || c.name != u && !c.isInGroup(u))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
}
function Fb(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && Lf.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function zb(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function fc(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function hc(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let s = t[r];
    if (!s.allowsMarkType(n))
      continue;
    let a = [], o = (i) => {
      a.push(i);
      for (let l = 0; l < i.edgeCount; l++) {
        let { type: u, next: c } = i.edge(l);
        if (u == e || a.indexOf(c) < 0 && o(c))
          return !0;
      }
    };
    if (o(s.contentMatch))
      return !0;
  }
}
class Gr {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, r) {
    r || (r = wi(t).createDocumentFragment());
    let s = r, a = [];
    return e.forEach((o) => {
      if (a.length || o.marks.length) {
        let i = 0, l = 0;
        for (; i < a.length && l < o.marks.length; ) {
          let u = o.marks[l];
          if (!this.marks[u.type.name]) {
            l++;
            continue;
          }
          if (!u.eq(a[i][0]) || u.type.spec.spanning === !1)
            break;
          i++, l++;
        }
        for (; i < a.length; )
          s = a.pop()[1];
        for (; l < o.marks.length; ) {
          let u = o.marks[l++], c = this.serializeMark(u, o.isInline, t);
          c && (a.push([u, s]), s.appendChild(c.dom), s = c.contentDOM || c.dom);
        }
      }
      s.appendChild(this.serializeNodeInner(o, t));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: s } = La(wi(t), this.nodes[e.type.name](e), null, e.attrs);
    if (s) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, s);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let s = e.marks.length - 1; s >= 0; s--) {
      let a = this.serializeMark(e.marks[s], e.isInline, t);
      a && ((a.contentDOM || a.dom).appendChild(r), r = a.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, t, r = {}) {
    let s = this.marks[e.type.name];
    return s && La(wi(r), s(e, t), null, e.attrs);
  }
  static renderSpec(e, t, r = null, s) {
    return La(e, t, r, s);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new Gr(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = pc(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return pc(e.marks);
  }
}
function pc(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function wi(n) {
  return n.document || window.document;
}
const mc = /* @__PURE__ */ new WeakMap();
function Vb(n) {
  let e = mc.get(n);
  return e === void 0 && mc.set(n, e = Hb(n)), e;
}
function Hb(n) {
  let e = null;
  function t(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let s = 0; s < r.length; s++)
            t(r[s]);
      else
        for (let s in r)
          t(r[s]);
  }
  return t(n), e;
}
function La(n, e, t, r) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let s = e[0], a;
  if (typeof s != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (a = Vb(r)) && a.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = s.indexOf(" ");
  o > 0 && (t = s.slice(0, o), s = s.slice(o + 1));
  let i, l = t ? n.createElementNS(t, s) : n.createElement(s), u = e[1], c = 1;
  if (u && typeof u == "object" && u.nodeType == null && !Array.isArray(u)) {
    c = 2;
    for (let d in u)
      if (u[d] != null) {
        let f = d.indexOf(" ");
        f > 0 ? l.setAttributeNS(d.slice(0, f), d.slice(f + 1), u[d]) : d == "style" && l.style ? l.style.cssText = u[d] : l.setAttribute(d, u[d]);
      }
  }
  for (let d = c; d < e.length; d++) {
    let f = e[d];
    if (f === 0) {
      if (d < e.length - 1 || d > c)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: p } = La(n, f, t, r);
      if (l.appendChild(h), p) {
        if (i)
          throw new RangeError("Multiple content holes");
        i = p;
      }
    }
  }
  return { dom: l, contentDOM: i };
}
const Bf = 65535, Ff = Math.pow(2, 16);
function Yb(n, e) {
  return n + e * Ff;
}
function gc(n) {
  return n & Bf;
}
function Wb(n) {
  return (n - (n & Bf)) / Ff;
}
const zf = 1, Vf = 2, Ba = 4, Hf = 8;
class sl {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Hf) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (zf | Ba)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Vf | Ba)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Ba) > 0;
  }
}
class rn {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && rn.empty)
      return rn.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, r = gc(e);
    if (!this.inverted)
      for (let s = 0; s < r; s++)
        t += this.ranges[s * 3 + 2] - this.ranges[s * 3 + 1];
    return this.ranges[r * 3] + t + Wb(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let s = 0, a = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let l = this.ranges[i] - (this.inverted ? s : 0);
      if (l > e)
        break;
      let u = this.ranges[i + a], c = this.ranges[i + o], d = l + u;
      if (e <= d) {
        let f = u ? e == l ? -1 : e == d ? 1 : t : t, h = l + s + (f < 0 ? 0 : c);
        if (r)
          return h;
        let p = e == (t < 0 ? l : d) ? null : Yb(i / 3, e - l), g = e == l ? Vf : e == d ? zf : Ba;
        return (t < 0 ? e != l : e != d) && (g |= Hf), new sl(h, g, p);
      }
      s += c - u;
    }
    return r ? e + s : new sl(e + s, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let r = 0, s = gc(t), a = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let i = 0; i < this.ranges.length; i += 3) {
      let l = this.ranges[i] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let u = this.ranges[i + a], c = l + u;
      if (e <= c && i == s * 3)
        return !0;
      r += this.ranges[i + o] - u;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let s = 0, a = 0; s < this.ranges.length; s += 3) {
      let o = this.ranges[s], i = o - (this.inverted ? a : 0), l = o + (this.inverted ? 0 : a), u = this.ranges[s + t], c = this.ranges[s + r];
      e(i, i + u, l, l + c), a += c - u;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new rn(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? rn.empty : new rn(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
rn.empty = new rn([]);
class na {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, t, r = 0, s = e ? e.length : 0) {
    this.mirror = t, this.from = r, this.to = s, this._maps = e || [], this.ownData = !(e || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new na(this._maps, this.mirror, e, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, r = this._maps.length; t < e._maps.length; t++) {
      let s = e.getMirror(t);
      this.appendMap(e._maps[t], s != null && s < t ? r + s : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this._maps.length + e._maps.length; t >= 0; t--) {
      let s = e.getMirror(t);
      this.appendMap(e._maps[t].invert(), s != null && s > t ? r - s - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new na();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let s = 0;
    for (let a = this.from; a < this.to; a++) {
      let o = this._maps[a], i = o.mapResult(e, t);
      if (i.recover != null) {
        let l = this.getMirror(a);
        if (l != null && l > a && l < this.to) {
          a = l, e = this._maps[l].recover(i.recover);
          continue;
        }
      }
      s |= i.delInfo, e = i.pos;
    }
    return r ? e : new sl(e, s, null);
  }
}
const ki = /* @__PURE__ */ Object.create(null);
class Yt {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return rn.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = ki[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in ki)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return ki[e] = t, t.prototype.jsonID = e, t;
  }
}
class bt {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new bt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new bt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, r, s) {
    try {
      return bt.ok(e.replace(t, r, s));
    } catch (a) {
      if (a instanceof qa)
        return bt.fail(a.message);
      throw a;
    }
  }
}
function Xl(n, e, t) {
  let r = [];
  for (let s = 0; s < n.childCount; s++) {
    let a = n.child(s);
    a.content.size && (a = a.copy(Xl(a.content, e, a))), a.isInline && (a = e(a, t, s)), r.push(a);
  }
  return te.fromArray(r);
}
class ar extends Yt {
  /**
  Create a mark step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), s = r.node(r.sharedDepth(this.to)), a = new me(Xl(t.content, (o, i) => !o.isAtom || !i.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), s), t.openStart, t.openEnd);
    return bt.fromReplace(e, this.from, this.to, a);
  }
  invert() {
    return new bn(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new ar(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof ar && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new ar(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new ar(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Yt.jsonID("addMark", ar);
class bn extends Yt {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new me(Xl(t.content, (s) => s.mark(this.mark.removeFromSet(s.marks)), e), t.openStart, t.openEnd);
    return bt.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new ar(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new bn(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof bn && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new bn(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new bn(t.from, t.to, e.markFromJSON(t.mark));
  }
}
Yt.jsonID("removeMark", bn);
class or extends Yt {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return bt.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return bt.fromReplace(e, this.pos, this.pos + 1, new me(te.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let s = 0; s < t.marks.length; s++)
          if (!t.marks[s].isInSet(r))
            return new or(this.pos, t.marks[s]);
        return new or(this.pos, this.mark);
      }
    }
    return new Vr(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new or(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new or(t.pos, e.markFromJSON(t.mark));
  }
}
Yt.jsonID("addNodeMark", or);
class Vr extends Yt {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return bt.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return bt.fromReplace(e, this.pos, this.pos + 1, new me(te.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new or(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Vr(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Vr(t.pos, e.markFromJSON(t.mark));
  }
}
Yt.jsonID("removeNodeMark", Vr);
class Tt extends Yt {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, r, s = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = s;
  }
  apply(e) {
    return this.structure && al(e, this.from, this.to) ? bt.fail("Structure replace would overwrite content") : bt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new rn([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Tt(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new Tt(t.pos, Math.max(t.pos, r.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof Tt) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? me.empty : new me(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Tt(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? me.empty : new me(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Tt(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Tt(t.from, t.to, me.fromJSON(e, t.slice), !!t.structure);
  }
}
Yt.jsonID("replace", Tt);
class At extends Yt {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, r, s, a, o, i = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = s, this.slice = a, this.insert = o, this.structure = i;
  }
  apply(e) {
    if (this.structure && (al(e, this.from, this.gapFrom) || al(e, this.gapTo, this.to)))
      return bt.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return bt.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? bt.fromReplace(e, this.from, this.to, r) : bt.fail("Content does not fit in gap");
  }
  getMap() {
    return new rn([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new At(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), s = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), a = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || s < t.pos || a > r.pos ? null : new At(t.pos, r.pos, s, a, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new At(t.from, t.to, t.gapFrom, t.gapTo, me.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
Yt.jsonID("replaceAround", At);
function al(n, e, t) {
  let r = n.resolve(e), s = t - e, a = r.depth;
  for (; s > 0 && a > 0 && r.indexAfter(a) == r.node(a).childCount; )
    a--, s--;
  if (s > 0) {
    let o = r.node(a).maybeChild(r.indexAfter(a));
    for (; s > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, s--;
    }
  }
  return !1;
}
function jb(n, e, t, r) {
  let s = [], a = [], o, i;
  n.doc.nodesBetween(e, t, (l, u, c) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!r.isInSet(d) && c.type.allowsMarkType(r.type)) {
      let f = Math.max(u, e), h = Math.min(u + l.nodeSize, t), p = r.addToSet(d);
      for (let g = 0; g < d.length; g++)
        d[g].isInSet(p) || (o && o.to == f && o.mark.eq(d[g]) ? o.to = h : s.push(o = new bn(f, h, d[g])));
      i && i.to == f ? i.to = h : a.push(i = new ar(f, h, r));
    }
  }), s.forEach((l) => n.step(l)), a.forEach((l) => n.step(l));
}
function Ub(n, e, t, r) {
  let s = [], a = 0;
  n.doc.nodesBetween(e, t, (o, i) => {
    if (!o.isInline)
      return;
    a++;
    let l = null;
    if (r instanceof zo) {
      let u = o.marks, c;
      for (; c = r.isInSet(u); )
        (l || (l = [])).push(c), u = c.removeFromSet(u);
    } else r ? r.isInSet(o.marks) && (l = [r]) : l = o.marks;
    if (l && l.length) {
      let u = Math.min(i + o.nodeSize, t);
      for (let c = 0; c < l.length; c++) {
        let d = l[c], f;
        for (let h = 0; h < s.length; h++) {
          let p = s[h];
          p.step == a - 1 && d.eq(s[h].style) && (f = p);
        }
        f ? (f.to = u, f.step = a) : s.push({ style: d, from: Math.max(i, e), to: u, step: a });
      }
    }
  }), s.forEach((o) => n.step(new bn(o.from, o.to, o.style)));
}
function Zl(n, e, t, r = t.contentMatch, s = !0) {
  let a = n.doc.nodeAt(e), o = [], i = e + 1;
  for (let l = 0; l < a.childCount; l++) {
    let u = a.child(l), c = i + u.nodeSize, d = r.matchType(u.type);
    if (!d)
      o.push(new Tt(i, c, me.empty));
    else {
      r = d;
      for (let f = 0; f < u.marks.length; f++)
        t.allowsMarkType(u.marks[f].type) || n.step(new bn(i, c, u.marks[f]));
      if (s && u.isText && t.whitespace != "pre") {
        let f, h = /\r?\n|\r/g, p;
        for (; f = h.exec(u.text); )
          p || (p = new me(te.from(t.schema.text(" ", t.allowedMarks(u.marks))), 0, 0)), o.push(new Tt(i + f.index, i + f.index + f[0].length, p));
      }
    }
    i = c;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(te.empty, !0);
    n.replace(i, i, new me(l, 0, 0));
  }
  for (let l = o.length - 1; l >= 0; l--)
    n.step(o[l]);
}
function qb(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function As(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let r = n.depth; ; --r) {
    let s = n.$from.node(r), a = n.$from.index(r), o = n.$to.indexAfter(r);
    if (r < n.depth && s.canReplace(a, o, t))
      return r;
    if (r == 0 || s.type.spec.isolating || !qb(s, a, o))
      break;
  }
  return null;
}
function Kb(n, e, t) {
  let { $from: r, $to: s, depth: a } = e, o = r.before(a + 1), i = s.after(a + 1), l = o, u = i, c = te.empty, d = 0;
  for (let p = a, g = !1; p > t; p--)
    g || r.index(p) > 0 ? (g = !0, c = te.from(r.node(p).copy(c)), d++) : l--;
  let f = te.empty, h = 0;
  for (let p = a, g = !1; p > t; p--)
    g || s.after(p + 1) < s.end(p) ? (g = !0, f = te.from(s.node(p).copy(f)), h++) : u++;
  n.step(new At(l, u, o, i, new me(c.append(f), d, h), c.size - d, !0));
}
function eu(n, e, t = null, r = n) {
  let s = Gb(n, e), a = s && Jb(r, e);
  return a ? s.map(yc).concat({ type: e, attrs: t }).concat(a.map(yc)) : null;
}
function yc(n) {
  return { type: n, attrs: null };
}
function Gb(n, e) {
  let { parent: t, startIndex: r, endIndex: s } = n, a = t.contentMatchAt(r).findWrapping(e);
  if (!a)
    return null;
  let o = a.length ? a[0] : e;
  return t.canReplaceWith(r, s, o) ? a : null;
}
function Jb(n, e) {
  let { parent: t, startIndex: r, endIndex: s } = n, a = t.child(r), o = e.contentMatch.findWrapping(a.type);
  if (!o)
    return null;
  let l = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let u = r; l && u < s; u++)
    l = l.matchType(t.child(u).type);
  return !l || !l.validEnd ? null : o;
}
function Qb(n, e, t) {
  let r = te.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (r.size) {
      let i = t[o].type.contentMatch.matchFragment(r);
      if (!i || !i.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = te.from(t[o].type.create(t[o].attrs, r));
  }
  let s = e.start, a = e.end;
  n.step(new At(s, a, s, a, new me(r, 0, 0), t.length, !0));
}
function Xb(n, e, t, r, s) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let a = n.steps.length;
  n.doc.nodesBetween(e, t, (o, i) => {
    let l = typeof s == "function" ? s(o) : s;
    if (o.isTextblock && !o.hasMarkup(r, l) && Zb(n.doc, n.mapping.slice(a).map(i), r)) {
      let u = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", p = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !p ? u = !1 : !h && p && (u = !0);
      }
      u === !1 && Wf(n, o, i, a), Zl(n, n.mapping.slice(a).map(i, 1), r, void 0, u === null);
      let c = n.mapping.slice(a), d = c.map(i, 1), f = c.map(i + o.nodeSize, 1);
      return n.step(new At(d, f, d + 1, f - 1, new me(te.from(r.create(l, null, o.marks)), 0, 0), 1, !0)), u === !0 && Yf(n, o, i, a), !1;
    }
  });
}
function Yf(n, e, t, r) {
  e.forEach((s, a) => {
    if (s.isText) {
      let o, i = /\r?\n|\r/g;
      for (; o = i.exec(s.text); ) {
        let l = n.mapping.slice(r).map(t + 1 + a + o.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function Wf(n, e, t, r) {
  e.forEach((s, a) => {
    if (s.type == s.type.schema.linebreakReplacement) {
      let o = n.mapping.slice(r).map(t + 1 + a);
      n.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function Zb(n, e, t) {
  let r = n.resolve(e), s = r.index();
  return r.parent.canReplaceWith(s, s + 1, t);
}
function e1(n, e, t, r, s) {
  let a = n.doc.nodeAt(e);
  if (!a)
    throw new RangeError("No node at given position");
  t || (t = a.type);
  let o = t.create(r, null, s || a.marks);
  if (a.isLeaf)
    return n.replaceWith(e, e + a.nodeSize, o);
  if (!t.validContent(a.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new At(e, e + a.nodeSize, e + 1, e + a.nodeSize - 1, new me(te.from(o), 0, 0), 1, !0));
}
function Wn(n, e, t = 1, r) {
  let s = n.resolve(e), a = s.depth - t, o = r && r[r.length - 1] || s.parent;
  if (a < 0 || s.parent.type.spec.isolating || !s.parent.canReplace(s.index(), s.parent.childCount) || !o.type.validContent(s.parent.content.cutByIndex(s.index(), s.parent.childCount)))
    return !1;
  for (let u = s.depth - 1, c = t - 2; u > a; u--, c--) {
    let d = s.node(u), f = s.index(u);
    if (d.type.spec.isolating)
      return !1;
    let h = d.content.cutByIndex(f, d.childCount), p = r && r[c + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let g = r && r[c] || d;
    if (!d.canReplace(f + 1, d.childCount) || !g.type.validContent(h))
      return !1;
  }
  let i = s.indexAfter(a), l = r && r[0];
  return s.node(a).canReplaceWith(i, i, l ? l.type : s.node(a + 1).type);
}
function t1(n, e, t = 1, r) {
  let s = n.doc.resolve(e), a = te.empty, o = te.empty;
  for (let i = s.depth, l = s.depth - t, u = t - 1; i > l; i--, u--) {
    a = te.from(s.node(i).copy(a));
    let c = r && r[u];
    o = te.from(c ? c.type.create(c.attrs, o) : s.node(i).copy(o));
  }
  n.step(new Tt(e, e, new me(a.append(o), t, t), !0));
}
function wr(n, e) {
  let t = n.resolve(e), r = t.index();
  return jf(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(r, r + 1);
}
function n1(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: r } = n.type.schema;
  for (let s = 0; s < e.childCount; s++) {
    let a = e.child(s), o = a.type == r ? n.type.schema.nodes.text : a.type;
    if (t = t.matchType(o), !t || !n.type.allowsMarks(a.marks))
      return !1;
  }
  return t.validEnd;
}
function jf(n, e) {
  return !!(n && e && !n.isLeaf && n1(n, e));
}
function Vo(n, e, t = -1) {
  let r = n.resolve(e);
  for (let s = r.depth; ; s--) {
    let a, o, i = r.index(s);
    if (s == r.depth ? (a = r.nodeBefore, o = r.nodeAfter) : t > 0 ? (a = r.node(s + 1), i++, o = r.node(s).maybeChild(i)) : (a = r.node(s).maybeChild(i - 1), o = r.node(s + 1)), a && !a.isTextblock && jf(a, o) && r.node(s).canReplace(i, i + 1))
      return e;
    if (s == 0)
      break;
    e = t < 0 ? r.before(s) : r.after(s);
  }
}
function r1(n, e, t) {
  let r = null, { linebreakReplacement: s } = n.doc.type.schema, a = n.doc.resolve(e - t), o = a.node().type;
  if (s && o.inlineContent) {
    let c = o.whitespace == "pre", d = !!o.contentMatch.matchType(s);
    c && !d ? r = !1 : !c && d && (r = !0);
  }
  let i = n.steps.length;
  if (r === !1) {
    let c = n.doc.resolve(e + t);
    Wf(n, c.node(), c.before(), i);
  }
  o.inlineContent && Zl(n, e + t - 1, o, a.node().contentMatchAt(a.index()), r == null);
  let l = n.mapping.slice(i), u = l.map(e - t);
  if (n.step(new Tt(u, l.map(e + t, -1), me.empty, !0)), r === !0) {
    let c = n.doc.resolve(u);
    Yf(n, c.node(), c.before(), n.steps.length);
  }
  return n;
}
function s1(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let s = r.depth - 1; s >= 0; s--) {
      let a = r.index(s);
      if (r.node(s).canReplaceWith(a, a, t))
        return r.before(s + 1);
      if (a > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let s = r.depth - 1; s >= 0; s--) {
      let a = r.indexAfter(s);
      if (r.node(s).canReplaceWith(a, a, t))
        return r.after(s + 1);
      if (a < r.node(s).childCount)
        return null;
    }
  return null;
}
function Uf(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let s = t.content;
  for (let a = 0; a < t.openStart; a++)
    s = s.firstChild.content;
  for (let a = 1; a <= (t.openStart == 0 && t.size ? 2 : 1); a++)
    for (let o = r.depth; o >= 0; o--) {
      let i = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, l = r.index(o) + (i > 0 ? 1 : 0), u = r.node(o), c = !1;
      if (a == 1)
        c = u.canReplace(l, l, s);
      else {
        let d = u.contentMatchAt(l).findWrapping(s.firstChild.type);
        c = d && u.canReplaceWith(l, l, d[0]);
      }
      if (c)
        return i == 0 ? r.pos : i < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function Ho(n, e, t = e, r = me.empty) {
  if (e == t && !r.size)
    return null;
  let s = n.resolve(e), a = n.resolve(t);
  return qf(s, a, r) ? new Tt(e, t, r) : new a1(s, a, r).fit();
}
function qf(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class a1 {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = te.empty;
    for (let s = 0; s <= e.depth; s++) {
      let a = e.node(s);
      this.frontier.push({
        type: a.type,
        match: a.contentMatchAt(e.indexAfter(s))
      });
    }
    for (let s = e.depth; s > 0; s--)
      this.placed = te.from(e.node(s).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let u = this.findFittable();
      u ? this.placeNodes(u) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, s = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!s)
      return null;
    let a = this.placed, o = r.depth, i = s.depth;
    for (; o && i && a.childCount == 1; )
      a = a.firstChild.content, o--, i--;
    let l = new me(a, o, i);
    return e > -1 ? new At(r.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || r.pos != this.$to.pos ? new Tt(r.pos, s.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, s = this.unplaced.openEnd; r < e; r++) {
      let a = t.firstChild;
      if (t.childCount > 1 && (s = 0), a.type.spec.isolating && s <= r) {
        e = r;
        break;
      }
      t = a.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let s, a = null;
        r ? (a = xi(this.unplaced.content, r - 1).firstChild, s = a.content) : s = this.unplaced.content;
        let o = s.firstChild;
        for (let i = this.depth; i >= 0; i--) {
          let { type: l, match: u } = this.frontier[i], c, d = null;
          if (t == 1 && (o ? u.matchType(o.type) || (d = u.fillBefore(te.from(o), !1)) : a && l.compatibleContent(a.type)))
            return { sliceDepth: r, frontierDepth: i, parent: a, inject: d };
          if (t == 2 && o && (c = u.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: i, parent: a, wrap: c };
          if (a && u.matchType(a.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, s = xi(e, t);
    return !s.childCount || s.firstChild.isLeaf ? !1 : (this.unplaced = new me(e, t + 1, Math.max(r, s.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, s = xi(e, t);
    if (s.childCount <= 1 && t > 0) {
      let a = e.size - t <= t + s.size;
      this.unplaced = new me(Ns(e, t - 1, 1), t - 1, a ? t - 1 : r);
    } else
      this.unplaced = new me(Ns(e, t, 1), t, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: s, wrap: a }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (a)
      for (let g = 0; g < a.length; g++)
        this.openFrontierNode(a[g]);
    let o = this.unplaced, i = r ? r.content : o.content, l = o.openStart - e, u = 0, c = [], { match: d, type: f } = this.frontier[t];
    if (s) {
      for (let g = 0; g < s.childCount; g++)
        c.push(s.child(g));
      d = d.matchFragment(s);
    }
    let h = i.size + e - (o.content.size - o.openEnd);
    for (; u < i.childCount; ) {
      let g = i.child(u), y = d.matchType(g.type);
      if (!y)
        break;
      u++, (u > 1 || l == 0 || g.content.size) && (d = y, c.push(Kf(g.mark(f.allowedMarks(g.marks)), u == 1 ? l : 0, u == i.childCount ? h : -1)));
    }
    let p = u == i.childCount;
    p || (h = -1), this.placed = Is(this.placed, t, te.from(c)), this.frontier[t].match = d, p && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, y = i; g < h; g++) {
      let v = y.lastChild;
      this.frontier.push({ type: v.type, match: v.contentMatchAt(v.childCount) }), y = v.content;
    }
    this.unplaced = p ? e == 0 ? me.empty : new me(Ns(o.content, e - 1, 1), e - 1, h < 0 ? o.openEnd : e - 1) : new me(Ns(o.content, e, u), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !Mi(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, s = this.$to.after(r);
    for (; r > 1 && s == this.$to.end(--r); )
      ++s;
    return s;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: r, type: s } = this.frontier[t], a = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), o = Mi(e, t, s, r, a);
      if (o) {
        for (let i = t - 1; i >= 0; i--) {
          let { match: l, type: u } = this.frontier[i], c = Mi(e, i, u, l, !0);
          if (!c || c.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: a ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Is(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let s = e.node(r), a = s.type.contentMatch.fillBefore(s.content, !0, e.index(r));
      this.openFrontierNode(s.type, s.attrs, a);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let s = this.frontier[this.depth];
    s.match = s.match.matchType(e), this.placed = Is(this.placed, this.depth, te.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(te.empty, !0);
    t.childCount && (this.placed = Is(this.placed, this.frontier.length, t));
  }
}
function Ns(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Ns(n.firstChild.content, e - 1, t)));
}
function Is(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Is(n.lastChild.content, e - 1, t)));
}
function xi(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function Kf(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, Kf(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(te.empty, !0)))), n.copy(r);
}
function Mi(n, e, t, r, s) {
  let a = n.node(e), o = s ? n.indexAfter(e) : n.index(e);
  if (o == a.childCount && !t.compatibleContent(a.type))
    return null;
  let i = r.fillBefore(a.content, !0, o);
  return i && !o1(t, a.content, o) ? i : null;
}
function o1(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function i1(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function l1(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let s = n.doc.resolve(e), a = n.doc.resolve(t);
  if (qf(s, a, r))
    return n.step(new Tt(e, t, r));
  let o = Jf(s, n.doc.resolve(t));
  o[o.length - 1] == 0 && o.pop();
  let i = -(s.depth + 1);
  o.unshift(i);
  for (let f = s.depth, h = s.pos - 1; f > 0; f--, h--) {
    let p = s.node(f).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    o.indexOf(f) > -1 ? i = f : s.before(f) == h && o.splice(1, 0, -f);
  }
  let l = o.indexOf(i), u = [], c = r.openStart;
  for (let f = r.content, h = 0; ; h++) {
    let p = f.firstChild;
    if (u.push(p), h == r.openStart)
      break;
    f = p.content;
  }
  for (let f = c - 1; f >= 0; f--) {
    let h = u[f], p = i1(h.type);
    if (p && !h.sameMarkup(s.node(Math.abs(i) - 1)))
      c = f;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let h = (f + c + 1) % (r.openStart + 1), p = u[h];
    if (p)
      for (let g = 0; g < o.length; g++) {
        let y = o[(g + l) % o.length], v = !0;
        y < 0 && (v = !1, y = -y);
        let C = s.node(y - 1), M = s.index(y - 1);
        if (C.canReplaceWith(M, M, p.type, p.marks))
          return n.replace(s.before(y), v ? a.after(y) : t, new me(Gf(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let d = n.steps.length;
  for (let f = o.length - 1; f >= 0 && (n.replace(e, t, r), !(n.steps.length > d)); f--) {
    let h = o[f];
    h < 0 || (e = s.before(h), t = a.after(h));
  }
}
function Gf(n, e, t, r, s) {
  if (e < t) {
    let a = n.firstChild;
    n = n.replaceChild(0, a.copy(Gf(a.content, e + 1, t, r, a)));
  }
  if (e > r) {
    let a = s.contentMatchAt(0), o = a.fillBefore(n).append(n);
    n = o.append(a.matchFragment(o).fillBefore(te.empty, !0));
  }
  return n;
}
function u1(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let s = s1(n.doc, e, r.type);
    s != null && (e = t = s);
  }
  n.replaceRange(e, t, new me(te.from(r), 0, 0));
}
function c1(n, e, t) {
  let r = n.doc.resolve(e), s = n.doc.resolve(t), a = Jf(r, s);
  for (let o = 0; o < a.length; o++) {
    let i = a[o], l = o == a.length - 1;
    if (l && i == 0 || r.node(i).type.contentMatch.validEnd)
      return n.delete(r.start(i), s.end(i));
    if (i > 0 && (l || r.node(i - 1).canReplace(r.index(i - 1), s.indexAfter(i - 1))))
      return n.delete(r.before(i), s.after(i));
  }
  for (let o = 1; o <= r.depth && o <= s.depth; o++)
    if (e - r.start(o) == r.depth - o && t > r.end(o) && s.end(o) - t != s.depth - o && r.start(o - 1) == s.start(o - 1) && r.node(o - 1).canReplace(r.index(o - 1), s.index(o - 1)))
      return n.delete(r.before(o), t);
  n.delete(e, t);
}
function Jf(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let s = r; s >= 0; s--) {
    let a = n.start(s);
    if (a < n.pos - (n.depth - s) || e.end(s) > e.pos + (e.depth - s) || n.node(s).type.spec.isolating || e.node(s).type.spec.isolating)
      break;
    (a == e.start(s) || s == n.depth && s == e.depth && n.parent.inlineContent && e.parent.inlineContent && s && e.start(s - 1) == a - 1) && t.push(s);
  }
  return t;
}
class us extends Yt {
  /**
  Construct an attribute step.
  */
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return bt.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let a in t.attrs)
      r[a] = t.attrs[a];
    r[this.attr] = this.value;
    let s = t.type.create(r, null, t.marks);
    return bt.fromReplace(e, this.pos, this.pos + 1, new me(te.from(s), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return rn.empty;
  }
  invert(e) {
    return new us(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new us(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new us(t.pos, t.attr, t.value);
  }
}
Yt.jsonID("attr", us);
class ra extends Yt {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let s in e.attrs)
      t[s] = e.attrs[s];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return bt.ok(r);
  }
  getMap() {
    return rn.empty;
  }
  invert(e) {
    return new ra(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new ra(t.attr, t.value);
  }
}
Yt.jsonID("docAttr", ra);
let vs = class extends Error {
};
vs = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
vs.prototype = Object.create(Error.prototype);
vs.prototype.constructor = vs;
vs.prototype.name = "TransformError";
class Qf {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new na();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new vs(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, r = me.empty) {
    let s = Ho(this.doc, e, t, r);
    return s && this.step(s), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, r) {
    return this.replace(e, t, new me(te.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, me.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, r) {
    return l1(this, e, t, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, r) {
    return u1(this, e, t, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return c1(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return Kb(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return r1(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return Qb(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, r, s = null) {
    return Xb(this, e, t, r, s), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, r = null, s) {
    return e1(this, e, t, r, s), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, r) {
    return this.step(new us(e, t, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new ra(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new or(e, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    let r = this.doc.nodeAt(e);
    if (!r)
      throw new RangeError("No node at position " + e);
    if (t instanceof Ge)
      t.isInSet(r.marks) && this.step(new Vr(e, t));
    else {
      let s = r.marks, a, o = [];
      for (; a = t.isInSet(s); )
        o.push(new Vr(e, a)), s = a.removeFromSet(s);
      for (let i = o.length - 1; i >= 0; i--)
        this.step(o[i]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, t = 1, r) {
    return t1(this, e, t, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, r) {
    return jb(this, e, t, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, r) {
    return Ub(this, e, t, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, r) {
    return Zl(this, e, t, r), this;
  }
}
const Si = /* @__PURE__ */ Object.create(null);
class $e {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new d1(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = me.empty) {
    let r = t.content.lastChild, s = null;
    for (let i = 0; i < t.openEnd; i++)
      s = r, r = r.lastChild;
    let a = e.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: l, $to: u } = o[i], c = e.mapping.slice(a);
      e.replaceRange(c.map(l.pos), c.map(u.pos), i ? me.empty : t), i == 0 && wc(e, a, (r ? r.isInline : s && s.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let r = e.steps.length, s = this.ranges;
    for (let a = 0; a < s.length; a++) {
      let { $from: o, $to: i } = s[a], l = e.mapping.slice(r), u = l.map(o.pos), c = l.map(i.pos);
      a ? e.deleteRange(u, c) : (e.replaceRangeWith(u, c, t), wc(e, r, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, r = !1) {
    let s = e.parent.inlineContent ? new Ie(e) : ts(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (s)
      return s;
    for (let a = e.depth - 1; a >= 0; a--) {
      let o = t < 0 ? ts(e.node(0), e.node(a), e.before(a + 1), e.index(a), t, r) : ts(e.node(0), e.node(a), e.after(a + 1), e.index(a) + 1, t, r);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new an(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return ts(e, e, 0, 0, 1) || new an(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return ts(e, e, e.content.size, e.childCount, -1) || new an(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = Si[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in Si)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return Si[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Ie.between(this.$anchor, this.$head).getBookmark();
  }
}
$e.prototype.visible = !0;
class d1 {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let vc = !1;
function bc(n) {
  !vc && !n.parent.inlineContent && (vc = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class Ie extends $e {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    bc(e), bc(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return $e.near(r);
    let s = e.resolve(t.map(this.anchor));
    return new Ie(s.parent.inlineContent ? s : r, r);
  }
  replace(e, t = me.empty) {
    if (super.replace(e, t), t == me.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof Ie && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Yo(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ie(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, r = t) {
    let s = e.resolve(t);
    return new this(s, r == t ? s : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, r) {
    let s = e.pos - t.pos;
    if ((!r || s) && (r = s >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let a = $e.findFrom(t, r, !0) || $e.findFrom(t, -r, !0);
      if (a)
        t = a.$head;
      else
        return $e.near(t, r);
    }
    return e.parent.inlineContent || (s == 0 ? e = t : (e = ($e.findFrom(e, -r, !0) || $e.findFrom(e, r, !0)).$anchor, e.pos < t.pos != s < 0 && (e = t))), new Ie(e, t);
  }
}
$e.jsonID("text", Ie);
class Yo {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new Yo(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Ie.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class Me extends $e {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: s } = t.mapResult(this.anchor), a = e.resolve(s);
    return r ? $e.near(a) : new Me(a);
  }
  content() {
    return new me(te.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof Me && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new tu(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Me(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new Me(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
Me.prototype.visible = !1;
$e.jsonID("node", Me);
class tu {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new Yo(r, r) : new tu(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && Me.isSelectable(r) ? new Me(t) : $e.near(t);
  }
}
class an extends $e {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = me.empty) {
    if (t == me.empty) {
      e.delete(0, e.doc.content.size);
      let r = $e.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new an(e);
  }
  map(e) {
    return new an(e);
  }
  eq(e) {
    return e instanceof an;
  }
  getBookmark() {
    return f1;
  }
}
$e.jsonID("all", an);
const f1 = {
  map() {
    return this;
  },
  resolve(n) {
    return new an(n);
  }
};
function ts(n, e, t, r, s, a = !1) {
  if (e.inlineContent)
    return Ie.create(n, t);
  for (let o = r - (s > 0 ? 0 : 1); s > 0 ? o < e.childCount : o >= 0; o += s) {
    let i = e.child(o);
    if (i.isAtom) {
      if (!a && Me.isSelectable(i))
        return Me.create(n, t - (s < 0 ? i.nodeSize : 0));
    } else {
      let l = ts(n, i, t + s, s < 0 ? i.childCount : 0, s, a);
      if (l)
        return l;
    }
    t += i.nodeSize * s;
  }
  return null;
}
function wc(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let s = n.steps[r];
  if (!(s instanceof Tt || s instanceof At))
    return;
  let a = n.mapping.maps[r], o;
  a.forEach((i, l, u, c) => {
    o == null && (o = c);
  }), n.setSelection($e.near(n.doc.resolve(o), t));
}
const kc = 1, Aa = 2, xc = 4;
class h1 extends Qf {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | kc) & ~Aa, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & kc) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= Aa, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return Ge.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Aa) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~Aa, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let r = this.selection;
    return t && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || Ge.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, r) {
    let s = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(s.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = t), r = r ?? t, !e)
        return this.deleteRange(t, r);
      let a = this.storedMarks;
      if (!a) {
        let o = this.doc.resolve(t);
        a = r == t ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(t, r, s.text(e, a)), this.selection.empty || this.setSelection($e.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= xc, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & xc) > 0;
  }
}
function Mc(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Rs {
  constructor(e, t, r) {
    this.name = e, this.init = Mc(t.init, r), this.apply = Mc(t.apply, r);
  }
}
const p1 = [
  new Rs("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Rs("selection", {
    init(n, e) {
      return n.selection || $e.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Rs("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, r) {
      return r.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Rs("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
class Ti {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = p1.slice(), t && t.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Rs(r.key, r.spec.state, r));
    });
  }
}
class is {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != t) {
        let s = this.config.plugins[r];
        if (s.spec.filterTransaction && !s.spec.filterTransaction.call(s, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], r = this.applyInner(e), s = null;
    for (; ; ) {
      let a = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let i = this.config.plugins[o];
        if (i.spec.appendTransaction) {
          let l = s ? s[o].n : 0, u = s ? s[o].state : this, c = l < t.length && i.spec.appendTransaction.call(i, l ? t.slice(l) : t, u, r);
          if (c && r.filterTransaction(c, o)) {
            if (c.setMeta("appendedTransaction", e), !s) {
              s = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                s.push(d < o ? { state: r, n: t.length } : { state: this, n: 0 });
            }
            t.push(c), r = r.applyInner(c), a = !0;
          }
          s && (s[o] = { state: r, n: t.length });
        }
      }
      if (!a)
        return { state: r, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new is(this.config), r = this.config.fields;
    for (let s = 0; s < r.length; s++) {
      let a = r[s];
      t[a.name] = a.apply(e, this[a.name], this, t);
    }
    return t;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new h1(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new Ti(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new is(t);
    for (let s = 0; s < t.fields.length; s++)
      r[t.fields[s].name] = t.fields[s].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new Ti(this.schema, e.plugins), r = t.fields, s = new is(t);
    for (let a = 0; a < r.length; a++) {
      let o = r[a].name;
      s[o] = this.hasOwnProperty(o) ? this[o] : r[a].init(e, s);
    }
    return s;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let s = e[r], a = s.spec.state;
        a && a.toJSON && (t[r] = a.toJSON.call(s, this[s.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, r) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let s = new Ti(e.schema, e.plugins), a = new is(s);
    return s.fields.forEach((o) => {
      if (o.name == "doc")
        a.doc = cr.fromJSON(e.schema, t.doc);
      else if (o.name == "selection")
        a.selection = $e.fromJSON(a.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (a.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let i in r) {
            let l = r[i], u = l.spec.state;
            if (l.key == o.name && u && u.fromJSON && Object.prototype.hasOwnProperty.call(t, i)) {
              a[o.name] = u.fromJSON.call(l, e, t[i], a);
              return;
            }
          }
        a[o.name] = o.init(e, a);
      }
    }), a;
  }
}
function Xf(n, e, t) {
  for (let r in n) {
    let s = n[r];
    s instanceof Function ? s = s.bind(e) : r == "handleDOMEvents" && (s = Xf(s, e, {})), t[r] = s;
  }
  return t;
}
class dt {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && Xf(e.props, this, this.props), this.key = e.key ? e.key.key : Zf("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Ci = /* @__PURE__ */ Object.create(null);
function Zf(n) {
  return n in Ci ? n + "$" + ++Ci[n] : (Ci[n] = 0, n + "$");
}
class _t {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = Zf(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const It = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, bs = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let ol = null;
const zn = function(n, e, t) {
  let r = ol || (ol = document.createRange());
  return r.setEnd(n, t ?? n.nodeValue.length), r.setStart(n, e || 0), r;
}, m1 = function() {
  ol = null;
}, Hr = function(n, e, t, r) {
  return t && (Sc(n, e, t, r, -1) || Sc(n, e, t, r, 1));
}, g1 = /^(img|br|input|textarea|hr)$/i;
function Sc(n, e, t, r, s) {
  for (var a; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (s < 0 ? 0 : hn(n))) {
      let o = n.parentNode;
      if (!o || o.nodeType != 1 || ya(n) || g1.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = It(n) + (s < 0 ? 0 : 1), n = o;
    } else if (n.nodeType == 1) {
      let o = n.childNodes[e + (s < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((a = o.pmViewDesc) === null || a === void 0) && a.ignoreForSelection)
          e += s;
        else
          return !1;
      else
        n = o, e = s < 0 ? hn(n) : 0;
    } else
      return !1;
  }
}
function hn(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function y1(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = hn(n);
    } else if (n.parentNode && !ya(n))
      e = It(n), n = n.parentNode;
    else
      return null;
  }
}
function v1(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !ya(n))
      e = It(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function b1(n, e, t) {
  for (let r = e == 0, s = e == hn(n); r || s; ) {
    if (n == t)
      return !0;
    let a = It(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && a == 0, s = s && a == hn(n);
  }
}
function ya(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const Wo = function(n) {
  return n.focusNode && Hr(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function Cr(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function w1(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function k1(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let r = n.caretPositionFromPoint(e, t);
      if (r)
        return { node: r.offsetNode, offset: Math.min(hn(r.offsetNode), r.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let r = n.caretRangeFromPoint(e, t);
    if (r)
      return { node: r.startContainer, offset: Math.min(hn(r.startContainer), r.startOffset) };
  }
}
const Nn = typeof navigator < "u" ? navigator : null, Tc = typeof document < "u" ? document : null, kr = Nn && Nn.userAgent || "", il = /Edge\/(\d+)/.exec(kr), eh = /MSIE \d/.exec(kr), ll = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(kr), tn = !!(eh || ll || il), fr = eh ? document.documentMode : ll ? +ll[1] : il ? +il[1] : 0, xn = !tn && /gecko\/(\d+)/i.test(kr);
xn && +(/Firefox\/(\d+)/.exec(kr) || [0, 0])[1];
const ul = !tn && /Chrome\/(\d+)/.exec(kr), Vt = !!ul, th = ul ? +ul[1] : 0, qt = !tn && !!Nn && /Apple Computer/.test(Nn.vendor), ws = qt && (/Mobile\/\w+/.test(kr) || !!Nn && Nn.maxTouchPoints > 2), dn = ws || (Nn ? /Mac/.test(Nn.platform) : !1), x1 = Nn ? /Win/.test(Nn.platform) : !1, Yn = /Android \d/.test(kr), va = !!Tc && "webkitFontSmoothing" in Tc.documentElement.style, M1 = va ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function S1(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function $n(n, e) {
  return typeof n == "number" ? n : n[e];
}
function T1(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, r = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * r
  };
}
function Cc(n, e, t) {
  let r = n.someProp("scrollThreshold") || 0, s = n.someProp("scrollMargin") || 5, a = n.dom.ownerDocument;
  for (let o = t || n.dom; o; ) {
    if (o.nodeType != 1) {
      o = bs(o);
      continue;
    }
    let i = o, l = i == a.body, u = l ? S1(a) : T1(i), c = 0, d = 0;
    if (e.top < u.top + $n(r, "top") ? d = -(u.top - e.top + $n(s, "top")) : e.bottom > u.bottom - $n(r, "bottom") && (d = e.bottom - e.top > u.bottom - u.top ? e.top + $n(s, "top") - u.top : e.bottom - u.bottom + $n(s, "bottom")), e.left < u.left + $n(r, "left") ? c = -(u.left - e.left + $n(s, "left")) : e.right > u.right - $n(r, "right") && (c = e.right - u.right + $n(s, "right")), c || d)
      if (l)
        a.defaultView.scrollBy(c, d);
      else {
        let h = i.scrollLeft, p = i.scrollTop;
        d && (i.scrollTop += d), c && (i.scrollLeft += c);
        let g = i.scrollLeft - h, y = i.scrollTop - p;
        e = { left: e.left - g, top: e.top - y, right: e.right - g, bottom: e.bottom - y };
      }
    let f = l ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(f))
      break;
    o = f == "absolute" ? o.offsetParent : bs(o);
  }
}
function C1(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), r, s;
  for (let a = (e.left + e.right) / 2, o = t + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let i = n.root.elementFromPoint(a, o);
    if (!i || i == n.dom || !n.dom.contains(i))
      continue;
    let l = i.getBoundingClientRect();
    if (l.top >= t - 20) {
      r = i, s = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: s, stack: nh(n.dom) };
}
function nh(n) {
  let e = [], t = n.ownerDocument;
  for (let r = n; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), n != t); r = bs(r))
    ;
  return e;
}
function A1({ refDOM: n, refTop: e, stack: t }) {
  let r = n ? n.getBoundingClientRect().top : 0;
  rh(t, r == 0 ? 0 : r - e);
}
function rh(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: r, top: s, left: a } = n[t];
    r.scrollTop != s + e && (r.scrollTop = s + e), r.scrollLeft != a && (r.scrollLeft = a);
  }
}
let Xr = null;
function D1(n) {
  if (n.setActive)
    return n.setActive();
  if (Xr)
    return n.focus(Xr);
  let e = nh(n);
  n.focus(Xr == null ? {
    get preventScroll() {
      return Xr = { preventScroll: !0 }, !0;
    }
  } : void 0), Xr || (Xr = !1, rh(e, 0));
}
function sh(n, e) {
  let t, r = 2e8, s, a = 0, o = e.top, i = e.top, l, u;
  for (let c = n.firstChild, d = 0; c; c = c.nextSibling, d++) {
    let f;
    if (c.nodeType == 1)
      f = c.getClientRects();
    else if (c.nodeType == 3)
      f = zn(c).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let p = f[h];
      if (p.top <= o && p.bottom >= i) {
        o = Math.max(p.bottom, o), i = Math.min(p.top, i);
        let g = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (g < r) {
          t = c, r = g, s = g && t.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, c.nodeType == 1 && g && (a = d + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !l && p.left <= e.left && p.right >= e.left && (l = c, u = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !t && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (a = d + 1);
    }
  }
  return !t && l && (t = l, s = u, r = 0), t && t.nodeType == 3 ? O1(t, s) : !t || r && t.nodeType == 1 ? { node: n, offset: a } : sh(t, s);
}
function O1(n, e) {
  let t = n.nodeValue.length, r = document.createRange();
  for (let s = 0; s < t; s++) {
    r.setEnd(n, s + 1), r.setStart(n, s);
    let a = Xn(r, 1);
    if (a.top != a.bottom && nu(e, a))
      return { node: n, offset: s + (e.left >= (a.left + a.right) / 2 ? 1 : 0) };
  }
  return { node: n, offset: 0 };
}
function nu(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function E1(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function P1(n, e, t) {
  let { node: r, offset: s } = sh(e, t), a = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    a = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(r, s, a);
}
function _1(n, e, t, r) {
  let s = -1;
  for (let a = e, o = !1; a != n.dom; ) {
    let i = n.docView.nearestDesc(a, !0), l;
    if (!i)
      return null;
    if (i.dom.nodeType == 1 && (i.node.isBlock && i.parent || !i.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = i.dom.getBoundingClientRect()).width || l.height) && (i.node.isBlock && i.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(i.dom.nodeName) && (!o && l.left > r.left || l.top > r.top ? s = i.posBefore : (!o && l.right < r.left || l.bottom < r.top) && (s = i.posAfter), o = !0), !i.contentDOM && s < 0 && !i.node.isText))
      return (i.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? i.posBefore : i.posAfter;
    a = i.dom.parentNode;
  }
  return s > -1 ? s : n.docView.posFromDOM(e, t, -1);
}
function ah(n, e, t) {
  let r = n.childNodes.length;
  if (r && t.top < t.bottom)
    for (let s = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - t.top) / (t.bottom - t.top)) - 2)), a = s; ; ) {
      let o = n.childNodes[a];
      if (o.nodeType == 1) {
        let i = o.getClientRects();
        for (let l = 0; l < i.length; l++) {
          let u = i[l];
          if (nu(e, u))
            return ah(o, e, u);
        }
      }
      if ((a = (a + 1) % r) == s)
        break;
    }
  return n;
}
function N1(n, e) {
  let t = n.dom.ownerDocument, r, s = 0, a = k1(t, e.left, e.top);
  a && ({ node: r, offset: s } = a);
  let o = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), i;
  if (!o || !n.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let u = n.dom.getBoundingClientRect();
    if (!nu(e, u) || (o = ah(n.dom, e, u), !o))
      return null;
  }
  if (qt)
    for (let u = o; r && u; u = bs(u))
      u.draggable && (r = void 0);
  if (o = E1(o, e), r) {
    if (xn && r.nodeType == 1 && (s = Math.min(s, r.childNodes.length), s < r.childNodes.length)) {
      let c = r.childNodes[s], d;
      c.nodeName == "IMG" && (d = c.getBoundingClientRect()).right <= e.left && d.bottom > e.top && s++;
    }
    let u;
    va && s && r.nodeType == 1 && (u = r.childNodes[s - 1]).nodeType == 1 && u.contentEditable == "false" && u.getBoundingClientRect().top >= e.top && s--, r == n.dom && s == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? i = n.state.doc.content.size : (s == 0 || r.nodeType != 1 || r.childNodes[s - 1].nodeName != "BR") && (i = _1(n, r, s, e));
  }
  i == null && (i = P1(n, o, e));
  let l = n.docView.nearestDesc(o, !0);
  return { pos: i, inside: l ? l.posAtStart - l.border : -1 };
}
function Ac(n) {
  return n.top < n.bottom || n.left < n.right;
}
function Xn(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let r = t[e < 0 ? 0 : t.length - 1];
    if (Ac(r))
      return r;
  }
  return Array.prototype.find.call(t, Ac) || n.getBoundingClientRect();
}
const I1 = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function oh(n, e, t) {
  let { node: r, offset: s, atom: a } = n.docView.domFromPos(e, t < 0 ? -1 : 1), o = va || xn;
  if (r.nodeType == 3)
    if (o && (I1.test(r.nodeValue) || (t < 0 ? !s : s == r.nodeValue.length))) {
      let l = Xn(zn(r, s, s), t);
      if (xn && s && /\s/.test(r.nodeValue[s - 1]) && s < r.nodeValue.length) {
        let u = Xn(zn(r, s - 1, s - 1), -1);
        if (u.top == l.top) {
          let c = Xn(zn(r, s, s + 1), -1);
          if (c.top != l.top)
            return Ps(c, c.left < u.left);
        }
      }
      return l;
    } else {
      let l = s, u = s, c = t < 0 ? 1 : -1;
      return t < 0 && !s ? (u++, c = -1) : t >= 0 && s == r.nodeValue.length ? (l--, c = 1) : t < 0 ? l-- : u++, Ps(Xn(zn(r, l, u), c), c < 0);
    }
  if (!n.state.doc.resolve(e - (a || 0)).parent.inlineContent) {
    if (a == null && s && (t < 0 || s == hn(r))) {
      let l = r.childNodes[s - 1];
      if (l.nodeType == 1)
        return Ai(l.getBoundingClientRect(), !1);
    }
    if (a == null && s < hn(r)) {
      let l = r.childNodes[s];
      if (l.nodeType == 1)
        return Ai(l.getBoundingClientRect(), !0);
    }
    return Ai(r.getBoundingClientRect(), t >= 0);
  }
  if (a == null && s && (t < 0 || s == hn(r))) {
    let l = r.childNodes[s - 1], u = l.nodeType == 3 ? zn(l, hn(l) - (o ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (u)
      return Ps(Xn(u, 1), !1);
  }
  if (a == null && s < hn(r)) {
    let l = r.childNodes[s];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let u = l ? l.nodeType == 3 ? zn(l, 0, o ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (u)
      return Ps(Xn(u, -1), !0);
  }
  return Ps(Xn(r.nodeType == 3 ? zn(r) : r, -t), t >= 0);
}
function Ps(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function Ai(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function ih(n, e, t) {
  let r = n.state, s = n.root.activeElement;
  r != e && n.updateState(e), s != n.dom && n.focus();
  try {
    return t();
  } finally {
    r != e && n.updateState(r), s != n.dom && s && s.focus();
  }
}
function R1(n, e, t) {
  let r = e.selection, s = t == "up" ? r.$from : r.$to;
  return ih(n, e, () => {
    let { node: a } = n.docView.domFromPos(s.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let i = n.docView.nearestDesc(a, !0);
      if (!i)
        break;
      if (i.node.isBlock) {
        a = i.contentDOM || i.dom;
        break;
      }
      a = i.dom.parentNode;
    }
    let o = oh(n, s.pos, 1);
    for (let i = a.firstChild; i; i = i.nextSibling) {
      let l;
      if (i.nodeType == 1)
        l = i.getClientRects();
      else if (i.nodeType == 3)
        l = zn(i, 0, i.nodeValue.length).getClientRects();
      else
        continue;
      for (let u = 0; u < l.length; u++) {
        let c = l[u];
        if (c.bottom > c.top + 1 && (t == "up" ? o.top - c.top > (c.bottom - o.top) * 2 : c.bottom - o.bottom > (o.bottom - c.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const $1 = /[\u0590-\u08ac]/;
function L1(n, e, t) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let s = r.parentOffset, a = !s, o = s == r.parent.content.size, i = n.domSelection();
  return i ? !$1.test(r.parent.textContent) || !i.modify ? t == "left" || t == "backward" ? a : o : ih(n, e, () => {
    let { focusNode: l, focusOffset: u, anchorNode: c, anchorOffset: d } = n.domSelectionRange(), f = i.caretBidiLevel;
    i.modify("move", t, "character");
    let h = r.depth ? n.docView.domAfterPos(r.before()) : n.dom, { focusNode: p, focusOffset: g } = n.domSelectionRange(), y = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && u == g;
    try {
      i.collapse(c, d), l && (l != c || u != d) && i.extend && i.extend(l, u);
    } catch {
    }
    return f != null && (i.caretBidiLevel = f), y;
  }) : r.pos == r.start() || r.pos == r.end();
}
let Dc = null, Oc = null, Ec = !1;
function B1(n, e, t) {
  return Dc == e && Oc == t ? Ec : (Dc = e, Oc = t, Ec = t == "up" || t == "down" ? R1(n, e, t) : L1(n, e, t));
}
const pn = 0, Pc = 1, Dr = 2, In = 3;
class ba {
  constructor(e, t, r, s) {
    this.parent = e, this.children = t, this.dom = r, this.contentDOM = s, this.dirty = pn, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, r = this.posAtStart; ; t++) {
      let s = this.children[t];
      if (s == e)
        return r;
      r += s.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let a, o;
        if (e == this.contentDOM)
          a = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          a = e.previousSibling;
        }
        for (; a && !((o = a.pmViewDesc) && o.parent == this); )
          a = a.previousSibling;
        return a ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let a, o;
        if (e == this.contentDOM)
          a = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          a = e.nextSibling;
        }
        for (; a && !((o = a.pmViewDesc) && o.parent == this); )
          a = a.nextSibling;
        return a ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let s;
    if (e == this.dom && this.contentDOM)
      s = t > It(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      s = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let a = e; ; a = a.parentNode) {
          if (a == this.dom) {
            s = !1;
            break;
          }
          if (a.previousSibling)
            break;
        }
      if (s == null && t == e.childNodes.length)
        for (let a = e; ; a = a.parentNode) {
          if (a == this.dom) {
            s = !0;
            break;
          }
          if (a.nextSibling)
            break;
        }
    }
    return s ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let r = !0, s = e; s; s = s.parentNode) {
      let a = this.getDesc(s), o;
      if (a && (!t || a.node))
        if (r && (o = a.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          r = !1;
        else
          return a;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let r = t; r; r = r.parent)
      if (r == this)
        return t;
  }
  posFromDOM(e, t, r) {
    for (let s = e; s; s = s.parentNode) {
      let a = this.getDesc(s);
      if (a)
        return a.localPosFromDOM(e, t, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, r = 0; t < this.children.length; t++) {
      let s = this.children[t], a = r + s.size;
      if (r == e && a != r) {
        for (; !s.border && s.children.length; )
          for (let o = 0; o < s.children.length; o++) {
            let i = s.children[o];
            if (i.size) {
              s = i;
              break;
            }
          }
        return s;
      }
      if (e < a)
        return s.descAt(e - r - s.border);
      r = a;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, s = 0;
    for (let a = 0; r < this.children.length; r++) {
      let o = this.children[r], i = a + o.size;
      if (i > e || o instanceof uh) {
        s = e - a;
        break;
      }
      a = i;
    }
    if (s)
      return this.children[r].domFromPos(s - this.children[r].border, t);
    for (let a; r && !(a = this.children[r - 1]).size && a instanceof lh && a.side >= 0; r--)
      ;
    if (t <= 0) {
      let a, o = !0;
      for (; a = r ? this.children[r - 1] : null, !(!a || a.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return a && t && o && !a.border && !a.domAtom ? a.domFromPos(a.size, t) : { node: this.contentDOM, offset: a ? It(a.dom) + 1 : 0 };
    } else {
      let a, o = !0;
      for (; a = r < this.children.length ? this.children[r] : null, !(!a || a.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return a && o && !a.border && !a.domAtom ? a.domFromPos(0, t) : { node: this.contentDOM, offset: a ? It(a.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let s = -1, a = -1;
    for (let o = r, i = 0; ; i++) {
      let l = this.children[i], u = o + l.size;
      if (s == -1 && e <= u) {
        let c = o + l.border;
        if (e >= c && t <= u - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, c);
        e = o;
        for (let d = i; d > 0; d--) {
          let f = this.children[d - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            s = It(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        s == -1 && (s = 0);
      }
      if (s > -1 && (u > t || i == this.children.length - 1)) {
        t = u;
        for (let c = i + 1; c < this.children.length; c++) {
          let d = this.children[c];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            a = It(d.dom);
            break;
          }
          t += d.size;
        }
        a == -1 && (a = this.contentDOM.childNodes.length);
        break;
      }
      o = u;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: s, toOffset: a };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: r } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || r == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, r, s = !1) {
    let a = Math.min(e, t), o = Math.max(e, t);
    for (let h = 0, p = 0; h < this.children.length; h++) {
      let g = this.children[h], y = p + g.size;
      if (a > p && o < y)
        return g.setSelection(e - p - g.border, t - p - g.border, r, s);
      p = y;
    }
    let i = this.domFromPos(e, e ? -1 : 1), l = t == e ? i : this.domFromPos(t, t ? -1 : 1), u = r.root.getSelection(), c = r.domSelectionRange(), d = !1;
    if ((xn || qt) && e == t) {
      let { node: h, offset: p } = i;
      if (h.nodeType == 3) {
        if (d = !!(p && h.nodeValue[p - 1] == `
`), d && p == h.nodeValue.length)
          for (let g = h, y; g; g = g.parentNode) {
            if (y = g.nextSibling) {
              y.nodeName == "BR" && (i = l = { node: y.parentNode, offset: It(y) + 1 });
              break;
            }
            let v = g.pmViewDesc;
            if (v && v.node && v.node.isBlock)
              break;
          }
      } else {
        let g = h.childNodes[p - 1];
        d = g && (g.nodeName == "BR" || g.contentEditable == "false");
      }
    }
    if (xn && c.focusNode && c.focusNode != l.node && c.focusNode.nodeType == 1) {
      let h = c.focusNode.childNodes[c.focusOffset];
      h && h.contentEditable == "false" && (s = !0);
    }
    if (!(s || d && qt) && Hr(i.node, i.offset, c.anchorNode, c.anchorOffset) && Hr(l.node, l.offset, c.focusNode, c.focusOffset))
      return;
    let f = !1;
    if ((u.extend || e == t) && !d) {
      u.collapse(i.node, i.offset);
      try {
        e != t && u.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > t) {
        let p = i;
        i = l, l = p;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(i.node, i.offset), u.removeAllRanges(), u.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let r = 0, s = 0; s < this.children.length; s++) {
      let a = this.children[s], o = r + a.size;
      if (r == o ? e <= o && t >= r : e < o && t > r) {
        let i = r + a.border, l = o - a.border;
        if (e >= i && t <= l) {
          this.dirty = e == r || t == o ? Dr : Pc, e == i && t == l && (a.contentLost || a.dom.parentNode != this.contentDOM) ? a.dirty = In : a.markDirty(e - i, t - i);
          return;
        } else
          a.dirty = a.dom == a.contentDOM && a.dom.parentNode == this.contentDOM && !a.children.length ? Dr : In;
      }
      r = o;
    }
    this.dirty = Dr;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let r = e == 1 ? Dr : Pc;
      t.dirty < r && (t.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class lh extends ba {
  constructor(e, t, r, s) {
    let a, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!a)
        return s;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let i = document.createElement("span");
        i.appendChild(o), o = i;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = t, this.widget = t, a = this;
  }
  matchesWidget(e) {
    return this.dirty == pn && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class F1 extends ba {
  constructor(e, t, r, s) {
    super(e, [], t, null), this.textDOM = r, this.text = s;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class Yr extends ba {
  constructor(e, t, r, s, a) {
    super(e, [], r, s), this.mark = t, this.spec = a;
  }
  static create(e, t, r, s) {
    let a = s.nodeViews[t.type.name], o = a && a(t, s, r);
    return (!o || !o.dom) && (o = Gr.renderSpec(document, t.type.spec.toDOM(t, r), null, t.attrs)), new Yr(e, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & In || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != In && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != pn) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = pn;
    }
  }
  slice(e, t, r) {
    let s = Yr.create(this.parent, this.mark, !0, r), a = this.children, o = this.size;
    t < o && (a = dl(a, t, o, r)), e > 0 && (a = dl(a, 0, e, r));
    for (let i = 0; i < a.length; i++)
      a[i].parent = s;
    return s.children = a, s;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class hr extends ba {
  constructor(e, t, r, s, a, o, i, l, u) {
    super(e, [], a, o), this.node = t, this.outerDeco = r, this.innerDeco = s, this.nodeDOM = i;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, r, s, a, o) {
    let i = a.nodeViews[t.type.name], l, u = i && i(t, a, () => {
      if (!l)
        return o;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, s), c = u && u.dom, d = u && u.contentDOM;
    if (t.isText) {
      if (!c)
        c = document.createTextNode(t.text);
      else if (c.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else c || ({ dom: c, contentDOM: d } = Gr.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !d && !t.isText && c.nodeName != "BR" && (c.hasAttribute("contenteditable") || (c.contentEditable = "false"), t.type.spec.draggable && (c.draggable = !0));
    let f = c;
    return c = fh(c, r, t), u ? l = new z1(e, t, r, s, c, d || null, f, u, a, o + 1) : t.isText ? new jo(e, t, r, s, c, f, a) : new hr(e, t, r, s, c, d || null, f, a, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let r = this.children[t];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => te.empty);
    }
    return e;
  }
  matchesNode(e, t, r) {
    return this.dirty == pn && e.eq(this.node) && Qa(t, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let r = this.node.inlineContent, s = t, a = e.composing ? this.localCompositionInfo(e, t) : null, o = a && a.pos > -1 ? a : null, i = a && a.pos < 0, l = new H1(this, o && o.node, e);
    j1(this.node, this.innerDeco, (u, c, d) => {
      u.spec.marks ? l.syncToMarks(u.spec.marks, r, e) : u.type.side >= 0 && !d && l.syncToMarks(c == this.node.childCount ? Ge.none : this.node.child(c).marks, r, e), l.placeWidget(u, e, s);
    }, (u, c, d, f) => {
      l.syncToMarks(u.marks, r, e);
      let h;
      l.findNodeMatch(u, c, d, f) || i && e.state.selection.from > s && e.state.selection.to < s + u.nodeSize && (h = l.findIndexWithChild(a.node)) > -1 && l.updateNodeAt(u, c, d, h, e) || l.updateNextNode(u, c, d, e, f, s) || l.addNode(u, c, d, e, s), s += u.nodeSize;
    }), l.syncToMarks([], r, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == Dr) && (o && this.protectLocalComposition(e, o), ch(this.contentDOM, this.children, e), ws && U1(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: r, to: s } = e.state.selection;
    if (!(e.state.selection instanceof Ie) || r < t || s > t + this.node.content.size)
      return null;
    let a = e.input.compositionNode;
    if (!a || !this.dom.contains(a.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = a.nodeValue, i = q1(this.node.content, o, r - t, s - t);
      return i < 0 ? null : { node: a, pos: i, text: o };
    } else
      return { node: a, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: r, text: s }) {
    if (this.getDesc(t))
      return;
    let a = t;
    for (; a.parentNode != this.contentDOM; a = a.parentNode) {
      for (; a.previousSibling; )
        a.parentNode.removeChild(a.previousSibling);
      for (; a.nextSibling; )
        a.parentNode.removeChild(a.nextSibling);
      a.pmViewDesc && (a.pmViewDesc = void 0);
    }
    let o = new F1(this, a, t, s);
    e.input.compositionNodes.push(o), this.children = dl(this.children, r, r + s.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, r, s) {
    return this.dirty == In || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, r, s), !0);
  }
  updateInner(e, t, r, s) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(s, this.posAtStart), this.dirty = pn;
  }
  updateOuterDeco(e) {
    if (Qa(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = dh(this.dom, this.nodeDOM, cl(this.outerDeco, this.node, t), cl(e, this.node, t)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function _c(n, e, t, r, s) {
  fh(r, e, n);
  let a = new hr(void 0, n, e, t, r, r, r, s, 0);
  return a.contentDOM && a.updateChildren(s, 0), a;
}
class jo extends hr {
  constructor(e, t, r, s, a, o, i) {
    super(e, t, r, s, a, null, o, i, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, r, s) {
    return this.dirty == In || this.dirty != pn && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != pn || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, s.trackWrites == this.nodeDOM && (s.trackWrites = null)), this.node = e, this.dirty = pn, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, r) {
    let s = this.node.cut(e, t), a = document.createTextNode(s.text);
    return new jo(this.parent, s, this.outerDeco, this.innerDeco, a, a, r);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = In);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class uh extends ba {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == pn && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class z1 extends hr {
  constructor(e, t, r, s, a, o, i, l, u, c) {
    super(e, t, r, s, a, o, i, u, c), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, r, s) {
    if (this.dirty == In)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let a = this.spec.update(e, t, r);
      return a && this.updateInner(e, t, r, s), a;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, r, s);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, r, s) {
    this.spec.setSelection ? this.spec.setSelection(e, t, r.root) : super.setSelection(e, t, r, s);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function ch(n, e, t) {
  let r = n.firstChild, s = !1;
  for (let a = 0; a < e.length; a++) {
    let o = e[a], i = o.dom;
    if (i.parentNode == n) {
      for (; i != r; )
        r = Nc(r), s = !0;
      r = r.nextSibling;
    } else
      s = !0, n.insertBefore(i, r);
    if (o instanceof Yr) {
      let l = r ? r.previousSibling : n.lastChild;
      ch(o.contentDOM, o.children, t), r = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; r; )
    r = Nc(r), s = !0;
  s && t.trackWrites == n && (t.trackWrites = null);
}
const Hs = function(n) {
  n && (this.nodeName = n);
};
Hs.prototype = /* @__PURE__ */ Object.create(null);
const Or = [new Hs()];
function cl(n, e, t) {
  if (n.length == 0)
    return Or;
  let r = t ? Or[0] : new Hs(), s = [r];
  for (let a = 0; a < n.length; a++) {
    let o = n[a].type.attrs;
    if (o) {
      o.nodeName && s.push(r = new Hs(o.nodeName));
      for (let i in o) {
        let l = o[i];
        l != null && (t && s.length == 1 && s.push(r = new Hs(e.isInline ? "span" : "div")), i == "class" ? r.class = (r.class ? r.class + " " : "") + l : i == "style" ? r.style = (r.style ? r.style + ";" : "") + l : i != "nodeName" && (r[i] = l));
      }
    }
  }
  return s;
}
function dh(n, e, t, r) {
  if (t == Or && r == Or)
    return e;
  let s = e;
  for (let a = 0; a < r.length; a++) {
    let o = r[a], i = t[a];
    if (a) {
      let l;
      i && i.nodeName == o.nodeName && s != n && (l = s.parentNode) && l.nodeName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(s), i = Or[0]), s = l;
    }
    V1(s, i || Or[0], o);
  }
  return s;
}
function V1(n, e, t) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in t) && n.removeAttribute(r);
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && t[r] != e[r] && n.setAttribute(r, t[r]);
  if (e.class != t.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], s = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let a = 0; a < r.length; a++)
      s.indexOf(r[a]) == -1 && n.classList.remove(r[a]);
    for (let a = 0; a < s.length; a++)
      r.indexOf(s[a]) == -1 && n.classList.add(s[a]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, s;
      for (; s = r.exec(e.style); )
        n.style.removeProperty(s[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function fh(n, e, t) {
  return dh(n, n, Or, cl(e, t, n.nodeType != 1));
}
function Qa(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function Nc(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class H1 {
  constructor(e, t, r) {
    this.lock = t, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = Y1(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let r = e; r < t; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, r) {
    let s = 0, a = this.stack.length >> 1, o = Math.min(a, e.length);
    for (; s < o && (s == a - 1 ? this.top : this.stack[s + 1 << 1]).matchesMark(e[s]) && e[s].type.spec.spanning !== !1; )
      s++;
    for (; s < a; )
      this.destroyRest(), this.top.dirty = pn, this.index = this.stack.pop(), this.top = this.stack.pop(), a--;
    for (; a < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let i = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let u = this.top.children[l];
        if (u.matchesMark(e[a]) && !this.isLocked(u.dom)) {
          i = l;
          break;
        }
      }
      if (i > -1)
        i > this.index && (this.changed = !0, this.destroyBetween(this.index, i)), this.top = this.top.children[this.index];
      else {
        let l = Yr.create(this.top, e[a], t, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, a++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, r, s) {
    let a = -1, o;
    if (s >= this.preMatch.index && (o = this.preMatch.matches[s - this.preMatch.index]).parent == this.top && o.matchesNode(e, t, r))
      a = this.top.children.indexOf(o, this.index);
    else
      for (let i = this.index, l = Math.min(this.top.children.length, i + 5); i < l; i++) {
        let u = this.top.children[i];
        if (u.matchesNode(e, t, r) && !this.preMatch.matched.has(u)) {
          a = i;
          break;
        }
      }
    return a < 0 ? !1 : (this.destroyBetween(this.index, a), this.index++, !0);
  }
  updateNodeAt(e, t, r, s, a) {
    let o = this.top.children[s];
    return o.dirty == In && o.dom == o.contentDOM && (o.dirty = Dr), o.update(e, t, r, a) ? (this.destroyBetween(this.index, s), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let s = this.index; s < this.top.children.length; s++)
            if (this.top.children[s] == r)
              return s;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, r, s, a, o) {
    for (let i = this.index; i < this.top.children.length; i++) {
      let l = this.top.children[i];
      if (l instanceof hr) {
        let u = this.preMatch.matched.get(l);
        if (u != null && u != a)
          return !1;
        let c = l.dom, d, f = this.isLocked(c) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != In && Qa(t, l.outerDeco));
        if (!f && l.update(e, t, r, s))
          return this.destroyBetween(this.index, i), l.dom != c && (this.changed = !0), this.index++, !0;
        if (!f && (d = this.recreateWrapper(l, e, t, r, s, o)))
          return this.destroyBetween(this.index, i), this.top.children[this.index] = d, d.contentDOM && (d.dirty = Dr, d.updateChildren(s, o + 1), d.dirty = pn), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, r, s, a, o) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !Qa(r, e.outerDeco) || !s.eq(e.innerDeco))
      return null;
    let i = hr.create(this.top, t, r, s, a, o);
    if (i.contentDOM) {
      i.children = e.children, e.children = [];
      for (let l of i.children)
        l.parent = i;
    }
    return e.destroy(), i;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, r, s, a) {
    let o = hr.create(this.top, e, t, r, s, a);
    o.contentDOM && o.updateChildren(s, a + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, t, r) {
    let s = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (s && s.matchesWidget(e) && (e == s.widget || !s.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let a = new lh(this.top, e, t, r);
      this.top.children.splice(this.index++, 0, a), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof Yr; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof jo) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((qt || Vt) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let s = new uh(this.top, [], r, null);
      t != this.top ? t.children.push(s) : t.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function Y1(n, e) {
  let t = e, r = t.children.length, s = n.childCount, a = /* @__PURE__ */ new Map(), o = [];
  e: for (; s > 0; ) {
    let i;
    for (; ; )
      if (r) {
        let u = t.children[r - 1];
        if (u instanceof Yr)
          t = u, r = u.children.length;
        else {
          i = u, r--;
          break;
        }
      } else {
        if (t == e)
          break e;
        r = t.parent.children.indexOf(t), t = t.parent;
      }
    let l = i.node;
    if (l) {
      if (l != n.child(s - 1))
        break;
      --s, a.set(i, s), o.push(i);
    }
  }
  return { index: s, matched: a, matches: o.reverse() };
}
function W1(n, e) {
  return n.type.side - e.type.side;
}
function j1(n, e, t, r) {
  let s = e.locals(n), a = 0;
  if (s.length == 0) {
    for (let u = 0; u < n.childCount; u++) {
      let c = n.child(u);
      r(c, s, e.forChild(a, c), u), a += c.nodeSize;
    }
    return;
  }
  let o = 0, i = [], l = null;
  for (let u = 0; ; ) {
    let c, d;
    for (; o < s.length && s[o].to == a; ) {
      let y = s[o++];
      y.widget && (c ? (d || (d = [c])).push(y) : c = y);
    }
    if (c)
      if (d) {
        d.sort(W1);
        for (let y = 0; y < d.length; y++)
          t(d[y], u, !!l);
      } else
        t(c, u, !!l);
    let f, h;
    if (l)
      h = -1, f = l, l = null;
    else if (u < n.childCount)
      h = u, f = n.child(u++);
    else
      break;
    for (let y = 0; y < i.length; y++)
      i[y].to <= a && i.splice(y--, 1);
    for (; o < s.length && s[o].from <= a && s[o].to > a; )
      i.push(s[o++]);
    let p = a + f.nodeSize;
    if (f.isText) {
      let y = p;
      o < s.length && s[o].from < y && (y = s[o].from);
      for (let v = 0; v < i.length; v++)
        i[v].to < y && (y = i[v].to);
      y < p && (l = f.cut(y - a), f = f.cut(0, y - a), p = y, h = -1);
    } else
      for (; o < s.length && s[o].to < p; )
        o++;
    let g = f.isInline && !f.isLeaf ? i.filter((y) => !y.inline) : i.slice();
    r(f, g, e.forChild(a, f), h), a = p;
  }
}
function U1(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function q1(n, e, t, r) {
  for (let s = 0, a = 0; s < n.childCount && a <= r; ) {
    let o = n.child(s++), i = a;
    if (a += o.nodeSize, !o.isText)
      continue;
    let l = o.text;
    for (; s < n.childCount; ) {
      let u = n.child(s++);
      if (a += u.nodeSize, !u.isText)
        break;
      l += u.text;
    }
    if (a >= t) {
      if (a >= r && l.slice(r - e.length - i, r - i) == e)
        return r - e.length;
      let u = i < r ? l.lastIndexOf(e, r - i - 1) : -1;
      if (u >= 0 && u + e.length + i >= t)
        return i + u;
      if (t == r && l.length >= r + e.length - i && l.slice(r - i, r - i + e.length) == e)
        return r;
    }
  }
  return -1;
}
function dl(n, e, t, r, s) {
  let a = [];
  for (let o = 0, i = 0; o < n.length; o++) {
    let l = n[o], u = i, c = i += l.size;
    u >= t || c <= e ? a.push(l) : (u < e && a.push(l.slice(0, e - u, r)), s && (a.push(s), s = void 0), c > t && a.push(l.slice(t - u, l.size, r)));
  }
  return a;
}
function ru(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let s = n.docView.nearestDesc(t.focusNode), a = s && s.size == 0, o = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let i = r.resolve(o), l, u;
  if (Wo(t)) {
    for (l = o; s && !s.node; )
      s = s.parent;
    let d = s.node;
    if (s && d.isAtom && Me.isSelectable(d) && s.parent && !(d.isInline && b1(t.focusNode, t.focusOffset, s.dom))) {
      let f = s.posBefore;
      u = new Me(o == f ? i : r.resolve(f));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let d = o, f = o;
      for (let h = 0; h < t.rangeCount; h++) {
        let p = t.getRangeAt(h);
        d = Math.min(d, n.docView.posFromDOM(p.startContainer, p.startOffset, 1)), f = Math.max(f, n.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, o] = f == n.state.selection.anchor ? [f, d] : [d, f], i = r.resolve(o);
    } else
      l = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let c = r.resolve(l);
  if (!u) {
    let d = e == "pointer" || n.state.selection.head < i.pos && !a ? 1 : -1;
    u = su(n, c, i, d);
  }
  return u;
}
function hh(n) {
  return n.editable ? n.hasFocus() : mh(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function jn(n, e = !1) {
  let t = n.state.selection;
  if (ph(n, t), !!hh(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && Vt) {
      let r = n.domSelectionRange(), s = n.domObserver.currentSelection;
      if (r.anchorNode && s.anchorNode && Hr(r.anchorNode, r.anchorOffset, s.anchorNode, s.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      G1(n);
    else {
      let { anchor: r, head: s } = t, a, o;
      Ic && !(t instanceof Ie) && (t.$from.parent.inlineContent || (a = Rc(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = Rc(n, t.to))), n.docView.setSelection(r, s, n, e), Ic && (a && $c(a), o && $c(o)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && K1(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const Ic = qt || Vt && th < 63;
function Rc(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), s = r < t.childNodes.length ? t.childNodes[r] : null, a = r ? t.childNodes[r - 1] : null;
  if (qt && s && s.contentEditable == "false")
    return Di(s);
  if ((!s || s.contentEditable == "false") && (!a || a.contentEditable == "false")) {
    if (s)
      return Di(s);
    if (a)
      return Di(a);
  }
}
function Di(n) {
  return n.contentEditable = "true", qt && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function $c(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function K1(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, s = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != s) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!hh(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function G1(n) {
  let e = n.domSelection(), t = document.createRange();
  if (!e)
    return;
  let r = n.cursorWrapper.dom, s = r.nodeName == "IMG";
  s ? t.setStart(r.parentNode, It(r) + 1) : t.setStart(r, 0), t.collapse(!0), e.removeAllRanges(), e.addRange(t), !s && !n.state.selection.visible && tn && fr <= 11 && (r.disabled = !0, r.disabled = !1);
}
function ph(n, e) {
  if (e instanceof Me) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (Lc(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    Lc(n);
}
function Lc(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function su(n, e, t, r) {
  return n.someProp("createSelectionBetween", (s) => s(n, e, t)) || Ie.between(e, t, r);
}
function Bc(n) {
  return n.editable && !n.hasFocus() ? !1 : mh(n);
}
function mh(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function J1(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return Hr(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function fl(n, e) {
  let { $anchor: t, $head: r } = n.selection, s = e > 0 ? t.max(r) : t.min(r), a = s.parent.inlineContent ? s.depth ? n.doc.resolve(e > 0 ? s.after() : s.before()) : null : s;
  return a && $e.findFrom(a, e);
}
function Zn(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function Fc(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Ie)
    if (t.indexOf("s") > -1) {
      let { $head: s } = r, a = s.textOffset ? null : e < 0 ? s.nodeBefore : s.nodeAfter;
      if (!a || a.isText || !a.isLeaf)
        return !1;
      let o = n.state.doc.resolve(s.pos + a.nodeSize * (e < 0 ? -1 : 1));
      return Zn(n, new Ie(r.$anchor, o));
    } else if (r.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let s = fl(n.state, e);
        return s && s instanceof Me ? Zn(n, s) : !1;
      } else if (!(dn && t.indexOf("m") > -1)) {
        let s = r.$head, a = s.textOffset ? null : e < 0 ? s.nodeBefore : s.nodeAfter, o;
        if (!a || a.isText)
          return !1;
        let i = e < 0 ? s.pos - a.nodeSize : s.pos;
        return a.isAtom || (o = n.docView.descAt(i)) && !o.contentDOM ? Me.isSelectable(a) ? Zn(n, new Me(e < 0 ? n.state.doc.resolve(s.pos - a.nodeSize) : s)) : va ? Zn(n, new Ie(n.state.doc.resolve(e < 0 ? i : i + a.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof Me && r.node.isInline)
      return Zn(n, new Ie(e > 0 ? r.$to : r.$from));
    {
      let s = fl(n.state, e);
      return s ? Zn(n, s) : !1;
    }
  }
}
function Xa(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function Ys(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function Zr(n, e) {
  return e < 0 ? Q1(n) : X1(n);
}
function Q1(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let s, a, o = !1;
  for (xn && t.nodeType == 1 && r < Xa(t) && Ys(t.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let i = t.childNodes[r - 1];
        if (Ys(i, -1))
          s = t, a = --r;
        else if (i.nodeType == 3)
          t = i, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (gh(t))
        break;
      {
        let i = t.previousSibling;
        for (; i && Ys(i, -1); )
          s = t.parentNode, a = It(i), i = i.previousSibling;
        if (i)
          t = i, r = Xa(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  o ? hl(n, t, r) : s && hl(n, s, a);
}
function X1(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let s = Xa(t), a, o;
  for (; ; )
    if (r < s) {
      if (t.nodeType != 1)
        break;
      let i = t.childNodes[r];
      if (Ys(i, 1))
        a = t, o = ++r;
      else
        break;
    } else {
      if (gh(t))
        break;
      {
        let i = t.nextSibling;
        for (; i && Ys(i, 1); )
          a = i.parentNode, o = It(i) + 1, i = i.nextSibling;
        if (i)
          t = i, r = 0, s = Xa(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = s = 0;
        }
      }
    }
  a && hl(n, a, o);
}
function gh(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function Z1(n, e) {
  for (; n && e == n.childNodes.length && !ya(n); )
    e = It(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function ew(n, e) {
  for (; n && !e && !ya(n); )
    e = It(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function hl(n, e, t) {
  if (e.nodeType != 3) {
    let a, o;
    (o = Z1(e, t)) ? (e = o, t = 0) : (a = ew(e, t)) && (e = a, t = a.nodeValue.length);
  }
  let r = n.domSelection();
  if (!r)
    return;
  if (Wo(r)) {
    let a = document.createRange();
    a.setEnd(e, t), a.setStart(e, t), r.removeAllRanges(), r.addRange(a);
  } else r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: s } = n;
  setTimeout(() => {
    n.state == s && jn(n);
  }, 50);
}
function zc(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(Vt || x1) && t.parent.inlineContent) {
    let s = n.coordsAtPos(e);
    if (e > t.start()) {
      let a = n.coordsAtPos(e - 1), o = (a.top + a.bottom) / 2;
      if (o > s.top && o < s.bottom && Math.abs(a.left - s.left) > 1)
        return a.left < s.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let a = n.coordsAtPos(e + 1), o = (a.top + a.bottom) / 2;
      if (o > s.top && o < s.bottom && Math.abs(a.left - s.left) > 1)
        return a.left > s.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Vc(n, e, t) {
  let r = n.state.selection;
  if (r instanceof Ie && !r.empty || t.indexOf("s") > -1 || dn && t.indexOf("m") > -1)
    return !1;
  let { $from: s, $to: a } = r;
  if (!s.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = fl(n.state, e);
    if (o && o instanceof Me)
      return Zn(n, o);
  }
  if (!s.parent.inlineContent) {
    let o = e < 0 ? s : a, i = r instanceof an ? $e.near(o, e) : $e.findFrom(o, e);
    return i ? Zn(n, i) : !1;
  }
  return !1;
}
function Hc(n, e) {
  if (!(n.state.selection instanceof Ie))
    return !0;
  let { $head: t, $anchor: r, empty: s } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!s)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let a = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (a && !a.isText) {
    let o = n.state.tr;
    return e < 0 ? o.delete(t.pos - a.nodeSize, t.pos) : o.delete(t.pos, t.pos + a.nodeSize), n.dispatch(o), !0;
  }
  return !1;
}
function Yc(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function tw(n) {
  if (!qt || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    Yc(n, r, "true"), setTimeout(() => Yc(n, r, "false"), 20);
  }
  return !1;
}
function nw(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function rw(n, e) {
  let t = e.keyCode, r = nw(e);
  if (t == 8 || dn && t == 72 && r == "c")
    return Hc(n, -1) || Zr(n, -1);
  if (t == 46 && !e.shiftKey || dn && t == 68 && r == "c")
    return Hc(n, 1) || Zr(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || dn && t == 66 && r == "c") {
    let s = t == 37 ? zc(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return Fc(n, s, r) || Zr(n, s);
  } else if (t == 39 || dn && t == 70 && r == "c") {
    let s = t == 39 ? zc(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return Fc(n, s, r) || Zr(n, s);
  } else {
    if (t == 38 || dn && t == 80 && r == "c")
      return Vc(n, -1, r) || Zr(n, -1);
    if (t == 40 || dn && t == 78 && r == "c")
      return tw(n) || Vc(n, 1, r) || Zr(n, 1);
    if (r == (dn ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function au(n, e) {
  n.someProp("transformCopied", (h) => {
    e = h(e, n);
  });
  let t = [], { content: r, openStart: s, openEnd: a } = e;
  for (; s > 1 && a > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    s--, a--;
    let h = r.firstChild;
    t.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let o = n.someProp("clipboardSerializer") || Gr.fromSchema(n.state.schema), i = xh(), l = i.createElement("div");
  l.appendChild(o.serializeFragment(r, { document: i }));
  let u = l.firstChild, c, d = 0;
  for (; u && u.nodeType == 1 && (c = kh[u.nodeName.toLowerCase()]); ) {
    for (let h = c.length - 1; h >= 0; h--) {
      let p = i.createElement(c[h]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), d++;
    }
    u = l.firstChild;
  }
  u && u.nodeType == 1 && u.setAttribute("data-pm-slice", `${s} ${a}${d ? ` -${d}` : ""} ${JSON.stringify(t)}`);
  let f = n.someProp("clipboardTextSerializer", (h) => h(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: f, slice: e };
}
function yh(n, e, t, r, s) {
  let a = s.parent.type.spec.code, o, i;
  if (!t && !e)
    return null;
  let l = e && (r || a || !t);
  if (l) {
    if (n.someProp("transformPastedText", (f) => {
      e = f(e, a || r, n);
    }), a)
      return e ? new me(te.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : me.empty;
    let d = n.someProp("clipboardTextParser", (f) => f(e, s, r, n));
    if (d)
      i = d;
    else {
      let f = s.marks(), { schema: h } = n.state, p = Gr.fromSchema(h);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((g) => {
        let y = o.appendChild(document.createElement("p"));
        g && y.appendChild(p.serializeNode(h.text(g, f)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (d) => {
      t = d(t, n);
    }), o = iw(t), va && lw(o);
  let u = o && o.querySelector("[data-pm-slice]"), c = u && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(u.getAttribute("data-pm-slice") || "");
  if (c && c[3])
    for (let d = +c[3]; d > 0; d--) {
      let f = o.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      o = f;
    }
  if (i || (i = (n.someProp("clipboardParser") || n.someProp("domParser") || dr.fromSchema(n.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(l || c),
    context: s,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !sw.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), c)
    i = uw(Wc(i, +c[1], +c[2]), c[4]);
  else if (i = me.maxOpen(aw(i.content, s), !0), i.openStart || i.openEnd) {
    let d = 0, f = 0;
    for (let h = i.content.firstChild; d < i.openStart && !h.type.spec.isolating; d++, h = h.firstChild)
      ;
    for (let h = i.content.lastChild; f < i.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    i = Wc(i, d, f);
  }
  return n.someProp("transformPasted", (d) => {
    i = d(i, n);
  }), i;
}
const sw = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function aw(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let s = e.node(t).contentMatchAt(e.index(t)), a, o = [];
    if (n.forEach((i) => {
      if (!o)
        return;
      let l = s.findWrapping(i.type), u;
      if (!l)
        return o = null;
      if (u = o.length && a.length && bh(l, a, i, o[o.length - 1], 0))
        o[o.length - 1] = u;
      else {
        o.length && (o[o.length - 1] = wh(o[o.length - 1], a.length));
        let c = vh(i, l);
        o.push(c), s = s.matchType(c.type), a = l;
      }
    }), o)
      return te.from(o);
  }
  return n;
}
function vh(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, te.from(n));
  return n;
}
function bh(n, e, t, r, s) {
  if (s < n.length && s < e.length && n[s] == e[s]) {
    let a = bh(n, e, t, r.lastChild, s + 1);
    if (a)
      return r.copy(r.content.replaceChild(r.childCount - 1, a));
    if (r.contentMatchAt(r.childCount).matchType(s == n.length - 1 ? t.type : n[s + 1]))
      return r.copy(r.content.append(te.from(vh(t, n, s + 1))));
  }
}
function wh(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, wh(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(te.empty, !0);
  return n.copy(t.append(r));
}
function pl(n, e, t, r, s, a) {
  let o = e < 0 ? n.firstChild : n.lastChild, i = o.content;
  return n.childCount > 1 && (a = 0), s < r - 1 && (i = pl(i, e, t, r, s + 1, a)), s >= t && (i = e < 0 ? o.contentMatchAt(0).fillBefore(i, a <= s).append(i) : i.append(o.contentMatchAt(o.childCount).fillBefore(te.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, o.copy(i));
}
function Wc(n, e, t) {
  return e < n.openStart && (n = new me(pl(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new me(pl(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const kh = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let jc = null;
function xh() {
  return jc || (jc = document.implementation.createHTMLDocument("title"));
}
let Oi = null;
function ow(n) {
  let e = window.trustedTypes;
  return e ? (Oi || (Oi = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), Oi.createHTML(n)) : n;
}
function iw(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = xh().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), s;
  if ((s = r && kh[r[1].toLowerCase()]) && (n = s.map((a) => "<" + a + ">").join("") + n + s.map((a) => "</" + a + ">").reverse().join("")), t.innerHTML = ow(n), s)
    for (let a = 0; a < s.length; a++)
      t = t.querySelector(s[a]) || t;
  return t;
}
function lw(n) {
  let e = n.querySelectorAll(Vt ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function uw(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: s, openStart: a, openEnd: o } = n;
  for (let i = r.length - 2; i >= 0; i -= 2) {
    let l = t.nodes[r[i]];
    if (!l || l.hasRequiredAttrs())
      break;
    s = te.from(l.create(r[i + 1], s)), a++, o++;
  }
  return new me(s, a, o);
}
const Kt = {}, Gt = {}, cw = { touchstart: !0, touchmove: !0 };
class dw {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function fw(n) {
  for (let e in Kt) {
    let t = Kt[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (r) => {
      pw(n, r) && !ou(n, r) && (n.editable || !(r.type in Gt)) && t(n, r);
    }, cw[e] ? { passive: !0 } : void 0);
  }
  qt && n.dom.addEventListener("input", () => null), ml(n);
}
function ir(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function hw(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function ml(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (r) => ou(n, r));
  });
}
function ou(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let r = t[e.type];
    return r ? r(n, e) || e.defaultPrevented : !1;
  });
}
function pw(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function mw(n, e) {
  !ou(n, e) && Kt[e.type] && (n.editable || !(e.type in Gt)) && Kt[e.type](n, e);
}
Gt.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Sh(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(Yn && Vt && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), ws && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (s) => s(n, Cr(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (r) => r(n, t)) || rw(n, t) ? t.preventDefault() : ir(n, "key");
};
Gt.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
Gt.keypress = (n, e) => {
  let t = e;
  if (Sh(n, t) || !t.charCode || t.ctrlKey && !t.altKey || dn && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (s) => s(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof Ie) || !r.$from.sameParent(r.$to)) {
    let s = String.fromCharCode(t.charCode), a = () => n.state.tr.insertText(s).scrollIntoView();
    !/[\r\n]/.test(s) && !n.someProp("handleTextInput", (o) => o(n, r.$from.pos, r.$to.pos, s, a)) && n.dispatch(a()), t.preventDefault();
  }
};
function Uo(n) {
  return { left: n.clientX, top: n.clientY };
}
function gw(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function iu(n, e, t, r, s) {
  if (r == -1)
    return !1;
  let a = n.state.doc.resolve(r);
  for (let o = a.depth + 1; o > 0; o--)
    if (n.someProp(e, (i) => o > a.depth ? i(n, t, a.nodeAfter, a.before(o), s, !0) : i(n, t, a.node(o), a.before(o), s, !1)))
      return !0;
  return !1;
}
function cs(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let r = n.state.tr.setSelection(e);
  r.setMeta("pointer", !0), n.dispatch(r);
}
function yw(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && Me.isSelectable(r) ? (cs(n, new Me(t)), !0) : !1;
}
function vw(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, s;
  t instanceof Me && (r = t.node);
  let a = n.state.doc.resolve(e);
  for (let o = a.depth + 1; o > 0; o--) {
    let i = o > a.depth ? a.nodeAfter : a.node(o);
    if (Me.isSelectable(i)) {
      r && t.$from.depth > 0 && o >= t.$from.depth && a.before(t.$from.depth + 1) == t.$from.pos ? s = a.before(t.$from.depth) : s = a.before(o);
      break;
    }
  }
  return s != null ? (cs(n, Me.create(n.state.doc, s)), !0) : !1;
}
function bw(n, e, t, r, s) {
  return iu(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (a) => a(n, e, r)) || (s ? vw(n, t) : yw(n, t));
}
function ww(n, e, t, r) {
  return iu(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (s) => s(n, e, r));
}
function kw(n, e, t, r) {
  return iu(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (s) => s(n, e, r)) || xw(n, t, r);
}
function xw(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? (cs(n, Ie.create(r, 0, r.content.size)), !0) : !1;
  let s = r.resolve(e);
  for (let a = s.depth + 1; a > 0; a--) {
    let o = a > s.depth ? s.nodeAfter : s.node(a), i = s.before(a);
    if (o.inlineContent)
      cs(n, Ie.create(r, i + 1, i + 1 + o.content.size));
    else if (Me.isSelectable(o))
      cs(n, Me.create(r, i));
    else
      continue;
    return !0;
  }
}
function lu(n) {
  return Za(n);
}
const Mh = dn ? "metaKey" : "ctrlKey";
Kt.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = lu(n), s = Date.now(), a = "singleClick";
  s - n.input.lastClick.time < 500 && gw(t, n.input.lastClick) && !t[Mh] && n.input.lastClick.button == t.button && (n.input.lastClick.type == "singleClick" ? a = "doubleClick" : n.input.lastClick.type == "doubleClick" && (a = "tripleClick")), n.input.lastClick = { time: s, x: t.clientX, y: t.clientY, type: a, button: t.button };
  let o = n.posAtCoords(Uo(t));
  o && (a == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new Mw(n, o, t, !!r)) : (a == "doubleClick" ? ww : kw)(n, o.pos, o.inside, t) ? t.preventDefault() : ir(n, "pointer"));
};
class Mw {
  constructor(e, t, r, s) {
    this.view = e, this.pos = t, this.event = r, this.flushed = s, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[Mh], this.allowDefault = r.shiftKey;
    let a, o;
    if (t.inside > -1)
      a = e.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let c = e.state.doc.resolve(t.pos);
      a = c.parent, o = c.depth ? c.before() : 0;
    }
    const i = s ? null : r.target, l = i ? e.docView.nearestDesc(i, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: u } = e.state;
    (r.button == 0 && a.type.spec.draggable && a.type.spec.selectable !== !1 || u instanceof Me && u.from <= o && u.to > o) && (this.mightDrag = {
      node: a,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && xn && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), ir(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => jn(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(Uo(e))), this.updateAllowDefault(e), this.allowDefault || !t ? ir(this.view, "pointer") : bw(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    qt && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Vt && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (cs(this.view, $e.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : ir(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), ir(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Kt.touchstart = (n) => {
  n.input.lastTouch = Date.now(), lu(n), ir(n, "pointer");
};
Kt.touchmove = (n) => {
  n.input.lastTouch = Date.now(), ir(n, "pointer");
};
Kt.contextmenu = (n) => lu(n);
function Sh(n, e) {
  return n.composing ? !0 : qt && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const Sw = Yn ? 5e3 : -1;
Gt.compositionstart = Gt.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof Ie && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), Za(n, !0), n.markCursor = null;
    else if (Za(n, !e.selection.empty), xn && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let s = r.focusNode, a = r.focusOffset; s && s.nodeType == 1 && a != 0; ) {
        let o = a < 0 ? s.lastChild : s.childNodes[a - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let i = n.domSelection();
          i && i.collapse(o, o.nodeValue.length);
          break;
        } else
          s = o, a = -1;
      }
    }
    n.input.composing = !0;
  }
  Th(n, Sw);
};
Gt.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, Th(n, 20));
};
function Th(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => Za(n), e));
}
function Ch(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = Cw()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function Tw(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = y1(e.focusNode, e.focusOffset), r = v1(e.focusNode, e.focusOffset);
  if (t && r && t != r) {
    let s = r.pmViewDesc, a = n.domObserver.lastChangedTextNode;
    if (t == a || r == a)
      return a;
    if (!s || !s.isText(r.nodeValue))
      return r;
    if (n.input.compositionNode == r) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return r;
    }
  }
  return t || r;
}
function Cw() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function Za(n, e = !1) {
  if (!(Yn && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), Ch(n), e || n.docView && n.docView.dirty) {
      let t = ru(n), r = n.state.selection;
      return t && !t.eq(r) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function Aw(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), s = document.createRange();
  s.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(s), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const sa = tn && fr < 15 || ws && M1 < 604;
Kt.copy = Gt.cut = (n, e) => {
  let t = e, r = n.state.selection, s = t.type == "cut";
  if (r.empty)
    return;
  let a = sa ? null : t.clipboardData, o = r.content(), { dom: i, text: l } = au(n, o);
  a ? (t.preventDefault(), a.clearData(), a.setData("text/html", i.innerHTML), a.setData("text/plain", l)) : Aw(n, i), s && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function Dw(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function Ow(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let s = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? aa(n, r.value, null, s, e) : aa(n, r.textContent, r.innerHTML, s, e);
  }, 50);
}
function aa(n, e, t, r, s) {
  let a = yh(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, s, a || me.empty)))
    return !0;
  if (!a)
    return !1;
  let o = Dw(a), i = o ? n.state.tr.replaceSelectionWith(o, r) : n.state.tr.replaceSelection(a);
  return n.dispatch(i.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Ah(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
Gt.paste = (n, e) => {
  let t = e;
  if (n.composing && !Yn)
    return;
  let r = sa ? null : t.clipboardData, s = n.input.shiftKey && n.input.lastKeyCode != 45;
  r && aa(n, Ah(r), r.getData("text/html"), s, t) ? t.preventDefault() : Ow(n, t);
};
class Dh {
  constructor(e, t, r) {
    this.slice = e, this.move = t, this.node = r;
  }
}
const Ew = dn ? "altKey" : "ctrlKey";
function Oh(n, e) {
  let t = n.someProp("dragCopies", (r) => !r(e));
  return t ?? !e[Ew];
}
Kt.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let s = n.state.selection, a = s.empty ? null : n.posAtCoords(Uo(t)), o;
  if (!(a && a.pos >= s.from && a.pos <= (s instanceof Me ? s.to - 1 : s.to))) {
    if (r && r.mightDrag)
      o = Me.create(n.state.doc, r.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let d = n.docView.nearestDesc(t.target, !0);
      d && d.node.type.spec.draggable && d != n.docView && (o = Me.create(n.state.doc, d.posBefore));
    }
  }
  let i = (o || n.state.selection).content(), { dom: l, text: u, slice: c } = au(n, i);
  (!t.dataTransfer.files.length || !Vt || th > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(sa ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", sa || t.dataTransfer.setData("text/plain", u), n.dragging = new Dh(c, Oh(n, t), o);
};
Kt.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
Gt.dragover = Gt.dragenter = (n, e) => e.preventDefault();
Gt.drop = (n, e) => {
  let t = e, r = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let s = n.posAtCoords(Uo(t));
  if (!s)
    return;
  let a = n.state.doc.resolve(s.pos), o = r && r.slice;
  o ? n.someProp("transformPasted", (p) => {
    o = p(o, n);
  }) : o = yh(n, Ah(t.dataTransfer), sa ? null : t.dataTransfer.getData("text/html"), !1, a);
  let i = !!(r && Oh(n, t));
  if (n.someProp("handleDrop", (p) => p(n, t, o || me.empty, i))) {
    t.preventDefault();
    return;
  }
  if (!o)
    return;
  t.preventDefault();
  let l = o ? Uf(n.state.doc, a.pos, o) : a.pos;
  l == null && (l = a.pos);
  let u = n.state.tr;
  if (i) {
    let { node: p } = r;
    p ? p.replace(u) : u.deleteSelection();
  }
  let c = u.mapping.map(l), d = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, f = u.doc;
  if (d ? u.replaceRangeWith(c, c, o.content.firstChild) : u.replaceRange(c, c, o), u.doc.eq(f))
    return;
  let h = u.doc.resolve(c);
  if (d && Me.isSelectable(o.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(o.content.firstChild))
    u.setSelection(new Me(h));
  else {
    let p = u.mapping.map(l);
    u.mapping.maps[u.mapping.maps.length - 1].forEach((g, y, v, C) => p = C), u.setSelection(su(n, h, u.doc.resolve(p)));
  }
  n.focus(), n.dispatch(u.setMeta("uiEvent", "drop"));
};
Kt.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && jn(n);
  }, 20));
};
Kt.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
Kt.beforeinput = (n, e) => {
  if (Vt && Yn && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (a) => a(n, Cr(8, "Backspace")))))
        return;
      let { $cursor: s } = n.state.selection;
      s && s.pos > 0 && n.dispatch(n.state.tr.delete(s.pos - 1, s.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in Gt)
  Kt[n] = Gt[n];
function oa(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class eo {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || $r, this.side = this.spec.side || 0;
  }
  map(e, t, r, s) {
    let { pos: a, deleted: o } = e.mapResult(t.from + s, this.side < 0 ? -1 : 1);
    return o ? null : new Ut(a - r, a - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof eo && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && oa(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class pr {
  constructor(e, t) {
    this.attrs = e, this.spec = t || $r;
  }
  map(e, t, r, s) {
    let a = e.map(t.from + s, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(t.to + s, this.spec.inclusiveEnd ? 1 : -1) - r;
    return a >= o ? null : new Ut(a, o, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof pr && oa(this.attrs, e.attrs) && oa(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof pr;
  }
  destroy() {
  }
}
class uu {
  constructor(e, t) {
    this.attrs = e, this.spec = t || $r;
  }
  map(e, t, r, s) {
    let a = e.mapResult(t.from + s, 1);
    if (a.deleted)
      return null;
    let o = e.mapResult(t.to + s, -1);
    return o.deleted || o.pos <= a.pos ? null : new Ut(a.pos - r, o.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: s } = e.content.findIndex(t.from), a;
    return s == t.from && !(a = e.child(r)).isText && s + a.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof uu && oa(this.attrs, e.attrs) && oa(this.spec, e.spec);
  }
  destroy() {
  }
}
class Ut {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new Ut(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, r) {
    return new Ut(e, e, new eo(t, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, r, s) {
    return new Ut(e, t, new pr(r, s));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, r, s) {
    return new Ut(e, t, new uu(r, s));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof pr;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof eo;
  }
}
const ns = [], $r = {};
class at {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : ns, this.children = t.length ? t : ns;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? to(t, e, 0, $r) : Ft;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, r) {
    let s = [];
    return this.findInner(e ?? 0, t ?? 1e9, s, 0, r), s;
  }
  findInner(e, t, r, s, a) {
    for (let o = 0; o < this.local.length; o++) {
      let i = this.local[o];
      i.from <= t && i.to >= e && (!a || a(i.spec)) && r.push(i.copy(i.from + s, i.to + s));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > e) {
        let i = this.children[o] + 1;
        this.children[o + 2].findInner(e - i, t - i, r, s + i, a);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, r) {
    return this == Ft || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || $r);
  }
  /**
  @internal
  */
  mapInner(e, t, r, s, a) {
    let o;
    for (let i = 0; i < this.local.length; i++) {
      let l = this.local[i].map(e, r, s);
      l && l.type.valid(t, l) ? (o || (o = [])).push(l) : a.onRemove && a.onRemove(this.local[i].spec);
    }
    return this.children.length ? Pw(this.children, o || [], e, t, r, s, a) : o ? new at(o.sort(Lr), ns) : Ft;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == Ft ? at.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let s, a = 0;
    e.forEach((i, l) => {
      let u = l + r, c;
      if (c = Ph(t, i, u)) {
        for (s || (s = this.children.slice()); a < s.length && s[a] < l; )
          a += 3;
        s[a] == l ? s[a + 2] = s[a + 2].addInner(i, c, u + 1) : s.splice(a, 0, l, l + i.nodeSize, to(c, i, u + 1, $r)), a += 3;
      }
    });
    let o = Eh(a ? _h(t) : t, -r);
    for (let i = 0; i < o.length; i++)
      o[i].type.valid(e, o[i]) || o.splice(i--, 1);
    return new at(o.length ? this.local.concat(o).sort(Lr) : this.local, s || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Ft ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, s = this.local;
    for (let a = 0; a < r.length; a += 3) {
      let o, i = r[a] + t, l = r[a + 1] + t;
      for (let c = 0, d; c < e.length; c++)
        (d = e[c]) && d.from > i && d.to < l && (e[c] = null, (o || (o = [])).push(d));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let u = r[a + 2].removeInner(o, i + 1);
      u != Ft ? r[a + 2] = u : (r.splice(a, 3), a -= 3);
    }
    if (s.length) {
      for (let a = 0, o; a < e.length; a++)
        if (o = e[a])
          for (let i = 0; i < s.length; i++)
            s[i].eq(o, t) && (s == this.local && (s = this.local.slice()), s.splice(i--, 1));
    }
    return r == this.children && s == this.local ? this : s.length || r.length ? new at(s, r) : Ft;
  }
  forChild(e, t) {
    if (this == Ft)
      return this;
    if (t.isLeaf)
      return at.empty;
    let r, s;
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] >= e) {
        this.children[i] == e && (r = this.children[i + 2]);
        break;
      }
    let a = e + 1, o = a + t.content.size;
    for (let i = 0; i < this.local.length; i++) {
      let l = this.local[i];
      if (l.from < o && l.to > a && l.type instanceof pr) {
        let u = Math.max(a, l.from) - a, c = Math.min(o, l.to) - a;
        u < c && (s || (s = [])).push(l.copy(u, c));
      }
    }
    if (s) {
      let i = new at(s.sort(Lr), ns);
      return r ? new nr([i, r]) : i;
    }
    return r || Ft;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof at) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return cu(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Ft)
      return ns;
    if (e.inlineContent || !this.local.some(pr.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof pr || t.push(this.local[r]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
at.empty = new at([], []);
at.removeOverlap = cu;
const Ft = at.empty;
class nr {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((s) => s.map(e, t, $r));
    return nr.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return at.empty;
    let r = [];
    for (let s = 0; s < this.members.length; s++) {
      let a = this.members[s].forChild(e, t);
      a != Ft && (a instanceof nr ? r = r.concat(a.members) : r.push(a));
    }
    return nr.from(r);
  }
  eq(e) {
    if (!(e instanceof nr) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let s = 0; s < this.members.length; s++) {
      let a = this.members[s].localsInner(e);
      if (a.length)
        if (!t)
          t = a;
        else {
          r && (t = t.slice(), r = !1);
          for (let o = 0; o < a.length; o++)
            t.push(a[o]);
        }
    }
    return t ? cu(r ? t : t.sort(Lr)) : ns;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Ft;
      case 1:
        return e[0];
      default:
        return new nr(e.every((t) => t instanceof at) ? e : e.reduce((t, r) => t.concat(r instanceof at ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function Pw(n, e, t, r, s, a, o) {
  let i = n.slice();
  for (let u = 0, c = a; u < t.maps.length; u++) {
    let d = 0;
    t.maps[u].forEach((f, h, p, g) => {
      let y = g - p - (h - f);
      for (let v = 0; v < i.length; v += 3) {
        let C = i[v + 1];
        if (C < 0 || f > C + c - d)
          continue;
        let M = i[v] + c - d;
        h >= M ? i[v + 1] = f <= M ? -2 : -1 : f >= c && y && (i[v] += y, i[v + 1] += y);
      }
      d += y;
    }), c = t.maps[u].map(c, -1);
  }
  let l = !1;
  for (let u = 0; u < i.length; u += 3)
    if (i[u + 1] < 0) {
      if (i[u + 1] == -2) {
        l = !0, i[u + 1] = -1;
        continue;
      }
      let c = t.map(n[u] + a), d = c - s;
      if (d < 0 || d >= r.content.size) {
        l = !0;
        continue;
      }
      let f = t.map(n[u + 1] + a, -1), h = f - s, { index: p, offset: g } = r.content.findIndex(d), y = r.maybeChild(p);
      if (y && g == d && g + y.nodeSize == h) {
        let v = i[u + 2].mapInner(t, y, c + 1, n[u] + a + 1, o);
        v != Ft ? (i[u] = d, i[u + 1] = h, i[u + 2] = v) : (i[u + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let u = _w(i, n, e, t, s, a, o), c = to(u, r, 0, o);
    e = c.local;
    for (let d = 0; d < i.length; d += 3)
      i[d + 1] < 0 && (i.splice(d, 3), d -= 3);
    for (let d = 0, f = 0; d < c.children.length; d += 3) {
      let h = c.children[d];
      for (; f < i.length && i[f] < h; )
        f += 3;
      i.splice(f, 0, c.children[d], c.children[d + 1], c.children[d + 2]);
    }
  }
  return new at(e.sort(Lr), i);
}
function Eh(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let s = n[r];
    t.push(new Ut(s.from + e, s.to + e, s.type));
  }
  return t;
}
function _w(n, e, t, r, s, a, o) {
  function i(l, u) {
    for (let c = 0; c < l.local.length; c++) {
      let d = l.local[c].map(r, s, u);
      d ? t.push(d) : o.onRemove && o.onRemove(l.local[c].spec);
    }
    for (let c = 0; c < l.children.length; c += 3)
      i(l.children[c + 2], l.children[c] + u + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && i(n[l + 2], e[l] + a + 1);
  return t;
}
function Ph(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, s = null;
  for (let a = 0, o; a < n.length; a++)
    (o = n[a]) && o.from > t && o.to < r && ((s || (s = [])).push(o), n[a] = null);
  return s;
}
function _h(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function to(n, e, t, r) {
  let s = [], a = !1;
  e.forEach((i, l) => {
    let u = Ph(n, i, l + t);
    if (u) {
      a = !0;
      let c = to(u, i, t + l + 1, r);
      c != Ft && s.push(l, l + i.nodeSize, c);
    }
  });
  let o = Eh(a ? _h(n) : n, -t).sort(Lr);
  for (let i = 0; i < o.length; i++)
    o[i].type.valid(e, o[i]) || (r.onRemove && r.onRemove(o[i].spec), o.splice(i--, 1));
  return o.length || s.length ? new at(o, s) : Ft;
}
function Lr(n, e) {
  return n.from - e.from || n.to - e.to;
}
function cu(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let s = t + 1; s < e.length; s++) {
        let a = e[s];
        if (a.from == r.from) {
          a.to != r.to && (e == n && (e = n.slice()), e[s] = a.copy(a.from, r.to), Uc(e, s + 1, a.copy(r.to, a.to)));
          continue;
        } else {
          a.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, a.from), Uc(e, s, r.copy(a.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function Uc(n, e, t) {
  for (; e < n.length && Lr(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function Ei(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let r = t(n.state);
    r && r != Ft && e.push(r);
  }), n.cursorWrapper && e.push(at.create(n.state.doc, [n.cursorWrapper.deco])), nr.from(e);
}
const Nw = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, Iw = tn && fr <= 11;
class Rw {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class $w {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new Rw(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let s = 0; s < r.length; s++)
        this.queue.push(r[s]);
      tn && fr <= 11 && r.some((s) => s.type == "childList" && s.removedNodes.length || s.type == "characterData" && s.oldValue.length > s.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), Iw && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, Nw)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Bc(this.view)) {
      if (this.suppressingSelectionUpdates)
        return jn(this.view);
      if (tn && fr <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Hr(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), r;
    for (let a = e.focusNode; a; a = bs(a))
      t.add(a);
    for (let a = e.anchorNode; a; a = bs(a))
      if (t.has(a)) {
        r = a;
        break;
      }
    let s = r && this.view.docView.nearestDesc(r);
    if (s && s.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let r = e.domSelectionRange(), s = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && Bc(e) && !this.ignoreSelectionChange(r), a = -1, o = -1, i = !1, l = [];
    if (e.editable)
      for (let c = 0; c < t.length; c++) {
        let d = this.registerMutation(t[c], l);
        d && (a = a < 0 ? d.from : Math.min(d.from, a), o = o < 0 ? d.to : Math.max(d.to, o), d.typeOver && (i = !0));
      }
    if (xn && l.length) {
      let c = l.filter((d) => d.nodeName == "BR");
      if (c.length == 2) {
        let [d, f] = c;
        d.parentNode && d.parentNode.parentNode == f.parentNode ? f.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let f of c) {
          let h = f.parentNode;
          h && h.nodeName == "LI" && (!d || Fw(e, d) != h) && f.remove();
        }
      }
    }
    let u = null;
    a < 0 && s && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && Wo(r) && (u = ru(e)) && u.eq($e.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, jn(e), this.currentSelection.set(r), e.scrollToSelection()) : (a > -1 || s) && (a > -1 && (e.docView.markDirty(a, o), Lw(e)), this.handleDOMChange(a, o, i, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || jn(e), this.currentSelection.set(r));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let c = 0; c < e.addedNodes.length; c++) {
        let d = e.addedNodes[c];
        t.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let s = e.previousSibling, a = e.nextSibling;
      if (tn && fr <= 11 && e.addedNodes.length)
        for (let c = 0; c < e.addedNodes.length; c++) {
          let { previousSibling: d, nextSibling: f } = e.addedNodes[c];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (s = d), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (a = f);
        }
      let o = s && s.parentNode == e.target ? It(s) + 1 : 0, i = r.localPosFromDOM(e.target, o, -1), l = a && a.parentNode == e.target ? It(a) : e.target.childNodes.length, u = r.localPosFromDOM(e.target, l, 1);
      return { from: i, to: u };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let qc = /* @__PURE__ */ new WeakMap(), Kc = !1;
function Lw(n) {
  if (!qc.has(n) && (qc.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = xn, Kc)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Kc = !0;
  }
}
function Gc(n, e) {
  let t = e.startContainer, r = e.startOffset, s = e.endContainer, a = e.endOffset, o = n.domAtPos(n.state.selection.anchor);
  return Hr(o.node, o.offset, s, a) && ([t, r, s, a] = [s, a, t, r]), { anchorNode: t, anchorOffset: r, focusNode: s, focusOffset: a };
}
function Bw(n, e) {
  if (e.getComposedRanges) {
    let s = e.getComposedRanges(n.root)[0];
    if (s)
      return Gc(n, s);
  }
  let t;
  function r(s) {
    s.preventDefault(), s.stopImmediatePropagation(), t = s.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", r, !0), t ? Gc(n, t) : null;
}
function Fw(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let r = n.docView.nearestDesc(t, !0);
    if (r && r.node.isBlock)
      return t;
  }
  return null;
}
function zw(n, e, t) {
  let { node: r, fromOffset: s, toOffset: a, from: o, to: i } = n.docView.parseRange(e, t), l = n.domSelectionRange(), u, c = l.anchorNode;
  if (c && n.dom.contains(c.nodeType == 1 ? c : c.parentNode) && (u = [{ node: c, offset: l.anchorOffset }], Wo(l) || u.push({ node: l.focusNode, offset: l.focusOffset })), Vt && n.input.lastKeyCode === 8)
    for (let y = a; y > s; y--) {
      let v = r.childNodes[y - 1], C = v.pmViewDesc;
      if (v.nodeName == "BR" && !C) {
        a = y;
        break;
      }
      if (!C || C.size)
        break;
    }
  let d = n.state.doc, f = n.someProp("domParser") || dr.fromSchema(n.state.schema), h = d.resolve(o), p = null, g = f.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: s,
    to: a,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: u,
    ruleFromNode: Vw,
    context: h
  });
  if (u && u[0].pos != null) {
    let y = u[0].pos, v = u[1] && u[1].pos;
    v == null && (v = y), p = { anchor: y + o, head: v + o };
  }
  return { doc: g, sel: p, from: o, to: i };
}
function Vw(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (qt && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || qt && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const Hw = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function Yw(n, e, t, r, s) {
  let a = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let k = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, _ = ru(n, k);
    if (_ && !n.state.selection.eq(_)) {
      if (Vt && Yn && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (ne) => ne(n, Cr(13, "Enter"))))
        return;
      let E = n.state.tr.setSelection(_);
      k == "pointer" ? E.setMeta("pointer", !0) : k == "key" && E.scrollIntoView(), a && E.setMeta("composition", a), n.dispatch(E);
    }
    return;
  }
  let o = n.state.doc.resolve(e), i = o.sharedDepth(t);
  e = o.before(i + 1), t = n.state.doc.resolve(t).after(i + 1);
  let l = n.state.selection, u = zw(n, e, t), c = n.state.doc, d = c.slice(u.from, u.to), f, h;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (f = n.state.selection.to, h = "end") : (f = n.state.selection.from, h = "start"), n.input.lastKeyCode = null;
  let p = Uw(d.content, u.doc.content, u.from, f, h);
  if (p && n.input.domChangeCount++, (ws && n.input.lastIOSEnter > Date.now() - 225 || Yn) && s.some((k) => k.nodeType == 1 && !Hw.test(k.nodeName)) && (!p || p.endA >= p.endB) && n.someProp("handleKeyDown", (k) => k(n, Cr(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (r && l instanceof Ie && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(u.sel && u.sel.anchor != u.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (u.sel) {
        let k = Jc(n, n.state.doc, u.sel);
        if (k && !k.eq(n.state.selection)) {
          let _ = n.state.tr.setSelection(k);
          a && _.setMeta("composition", a), n.dispatch(_);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && p.start == p.endB && n.state.selection instanceof Ie && (p.start > n.state.selection.from && p.start <= n.state.selection.from + 2 && n.state.selection.from >= u.from ? p.start = n.state.selection.from : p.endA < n.state.selection.to && p.endA >= n.state.selection.to - 2 && n.state.selection.to <= u.to && (p.endB += n.state.selection.to - p.endA, p.endA = n.state.selection.to)), tn && fr <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > u.from && u.doc.textBetween(p.start - u.from - 1, p.start - u.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let g = u.doc.resolveNoCache(p.start - u.from), y = u.doc.resolveNoCache(p.endB - u.from), v = c.resolve(p.start), C = g.sameParent(y) && g.parent.inlineContent && v.end() >= p.endA, M;
  if ((ws && n.input.lastIOSEnter > Date.now() - 225 && (!C || s.some((k) => k.nodeName == "DIV" || k.nodeName == "P")) || !C && g.pos < u.doc.content.size && (!g.sameParent(y) || !g.parent.inlineContent) && !/\S/.test(u.doc.textBetween(g.pos, y.pos, "", "")) && (M = $e.findFrom(u.doc.resolve(g.pos + 1), 1, !0)) && M.head > g.pos) && n.someProp("handleKeyDown", (k) => k(n, Cr(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > p.start && jw(c, p.start, p.endA, g, y) && n.someProp("handleKeyDown", (k) => k(n, Cr(8, "Backspace")))) {
    Yn && Vt && n.domObserver.suppressSelectionUpdates();
    return;
  }
  Vt && p.endB == p.start && (n.input.lastChromeDelete = Date.now()), Yn && !C && g.start() != y.start() && y.parentOffset == 0 && g.depth == y.depth && u.sel && u.sel.anchor == u.sel.head && u.sel.head == p.endA && (p.endB -= 2, y = u.doc.resolveNoCache(p.endB - u.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(k) {
      return k(n, Cr(13, "Enter"));
    });
  }, 20));
  let S = p.start, D = p.endA, I = (k) => {
    let _ = k || n.state.tr.replace(S, D, u.doc.slice(p.start - u.from, p.endB - u.from));
    if (u.sel) {
      let E = Jc(n, _.doc, u.sel);
      E && !(Vt && n.composing && E.empty && (p.start != p.endB || n.input.lastChromeDelete < Date.now() - 100) && (E.head == S || E.head == _.mapping.map(D) - 1) || tn && E.empty && E.head == S) && _.setSelection(E);
    }
    return a && _.setMeta("composition", a), _.scrollIntoView();
  }, x;
  if (C) {
    if (g.pos == y.pos) {
      tn && fr <= 11 && g.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => jn(n), 20));
      let k = I(n.state.tr.delete(S, D)), _ = c.resolve(p.start).marksAcross(c.resolve(p.endA));
      _ && k.ensureMarks(_), n.dispatch(k);
    } else if (
      // Adding or removing a mark
      p.endA == p.endB && (x = Ww(g.parent.content.cut(g.parentOffset, y.parentOffset), v.parent.content.cut(v.parentOffset, p.endA - v.start())))
    ) {
      let k = I(n.state.tr);
      x.type == "add" ? k.addMark(S, D, x.mark) : k.removeMark(S, D, x.mark), n.dispatch(k);
    } else if (g.parent.child(g.index()).isText && g.index() == y.index() - (y.textOffset ? 0 : 1)) {
      let k = g.parent.textBetween(g.parentOffset, y.parentOffset), _ = () => I(n.state.tr.insertText(k, S, D));
      n.someProp("handleTextInput", (E) => E(n, S, D, k, _)) || n.dispatch(_());
    }
  } else
    n.dispatch(I());
}
function Jc(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : su(n, e.resolve(t.anchor), e.resolve(t.head));
}
function Ww(n, e) {
  let t = n.firstChild.marks, r = e.firstChild.marks, s = t, a = r, o, i, l;
  for (let c = 0; c < r.length; c++)
    s = r[c].removeFromSet(s);
  for (let c = 0; c < t.length; c++)
    a = t[c].removeFromSet(a);
  if (s.length == 1 && a.length == 0)
    i = s[0], o = "add", l = (c) => c.mark(i.addToSet(c.marks));
  else if (s.length == 0 && a.length == 1)
    i = a[0], o = "remove", l = (c) => c.mark(i.removeFromSet(c.marks));
  else
    return null;
  let u = [];
  for (let c = 0; c < e.childCount; c++)
    u.push(l(e.child(c)));
  if (te.from(u).eq(n))
    return { mark: i, type: o };
}
function jw(n, e, t, r, s) {
  if (
    // The content must have shrunk
    t - e <= s.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Pi(r, !0, !1) < s.pos
  )
    return !1;
  let a = n.resolve(e);
  if (!r.parent.isTextblock) {
    let i = a.nodeAfter;
    return i != null && t == e + i.nodeSize;
  }
  if (a.parentOffset < a.parent.content.size || !a.parent.isTextblock)
    return !1;
  let o = n.resolve(Pi(a, !0, !0));
  return !o.parent.isTextblock || o.pos > t || Pi(o, !0, !1) < t ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function Pi(n, e, t) {
  let r = n.depth, s = e ? n.end() : n.pos;
  for (; r > 0 && (e || n.indexAfter(r) == n.node(r).childCount); )
    r--, s++, e = !1;
  if (t) {
    let a = n.node(r).maybeChild(n.indexAfter(r));
    for (; a && !a.isLeaf; )
      a = a.firstChild, s++;
  }
  return s;
}
function Uw(n, e, t, r, s) {
  let a = n.findDiffStart(e, t);
  if (a == null)
    return null;
  let { a: o, b: i } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (s == "end") {
    let l = Math.max(0, a - Math.min(o, i));
    r -= o + l - a;
  }
  if (o < a && n.size < e.size) {
    let l = r <= a && r >= o ? a - r : 0;
    a -= l, a && a < e.size && Qc(e.textBetween(a - 1, a + 1)) && (a += l ? 1 : -1), i = a + (i - o), o = a;
  } else if (i < a) {
    let l = r <= a && r >= i ? a - r : 0;
    a -= l, a && a < n.size && Qc(n.textBetween(a - 1, a + 1)) && (a += l ? 1 : -1), o = a + (o - i), i = a;
  }
  return { start: a, endA: o, endB: i };
}
function Qc(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
class Nh {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new dw(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(nd), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = ed(this), Zc(this), this.nodeViews = td(this), this.docView = _c(this.state.doc, Xc(this), Ei(this), this.dom, this), this.domObserver = new $w(this, (r, s, a, o) => Yw(this, r, s, a, o)), this.domObserver.start(), fw(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && ml(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(nd), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let r in this._props)
      t[r] = this._props[r];
    t.state = this.state;
    for (let r in e)
      t[r] = e[r];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var r;
    let s = this.state, a = !1, o = !1;
    e.storedMarks && this.composing && (Ch(this), o = !0), this.state = e;
    let i = s.plugins != e.plugins || this._props.plugins != t.plugins;
    if (i || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = td(this);
      Kw(h, this.nodeViews) && (this.nodeViews = h, a = !0);
    }
    (i || t.handleDOMEvents != this._props.handleDOMEvents) && ml(this), this.editable = ed(this), Zc(this);
    let l = Ei(this), u = Xc(this), c = s.plugins != e.plugins && !s.doc.eq(e.doc) ? "reset" : e.scrollToSelection > s.scrollToSelection ? "to selection" : "preserve", d = a || !this.docView.matchesNode(e.doc, u, l);
    (d || !e.selection.eq(s.selection)) && (o = !0);
    let f = c == "preserve" && o && this.dom.style.overflowAnchor == null && C1(this);
    if (o) {
      this.domObserver.stop();
      let h = d && (tn || Vt) && !this.composing && !s.selection.empty && !e.selection.empty && qw(s.selection, e.selection);
      if (d) {
        let p = Vt ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = Tw(this)), (a || !this.docView.update(e.doc, u, l, this)) && (this.docView.updateOuterDeco(u), this.docView.destroy(), this.docView = _c(e.doc, u, l, this.dom, this)), p && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && J1(this)) ? jn(this, h) : (ph(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(s), !((r = this.dragging) === null || r === void 0) && r.node && !s.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, s), c == "reset" ? this.dom.scrollTop = 0 : c == "to selection" ? this.scrollToSelection() : f && A1(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof Me) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && Cc(this, t.getBoundingClientRect(), e);
      } else
        Cc(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let r = this.directPlugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let r = this.state.plugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let r = this.pluginViews[t];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let r = e.node, s = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      s = r.from;
    else {
      let a = r.from + (this.state.doc.content.size - t.doc.content.size);
      (a > 0 && this.state.doc.nodeAt(a)) == r.node && (s = a);
    }
    this.dragging = new Dh(e.slice, e.move, s < 0 ? void 0 : Me.create(this.state.doc, s));
  }
  someProp(e, t) {
    let r = this._props && this._props[e], s;
    if (r != null && (s = t ? t(r) : r))
      return s;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let i = this.directPlugins[o].props[e];
      if (i != null && (s = t ? t(i) : i))
        return s;
    }
    let a = this.state.plugins;
    if (a)
      for (let o = 0; o < a.length; o++) {
        let i = a[o].props[e];
        if (i != null && (s = t ? t(i) : i))
          return s;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (tn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && D1(this.dom), jn(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return N1(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return oh(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, r = -1) {
    let s = this.docView.posFromDOM(e, t, r);
    if (s == null)
      throw new RangeError("DOM position not inside the editor");
    return s;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return B1(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return aa(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return aa(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return au(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (hw(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Ei(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, m1());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return mw(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? qt && this.root.nodeType === 11 && w1(this.dom.ownerDocument) == this.dom && Bw(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
Nh.prototype.dispatch = function(n) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, n) : this.updateState(this.state.apply(n));
};
function Xc(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let r in t)
        r == "class" ? e.class += " " + t[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + t[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(t[r]));
  }), e.translate || (e.translate = "no"), [Ut.node(0, n.state.doc.content.size, e)];
}
function Zc(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: Ut.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function ed(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function qw(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function td(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    for (let s in r)
      Object.prototype.hasOwnProperty.call(e, s) || (e[s] = r[s]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function Kw(n, e) {
  let t = 0, r = 0;
  for (let s in n) {
    if (n[s] != e[s])
      return !0;
    t++;
  }
  for (let s in e)
    r++;
  return t != r;
}
function nd(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var gr = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, no = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, Gw = typeof navigator < "u" && /Mac/.test(navigator.platform), Jw = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Rt = 0; Rt < 10; Rt++) gr[48 + Rt] = gr[96 + Rt] = String(Rt);
for (var Rt = 1; Rt <= 24; Rt++) gr[Rt + 111] = "F" + Rt;
for (var Rt = 65; Rt <= 90; Rt++)
  gr[Rt] = String.fromCharCode(Rt + 32), no[Rt] = String.fromCharCode(Rt);
for (var _i in gr) no.hasOwnProperty(_i) || (no[_i] = gr[_i]);
function Qw(n) {
  var e = Gw && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || Jw && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? no : gr)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const Xw = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), Zw = typeof navigator < "u" && /Win/.test(navigator.platform);
function ek(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let r, s, a, o;
  for (let i = 0; i < e.length - 1; i++) {
    let l = e[i];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      s = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      Xw ? o = !0 : s = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (t = "Alt-" + t), s && (t = "Ctrl-" + t), o && (t = "Meta-" + t), a && (t = "Shift-" + t), t;
}
function tk(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[ek(t)] = n[t];
  return e;
}
function Ni(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function nk(n) {
  return new dt({ props: { handleKeyDown: Ih(n) } });
}
function Ih(n) {
  let e = tk(n);
  return function(t, r) {
    let s = Qw(r), a, o = e[Ni(s, r)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (s.length == 1 && s != " ") {
      if (r.shiftKey) {
        let i = e[Ni(s, r, !1)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(Zw && r.ctrlKey && r.altKey) && (a = gr[r.keyCode]) && a != s) {
        let i = e[Ni(a, r)];
        if (i && i(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const du = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function Rh(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const $h = (n, e, t) => {
  let r = Rh(n, t);
  if (!r)
    return !1;
  let s = fu(r);
  if (!s) {
    let o = r.blockRange(), i = o && As(o);
    return i == null ? !1 : (e && e(n.tr.lift(o, i).scrollIntoView()), !0);
  }
  let a = s.nodeBefore;
  if (jh(n, s, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (ks(a, "end") || Me.isSelectable(a)))
    for (let o = r.depth; ; o--) {
      let i = Ho(n.doc, r.before(o), r.after(o), me.empty);
      if (i && i.slice.size < i.to - i.from) {
        if (e) {
          let l = n.tr.step(i);
          l.setSelection(ks(a, "end") ? $e.findFrom(l.doc.resolve(l.mapping.map(s.pos, -1)), -1) : Me.create(l.doc, s.pos - a.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || r.node(o - 1).childCount > 1)
        break;
    }
  return a.isAtom && s.depth == r.depth - 1 ? (e && e(n.tr.delete(s.pos - a.nodeSize, s.pos).scrollIntoView()), !0) : !1;
}, rk = (n, e, t) => {
  let r = Rh(n, t);
  if (!r)
    return !1;
  let s = fu(r);
  return s ? Lh(n, s, e) : !1;
}, sk = (n, e, t) => {
  let r = Fh(n, t);
  if (!r)
    return !1;
  let s = hu(r);
  return s ? Lh(n, s, e) : !1;
};
function Lh(n, e, t) {
  let r = e.nodeBefore, s = r, a = e.pos - 1;
  for (; !s.isTextblock; a--) {
    if (s.type.spec.isolating)
      return !1;
    let c = s.lastChild;
    if (!c)
      return !1;
    s = c;
  }
  let o = e.nodeAfter, i = o, l = e.pos + 1;
  for (; !i.isTextblock; l++) {
    if (i.type.spec.isolating)
      return !1;
    let c = i.firstChild;
    if (!c)
      return !1;
    i = c;
  }
  let u = Ho(n.doc, a, l, me.empty);
  if (!u || u.from != a || u instanceof Tt && u.slice.size >= l - a)
    return !1;
  if (t) {
    let c = n.tr.step(u);
    c.setSelection(Ie.create(c.doc, a)), t(c.scrollIntoView());
  }
  return !0;
}
function ks(n, e, t = !1) {
  for (let r = n; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (t && r.childCount != 1)
      return !1;
  }
  return !1;
}
const Bh = (n, e, t) => {
  let { $head: r, empty: s } = n.selection, a = r;
  if (!s)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : r.parentOffset > 0)
      return !1;
    a = fu(r);
  }
  let o = a && a.nodeBefore;
  return !o || !Me.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(Me.create(n.doc, a.pos - o.nodeSize)).scrollIntoView()), !0);
};
function fu(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function Fh(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const zh = (n, e, t) => {
  let r = Fh(n, t);
  if (!r)
    return !1;
  let s = hu(r);
  if (!s)
    return !1;
  let a = s.nodeAfter;
  if (jh(n, s, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (ks(a, "start") || Me.isSelectable(a))) {
    let o = Ho(n.doc, r.before(), r.after(), me.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let i = n.tr.step(o);
        i.setSelection(ks(a, "start") ? $e.findFrom(i.doc.resolve(i.mapping.map(s.pos)), 1) : Me.create(i.doc, i.mapping.map(s.pos))), e(i.scrollIntoView());
      }
      return !0;
    }
  }
  return a.isAtom && s.depth == r.depth - 1 ? (e && e(n.tr.delete(s.pos, s.pos + a.nodeSize).scrollIntoView()), !0) : !1;
}, Vh = (n, e, t) => {
  let { $head: r, empty: s } = n.selection, a = r;
  if (!s)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : r.parentOffset < r.parent.content.size)
      return !1;
    a = hu(r);
  }
  let o = a && a.nodeAfter;
  return !o || !Me.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(Me.create(n.doc, a.pos)).scrollIntoView()), !0);
};
function hu(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const ak = (n, e) => {
  let t = n.selection, r = t instanceof Me, s;
  if (r) {
    if (t.node.isTextblock || !wr(n.doc, t.from))
      return !1;
    s = t.from;
  } else if (s = Vo(n.doc, t.from, -1), s == null)
    return !1;
  if (e) {
    let a = n.tr.join(s);
    r && a.setSelection(Me.create(a.doc, s - n.doc.resolve(s).nodeBefore.nodeSize)), e(a.scrollIntoView());
  }
  return !0;
}, ok = (n, e) => {
  let t = n.selection, r;
  if (t instanceof Me) {
    if (t.node.isTextblock || !wr(n.doc, t.to))
      return !1;
    r = t.to;
  } else if (r = Vo(n.doc, t.to, 1), r == null)
    return !1;
  return e && e(n.tr.join(r).scrollIntoView()), !0;
}, ik = (n, e) => {
  let { $from: t, $to: r } = n.selection, s = t.blockRange(r), a = s && As(s);
  return a == null ? !1 : (e && e(n.tr.lift(s, a).scrollIntoView()), !0);
}, Hh = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(r) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function pu(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const lk = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(r))
    return !1;
  let s = t.node(-1), a = t.indexAfter(-1), o = pu(s.contentMatchAt(a));
  if (!o || !s.canReplaceWith(a, a, o))
    return !1;
  if (e) {
    let i = t.after(), l = n.tr.replaceWith(i, i, o.createAndFill());
    l.setSelection($e.near(l.doc.resolve(i), 1)), e(l.scrollIntoView());
  }
  return !0;
}, Yh = (n, e) => {
  let t = n.selection, { $from: r, $to: s } = t;
  if (t instanceof an || r.parent.inlineContent || s.parent.inlineContent)
    return !1;
  let a = pu(s.parent.contentMatchAt(s.indexAfter()));
  if (!a || !a.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && s.index() < s.parent.childCount ? r : s).pos, i = n.tr.insert(o, a.createAndFill());
    i.setSelection(Ie.create(i.doc, o + 1)), e(i.scrollIntoView());
  }
  return !0;
}, Wh = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let a = t.before();
    if (Wn(n.doc, a))
      return e && e(n.tr.split(a).scrollIntoView()), !0;
  }
  let r = t.blockRange(), s = r && As(r);
  return s == null ? !1 : (e && e(n.tr.lift(r, s).scrollIntoView()), !0);
};
function uk(n) {
  return (e, t) => {
    let { $from: r, $to: s } = e.selection;
    if (e.selection instanceof Me && e.selection.node.isBlock)
      return !r.parentOffset || !Wn(e.doc, r.pos) ? !1 : (t && t(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let a = [], o, i, l = !1, u = !1;
    for (let h = r.depth; ; h--)
      if (r.node(h).isBlock) {
        l = r.end(h) == r.pos + (r.depth - h), u = r.start(h) == r.pos - (r.depth - h), i = pu(r.node(h - 1).contentMatchAt(r.indexAfter(h - 1))), a.unshift(l && i ? { type: i } : null), o = h;
        break;
      } else {
        if (h == 1)
          return !1;
        a.unshift(null);
      }
    let c = e.tr;
    (e.selection instanceof Ie || e.selection instanceof an) && c.deleteSelection();
    let d = c.mapping.map(r.pos), f = Wn(c.doc, d, a.length, a);
    if (f || (a[0] = i ? { type: i } : null, f = Wn(c.doc, d, a.length, a)), !f)
      return !1;
    if (c.split(d, a.length, a), !l && u && r.node(o).type != i) {
      let h = c.mapping.map(r.before(o)), p = c.doc.resolve(h);
      i && r.node(o - 1).canReplaceWith(p.index(), p.index() + 1, i) && c.setNodeMarkup(c.mapping.map(r.before(o)), i);
    }
    return t && t(c.scrollIntoView()), !0;
  };
}
const ck = uk(), dk = (n, e) => {
  let { $from: t, to: r } = n.selection, s, a = t.sharedDepth(r);
  return a == 0 ? !1 : (s = t.before(a), e && e(n.tr.setSelection(Me.create(n.doc, s))), !0);
};
function fk(n, e, t) {
  let r = e.nodeBefore, s = e.nodeAfter, a = e.index();
  return !r || !s || !r.type.compatibleContent(s.type) ? !1 : !r.content.size && e.parent.canReplace(a - 1, a) ? (t && t(n.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(a, a + 1) || !(s.isTextblock || wr(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function jh(n, e, t, r) {
  let s = e.nodeBefore, a = e.nodeAfter, o, i, l = s.type.spec.isolating || a.type.spec.isolating;
  if (!l && fk(n, e, t))
    return !0;
  let u = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (u && (o = (i = s.contentMatchAt(s.childCount)).findWrapping(a.type)) && i.matchType(o[0] || a.type).validEnd) {
    if (t) {
      let h = e.pos + a.nodeSize, p = te.empty;
      for (let v = o.length - 1; v >= 0; v--)
        p = te.from(o[v].create(null, p));
      p = te.from(s.copy(p));
      let g = n.tr.step(new At(e.pos - 1, h, e.pos, h, new me(p, 1, 0), o.length, !0)), y = g.doc.resolve(h + 2 * o.length);
      y.nodeAfter && y.nodeAfter.type == s.type && wr(g.doc, y.pos) && g.join(y.pos), t(g.scrollIntoView());
    }
    return !0;
  }
  let c = a.type.spec.isolating || r > 0 && l ? null : $e.findFrom(e, 1), d = c && c.$from.blockRange(c.$to), f = d && As(d);
  if (f != null && f >= e.depth)
    return t && t(n.tr.lift(d, f).scrollIntoView()), !0;
  if (u && ks(a, "start", !0) && ks(s, "end")) {
    let h = s, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let g = a, y = 1;
    for (; !g.isTextblock; g = g.firstChild)
      y++;
    if (h.canReplace(h.childCount, h.childCount, g.content)) {
      if (t) {
        let v = te.empty;
        for (let M = p.length - 1; M >= 0; M--)
          v = te.from(p[M].copy(v));
        let C = n.tr.step(new At(e.pos - p.length, e.pos + a.nodeSize, e.pos + y, e.pos + a.nodeSize - y, new me(v, p.length, 0), 0, !0));
        t(C.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Uh(n) {
  return function(e, t) {
    let r = e.selection, s = n < 0 ? r.$from : r.$to, a = s.depth;
    for (; s.node(a).isInline; ) {
      if (!a)
        return !1;
      a--;
    }
    return s.node(a).isTextblock ? (t && t(e.tr.setSelection(Ie.create(e.doc, n < 0 ? s.start(a) : s.end(a)))), !0) : !1;
  };
}
const hk = Uh(-1), pk = Uh(1);
function mk(n, e = null) {
  return function(t, r) {
    let { $from: s, $to: a } = t.selection, o = s.blockRange(a), i = o && eu(o, n, e);
    return i ? (r && r(t.tr.wrap(o, i).scrollIntoView()), !0) : !1;
  };
}
function rd(n, e = null) {
  return function(t, r) {
    let s = !1;
    for (let a = 0; a < t.selection.ranges.length && !s; a++) {
      let { $from: { pos: o }, $to: { pos: i } } = t.selection.ranges[a];
      t.doc.nodesBetween(o, i, (l, u) => {
        if (s)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            s = !0;
          else {
            let c = t.doc.resolve(u), d = c.index();
            s = c.parent.canReplaceWith(d, d + 1, n);
          }
      });
    }
    if (!s)
      return !1;
    if (r) {
      let a = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: i }, $to: { pos: l } } = t.selection.ranges[o];
        a.setBlockType(i, l, n, e);
      }
      r(a.scrollIntoView());
    }
    return !0;
  };
}
function mu(...n) {
  return function(e, t, r) {
    for (let s = 0; s < n.length; s++)
      if (n[s](e, t, r))
        return !0;
    return !1;
  };
}
mu(du, $h, Bh);
mu(du, zh, Vh);
mu(Hh, Yh, Wh, ck);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function gk(n, e = null) {
  return function(t, r) {
    let { $from: s, $to: a } = t.selection, o = s.blockRange(a);
    if (!o)
      return !1;
    let i = r ? t.tr : null;
    return yk(i, o, n, e) ? (r && r(i.scrollIntoView()), !0) : !1;
  };
}
function yk(n, e, t, r = null) {
  let s = !1, a = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = o.resolve(e.start - 2);
    a = new Ga(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new Ga(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), s = !0;
  }
  let i = eu(a, t, r, e);
  return i ? (n && vk(n, e, i, s, t), !0) : !1;
}
function vk(n, e, t, r, s) {
  let a = te.empty;
  for (let c = t.length - 1; c >= 0; c--)
    a = te.from(t[c].type.create(t[c].attrs, a));
  n.step(new At(e.start - (r ? 2 : 0), e.end, e.start, e.end, new me(a, 0, 0), t.length, !0));
  let o = 0;
  for (let c = 0; c < t.length; c++)
    t[c].type == s && (o = c + 1);
  let i = t.length - o, l = e.start + t.length - (r ? 2 : 0), u = e.parent;
  for (let c = e.startIndex, d = e.endIndex, f = !0; c < d; c++, f = !1)
    !f && Wn(n.doc, l, i) && (n.split(l, i), l += 2 * i), l += u.child(c).nodeSize;
  return n;
}
function bk(n) {
  return function(e, t) {
    let { $from: r, $to: s } = e.selection, a = r.blockRange(s, (o) => o.childCount > 0 && o.firstChild.type == n);
    return a ? t ? r.node(a.depth - 1).type == n ? wk(e, t, n, a) : kk(e, t, a) : !0 : !1;
  };
}
function wk(n, e, t, r) {
  let s = n.tr, a = r.end, o = r.$to.end(r.depth);
  a < o && (s.step(new At(a - 1, o, a, o, new me(te.from(t.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Ga(s.doc.resolve(r.$from.pos), s.doc.resolve(o), r.depth));
  const i = As(r);
  if (i == null)
    return !1;
  s.lift(r, i);
  let l = s.doc.resolve(s.mapping.map(a, -1) - 1);
  return wr(s.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && s.join(l.pos), e(s.scrollIntoView()), !0;
}
function kk(n, e, t) {
  let r = n.tr, s = t.parent;
  for (let h = t.end, p = t.endIndex - 1, g = t.startIndex; p > g; p--)
    h -= s.child(p).nodeSize, r.delete(h - 1, h + 1);
  let a = r.doc.resolve(t.start), o = a.nodeAfter;
  if (r.mapping.map(t.end) != t.start + a.nodeAfter.nodeSize)
    return !1;
  let i = t.startIndex == 0, l = t.endIndex == s.childCount, u = a.node(-1), c = a.index(-1);
  if (!u.canReplace(c + (i ? 0 : 1), c + 1, o.content.append(l ? te.empty : te.from(s))))
    return !1;
  let d = a.pos, f = d + o.nodeSize;
  return r.step(new At(d - (i ? 1 : 0), f + (l ? 1 : 0), d + 1, f - 1, new me((i ? te.empty : te.from(s.copy(te.empty))).append(l ? te.empty : te.from(s.copy(te.empty))), i ? 0 : 1, l ? 0 : 1), i ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function xk(n) {
  return function(e, t) {
    let { $from: r, $to: s } = e.selection, a = r.blockRange(s, (u) => u.childCount > 0 && u.firstChild.type == n);
    if (!a)
      return !1;
    let o = a.startIndex;
    if (o == 0)
      return !1;
    let i = a.parent, l = i.child(o - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let u = l.lastChild && l.lastChild.type == i.type, c = te.from(u ? n.create() : null), d = new me(te.from(n.create(null, te.from(i.type.create(null, c)))), u ? 3 : 1, 0), f = a.start, h = a.end;
      t(e.tr.step(new At(f - (u ? 3 : 1), h, f, h, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
var Mk = Object.defineProperty, qh = (n, e) => {
  for (var t in e)
    Mk(n, t, { get: e[t], enumerable: !0 });
};
function qo(n) {
  const { state: e, transaction: t } = n;
  let { selection: r } = t, { doc: s } = t, { storedMarks: a } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return a;
    },
    get selection() {
      return r;
    },
    get doc() {
      return s;
    },
    get tr() {
      return r = t.selection, s = t.doc, a = t.storedMarks, t;
    }
  };
}
var Ko = class {
  constructor(n) {
    this.editor = n.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = n.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: n, editor: e, state: t } = this, { view: r } = e, { tr: s } = t, a = this.buildProps(s);
    return Object.fromEntries(
      Object.entries(n).map(([o, i]) => [o, (...u) => {
        const c = i(...u)(a);
        return !s.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(s), c;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(n, e = !0) {
    const { rawCommands: t, editor: r, state: s } = this, { view: a } = r, o = [], i = !!n, l = n || s.tr, u = () => (!i && e && !l.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(l), o.every((d) => d === !0)), c = {
      ...Object.fromEntries(
        Object.entries(t).map(([d, f]) => [d, (...p) => {
          const g = this.buildProps(l, e), y = f(...p)(g);
          return o.push(y), c;
        }])
      ),
      run: u
    };
    return c;
  }
  createCan(n) {
    const { rawCommands: e, state: t } = this, r = !1, s = n || t.tr, a = this.buildProps(s, r);
    return {
      ...Object.fromEntries(
        Object.entries(e).map(([i, l]) => [i, (...u) => l(...u)({ ...a, dispatch: void 0 })])
      ),
      chain: () => this.createChain(s, r)
    };
  }
  buildProps(n, e = !0) {
    const { rawCommands: t, editor: r, state: s } = this, { view: a } = r, o = {
      tr: n,
      editor: r,
      view: a,
      state: qo({
        state: s,
        transaction: n
      }),
      dispatch: e ? () => {
      } : void 0,
      chain: () => this.createChain(n, e),
      can: () => this.createCan(n),
      get commands() {
        return Object.fromEntries(
          Object.entries(t).map(([i, l]) => [i, (...u) => l(...u)(o)])
        );
      }
    };
    return o;
  }
}, Sk = class {
  constructor() {
    this.callbacks = {};
  }
  on(n, e) {
    return this.callbacks[n] || (this.callbacks[n] = []), this.callbacks[n].push(e), this;
  }
  emit(n, ...e) {
    const t = this.callbacks[n];
    return t && t.forEach((r) => r.apply(this, e)), this;
  }
  off(n, e) {
    const t = this.callbacks[n];
    return t && (e ? this.callbacks[n] = t.filter((r) => r !== e) : delete this.callbacks[n]), this;
  }
  once(n, e) {
    const t = (...r) => {
      this.off(n, t), e.apply(this, r);
    };
    return this.on(n, t);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
};
function Kh(n, e) {
  const t = new Qf(n);
  return e.forEach((r) => {
    r.steps.forEach((s) => {
      t.step(s);
    });
  }), t;
}
var Gh = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const r = e[t];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? n.removeChild(r) : r.nodeType === 1 && Gh(r);
  }
  return n;
};
function Da(n) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return Gh(t);
}
function ia(n, e, t) {
  if (n instanceof cr || n instanceof te)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const r = typeof n == "object" && n !== null, s = typeof n == "string";
  if (r)
    try {
      if (Array.isArray(n) && n.length > 0)
        return te.fromArray(n.map((i) => e.nodeFromJSON(i)));
      const o = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (a) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: a });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", a), ia("", e, t);
    }
  if (s) {
    if (t.errorOnInvalidContent) {
      let o = !1, i = "";
      const l = new Rf({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (u) => (o = !0, i = typeof u == "string" ? u : u.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? dr.fromSchema(l).parseSlice(Da(n), t.parseOptions) : dr.fromSchema(l).parse(Da(n), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${i}`)
        });
    }
    const a = dr.fromSchema(e);
    return t.slice ? a.parseSlice(Da(n), t.parseOptions).content : a.parse(Da(n), t.parseOptions);
  }
  return ia("", e, t);
}
function gl(n, e, t = {}, r = {}) {
  return ia(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
function Tk(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function Ck(n, e, t) {
  const r = [];
  return n.nodesBetween(e.from, e.to, (s, a) => {
    t(s) && r.push({
      node: s,
      pos: a
    });
  }), r;
}
function Ak(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const r = n.node(t);
    if (e(r))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: r
      };
  }
}
function Go(n) {
  return (e) => Ak(e.$from, n);
}
function xe(n, e, t) {
  return n.config[e] === void 0 && n.parent ? xe(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? xe(n.parent, e, t) : null
  }) : n.config[e];
}
function gu(n) {
  return n.map((e) => {
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    }, r = xe(e, "addExtensions", t);
    return r ? [e, ...gu(r())] : e;
  }).flat(10);
}
function yu(n, e) {
  const t = Gr.fromSchema(e).serializeFragment(n), s = document.implementation.createHTMLDocument().createElement("div");
  return s.appendChild(t), s.innerHTML;
}
function Jh(n) {
  return typeof n == "function";
}
function je(n, e = void 0, ...t) {
  return Jh(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function Dk(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function la(n) {
  const e = n.filter((s) => s.type === "extension"), t = n.filter((s) => s.type === "node"), r = n.filter((s) => s.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: r
  };
}
function Qh(n) {
  const e = [], { nodeExtensions: t, markExtensions: r } = la(n), s = [...t, ...r], a = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((o) => {
    const i = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: s
    }, l = xe(
      o,
      "addGlobalAttributes",
      i
    );
    if (!l)
      return;
    l().forEach((c) => {
      c.types.forEach((d) => {
        Object.entries(c.attributes).forEach(([f, h]) => {
          e.push({
            type: d,
            name: f,
            attribute: {
              ...a,
              ...h
            }
          });
        });
      });
    });
  }), s.forEach((o) => {
    const i = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = xe(
      o,
      "addAttributes",
      i
    );
    if (!l)
      return;
    const u = l();
    Object.entries(u).forEach(([c, d]) => {
      const f = {
        ...a,
        ...d
      };
      typeof (f == null ? void 0 : f.default) == "function" && (f.default = f.default()), f != null && f.isRequired && (f == null ? void 0 : f.default) === void 0 && delete f.default, e.push({
        type: o.name,
        name: c,
        attribute: f
      });
    });
  }), e;
}
function yt(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const r = { ...e };
    return Object.entries(t).forEach(([s, a]) => {
      if (!r[s]) {
        r[s] = a;
        return;
      }
      if (s === "class") {
        const i = a ? String(a).split(" ") : [], l = r[s] ? r[s].split(" ") : [], u = i.filter((c) => !l.includes(c));
        r[s] = [...l, ...u].join(" ");
      } else if (s === "style") {
        const i = a ? a.split(";").map((c) => c.trim()).filter(Boolean) : [], l = r[s] ? r[s].split(";").map((c) => c.trim()).filter(Boolean) : [], u = /* @__PURE__ */ new Map();
        l.forEach((c) => {
          const [d, f] = c.split(":").map((h) => h.trim());
          u.set(d, f);
        }), i.forEach((c) => {
          const [d, f] = c.split(":").map((h) => h.trim());
          u.set(d, f);
        }), r[s] = Array.from(u.entries()).map(([c, d]) => `${c}: ${d}`).join("; ");
      } else
        r[s] = a;
    }), r;
  }, {});
}
function ro(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, r) => yt(t, r), {});
}
function Ok(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function sd(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const r = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (r === !1)
        return !1;
      const s = e.reduce((a, o) => {
        const i = o.attribute.parseHTML ? o.attribute.parseHTML(t) : Ok(t.getAttribute(o.name));
        return i == null ? a : {
          ...a,
          [o.name]: i
        };
      }, {});
      return { ...r, ...s };
    }
  };
}
function ad(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && Dk(t) ? !1 : t != null)
  );
}
function Ek(n, e) {
  var t;
  const r = Qh(n), { nodeExtensions: s, markExtensions: a } = la(n), o = (t = s.find((u) => xe(u, "topNode"))) == null ? void 0 : t.name, i = Object.fromEntries(
    s.map((u) => {
      const c = r.filter((v) => v.type === u.name), d = {
        name: u.name,
        options: u.options,
        storage: u.storage,
        editor: e
      }, f = n.reduce((v, C) => {
        const M = xe(C, "extendNodeSchema", d);
        return {
          ...v,
          ...M ? M(u) : {}
        };
      }, {}), h = ad({
        ...f,
        content: je(xe(u, "content", d)),
        marks: je(xe(u, "marks", d)),
        group: je(xe(u, "group", d)),
        inline: je(xe(u, "inline", d)),
        atom: je(xe(u, "atom", d)),
        selectable: je(xe(u, "selectable", d)),
        draggable: je(xe(u, "draggable", d)),
        code: je(xe(u, "code", d)),
        whitespace: je(xe(u, "whitespace", d)),
        linebreakReplacement: je(
          xe(u, "linebreakReplacement", d)
        ),
        defining: je(xe(u, "defining", d)),
        isolating: je(xe(u, "isolating", d)),
        attrs: Object.fromEntries(
          c.map((v) => {
            var C, M;
            return [
              v.name,
              { default: (C = v == null ? void 0 : v.attribute) == null ? void 0 : C.default, validate: (M = v == null ? void 0 : v.attribute) == null ? void 0 : M.validate }
            ];
          })
        )
      }), p = je(xe(u, "parseHTML", d));
      p && (h.parseDOM = p.map(
        (v) => sd(v, c)
      ));
      const g = xe(u, "renderHTML", d);
      g && (h.toDOM = (v) => g({
        node: v,
        HTMLAttributes: ro(v, c)
      }));
      const y = xe(u, "renderText", d);
      return y && (h.toText = y), [u.name, h];
    })
  ), l = Object.fromEntries(
    a.map((u) => {
      const c = r.filter((y) => y.type === u.name), d = {
        name: u.name,
        options: u.options,
        storage: u.storage,
        editor: e
      }, f = n.reduce((y, v) => {
        const C = xe(v, "extendMarkSchema", d);
        return {
          ...y,
          ...C ? C(u) : {}
        };
      }, {}), h = ad({
        ...f,
        inclusive: je(xe(u, "inclusive", d)),
        excludes: je(xe(u, "excludes", d)),
        group: je(xe(u, "group", d)),
        spanning: je(xe(u, "spanning", d)),
        code: je(xe(u, "code", d)),
        attrs: Object.fromEntries(
          c.map((y) => {
            var v, C;
            return [
              y.name,
              { default: (v = y == null ? void 0 : y.attribute) == null ? void 0 : v.default, validate: (C = y == null ? void 0 : y.attribute) == null ? void 0 : C.validate }
            ];
          })
        )
      }), p = je(xe(u, "parseHTML", d));
      p && (h.parseDOM = p.map(
        (y) => sd(y, c)
      ));
      const g = xe(u, "renderHTML", d);
      return g && (h.toDOM = (y) => g({
        mark: y,
        HTMLAttributes: ro(y, c)
      })), [u.name, h];
    })
  );
  return new Rf({
    topNode: o,
    nodes: i,
    marks: l
  });
}
function Pk(n) {
  const e = n.filter((t, r) => n.indexOf(t) !== r);
  return Array.from(new Set(e));
}
function vu(n) {
  return n.sort((t, r) => {
    const s = xe(t, "priority") || 100, a = xe(r, "priority") || 100;
    return s > a ? -1 : s < a ? 1 : 0;
  });
}
function Xh(n) {
  const e = vu(gu(n)), t = Pk(e.map((r) => r.name));
  return t.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${t.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`
  ), e;
}
function Zh(n, e, t) {
  const { from: r, to: s } = e, { blockSeparator: a = `

`, textSerializers: o = {} } = t || {};
  let i = "";
  return n.nodesBetween(r, s, (l, u, c, d) => {
    var f;
    l.isBlock && u > r && (i += a);
    const h = o == null ? void 0 : o[l.type.name];
    if (h)
      return c && (i += h({
        node: l,
        pos: u,
        parent: c,
        index: d,
        range: e
      })), !1;
    l.isText && (i += (f = l == null ? void 0 : l.text) == null ? void 0 : f.slice(Math.max(r, u) - u, s - u));
  }), i;
}
function _k(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return Zh(n, t, e);
}
function ep(n) {
  return Object.fromEntries(
    Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText])
  );
}
function qn(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
function tp(n, e) {
  const t = qn(e, n.schema), { from: r, to: s, empty: a } = n.selection, o = [];
  a ? (n.storedMarks && o.push(...n.storedMarks), o.push(...n.selection.$head.marks())) : n.doc.nodesBetween(r, s, (l) => {
    o.push(...l.marks);
  });
  const i = o.find((l) => l.type.name === t.name);
  return i ? { ...i.attrs } : {};
}
function xt(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
function Nk(n, e) {
  const t = xt(e, n.schema), { from: r, to: s } = n.selection, a = [];
  n.doc.nodesBetween(r, s, (i) => {
    a.push(i);
  });
  const o = a.reverse().find((i) => i.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function Jo(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function np(n, e) {
  const t = Jo(
    typeof e == "string" ? e : e.name,
    n.schema
  );
  return t === "node" ? Nk(n, e) : t === "mark" ? tp(n, e) : {};
}
function Ik(n, e = JSON.stringify) {
  const t = {};
  return n.filter((r) => {
    const s = e(r);
    return Object.prototype.hasOwnProperty.call(t, s) ? !1 : t[s] = !0;
  });
}
function Rk(n) {
  const e = Ik(n);
  return e.length === 1 ? e : e.filter((t, r) => !e.filter((a, o) => o !== r).some((a) => t.oldRange.from >= a.oldRange.from && t.oldRange.to <= a.oldRange.to && t.newRange.from >= a.newRange.from && t.newRange.to <= a.newRange.to));
}
function rp(n) {
  const { mapping: e, steps: t } = n, r = [];
  return e.maps.forEach((s, a) => {
    const o = [];
    if (s.ranges.length)
      s.forEach((i, l) => {
        o.push({ from: i, to: l });
      });
    else {
      const { from: i, to: l } = t[a];
      if (i === void 0 || l === void 0)
        return;
      o.push({ from: i, to: l });
    }
    o.forEach(({ from: i, to: l }) => {
      const u = e.slice(a).map(i, -1), c = e.slice(a).map(l), d = e.invert().map(u, -1), f = e.invert().map(c);
      r.push({
        oldRange: {
          from: d,
          to: f
        },
        newRange: {
          from: u,
          to: c
        }
      });
    });
  }), Rk(r);
}
function bu(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
function so(n, e, t = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((s) => t.strict ? e[s] === n[s] : bu(e[s]) ? e[s].test(n[s]) : e[s] === n[s]) : !0;
}
function sp(n, e, t = {}) {
  return n.find((r) => r.type === e && so(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((s) => [s, r.attrs[s]])),
    t
  ));
}
function od(n, e, t = {}) {
  return !!sp(n, e, t);
}
function wu(n, e, t) {
  var r;
  if (!n || !e)
    return;
  let s = n.parent.childAfter(n.parentOffset);
  if ((!s.node || !s.node.marks.some((c) => c.type === e)) && (s = n.parent.childBefore(n.parentOffset)), !s.node || !s.node.marks.some((c) => c.type === e) || (t = t || ((r = s.node.marks[0]) == null ? void 0 : r.attrs), !sp([...s.node.marks], e, t)))
    return;
  let o = s.index, i = n.start() + s.offset, l = o + 1, u = i + s.node.nodeSize;
  for (; o > 0 && od([...n.parent.child(o - 1).marks], e, t); )
    o -= 1, i -= n.parent.child(o).nodeSize;
  for (; l < n.parent.childCount && od([...n.parent.child(l).marks], e, t); )
    u += n.parent.child(l).nodeSize, l += 1;
  return {
    from: i,
    to: u
  };
}
function ku(n, e, t) {
  const r = [];
  return n === e ? t.resolve(n).marks().forEach((s) => {
    const a = t.resolve(n), o = wu(a, s.type);
    o && r.push({
      mark: s,
      ...o
    });
  }) : t.nodesBetween(n, e, (s, a) => {
    !s || (s == null ? void 0 : s.nodeSize) === void 0 || r.push(
      ...s.marks.map((o) => ({
        from: a,
        to: a + s.nodeSize,
        mark: o
      }))
    );
  }), r;
}
var $k = (n, e, t, r = 20) => {
  const s = n.doc.resolve(t);
  let a = r, o = null;
  for (; a > 0 && o === null; ) {
    const i = s.node(a);
    (i == null ? void 0 : i.type.name) === e ? o = i : a -= 1;
  }
  return [o, a];
};
function Ii(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function Fa(n, e, t) {
  return Object.fromEntries(
    Object.entries(t).filter(([r]) => {
      const s = n.find((a) => a.type === e && a.name === r);
      return s ? s.attribute.keepOnSplit : !1;
    })
  );
}
var Lk = (n, e = 500) => {
  let t = "";
  const r = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, r - e), r, (s, a, o, i) => {
    var l, u;
    const c = ((u = (l = s.type.spec).toText) == null ? void 0 : u.call(l, {
      node: s,
      pos: a,
      parent: o,
      index: i
    })) || s.textContent || "%leaf%";
    t += s.isAtom && !s.isText ? c : c.slice(0, Math.max(0, r - a));
  }), t;
};
function yl(n, e, t = {}) {
  const { empty: r, ranges: s } = n.selection, a = e ? qn(e, n.schema) : null;
  if (r)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((d) => a ? a.name === d.type.name : !0).find((d) => so(d.attrs, t, { strict: !1 }));
  let o = 0;
  const i = [];
  if (s.forEach(({ $from: d, $to: f }) => {
    const h = d.pos, p = f.pos;
    n.doc.nodesBetween(h, p, (g, y) => {
      if (!g.isText && !g.marks.length)
        return;
      const v = Math.max(h, y), C = Math.min(p, y + g.nodeSize), M = C - v;
      o += M, i.push(
        ...g.marks.map((S) => ({
          mark: S,
          from: v,
          to: C
        }))
      );
    });
  }), o === 0)
    return !1;
  const l = i.filter((d) => a ? a.name === d.mark.type.name : !0).filter((d) => so(d.mark.attrs, t, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), u = i.filter((d) => a ? d.mark.type !== a && d.mark.type.excludes(a) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (l > 0 ? l + u : l) >= o;
}
function yr(n, e, t = {}) {
  const { from: r, to: s, empty: a } = n.selection, o = e ? xt(e, n.schema) : null, i = [];
  n.doc.nodesBetween(r, s, (d, f) => {
    if (d.isText)
      return;
    const h = Math.max(r, f), p = Math.min(s, f + d.nodeSize);
    i.push({
      node: d,
      from: h,
      to: p
    });
  });
  const l = s - r, u = i.filter((d) => o ? o.name === d.node.type.name : !0).filter((d) => so(d.node.attrs, t, { strict: !1 }));
  return a ? !!u.length : u.reduce((d, f) => d + f.to - f.from, 0) >= l;
}
function Bk(n, e, t = {}) {
  if (!e)
    return yr(n, null, t) || yl(n, null, t);
  const r = Jo(e, n.schema);
  return r === "node" ? yr(n, e, t) : r === "mark" ? yl(n, e, t) : !1;
}
var Fk = (n, e) => {
  const { $from: t, $to: r, $anchor: s } = n.selection;
  if (e) {
    const a = Go((i) => i.type.name === e)(n.selection);
    if (!a)
      return !1;
    const o = n.doc.resolve(a.pos + 1);
    return s.pos + 1 === o.end();
  }
  return !(r.parentOffset < r.parent.nodeSize - 2 || t.pos !== r.pos);
}, zk = (n) => {
  const { $from: e, $to: t } = n.selection;
  return !(e.parentOffset > 0 || e.pos !== t.pos);
};
function id(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function ld(n, e) {
  const { nodeExtensions: t } = la(e), r = t.find((o) => o.name === n);
  if (!r)
    return !1;
  const s = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, a = je(xe(r, "group", s));
  return typeof a != "string" ? !1 : a.split(" ").includes("list");
}
function Qo(n, {
  checkChildren: e = !0,
  ignoreWhitespace: t = !1
} = {}) {
  var r;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((r = n.text) != null ? r : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let s = !0;
    return n.content.forEach((a) => {
      s !== !1 && (Qo(a, { ignoreWhitespace: t, checkChildren: e }) || (s = !1));
    }), s;
  }
  return !1;
}
function ap(n) {
  return n instanceof Me;
}
function op(n) {
  return n instanceof Ie;
}
function Er(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function ip(n, e = null) {
  if (!e)
    return null;
  const t = $e.atStart(n), r = $e.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return r;
  const s = t.from, a = r.to;
  return e === "all" ? Ie.create(n, Er(0, s, a), Er(n.content.size, s, a)) : Ie.create(n, Er(e, s, a), Er(e, s, a));
}
function Vk(n, e, t) {
  const r = n.steps.length - 1;
  if (r < e)
    return;
  const s = n.steps[r];
  if (!(s instanceof Tt || s instanceof At))
    return;
  const a = n.mapping.maps[r];
  let o = 0;
  a.forEach((i, l, u, c) => {
    o === 0 && (o = c);
  }), n.setSelection($e.near(n.doc.resolve(o), t));
}
var Xo = class {
  constructor(n) {
    this.find = n.find, this.handler = n.handler;
  }
}, Hk = (n, e) => {
  if (bu(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const r = [t.text];
  return r.index = t.index, r.input = n, r.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(t.replaceWith)), r;
};
function Oa(n) {
  var e;
  const { editor: t, from: r, to: s, text: a, rules: o, plugin: i } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const u = l.state.doc.resolve(r);
  if (
    // check for code node
    u.parent.type.spec.code || (e = u.nodeBefore || u.nodeAfter) != null && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let c = !1;
  const d = Lk(u) + a;
  return o.forEach((f) => {
    if (c)
      return;
    const h = Hk(d, f.find);
    if (!h)
      return;
    const p = l.state.tr, g = qo({
      state: l.state,
      transaction: p
    }), y = {
      from: r - (h[0].length - a.length),
      to: s
    }, { commands: v, chain: C, can: M } = new Ko({
      editor: t,
      state: g
    });
    f.handler({
      state: g,
      range: y,
      match: h,
      commands: v,
      chain: C,
      can: M
    }) === null || !p.steps.length || (p.setMeta(i, {
      transform: p,
      from: r,
      to: s,
      text: a
    }), l.dispatch(p), c = !0);
  }), c;
}
function Yk(n) {
  const { editor: e, rules: t } = n, r = new dt({
    state: {
      init() {
        return null;
      },
      apply(s, a, o) {
        const i = s.getMeta(r);
        if (i)
          return i;
        const l = s.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: c } = l;
          typeof c == "string" ? c = c : c = yu(te.from(c), o.schema);
          const { from: d } = l, f = d + c.length;
          Oa({
            editor: e,
            from: d,
            to: f,
            text: c,
            rules: t,
            plugin: r
          });
        }), s.selectionSet || s.docChanged ? null : a;
      }
    },
    props: {
      handleTextInput(s, a, o, i) {
        return Oa({
          editor: e,
          from: a,
          to: o,
          text: i,
          rules: t,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (s) => (setTimeout(() => {
          const { $cursor: a } = s.state.selection;
          a && Oa({
            editor: e,
            from: a.pos,
            to: a.pos,
            text: "",
            rules: t,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(s, a) {
        if (a.key !== "Enter")
          return !1;
        const { $cursor: o } = s.state.selection;
        return o ? Oa({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function Wk(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function Ea(n) {
  return Wk(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function lp(n, e) {
  const t = { ...n };
  return Ea(n) && Ea(e) && Object.keys(e).forEach((r) => {
    Ea(e[r]) && Ea(n[r]) ? t[r] = lp(n[r], e[r]) : t[r] = e[r];
  }), t;
}
var xu = class {
  constructor(n = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...n
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...je(
        xe(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...je(
        xe(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(n = {}) {
    const e = this.extend({
      ...this.config,
      addOptions: () => lp(this.options, n)
    });
    return e.name = this.name, e.parent = this.parent, e;
  }
  extend(n = {}) {
    const e = new this.constructor({ ...this.config, ...n });
    return e.parent = this, this.child = e, e.name = "name" in n ? n.name : e.parent.name, e;
  }
}, xr = class up extends xu {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new up(t);
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: r } = e.state, s = e.state.selection.$from;
    if (s.pos === s.end()) {
      const o = s.marks();
      if (!!!o.find((u) => (u == null ? void 0 : u.type.name) === t.name))
        return !1;
      const l = o.find((u) => (u == null ? void 0 : u.type.name) === t.name);
      return l && r.removeStoredMark(l), r.insertText(" ", s.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
};
function jk(n) {
  return typeof n == "number";
}
var Uk = class {
  constructor(n) {
    this.find = n.find, this.handler = n.handler;
  }
}, qk = (n, e, t) => {
  if (bu(e))
    return [...n.matchAll(e)];
  const r = e(n, t);
  return r ? r.map((s) => {
    const a = [s.text];
    return a.index = s.index, a.input = n, a.data = s.data, s.replaceWith && (s.text.includes(s.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), a.push(s.replaceWith)), a;
  }) : [];
};
function Kk(n) {
  const { editor: e, state: t, from: r, to: s, rule: a, pasteEvent: o, dropEvent: i } = n, { commands: l, chain: u, can: c } = new Ko({
    editor: e,
    state: t
  }), d = [];
  return t.doc.nodesBetween(r, s, (h, p) => {
    var g, y, v, C, M;
    if ((y = (g = h.type) == null ? void 0 : g.spec) != null && y.code || !(h.isText || h.isTextblock || h.isInline))
      return;
    const S = (M = (C = (v = h.content) == null ? void 0 : v.size) != null ? C : h.nodeSize) != null ? M : 0, D = Math.max(r, p), I = Math.min(s, p + S);
    if (D >= I)
      return;
    const x = h.isText ? h.text || "" : h.textBetween(D - p, I - p, void 0, "￼");
    qk(x, a.find, o).forEach((_) => {
      if (_.index === void 0)
        return;
      const E = D + _.index + 1, ne = E + _[0].length, de = {
        from: t.tr.mapping.map(E),
        to: t.tr.mapping.map(ne)
      }, be = a.handler({
        state: t,
        range: de,
        match: _,
        commands: l,
        chain: u,
        can: c,
        pasteEvent: o,
        dropEvent: i
      });
      d.push(be);
    });
  }), d.every((h) => h !== null);
}
var Pa = null, Gk = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) == null || e.setData("text/html", n), t;
};
function Jk(n) {
  const { editor: e, rules: t } = n;
  let r = null, s = !1, a = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, i;
  try {
    i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    i = null;
  }
  const l = ({
    state: c,
    from: d,
    to: f,
    rule: h,
    pasteEvt: p
  }) => {
    const g = c.tr, y = qo({
      state: c,
      transaction: g
    });
    if (!(!Kk({
      editor: e,
      state: y,
      from: Math.max(d - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: i
    }) || !g.steps.length)) {
      try {
        i = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        i = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, g;
    }
  };
  return t.map((c) => new dt({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const f = (p) => {
        var g;
        r = (g = d.dom.parentElement) != null && g.contains(p.target) ? d.dom.parentElement : null, r && (Pa = e);
      }, h = () => {
        Pa && (Pa = null);
      };
      return window.addEventListener("dragstart", f), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", f), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, f) => {
          if (a = r === d.dom.parentElement, i = f, !a) {
            const h = Pa;
            h != null && h.isEditable && setTimeout(() => {
              const p = h.state.selection;
              p && h.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (d, f) => {
          var h;
          const p = (h = f.clipboardData) == null ? void 0 : h.getData("text/html");
          return o = f, s = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (d, f, h) => {
      const p = d[0], g = p.getMeta("uiEvent") === "paste" && !s, y = p.getMeta("uiEvent") === "drop" && !a, v = p.getMeta("applyPasteRules"), C = !!v;
      if (!g && !y && !C)
        return;
      if (C) {
        let { text: D } = v;
        typeof D == "string" ? D = D : D = yu(te.from(D), h.schema);
        const { from: I } = v, x = I + D.length, k = Gk(D);
        return l({
          rule: c,
          state: h,
          from: I,
          to: { b: x },
          pasteEvt: k
        });
      }
      const M = f.doc.content.findDiffStart(h.doc.content), S = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!jk(M) || !S || M === S.b))
        return l({
          rule: c,
          state: h,
          from: M,
          to: S,
          pasteEvt: o
        });
    }
  }));
}
var Zo = class {
  constructor(n, e) {
    this.splittableMarks = [], this.editor = e, this.extensions = Xh(n), this.schema = Ek(this.extensions, e), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((n, e) => {
      const t = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: Ii(e.name, this.schema)
      }, r = xe(e, "addCommands", t);
      return r ? {
        ...n,
        ...r()
      } : n;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: n } = this;
    return vu([...this.extensions].reverse()).map((r) => {
      const s = {
        name: r.name,
        options: r.options,
        storage: this.editor.extensionStorage[r.name],
        editor: n,
        type: Ii(r.name, this.schema)
      }, a = [], o = xe(
        r,
        "addKeyboardShortcuts",
        s
      );
      let i = {};
      if (r.type === "mark" && xe(r, "exitable", s) && (i.ArrowRight = () => xr.handleExit({ editor: n, mark: r })), o) {
        const f = Object.fromEntries(
          Object.entries(o()).map(([h, p]) => [h, () => p({ editor: n })])
        );
        i = { ...i, ...f };
      }
      const l = nk(i);
      a.push(l);
      const u = xe(r, "addInputRules", s);
      if (id(r, n.options.enableInputRules) && u) {
        const f = u();
        if (f && f.length) {
          const h = Yk({
            editor: n,
            rules: f
          }), p = Array.isArray(h) ? h : [h];
          a.push(...p);
        }
      }
      const c = xe(r, "addPasteRules", s);
      if (id(r, n.options.enablePasteRules) && c) {
        const f = c();
        if (f && f.length) {
          const h = Jk({ editor: n, rules: f });
          a.push(...h);
        }
      }
      const d = xe(
        r,
        "addProseMirrorPlugins",
        s
      );
      if (d) {
        const f = d();
        a.push(...f);
      }
      return a;
    }).flat();
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Qh(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: n } = this, { nodeExtensions: e } = la(this.extensions);
    return Object.fromEntries(
      e.filter((t) => !!xe(t, "addNodeView")).map((t) => {
        const r = this.attributes.filter((i) => i.type === t.name), s = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: n,
          type: xt(t.name, this.schema)
        }, a = xe(t, "addNodeView", s);
        if (!a)
          return [];
        const o = (i, l, u, c, d) => {
          const f = ro(i, r);
          return a()({
            // pass-through
            node: i,
            view: l,
            getPos: u,
            decorations: c,
            innerDecorations: d,
            // tiptap-specific
            editor: n,
            extension: t,
            HTMLAttributes: f
          });
        };
        return [t.name, o];
      })
    );
  }
  get markViews() {
    const { editor: n } = this, { markExtensions: e } = la(this.extensions);
    return Object.fromEntries(
      e.filter((t) => !!xe(t, "addMarkView")).map((t) => {
        const r = this.attributes.filter((i) => i.type === t.name), s = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: n,
          type: qn(t.name, this.schema)
        }, a = xe(t, "addMarkView", s);
        if (!a)
          return [];
        const o = (i, l, u) => {
          const c = ro(i, r);
          return a()({
            // pass-through
            mark: i,
            view: l,
            inline: u,
            // tiptap-specific
            editor: n,
            extension: t,
            HTMLAttributes: c,
            updateAttributes: (d) => {
              fM(i, n, d);
            }
          });
        };
        return [t.name, o];
      })
    );
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const n = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      n.map((e) => [e.name, e.storage])
    ), n.forEach((e) => {
      var t;
      const r = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: Ii(e.name, this.schema)
      };
      e.type === "mark" && ((t = je(xe(e, "keepOnSplit", r))) == null || t) && this.splittableMarks.push(e.name);
      const s = xe(e, "onBeforeCreate", r), a = xe(e, "onCreate", r), o = xe(e, "onUpdate", r), i = xe(
        e,
        "onSelectionUpdate",
        r
      ), l = xe(e, "onTransaction", r), u = xe(e, "onFocus", r), c = xe(e, "onBlur", r), d = xe(e, "onDestroy", r);
      s && this.editor.on("beforeCreate", s), a && this.editor.on("create", a), o && this.editor.on("update", o), i && this.editor.on("selectionUpdate", i), l && this.editor.on("transaction", l), u && this.editor.on("focus", u), c && this.editor.on("blur", c), d && this.editor.on("destroy", d);
    });
  }
};
Zo.resolve = Xh;
Zo.sort = vu;
Zo.flatten = gu;
var Qk = {};
qh(Qk, {
  ClipboardTextSerializer: () => dp,
  Commands: () => pp,
  Delete: () => mp,
  Drop: () => gp,
  Editable: () => yp,
  FocusEvents: () => bp,
  Keymap: () => wp,
  Paste: () => kp,
  Tabindex: () => xp,
  focusEventsPluginKey: () => vp
});
var Je = class cp extends xu {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new cp(t);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
}, dp = Je.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new dt({
        key: new _t("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: r, selection: s } = e, { ranges: a } = s, o = Math.min(...a.map((c) => c.$from.pos)), i = Math.max(...a.map((c) => c.$to.pos)), l = ep(t);
            return Zh(r, { from: o, to: i }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), fp = {};
qh(fp, {
  blur: () => Xk,
  clearContent: () => Zk,
  clearNodes: () => ex,
  command: () => tx,
  createParagraphNear: () => nx,
  cut: () => rx,
  deleteCurrentNode: () => sx,
  deleteNode: () => ax,
  deleteRange: () => ox,
  deleteSelection: () => ix,
  enter: () => lx,
  exitCode: () => ux,
  extendMarkRange: () => cx,
  first: () => dx,
  focus: () => hx,
  forEach: () => px,
  insertContent: () => mx,
  insertContentAt: () => yx,
  joinBackward: () => wx,
  joinDown: () => bx,
  joinForward: () => kx,
  joinItemBackward: () => xx,
  joinItemForward: () => Mx,
  joinTextblockBackward: () => Sx,
  joinTextblockForward: () => Tx,
  joinUp: () => vx,
  keyboardShortcut: () => Ax,
  lift: () => Dx,
  liftEmptyBlock: () => Ox,
  liftListItem: () => Ex,
  newlineInCode: () => Px,
  resetAttributes: () => _x,
  scrollIntoView: () => Nx,
  selectAll: () => Ix,
  selectNodeBackward: () => Rx,
  selectNodeForward: () => $x,
  selectParentNode: () => Lx,
  selectTextblockEnd: () => Bx,
  selectTextblockStart: () => Fx,
  setContent: () => zx,
  setMark: () => Hx,
  setMeta: () => Yx,
  setNode: () => Wx,
  setNodeSelection: () => jx,
  setTextSelection: () => Ux,
  sinkListItem: () => qx,
  splitBlock: () => Kx,
  splitListItem: () => Gx,
  toggleList: () => Jx,
  toggleMark: () => Qx,
  toggleNode: () => Xx,
  toggleWrap: () => Zx,
  undoInputRule: () => eM,
  unsetAllMarks: () => tM,
  unsetMark: () => nM,
  updateAttributes: () => rM,
  wrapIn: () => sM,
  wrapInList: () => aM
});
var Xk = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window == null ? void 0 : window.getSelection()) == null || t.removeAllRanges());
}), !0), Zk = (n = !0) => ({ commands: e }) => e.setContent("", { emitUpdate: n }), ex = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: r } = e, { ranges: s } = r;
  return t && s.forEach(({ $from: a, $to: o }) => {
    n.doc.nodesBetween(a.pos, o.pos, (i, l) => {
      if (i.type.isText)
        return;
      const { doc: u, mapping: c } = e, d = u.resolve(c.map(l)), f = u.resolve(c.map(l + i.nodeSize)), h = d.blockRange(f);
      if (!h)
        return;
      const p = As(h);
      if (i.type.isTextblock) {
        const { defaultType: g } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(h.start, g);
      }
      (p || p === 0) && e.lift(h, p);
    });
  }), !0;
}, tx = (n) => (e) => n(e), nx = () => ({ state: n, dispatch: e }) => Yh(n, e), rx = (n, e) => ({ editor: t, tr: r }) => {
  const { state: s } = t, a = s.doc.slice(n.from, n.to);
  r.deleteRange(n.from, n.to);
  const o = r.mapping.map(e);
  return r.insert(o, a.content), r.setSelection(new Ie(r.doc.resolve(Math.max(o - 1, 0)))), !0;
}, sx = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, r = t.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const s = n.selection.$anchor;
  for (let a = s.depth; a > 0; a -= 1)
    if (s.node(a).type === r.type) {
      if (e) {
        const i = s.before(a), l = s.after(a);
        n.delete(i, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, ax = (n) => ({ tr: e, state: t, dispatch: r }) => {
  const s = xt(n, t.schema), a = e.selection.$anchor;
  for (let o = a.depth; o > 0; o -= 1)
    if (a.node(o).type === s) {
      if (r) {
        const l = a.before(o), u = a.after(o);
        e.delete(l, u).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, ox = (n) => ({ tr: e, dispatch: t }) => {
  const { from: r, to: s } = n;
  return t && e.delete(r, s), !0;
}, ix = () => ({ state: n, dispatch: e }) => du(n, e), lx = () => ({ commands: n }) => n.keyboardShortcut("Enter"), ux = () => ({ state: n, dispatch: e }) => lk(n, e), cx = (n, e = {}) => ({ tr: t, state: r, dispatch: s }) => {
  const a = qn(n, r.schema), { doc: o, selection: i } = t, { $from: l, from: u, to: c } = i;
  if (s) {
    const d = wu(l, a, e);
    if (d && d.from <= u && d.to >= c) {
      const f = Ie.create(o, d.from, d.to);
      t.setSelection(f);
    }
  }
  return !0;
}, dx = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let r = 0; r < t.length; r += 1)
    if (t[r](e))
      return !0;
  return !1;
};
function fx() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function Mu() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
var hx = (n = null, e = {}) => ({ editor: t, view: r, tr: s, dispatch: a }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (Mu() || fx()) && r.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (r.focus(), e != null && e.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && n === null || n === !1)
    return !0;
  if (a && n === null && !op(t.state.selection))
    return o(), !0;
  const i = ip(s.doc, n) || t.state.selection, l = t.state.selection.eq(i);
  return a && (l || s.setSelection(i), l && s.storedMarks && s.setStoredMarks(s.storedMarks), o()), !0;
}, px = (n, e) => (t) => n.every((r, s) => e(r, { ...t, index: s })), mx = (n, e) => ({ tr: t, commands: r }) => r.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), gx = (n) => !("type" in n), yx = (n, e, t) => ({ tr: r, dispatch: s, editor: a }) => {
  var o;
  if (s) {
    t = {
      parseOptions: a.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let i;
    const { selection: l } = a.state, u = (v) => {
      a.emit("contentError", {
        editor: a,
        error: v,
        disableCollaboration: () => {
          "collaboration" in a.storage && typeof a.storage.collaboration == "object" && a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !a.options.enableContentCheck && a.options.emitContentError)
      try {
        ia(e, a.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (v) {
        u(v);
      }
    try {
      i = ia(e, a.schema, {
        parseOptions: c,
        errorOnInvalidContent: (o = t.errorOnInvalidContent) != null ? o : a.options.enableContentCheck
      });
    } catch (v) {
      return u(v), !1;
    }
    let { from: d, to: f } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, h = !0, p = !0;
    if ((gx(i) ? i : [i]).forEach((v) => {
      v.check(), h = h ? v.isText && v.marks.length === 0 : !1, p = p ? v.isBlock : !1;
    }), d === f && p) {
      const { parent: v } = r.doc.resolve(d);
      v.isTextblock && !v.type.spec.code && !v.childCount && (d -= 1, f += 1);
    }
    let y;
    if (h) {
      if (Array.isArray(e))
        y = e.map((v) => v.text || "").join("");
      else if (e instanceof te) {
        let v = "";
        e.forEach((C) => {
          C.text && (v += C.text);
        }), y = v;
      } else typeof e == "object" && e && e.text ? y = e.text : y = e;
      r.insertText(y, d, f);
    } else {
      y = i;
      const v = l.$from.parentOffset === 0, C = l.$from.node().isText || l.$from.node().isTextblock, M = l.$from.node().content.size > 0;
      v && C && M && (d = Math.max(0, d - 1)), r.replaceWith(d, f, y);
    }
    t.updateSelection && Vk(r, r.steps.length - 1, -1), t.applyInputRules && r.setMeta("applyInputRules", { from: d, text: y }), t.applyPasteRules && r.setMeta("applyPasteRules", { from: d, text: y });
  }
  return !0;
}, vx = () => ({ state: n, dispatch: e }) => ak(n, e), bx = () => ({ state: n, dispatch: e }) => ok(n, e), wx = () => ({ state: n, dispatch: e }) => $h(n, e), kx = () => ({ state: n, dispatch: e }) => zh(n, e), xx = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = Vo(n.doc, n.selection.$from.pos, -1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, Mx = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = Vo(n.doc, n.selection.$from.pos, 1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, Sx = () => ({ state: n, dispatch: e }) => rk(n, e), Tx = () => ({ state: n, dispatch: e }) => sk(n, e);
function hp() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function Cx(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let r, s, a, o;
  for (let i = 0; i < e.length - 1; i += 1) {
    const l = e[i];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      s = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      Mu() || hp() ? o = !0 : s = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (t = `Alt-${t}`), s && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), a && (t = `Shift-${t}`), t;
}
var Ax = (n) => ({ editor: e, view: t, tr: r, dispatch: s }) => {
  const a = Cx(n).split(/-(?!$)/), o = a.find((u) => !["Alt", "Ctrl", "Meta", "Shift"].includes(u)), i = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: a.includes("Alt"),
    ctrlKey: a.includes("Ctrl"),
    metaKey: a.includes("Meta"),
    shiftKey: a.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (u) => u(t, i));
  });
  return l == null || l.steps.forEach((u) => {
    const c = u.map(r.mapping);
    c && s && r.maybeStep(c);
  }), !0;
}, Dx = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const s = xt(n, t.schema);
  return yr(t, s, e) ? ik(t, r) : !1;
}, Ox = () => ({ state: n, dispatch: e }) => Wh(n, e), Ex = (n) => ({ state: e, dispatch: t }) => {
  const r = xt(n, e.schema);
  return bk(r)(e, t);
}, Px = () => ({ state: n, dispatch: e }) => Hh(n, e);
function ud(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((r, s) => (t.includes(s) || (r[s] = n[s]), r), {});
}
var _x = (n, e) => ({ tr: t, state: r, dispatch: s }) => {
  let a = null, o = null;
  const i = Jo(
    typeof n == "string" ? n : n.name,
    r.schema
  );
  return i ? (i === "node" && (a = xt(n, r.schema)), i === "mark" && (o = qn(n, r.schema)), s && t.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (u, c) => {
      a && a === u.type && t.setNodeMarkup(c, void 0, ud(u.attrs, e)), o && u.marks.length && u.marks.forEach((d) => {
        o === d.type && t.addMark(c, c + u.nodeSize, o.create(ud(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, Nx = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), Ix = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new an(n.doc);
    n.setSelection(t);
  }
  return !0;
}, Rx = () => ({ state: n, dispatch: e }) => Bh(n, e), $x = () => ({ state: n, dispatch: e }) => Vh(n, e), Lx = () => ({ state: n, dispatch: e }) => dk(n, e), Bx = () => ({ state: n, dispatch: e }) => pk(n, e), Fx = () => ({ state: n, dispatch: e }) => hk(n, e), zx = (n, { errorOnInvalidContent: e, emitUpdate: t = !0, parseOptions: r = {} } = {}) => ({ editor: s, tr: a, dispatch: o, commands: i }) => {
  const { doc: l } = a;
  if (r.preserveWhitespace !== "full") {
    const u = gl(n, s.schema, r, {
      errorOnInvalidContent: e ?? s.options.enableContentCheck
    });
    return o && a.replaceWith(0, l.content.size, u).setMeta("preventUpdate", !t), !0;
  }
  return o && a.setMeta("preventUpdate", !t), i.insertContentAt({ from: 0, to: l.content.size }, n, {
    parseOptions: r,
    errorOnInvalidContent: e ?? s.options.enableContentCheck
  });
};
function Vx(n, e, t) {
  var r;
  const { selection: s } = e;
  let a = null;
  if (op(s) && (a = s.$cursor), a) {
    const i = (r = n.storedMarks) != null ? r : a.marks();
    return !!t.isInSet(i) || !i.some((l) => l.type.excludes(t));
  }
  const { ranges: o } = s;
  return o.some(({ $from: i, $to: l }) => {
    let u = i.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(i.pos, l.pos, (c, d, f) => {
      if (u)
        return !1;
      if (c.isInline) {
        const h = !f || f.type.allowsMarkType(t), p = !!t.isInSet(c.marks) || !c.marks.some((g) => g.type.excludes(t));
        u = h && p;
      }
      return !u;
    }), u;
  });
}
var Hx = (n, e = {}) => ({ tr: t, state: r, dispatch: s }) => {
  const { selection: a } = t, { empty: o, ranges: i } = a, l = qn(n, r.schema);
  if (s)
    if (o) {
      const u = tp(r, l);
      t.addStoredMark(
        l.create({
          ...u,
          ...e
        })
      );
    } else
      i.forEach((u) => {
        const c = u.$from.pos, d = u.$to.pos;
        r.doc.nodesBetween(c, d, (f, h) => {
          const p = Math.max(h, c), g = Math.min(h + f.nodeSize, d);
          f.marks.find((v) => v.type === l) ? f.marks.forEach((v) => {
            l === v.type && t.addMark(
              p,
              g,
              l.create({
                ...v.attrs,
                ...e
              })
            );
          }) : t.addMark(p, g, l.create(e));
        });
      });
  return Vx(r, t, l);
}, Yx = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), Wx = (n, e = {}) => ({ state: t, dispatch: r, chain: s }) => {
  const a = xt(n, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), a.isTextblock ? s().command(({ commands: i }) => rd(a, { ...o, ...e })(t) ? !0 : i.clearNodes()).command(({ state: i }) => rd(a, { ...o, ...e })(i, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, jx = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, s = Er(n, 0, r.content.size), a = Me.create(r, s);
    e.setSelection(a);
  }
  return !0;
}, Ux = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, { from: s, to: a } = typeof n == "number" ? { from: n, to: n } : n, o = Ie.atStart(r).from, i = Ie.atEnd(r).to, l = Er(s, o, i), u = Er(a, o, i), c = Ie.create(r, l, u);
    e.setSelection(c);
  }
  return !0;
}, qx = (n) => ({ state: e, dispatch: t }) => {
  const r = xt(n, e.schema);
  return xk(r)(e, t);
};
function cd(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const r = t.filter((s) => e == null ? void 0 : e.includes(s.type.name));
    n.tr.ensureMarks(r);
  }
}
var Kx = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: r, editor: s }) => {
  const { selection: a, doc: o } = e, { $from: i, $to: l } = a, u = s.extensionManager.attributes, c = Fa(u, i.node().type.name, i.node().attrs);
  if (a instanceof Me && a.node.isBlock)
    return !i.parentOffset || !Wn(o, i.pos) ? !1 : (r && (n && cd(t, s.extensionManager.splittableMarks), e.split(i.pos).scrollIntoView()), !0);
  if (!i.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, f = i.depth === 0 ? void 0 : Tk(i.node(-1).contentMatchAt(i.indexAfter(-1)));
  let h = d && f ? [
    {
      type: f,
      attrs: c
    }
  ] : void 0, p = Wn(e.doc, e.mapping.map(i.pos), 1, h);
  if (!h && !p && Wn(e.doc, e.mapping.map(i.pos), 1, f ? [{ type: f }] : void 0) && (p = !0, h = f ? [
    {
      type: f,
      attrs: c
    }
  ] : void 0), r) {
    if (p && (a instanceof Ie && e.deleteSelection(), e.split(e.mapping.map(i.pos), 1, h), f && !d && !i.parentOffset && i.parent.type !== f)) {
      const g = e.mapping.map(i.before()), y = e.doc.resolve(g);
      i.node(-1).canReplaceWith(y.index(), y.index() + 1, f) && e.setNodeMarkup(e.mapping.map(i.before()), f);
    }
    n && cd(t, s.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, Gx = (n, e = {}) => ({ tr: t, state: r, dispatch: s, editor: a }) => {
  var o;
  const i = xt(n, r.schema), { $from: l, $to: u } = r.selection, c = r.selection.node;
  if (c && c.isBlock || l.depth < 2 || !l.sameParent(u))
    return !1;
  const d = l.node(-1);
  if (d.type !== i)
    return !1;
  const f = a.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== i || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (s) {
      let v = te.empty;
      const C = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let k = l.depth - C; k >= l.depth - 3; k -= 1)
        v = te.from(l.node(k).copy(v));
      const M = (
        // eslint-disable-next-line no-nested-ternary
        l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3
      ), S = {
        ...Fa(f, l.node().type.name, l.node().attrs),
        ...e
      }, D = ((o = i.contentMatch.defaultType) == null ? void 0 : o.createAndFill(S)) || void 0;
      v = v.append(te.from(i.createAndFill(null, D) || void 0));
      const I = l.before(l.depth - (C - 1));
      t.replace(I, l.after(-M), new me(v, 4 - C, 0));
      let x = -1;
      t.doc.nodesBetween(I, t.doc.content.size, (k, _) => {
        if (x > -1)
          return !1;
        k.isTextblock && k.content.size === 0 && (x = _ + 1);
      }), x > -1 && t.setSelection(Ie.near(t.doc.resolve(x))), t.scrollIntoView();
    }
    return !0;
  }
  const h = u.pos === l.end() ? d.contentMatchAt(0).defaultType : null, p = {
    ...Fa(f, d.type.name, d.attrs),
    ...e
  }, g = {
    ...Fa(f, l.node().type.name, l.node().attrs),
    ...e
  };
  t.delete(l.pos, u.pos);
  const y = h ? [
    { type: i, attrs: p },
    { type: h, attrs: g }
  ] : [{ type: i, attrs: p }];
  if (!Wn(t.doc, l.pos, 2))
    return !1;
  if (s) {
    const { selection: v, storedMarks: C } = r, { splittableMarks: M } = a.extensionManager, S = C || v.$to.parentOffset && v.$from.marks();
    if (t.split(l.pos, 2, y).scrollIntoView(), !S || !s)
      return !0;
    const D = S.filter((I) => M.includes(I.type.name));
    t.ensureMarks(D);
  }
  return !0;
}, Ri = (n, e) => {
  const t = Go((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (r === void 0)
    return !0;
  const s = n.doc.nodeAt(r);
  return t.node.type === (s == null ? void 0 : s.type) && wr(n.doc, t.pos) && n.join(t.pos), !0;
}, $i = (n, e) => {
  const t = Go((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(t.start).after(t.depth);
  if (r === void 0)
    return !0;
  const s = n.doc.nodeAt(r);
  return t.node.type === (s == null ? void 0 : s.type) && wr(n.doc, r) && n.join(r), !0;
}, Jx = (n, e, t, r = {}) => ({ editor: s, tr: a, state: o, dispatch: i, chain: l, commands: u, can: c }) => {
  const { extensions: d, splittableMarks: f } = s.extensionManager, h = xt(n, o.schema), p = xt(e, o.schema), { selection: g, storedMarks: y } = o, { $from: v, $to: C } = g, M = v.blockRange(C), S = y || g.$to.parentOffset && g.$from.marks();
  if (!M)
    return !1;
  const D = Go((I) => ld(I.type.name, d))(g);
  if (M.depth >= 1 && D && M.depth - D.depth <= 1) {
    if (D.node.type === h)
      return u.liftListItem(p);
    if (ld(D.node.type.name, d) && h.validContent(D.node.content) && i)
      return l().command(() => (a.setNodeMarkup(D.pos, h), !0)).command(() => Ri(a, h)).command(() => $i(a, h)).run();
  }
  return !t || !S || !i ? l().command(() => c().wrapInList(h, r) ? !0 : u.clearNodes()).wrapInList(h, r).command(() => Ri(a, h)).command(() => $i(a, h)).run() : l().command(() => {
    const I = c().wrapInList(h, r), x = S.filter((k) => f.includes(k.type.name));
    return a.ensureMarks(x), I ? !0 : u.clearNodes();
  }).wrapInList(h, r).command(() => Ri(a, h)).command(() => $i(a, h)).run();
}, Qx = (n, e = {}, t = {}) => ({ state: r, commands: s }) => {
  const { extendEmptyMarkRange: a = !1 } = t, o = qn(n, r.schema);
  return yl(r, o, e) ? s.unsetMark(o, { extendEmptyMarkRange: a }) : s.setMark(o, e);
}, Xx = (n, e, t = {}) => ({ state: r, commands: s }) => {
  const a = xt(n, r.schema), o = xt(e, r.schema), i = yr(r, a, t);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), i ? s.setNode(o, l) : s.setNode(a, { ...l, ...t });
}, Zx = (n, e = {}) => ({ state: t, commands: r }) => {
  const s = xt(n, t.schema);
  return yr(t, s, e) ? r.lift(s) : r.wrapIn(s, e);
}, eM = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let r = 0; r < t.length; r += 1) {
    const s = t[r];
    let a;
    if (s.spec.isInputRules && (a = s.getState(n))) {
      if (e) {
        const o = n.tr, i = a.transform;
        for (let l = i.steps.length - 1; l >= 0; l -= 1)
          o.step(i.steps[l].invert(i.docs[l]));
        if (a.text) {
          const l = o.doc.resolve(a.from).marks();
          o.replaceWith(a.from, a.to, n.schema.text(a.text, l));
        } else
          o.delete(a.from, a.to);
      }
      return !0;
    }
  }
  return !1;
}, tM = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: r, ranges: s } = t;
  return r || e && s.forEach((a) => {
    n.removeMark(a.$from.pos, a.$to.pos);
  }), !0;
}, nM = (n, e = {}) => ({ tr: t, state: r, dispatch: s }) => {
  var a;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: i } = t, l = qn(n, r.schema), { $from: u, empty: c, ranges: d } = i;
  if (!s)
    return !0;
  if (c && o) {
    let { from: f, to: h } = i;
    const p = (a = u.marks().find((y) => y.type === l)) == null ? void 0 : a.attrs, g = wu(u, l, p);
    g && (f = g.from, h = g.to), t.removeMark(f, h, l);
  } else
    d.forEach((f) => {
      t.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, rM = (n, e = {}) => ({ tr: t, state: r, dispatch: s }) => {
  let a = null, o = null;
  const i = Jo(
    typeof n == "string" ? n : n.name,
    r.schema
  );
  return i ? (i === "node" && (a = xt(n, r.schema)), i === "mark" && (o = qn(n, r.schema)), s && t.selection.ranges.forEach((l) => {
    const u = l.$from.pos, c = l.$to.pos;
    let d, f, h, p;
    t.selection.empty ? r.doc.nodesBetween(u, c, (g, y) => {
      a && a === g.type && (h = Math.max(y, u), p = Math.min(y + g.nodeSize, c), d = y, f = g);
    }) : r.doc.nodesBetween(u, c, (g, y) => {
      y < u && a && a === g.type && (h = Math.max(y, u), p = Math.min(y + g.nodeSize, c), d = y, f = g), y >= u && y <= c && (a && a === g.type && t.setNodeMarkup(y, void 0, {
        ...g.attrs,
        ...e
      }), o && g.marks.length && g.marks.forEach((v) => {
        if (o === v.type) {
          const C = Math.max(y, u), M = Math.min(y + g.nodeSize, c);
          t.addMark(
            C,
            M,
            o.create({
              ...v.attrs,
              ...e
            })
          );
        }
      }));
    }), f && (d !== void 0 && t.setNodeMarkup(d, void 0, {
      ...f.attrs,
      ...e
    }), o && f.marks.length && f.marks.forEach((g) => {
      o === g.type && t.addMark(
        h,
        p,
        o.create({
          ...g.attrs,
          ...e
        })
      );
    }));
  }), !0) : !1;
}, sM = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const s = xt(n, t.schema);
  return mk(s, e)(t, r);
}, aM = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const s = xt(n, t.schema);
  return gk(s, e)(t, r);
}, pp = Je.create({
  name: "commands",
  addCommands() {
    return {
      ...fp
    };
  }
}), mp = Je.create({
  name: "delete",
  onUpdate({ transaction: n, appendedTransactions: e }) {
    var t, r, s;
    const a = () => {
      var o, i, l, u;
      if ((u = (l = (i = (o = this.editor.options.coreExtensionOptions) == null ? void 0 : o.delete) == null ? void 0 : i.filterTransaction) == null ? void 0 : l.call(i, n)) != null ? u : n.getMeta("y-sync$"))
        return;
      const c = Kh(n.before, [n, ...e]);
      rp(c).forEach((h) => {
        c.mapping.mapResult(h.oldRange.from).deletedAfter && c.mapping.mapResult(h.oldRange.to).deletedBefore && c.before.nodesBetween(h.oldRange.from, h.oldRange.to, (p, g) => {
          const y = g + p.nodeSize - 2, v = h.oldRange.from <= g && y <= h.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: p,
            from: g,
            to: y,
            newFrom: c.mapping.map(g),
            newTo: c.mapping.map(y),
            deletedRange: h.oldRange,
            newRange: h.newRange,
            partial: !v,
            editor: this.editor,
            transaction: n,
            combinedTransform: c
          });
        });
      });
      const f = c.mapping;
      c.steps.forEach((h, p) => {
        var g, y;
        if (h instanceof bn) {
          const v = f.slice(p).map(h.from, -1), C = f.slice(p).map(h.to), M = f.invert().map(v, -1), S = f.invert().map(C), D = (g = c.doc.nodeAt(v - 1)) == null ? void 0 : g.marks.some((x) => x.eq(h.mark)), I = (y = c.doc.nodeAt(C)) == null ? void 0 : y.marks.some((x) => x.eq(h.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: h.mark,
            from: h.from,
            to: h.to,
            deletedRange: {
              from: M,
              to: S
            },
            newRange: {
              from: v,
              to: C
            },
            partial: !!(I || D),
            editor: this.editor,
            transaction: n,
            combinedTransform: c
          });
        }
      });
    };
    (s = (r = (t = this.editor.options.coreExtensionOptions) == null ? void 0 : t.delete) == null ? void 0 : r.async) == null || s ? setTimeout(a, 0) : a();
  }
}), gp = Je.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new dt({
        key: new _t("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: r
            });
          }
        }
      })
    ];
  }
}), yp = Je.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new dt({
        key: new _t("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), vp = new _t("focusEvents"), bp = Je.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new dt({
        key: vp,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const r = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const r = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), wp = Je.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: i }) => {
        const { selection: l, doc: u } = i, { empty: c, $anchor: d } = l, { pos: f, parent: h } = d, p = d.parent.isTextblock && f > 0 ? i.doc.resolve(f - 1) : d, g = p.parent.type.spec.isolating, y = d.pos - d.parentOffset, v = g && p.parent.childCount === 1 ? y === d.pos : $e.atStart(u).from === f;
        return !c || !h.type.isTextblock || h.textContent.length || !v || v && d.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, s = {
      ...r
    }, a = {
      ...r,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Mu() || hp() ? a : s;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new dt({
        key: new _t("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((g) => g.getMeta("composition")))
            return;
          const r = n.some((g) => g.docChanged) && !e.doc.eq(t.doc), s = n.some((g) => g.getMeta("preventClearDocument"));
          if (!r || s)
            return;
          const { empty: a, from: o, to: i } = e.selection, l = $e.atStart(e.doc).from, u = $e.atEnd(e.doc).to;
          if (a || !(o === l && i === u) || !Qo(t.doc))
            return;
          const f = t.tr, h = qo({
            state: t,
            transaction: f
          }), { commands: p } = new Ko({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), kp = Je.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new dt({
        key: new _t("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), xp = Je.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new dt({
        key: new _t("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
}), oM = class rs {
  constructor(e, t, r = !1, s = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = t, this.currentNode = s;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) != null ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new rs(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new rs(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new rs(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, r) => {
      const s = t.isBlock && !t.isTextblock, a = t.isAtom && !t.isText, o = this.pos + r + (a ? 0 : 1);
      if (o < 0 || o > this.resolvedPos.doc.nodeSize - 2)
        return;
      const i = this.resolvedPos.doc.resolve(o);
      if (!s && i.depth <= this.depth)
        return;
      const l = new rs(i, this.editor, s, s ? t : null);
      s && (l.actualDepth = this.depth + 1), e.push(new rs(i, this.editor, s, s ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let r = null, s = this.parent;
    for (; s && !r; ) {
      if (s.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const a = s.node.attrs, o = Object.keys(t);
          for (let i = 0; i < o.length; i += 1) {
            const l = o[i];
            if (a[l] !== t[l])
              break;
          }
        } else
          r = s;
      s = s.parent;
    }
    return r;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, r = !1) {
    let s = [];
    if (!this.children || this.children.length === 0)
      return s;
    const a = Object.keys(t);
    return this.children.forEach((o) => {
      r && s.length > 0 || (o.node.type.name === e && a.every((l) => t[l] === o.node.attrs[l]) && s.push(o), !(r && s.length > 0) && (s = s.concat(o.querySelectorAll(e, t, r))));
    }), s;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}, iM = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function lM(n, e, t) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const s = document.createElement("style");
  return e && s.setAttribute("nonce", e), s.setAttribute("data-tiptap-style", ""), s.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(s), s;
}
var uM = class extends Sk {
  constructor(e = {}) {
    super(), this.css = null, this.editorView = null, this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: s }) => {
        throw s;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: s, slice: a, moved: o }) => this.options.onDrop(s, a, o)), this.on("paste", ({ event: s, slice: a }) => this.options.onPaste(s, a)), this.on("delete", this.options.onDelete);
    const t = this.createDoc(), r = ip(t, this.options.autofocus);
    this.editorState = is.create({
      doc: t,
      schema: this.schema,
      selection: r || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(e) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(e), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const e = this.editorView.dom;
      e != null && e.editor && delete e.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (e) {
        console.warn("Failed to remove CSS element:", e);
      }
    this.css = null;
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = lM(iM, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, t = !0) {
    this.setOptions({ editable: e }), t && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (e) => {
          this.editorState = e;
        },
        dispatch: (e) => {
          this.editorState = this.state.apply(e);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (e, t) => {
          if (t === "state")
            return this.editorState;
          if (t in e)
            return Reflect.get(e, t);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${t}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, t) {
    const r = Jh(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], s = this.state.reconfigure({ plugins: r });
    return this.view.updateState(s), s;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let r = t;
    if ([].concat(e).forEach((a) => {
      const o = typeof a == "string" ? `${a}$` : a.key;
      r = r.filter((i) => !i.key.startsWith(o));
    }), t.length === r.length)
      return;
    const s = this.state.reconfigure({
      plugins: r
    });
    return this.view.updateState(s), s;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, t;
    const s = [...this.options.enableCoreExtensions ? [
      yp,
      dp.configure({
        blockSeparator: (t = (e = this.options.coreExtensionOptions) == null ? void 0 : e.clipboardTextSerializer) == null ? void 0 : t.blockSeparator
      }),
      pp,
      bp,
      wp,
      xp,
      gp,
      kp,
      mp
    ].filter((a) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[a.name] !== !1 : !0) : [], ...this.options.extensions].filter((a) => ["extension", "node", "mark"].includes(a == null ? void 0 : a.type));
    this.extensionManager = new Zo(s, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new Ko({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let e;
    try {
      e = gl(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (t) {
      if (!(t instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(t.message))
        throw t;
      this.emit("contentError", {
        editor: this,
        error: t,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((r) => r.name !== "collaboration"), this.createExtensionManager();
        }
      }), e = gl(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return e;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(e) {
    var t;
    this.editorView = new Nh(e, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(t = this.options.editorProps) == null ? void 0 : t.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: this.editorState
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass(), this.injectCSS();
    const s = this.view.dom;
    s.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((c) => {
        var d;
        return (d = this.capturedTransaction) == null ? void 0 : d.step(c);
      });
      return;
    }
    const { state: t, transactions: r } = this.state.applyTransaction(e), s = !this.state.selection.eq(t.selection), a = r.includes(e), o = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: t
    }), !a)
      return;
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e,
      appendedTransactions: r.slice(1)
    }), s && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const i = r.findLast((c) => c.getMeta("focus") || c.getMeta("blur")), l = i == null ? void 0 : i.getMeta("focus"), u = i == null ? void 0 : i.getMeta("blur");
    l && this.emit("focus", {
      editor: this,
      event: l.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), u && this.emit("blur", {
      editor: this,
      event: u.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: i
    }), !(e.getMeta("preventUpdate") || !r.some((c) => c.docChanged) || o.doc.eq(t.doc)) && this.emit("update", {
      editor: this,
      transaction: e,
      appendedTransactions: r.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return np(this.state, e);
  }
  isActive(e, t) {
    const r = typeof e == "string" ? e : null, s = typeof e == "string" ? t : e;
    return Bk(this.state, r, s);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return yu(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: t = `

`, textSerializers: r = {} } = e || {};
    return _k(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...ep(this.schema),
        ...r
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Qo(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.unmount(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e, t;
    return (t = (e = this.editorView) == null ? void 0 : e.isDestroyed) != null ? t : !0;
  }
  $node(e, t) {
    var r;
    return ((r = this.$doc) == null ? void 0 : r.querySelector(e, t)) || null;
  }
  $nodes(e, t) {
    var r;
    return ((r = this.$doc) == null ? void 0 : r.querySelectorAll(e, t)) || null;
  }
  $pos(e) {
    const t = this.state.doc.resolve(e);
    return new oM(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function xs(n) {
  return new Xo({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const s = je(n.getAttributes, void 0, r);
      if (s === !1 || s === null)
        return null;
      const { tr: a } = e, o = r[r.length - 1], i = r[0];
      if (o) {
        const l = i.search(/\S/), u = t.from + i.indexOf(o), c = u + o.length;
        if (ku(t.from, t.to, e.doc).filter((h) => h.mark.type.excluded.find((g) => g === n.type && g !== h.mark.type)).filter((h) => h.to > u).length)
          return null;
        c < t.to && a.delete(c, t.to), u > t.from && a.delete(t.from + l, u);
        const f = t.from + l + o.length;
        a.addMark(t.from + l, f, n.type.create(s || {})), a.removeStoredMark(n.type);
      }
    }
  });
}
function cM(n) {
  return new Xo({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const s = je(n.getAttributes, void 0, r) || {}, { tr: a } = e, o = t.from;
      let i = t.to;
      const l = n.type.create(s);
      if (r[1]) {
        const u = r[0].lastIndexOf(r[1]);
        let c = o + u;
        c > i ? c = i : i = c + r[1].length;
        const d = r[0][r[0].length - 1];
        a.insertText(d, o + r[0].length - 1), a.replaceWith(c, i, l);
      } else if (r[0]) {
        const u = n.type.isInline ? o : o - 1;
        a.insert(u, n.type.create(s)).delete(a.mapping.map(o), a.mapping.map(i));
      }
      a.scrollIntoView();
    }
  });
}
function vl(n) {
  return new Xo({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const s = e.doc.resolve(t.from), a = je(n.getAttributes, void 0, r) || {};
      if (!s.node(-1).canReplaceWith(s.index(-1), s.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, a);
    }
  });
}
function Ms(n) {
  return new Xo({
    find: n.find,
    handler: ({ state: e, range: t, match: r, chain: s }) => {
      const a = je(n.getAttributes, void 0, r) || {}, o = e.tr.delete(t.from, t.to), l = o.doc.resolve(t.from).blockRange(), u = l && eu(l, n.type, a);
      if (!u)
        return null;
      if (o.wrap(l, u), n.keepMarks && n.editor) {
        const { selection: d, storedMarks: f } = e, { splittableMarks: h } = n.editor.extensionManager, p = f || d.$to.parentOffset && d.$from.marks();
        if (p) {
          const g = p.filter((y) => h.includes(y.type.name));
          o.ensureMarks(g);
        }
      }
      if (n.keepAttributes) {
        const d = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        s().updateAttributes(d, a).run();
      }
      const c = o.doc.resolve(t.from - 1).nodeBefore;
      c && c.type === n.type && wr(o.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(r, c)) && o.join(t.from - 1);
    }
  });
}
function dM(n, e) {
  const { selection: t } = n, { $from: r } = t;
  if (t instanceof Me) {
    const a = r.index();
    return r.parent.canReplaceWith(a, a + 1, e);
  }
  let s = r.depth;
  for (; s >= 0; ) {
    const a = r.index(s);
    if (r.node(s).contentMatchAt(a).matchType(e))
      return !0;
    s -= 1;
  }
  return !1;
}
function fM(n, e, t = {}) {
  const { state: r } = e, { doc: s, tr: a } = r, o = n;
  s.descendants((i, l) => {
    const u = a.mapping.map(l), c = a.mapping.map(l) + i.nodeSize;
    let d = null;
    if (i.marks.forEach((h) => {
      if (h !== o)
        return !1;
      d = h;
    }), !d)
      return;
    let f = !1;
    if (Object.keys(t).forEach((h) => {
      t[h] !== d.attrs[h] && (f = !0);
    }), f) {
      const h = n.type.create({
        ...n.attrs,
        ...t
      });
      a.removeMark(u, c, n.type), a.addMark(u, c, h);
    }
  }), a.docChanged && e.view.dispatch(a);
}
var on = class Mp extends xu {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new Mp(t);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
};
function Wr(n) {
  return new Uk({
    find: n.find,
    handler: ({ state: e, range: t, match: r, pasteEvent: s }) => {
      const a = je(n.getAttributes, void 0, r, s);
      if (a === !1 || a === null)
        return null;
      const { tr: o } = e, i = r[r.length - 1], l = r[0];
      let u = t.to;
      if (i) {
        const c = l.search(/\S/), d = t.from + l.indexOf(i), f = d + i.length;
        if (ku(t.from, t.to, e.doc).filter((p) => p.mark.type.excluded.find((y) => y === n.type && y !== p.mark.type)).filter((p) => p.to > d).length)
          return null;
        f < t.to && o.delete(f, t.to), d > t.from && o.delete(t.from + c, d), u = t.from + c + i.length, o.addMark(t.from + c, u, n.type.create(a || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
function dd(n) {
  return im((e, t) => ({
    get() {
      return e(), n;
    },
    set(r) {
      n = r, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t();
        });
      });
    }
  }));
}
var hM = class extends uM {
  constructor(n = {}) {
    return super(n), this.contentComponent = null, this.appContext = null, this.reactiveState = dd(this.view.state), this.reactiveExtensionStorage = dd(this.extensionStorage), this.on("beforeTransaction", ({ nextState: e }) => {
      this.reactiveState.value = e, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), om(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(n, e) {
    const t = super.registerPlugin(n, e);
    return this.reactiveState && (this.reactiveState.value = t), t;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(n) {
    const e = super.unregisterPlugin(n);
    return this.reactiveState && e && (this.reactiveState.value = e), e;
  }
}, pM = Fe({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(n) {
    const e = W(), t = Cd();
    return Ol(() => {
      const r = n.editor;
      r && r.options.element && e.value && kt(() => {
        var s;
        if (!e.value || !((s = r.options.element) != null && s.firstChild))
          return;
        const a = b(e.value);
        e.value.append(...r.options.element.childNodes), r.contentComponent = t.ctx._, t && (r.appContext = {
          ...t.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: t.provides
        }), r.setOptions({
          element: a
        }), r.createNodeViews();
      });
    }), Ad(() => {
      const r = n.editor;
      r && (r.contentComponent = null, r.appContext = null);
    }), { rootEl: e };
  },
  render() {
    return fa("div", {
      ref: (n) => {
        this.rootEl = n;
      }
    });
  }
});
Fe({
  name: "NodeViewContent",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  render() {
    return fa(this.as, {
      style: {
        whiteSpace: "pre-wrap"
      },
      "data-node-view-content": ""
    });
  }
});
Fe({
  name: "NodeViewWrapper",
  props: {
    as: {
      type: String,
      default: "div"
    }
  },
  inject: ["onDragStart", "decorationClasses"],
  render() {
    var n, e;
    return fa(
      this.as,
      {
        // @ts-ignore
        class: this.decorationClasses,
        style: {
          whiteSpace: "normal"
        },
        "data-node-view-wrapper": "",
        // @ts-ignore (https://github.com/vuejs/vue-next/issues/3031)
        onDragstart: this.onDragStart
      },
      (e = (n = this.$slots).default) == null ? void 0 : e.call(n)
    );
  }
});
var mM = (n = {}) => {
  const e = am();
  return Pt(() => {
    e.value = new hM(n);
  }), Ad(() => {
    var t, r, s;
    const a = (t = e.value) == null ? void 0 : t.options.element, o = a == null ? void 0 : a.cloneNode(!0);
    (r = a == null ? void 0 : a.parentNode) == null || r.replaceChild(o, a), (s = e.value) == null || s.destroy();
  }), e;
};
Fe({
  name: "MarkViewContent",
  props: {
    as: {
      type: String,
      default: "span"
    }
  },
  render() {
    return fa(this.as, {
      style: {
        whiteSpace: "inherit"
      },
      "data-mark-view-content": ""
    });
  }
});
var ao = (n, e) => {
  if (n === "slot")
    return 0;
  if (n instanceof Function)
    return n(e);
  const { children: t, ...r } = e ?? {};
  if (n === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [n, r, t];
}, gM = /^\s*>\s$/, yM = on.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return /* @__PURE__ */ ao("blockquote", { ...yt(this.options.HTMLAttributes, n), children: /* @__PURE__ */ ao("slot", {}) });
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Ms({
        find: gM,
        type: this.type
      })
    ];
  }
}), vM = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, bM = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, wM = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, kM = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, xM = xr.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return /* @__PURE__ */ ao("strong", { ...yt(this.options.HTMLAttributes, n), children: /* @__PURE__ */ ao("slot", {}) });
  },
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      xs({
        find: vM,
        type: this.type
      }),
      xs({
        find: wM,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Wr({
        find: bM,
        type: this.type
      }),
      Wr({
        find: kM,
        type: this.type
      })
    ];
  }
}), MM = /(^|[^`])`([^`]+)`(?!`)/, SM = /(^|[^`])`([^`]+)`(?!`)/g, TM = xr.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      xs({
        find: MM,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Wr({
        find: SM,
        type: this.type
      })
    ];
  }
}), CM = /^```([a-z]+)?[\s\n]$/, AM = /^~~~([a-z]+)?[\s\n]$/, DM = on.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options, a = [...((e = n.firstElementChild) == null ? void 0 : e.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return a || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      yt(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: r, empty: s } = t;
        if (!s || r.parent.type !== this.type)
          return !1;
        const a = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !a || !o ? !1 : n.chain().command(({ tr: i }) => (i.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: r } = e, { $from: s, empty: a } = t;
        if (!a || s.parent.type !== this.type || !(s.parentOffset === s.parent.nodeSize - 2))
          return !1;
        const i = s.after();
        return i === void 0 ? !1 : r.nodeAt(i) ? n.commands.command(({ tr: u }) => (u.setSelection($e.near(r.resolve(i))), !0)) : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      vl({
        find: CM,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      vl({
        find: AM,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new dt({
        key: new _t("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), s = r ? JSON.parse(r) : void 0, a = s == null ? void 0 : s.mode;
            if (!t || !a)
              return !1;
            const { tr: o, schema: i } = n.state, l = i.text(t.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: a }, l)), o.selection.$from.parent.type !== this.type && o.setSelection(Ie.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), n.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), OM = on.create({
  name: "doc",
  topNode: !0,
  content: "block+"
}), EM = on.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", yt(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: r }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: s, storedMarks: a } = t;
          if (s.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: i } = r.extensionManager, l = a || s.$to.parentOffset && s.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: u, dispatch: c }) => {
            if (c && l && o) {
              const d = l.filter((f) => i.includes(f.type.name));
              u.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), PM = on.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, yt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (n, e) => ({
        ...n,
        [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((n) => vl({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
}), _M = on.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", yt(this.options.HTMLAttributes, n)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        if (!dM(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: t } = e, { $to: r } = t, s = n();
        return ap(t) ? s.insertContentAt(r.pos, {
          type: this.name
        }) : s.insertContent({ type: this.name }), s.command(({ tr: a, dispatch: o }) => {
          var i;
          if (o) {
            const { $to: l } = a.selection, u = l.end();
            if (l.nodeAfter)
              l.nodeAfter.isTextblock ? a.setSelection(Ie.create(a.doc, l.pos + 1)) : l.nodeAfter.isBlock ? a.setSelection(Me.create(a.doc, l.pos)) : a.setSelection(Ie.create(a.doc, l.pos));
            else {
              const c = (i = l.parent.type.contentMatch.defaultType) == null ? void 0 : i.create();
              c && (a.insert(u, c), a.setSelection(Ie.create(a.doc, u + 1)));
            }
            a.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      cM({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), NM = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, IM = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, RM = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, $M = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, LM = xr.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      xs({
        find: NM,
        type: this.type
      }),
      xs({
        find: RM,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Wr({
        find: IM,
        type: this.type
      }),
      Wr({
        find: $M,
        type: this.type
      })
    ];
  }
});
const BM = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", FM = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", bl = "numeric", wl = "ascii", kl = "alpha", Ws = "asciinumeric", $s = "alphanumeric", xl = "domain", Sp = "emoji", zM = "scheme", VM = "slashscheme", Li = "whitespace";
function HM(n, e) {
  return n in e || (e[n] = []), e[n];
}
function Pr(n, e, t) {
  e[bl] && (e[Ws] = !0, e[$s] = !0), e[wl] && (e[Ws] = !0, e[kl] = !0), e[Ws] && (e[$s] = !0), e[kl] && (e[$s] = !0), e[$s] && (e[xl] = !0), e[Sp] && (e[xl] = !0);
  for (const r in e) {
    const s = HM(r, t);
    s.indexOf(n) < 0 && s.push(n);
  }
}
function YM(n, e) {
  const t = {};
  for (const r in e)
    e[r].indexOf(n) >= 0 && (t[r] = !0);
  return t;
}
function Jt(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
Jt.groups = {};
Jt.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let r = 0; r < e.jr.length; r++) {
      const s = e.jr[r][0], a = e.jr[r][1];
      if (a && s.test(n))
        return a;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, r) {
    for (let s = 0; s < n.length; s++)
      this.tt(n[s], e, t, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, r) {
    r = r || Jt.groups;
    let s;
    return e && e.j ? s = e : (s = new Jt(e), t && r && Pr(e, t, r)), this.jr.push([n, s]), s;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, r) {
    let s = this;
    const a = n.length;
    if (!a)
      return s;
    for (let o = 0; o < a - 1; o++)
      s = s.tt(n[o]);
    return s.tt(n[a - 1], e, t, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, r) {
    r = r || Jt.groups;
    const s = this;
    if (e && e.j)
      return s.j[n] = e, e;
    const a = e;
    let o, i = s.go(n);
    if (i ? (o = new Jt(), Object.assign(o.j, i.j), o.jr.push.apply(o.jr, i.jr), o.jd = i.jd, o.t = i.t) : o = new Jt(), a) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const l = Object.assign(YM(o.t, r), t);
          Pr(a, l, r);
        } else t && Pr(a, t, r);
      o.t = a;
    }
    return s.j[n] = o, o;
  }
};
const Le = (n, e, t, r, s) => n.ta(e, t, r, s), it = (n, e, t, r, s) => n.tr(e, t, r, s), fd = (n, e, t, r, s) => n.ts(e, t, r, s), ae = (n, e, t, r, s) => n.tt(e, t, r, s), Fn = "WORD", Ml = "UWORD", Tp = "ASCIINUMERICAL", Cp = "ALPHANUMERICAL", ua = "LOCALHOST", Sl = "TLD", Tl = "UTLD", za = "SCHEME", ss = "SLASH_SCHEME", Su = "NUM", Cl = "WS", Tu = "NL", js = "OPENBRACE", Us = "CLOSEBRACE", oo = "OPENBRACKET", io = "CLOSEBRACKET", lo = "OPENPAREN", uo = "CLOSEPAREN", co = "OPENANGLEBRACKET", fo = "CLOSEANGLEBRACKET", ho = "FULLWIDTHLEFTPAREN", po = "FULLWIDTHRIGHTPAREN", mo = "LEFTCORNERBRACKET", go = "RIGHTCORNERBRACKET", yo = "LEFTWHITECORNERBRACKET", vo = "RIGHTWHITECORNERBRACKET", bo = "FULLWIDTHLESSTHAN", wo = "FULLWIDTHGREATERTHAN", ko = "AMPERSAND", xo = "APOSTROPHE", Mo = "ASTERISK", er = "AT", So = "BACKSLASH", To = "BACKTICK", Co = "CARET", rr = "COLON", Cu = "COMMA", Ao = "DOLLAR", Tn = "DOT", Do = "EQUALS", Au = "EXCLAMATION", cn = "HYPHEN", qs = "PERCENT", Oo = "PIPE", Eo = "PLUS", Po = "POUND", Ks = "QUERY", Du = "QUOTE", Ap = "FULLWIDTHMIDDLEDOT", Ou = "SEMI", Cn = "SLASH", Gs = "TILDE", _o = "UNDERSCORE", Dp = "EMOJI", No = "SYM";
var Op = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: Cp,
  AMPERSAND: ko,
  APOSTROPHE: xo,
  ASCIINUMERICAL: Tp,
  ASTERISK: Mo,
  AT: er,
  BACKSLASH: So,
  BACKTICK: To,
  CARET: Co,
  CLOSEANGLEBRACKET: fo,
  CLOSEBRACE: Us,
  CLOSEBRACKET: io,
  CLOSEPAREN: uo,
  COLON: rr,
  COMMA: Cu,
  DOLLAR: Ao,
  DOT: Tn,
  EMOJI: Dp,
  EQUALS: Do,
  EXCLAMATION: Au,
  FULLWIDTHGREATERTHAN: wo,
  FULLWIDTHLEFTPAREN: ho,
  FULLWIDTHLESSTHAN: bo,
  FULLWIDTHMIDDLEDOT: Ap,
  FULLWIDTHRIGHTPAREN: po,
  HYPHEN: cn,
  LEFTCORNERBRACKET: mo,
  LEFTWHITECORNERBRACKET: yo,
  LOCALHOST: ua,
  NL: Tu,
  NUM: Su,
  OPENANGLEBRACKET: co,
  OPENBRACE: js,
  OPENBRACKET: oo,
  OPENPAREN: lo,
  PERCENT: qs,
  PIPE: Oo,
  PLUS: Eo,
  POUND: Po,
  QUERY: Ks,
  QUOTE: Du,
  RIGHTCORNERBRACKET: go,
  RIGHTWHITECORNERBRACKET: vo,
  SCHEME: za,
  SEMI: Ou,
  SLASH: Cn,
  SLASH_SCHEME: ss,
  SYM: No,
  TILDE: Gs,
  TLD: Sl,
  UNDERSCORE: _o,
  UTLD: Tl,
  UWORD: Ml,
  WORD: Fn,
  WS: Cl
});
const Ln = /[a-z]/, _s = new RegExp("\\p{L}", "u"), Bi = new RegExp("\\p{Emoji}", "u"), Bn = /\d/, Fi = /\s/, hd = "\r", zi = `
`, WM = "️", jM = "‍", Vi = "￼";
let _a = null, Na = null;
function UM(n = []) {
  const e = {};
  Jt.groups = e;
  const t = new Jt();
  _a == null && (_a = pd(BM)), Na == null && (Na = pd(FM)), ae(t, "'", xo), ae(t, "{", js), ae(t, "}", Us), ae(t, "[", oo), ae(t, "]", io), ae(t, "(", lo), ae(t, ")", uo), ae(t, "<", co), ae(t, ">", fo), ae(t, "（", ho), ae(t, "）", po), ae(t, "「", mo), ae(t, "」", go), ae(t, "『", yo), ae(t, "』", vo), ae(t, "＜", bo), ae(t, "＞", wo), ae(t, "&", ko), ae(t, "*", Mo), ae(t, "@", er), ae(t, "`", To), ae(t, "^", Co), ae(t, ":", rr), ae(t, ",", Cu), ae(t, "$", Ao), ae(t, ".", Tn), ae(t, "=", Do), ae(t, "!", Au), ae(t, "-", cn), ae(t, "%", qs), ae(t, "|", Oo), ae(t, "+", Eo), ae(t, "#", Po), ae(t, "?", Ks), ae(t, '"', Du), ae(t, "/", Cn), ae(t, ";", Ou), ae(t, "~", Gs), ae(t, "_", _o), ae(t, "\\", So), ae(t, "・", Ap);
  const r = it(t, Bn, Su, {
    [bl]: !0
  });
  it(r, Bn, r);
  const s = it(r, Ln, Tp, {
    [Ws]: !0
  }), a = it(r, _s, Cp, {
    [$s]: !0
  }), o = it(t, Ln, Fn, {
    [wl]: !0
  });
  it(o, Bn, s), it(o, Ln, o), it(s, Bn, s), it(s, Ln, s);
  const i = it(t, _s, Ml, {
    [kl]: !0
  });
  it(i, Ln), it(i, Bn, a), it(i, _s, i), it(a, Bn, a), it(a, Ln), it(a, _s, a);
  const l = ae(t, zi, Tu, {
    [Li]: !0
  }), u = ae(t, hd, Cl, {
    [Li]: !0
  }), c = it(t, Fi, Cl, {
    [Li]: !0
  });
  ae(t, Vi, c), ae(u, zi, l), ae(u, Vi, c), it(u, Fi, c), ae(c, hd), ae(c, zi), it(c, Fi, c), ae(c, Vi, c);
  const d = it(t, Bi, Dp, {
    [Sp]: !0
  });
  ae(d, "#"), it(d, Bi, d), ae(d, WM, d);
  const f = ae(d, jM);
  ae(f, "#"), it(f, Bi, d);
  const h = [[Ln, o], [Bn, s]], p = [[Ln, null], [_s, i], [Bn, a]];
  for (let g = 0; g < _a.length; g++)
    Qn(t, _a[g], Sl, Fn, h);
  for (let g = 0; g < Na.length; g++)
    Qn(t, Na[g], Tl, Ml, p);
  Pr(Sl, {
    tld: !0,
    ascii: !0
  }, e), Pr(Tl, {
    utld: !0,
    alpha: !0
  }, e), Qn(t, "file", za, Fn, h), Qn(t, "mailto", za, Fn, h), Qn(t, "http", ss, Fn, h), Qn(t, "https", ss, Fn, h), Qn(t, "ftp", ss, Fn, h), Qn(t, "ftps", ss, Fn, h), Pr(za, {
    scheme: !0,
    ascii: !0
  }, e), Pr(ss, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((g, y) => g[0] > y[0] ? 1 : -1);
  for (let g = 0; g < n.length; g++) {
    const y = n[g][0], C = n[g][1] ? {
      [zM]: !0
    } : {
      [VM]: !0
    };
    y.indexOf("-") >= 0 ? C[xl] = !0 : Ln.test(y) ? Bn.test(y) ? C[Ws] = !0 : C[wl] = !0 : C[bl] = !0, fd(t, y, y, C);
  }
  return fd(t, "localhost", ua, {
    ascii: !0
  }), t.jd = new Jt(No), {
    start: t,
    tokens: Object.assign({
      groups: e
    }, Op)
  };
}
function Ep(n, e) {
  const t = qM(e.replace(/[A-Z]/g, (i) => i.toLowerCase())), r = t.length, s = [];
  let a = 0, o = 0;
  for (; o < r; ) {
    let i = n, l = null, u = 0, c = null, d = -1, f = -1;
    for (; o < r && (l = i.go(t[o])); )
      i = l, i.accepts() ? (d = 0, f = 0, c = i) : d >= 0 && (d += t[o].length, f++), u += t[o].length, a += t[o].length, o++;
    a -= d, o -= f, u -= d, s.push({
      t: c.t,
      // token type/name
      v: e.slice(a - u, a),
      // string value
      s: a - u,
      // start index
      e: a
      // end index (excluding)
    });
  }
  return s;
}
function qM(n) {
  const e = [], t = n.length;
  let r = 0;
  for (; r < t; ) {
    let s = n.charCodeAt(r), a, o = s < 55296 || s > 56319 || r + 1 === t || (a = n.charCodeAt(r + 1)) < 56320 || a > 57343 ? n[r] : n.slice(r, r + 2);
    e.push(o), r += o.length;
  }
  return e;
}
function Qn(n, e, t, r, s) {
  let a;
  const o = e.length;
  for (let i = 0; i < o - 1; i++) {
    const l = e[i];
    n.j[l] ? a = n.j[l] : (a = new Jt(r), a.jr = s.slice(), n.j[l] = a), n = a;
  }
  return a = new Jt(t), a.jr = s.slice(), n.j[e[o - 1]] = a, a;
}
function pd(n) {
  const e = [], t = [];
  let r = 0, s = "0123456789";
  for (; r < n.length; ) {
    let a = 0;
    for (; s.indexOf(n[r + a]) >= 0; )
      a++;
    if (a > 0) {
      e.push(t.join(""));
      for (let o = parseInt(n.substring(r, r + a), 10); o > 0; o--)
        t.pop();
      r += a;
    } else
      t.push(n[r]), r++;
  }
  return e;
}
const ca = {
  defaultProtocol: "http",
  events: null,
  format: md,
  formatHref: md,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Eu(n, e = null) {
  let t = Object.assign({}, ca);
  n && (t = Object.assign(t, n instanceof Eu ? n.o : n));
  const r = t.ignoreTags, s = [];
  for (let a = 0; a < r.length; a++)
    s.push(r[a].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = s;
}
Eu.prototype = {
  o: ca,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const r = e != null;
    let s = this.o[n];
    return s && (typeof s == "object" ? (s = t.t in s ? s[t.t] : ca[n], typeof s == "function" && r && (s = s(e, t))) : typeof s == "function" && r && (s = s(e, t.t, t)), s);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let r = this.o[n];
    return typeof r == "function" && e != null && (r = r(e, t.t, t)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function md(n) {
  return n;
}
function Pp(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
Pp.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), r = n.get("format", e, this);
    return t && r.length > t ? r.substring(0, t) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = ca.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), r = n.get("formatHref", t, this), s = n.get("tagName", t, e), a = this.toFormattedString(n), o = {}, i = n.get("className", t, e), l = n.get("target", t, e), u = n.get("rel", t, e), c = n.getObj("attributes", t, e), d = n.getObj("events", t, e);
    return o.href = r, i && (o.class = i), l && (o.target = l), u && (o.rel = u), c && Object.assign(o, c), {
      tagName: s,
      attributes: o,
      content: a,
      eventListeners: d
    };
  }
};
function ei(n, e) {
  class t extends Pp {
    constructor(s, a) {
      super(s, a), this.t = n;
    }
  }
  for (const r in e)
    t.prototype[r] = e[r];
  return t.t = n, t;
}
const gd = ei("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), yd = ei("text"), KM = ei("nl"), Ia = ei("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = ca.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== ua && n[1].t === rr;
  }
}), un = (n) => new Jt(n);
function GM({
  groups: n
}) {
  const e = n.domain.concat([ko, Mo, er, So, To, Co, Ao, Do, cn, Su, qs, Oo, Eo, Po, Cn, No, Gs, _o]), t = [xo, rr, Cu, Tn, Au, qs, Ks, Du, Ou, co, fo, js, Us, io, oo, lo, uo, ho, po, mo, go, yo, vo, bo, wo], r = [ko, xo, Mo, So, To, Co, Ao, Do, cn, js, Us, qs, Oo, Eo, Po, Ks, Cn, No, Gs, _o], s = un(), a = ae(s, Gs);
  Le(a, r, a), Le(a, n.domain, a);
  const o = un(), i = un(), l = un();
  Le(s, n.domain, o), Le(s, n.scheme, i), Le(s, n.slashscheme, l), Le(o, r, a), Le(o, n.domain, o);
  const u = ae(o, er);
  ae(a, er, u), ae(i, er, u), ae(l, er, u);
  const c = ae(a, Tn);
  Le(c, r, a), Le(c, n.domain, a);
  const d = un();
  Le(u, n.domain, d), Le(d, n.domain, d);
  const f = ae(d, Tn);
  Le(f, n.domain, d);
  const h = un(gd);
  Le(f, n.tld, h), Le(f, n.utld, h), ae(u, ua, h);
  const p = ae(d, cn);
  ae(p, cn, p), Le(p, n.domain, d), Le(h, n.domain, d), ae(h, Tn, f), ae(h, cn, p);
  const g = ae(h, rr);
  Le(g, n.numeric, gd);
  const y = ae(o, cn), v = ae(o, Tn);
  ae(y, cn, y), Le(y, n.domain, o), Le(v, r, a), Le(v, n.domain, o);
  const C = un(Ia);
  Le(v, n.tld, C), Le(v, n.utld, C), Le(C, n.domain, o), Le(C, r, a), ae(C, Tn, v), ae(C, cn, y), ae(C, er, u);
  const M = ae(C, rr), S = un(Ia);
  Le(M, n.numeric, S);
  const D = un(Ia), I = un();
  Le(D, e, D), Le(D, t, I), Le(I, e, D), Le(I, t, I), ae(C, Cn, D), ae(S, Cn, D);
  const x = ae(i, rr), k = ae(l, rr), _ = ae(k, Cn), E = ae(_, Cn);
  Le(i, n.domain, o), ae(i, Tn, v), ae(i, cn, y), Le(l, n.domain, o), ae(l, Tn, v), ae(l, cn, y), Le(x, n.domain, D), ae(x, Cn, D), ae(x, Ks, D), Le(E, n.domain, D), Le(E, e, D), ae(E, Cn, D);
  const ne = [
    [js, Us],
    // {}
    [oo, io],
    // []
    [lo, uo],
    // ()
    [co, fo],
    // <>
    [ho, po],
    // （）
    [mo, go],
    // 「」
    [yo, vo],
    // 『』
    [bo, wo]
    // ＜＞
  ];
  for (let de = 0; de < ne.length; de++) {
    const [be, R] = ne[de], F = ae(D, be);
    ae(I, be, F), ae(F, R, D);
    const $ = un(Ia);
    Le(F, e, $);
    const U = un();
    Le(F, t), Le($, e, $), Le($, t, U), Le(U, e, $), Le(U, t, U), ae($, R, D), ae(U, R, D);
  }
  return ae(s, ua, C), ae(s, Tu, KM), {
    start: s,
    tokens: Op
  };
}
function JM(n, e, t) {
  let r = t.length, s = 0, a = [], o = [];
  for (; s < r; ) {
    let i = n, l = null, u = null, c = 0, d = null, f = -1;
    for (; s < r && !(l = i.go(t[s].t)); )
      o.push(t[s++]);
    for (; s < r && (u = l || i.go(t[s].t)); )
      l = null, i = u, i.accepts() ? (f = 0, d = i) : f >= 0 && f++, s++, c++;
    if (f < 0)
      s -= c, s < r && (o.push(t[s]), s++);
    else {
      o.length > 0 && (a.push(Hi(yd, e, o)), o = []), s -= f, c -= f;
      const h = d.t, p = t.slice(s - c, s);
      a.push(Hi(h, e, p));
    }
  }
  return o.length > 0 && a.push(Hi(yd, e, o)), a;
}
function Hi(n, e, t) {
  const r = t[0].s, s = t[t.length - 1].e, a = e.slice(r, s);
  return new n(a, t);
}
const QM = typeof console < "u" && console && console.warn || (() => {
}), XM = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", tt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function ZM() {
  return Jt.groups = {}, tt.scanner = null, tt.parser = null, tt.tokenQueue = [], tt.pluginQueue = [], tt.customSchemes = [], tt.initialized = !1, tt;
}
function vd(n, e = !1) {
  if (tt.initialized && QM(`linkifyjs: already initialized - will not register custom scheme "${n}" ${XM}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  tt.customSchemes.push([n, e]);
}
function eS() {
  tt.scanner = UM(tt.customSchemes);
  for (let n = 0; n < tt.tokenQueue.length; n++)
    tt.tokenQueue[n][1]({
      scanner: tt.scanner
    });
  tt.parser = GM(tt.scanner.tokens);
  for (let n = 0; n < tt.pluginQueue.length; n++)
    tt.pluginQueue[n][1]({
      scanner: tt.scanner,
      parser: tt.parser
    });
  return tt.initialized = !0, tt;
}
function Pu(n) {
  return tt.initialized || eS(), JM(tt.parser.start, n, Ep(tt.scanner.start, n));
}
Pu.scan = Ep;
function _p(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const r = new Eu(t), s = Pu(n), a = [];
  for (let o = 0; o < s.length; o++) {
    const i = s[o];
    i.isLink && (!e || i.t === e) && r.check(i) && a.push(i.toFormattedObject(r));
  }
  return a;
}
var _u = "[\0-   ᠎ -\u2029 　]", tS = new RegExp(_u), nS = new RegExp(`${_u}$`), rS = new RegExp(_u, "g");
function sS(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function aS(n) {
  return new dt({
    key: new _t("autolink"),
    appendTransaction: (e, t, r) => {
      const s = e.some((u) => u.docChanged) && !t.doc.eq(r.doc), a = e.some((u) => u.getMeta("preventAutolink"));
      if (!s || a)
        return;
      const { tr: o } = r, i = Kh(t.doc, [...e]);
      if (rp(i).forEach(({ newRange: u }) => {
        const c = Ck(r.doc, u, (h) => h.isTextblock);
        let d, f;
        if (c.length > 1)
          d = c[0], f = r.doc.textBetween(
            d.pos,
            d.pos + d.node.nodeSize,
            void 0,
            " "
          );
        else if (c.length) {
          const h = r.doc.textBetween(u.from, u.to, " ", " ");
          if (!nS.test(h))
            return;
          d = c[0], f = r.doc.textBetween(d.pos, u.to, void 0, " ");
        }
        if (d && f) {
          const h = f.split(tS).filter(Boolean);
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], g = d.pos + f.lastIndexOf(p);
          if (!p)
            return !1;
          const y = Pu(p).map((v) => v.toObject(n.defaultProtocol));
          if (!sS(y))
            return !1;
          y.filter((v) => v.isLink).map((v) => ({
            ...v,
            from: g + v.start + 1,
            to: g + v.end + 1
          })).filter((v) => r.schema.marks.code ? !r.doc.rangeHasMark(v.from, v.to, r.schema.marks.code) : !0).filter((v) => n.validate(v.value)).filter((v) => n.shouldAutoLink(v.value)).forEach((v) => {
            ku(v.from, v.to, r.doc).some((C) => C.mark.type === n.type) || o.addMark(
              v.from,
              v.to,
              n.type.create({
                href: v.href
              })
            );
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function oS(n) {
  return new dt({
    key: new _t("handleClickLink"),
    props: {
      handleClick: (e, t, r) => {
        var s, a;
        if (r.button !== 0 || !e.editable)
          return !1;
        let o = null;
        if (r.target instanceof HTMLAnchorElement)
          o = r.target;
        else {
          let c = r.target;
          const d = [];
          for (; c.nodeName !== "DIV"; )
            d.push(c), c = c.parentNode;
          o = d.find((f) => f.nodeName === "A");
        }
        if (!o)
          return !1;
        const i = np(e.state, n.type.name), l = (s = o == null ? void 0 : o.href) != null ? s : i.href, u = (a = o == null ? void 0 : o.target) != null ? a : i.target;
        return n.enableClickSelection && n.editor.commands.extendMarkRange(n.type.name), o && l ? (window.open(l, u), !0) : !1;
      }
    }
  });
}
function iS(n) {
  return new dt({
    key: new _t("handlePasteLink"),
    props: {
      handlePaste: (e, t, r) => {
        const { state: s } = e, { selection: a } = s, { empty: o } = a;
        if (o)
          return !1;
        let i = "";
        r.content.forEach((u) => {
          i += u.textContent;
        });
        const l = _p(i, { defaultProtocol: n.defaultProtocol }).find(
          (u) => u.isLink && u.value === i
        );
        return !i || !l ? !1 : n.editor.commands.setMark(n.type, {
          href: l.href
        });
      }
    }
  });
}
function Sr(n, e) {
  const t = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return e && e.forEach((r) => {
    const s = typeof r == "string" ? r : r.scheme;
    s && t.push(s);
  }), !n || n.replace(rS, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var lS = xr.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        vd(n);
        return;
      }
      vd(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    ZM();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!Sr(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!Sr(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!Sr(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", yt(this.options.HTMLAttributes, n), 0] : ["a", yt(this.options.HTMLAttributes, { ...n, href: "" }), 0];
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!Sr(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n || {};
        return t && !this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!Sr(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Wr({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: r } = this.options, s = _p(n).filter(
              (a) => a.isLink && this.options.isAllowedUri(a.value, {
                defaultValidate: (o) => !!Sr(o, t),
                protocols: t,
                defaultProtocol: r
              })
            );
            s.length && s.forEach(
              (a) => e.push({
                text: a.value,
                data: {
                  href: a.href
                },
                index: a.start
              })
            );
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) == null ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(
      aS({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (r) => this.options.isAllowedUri(r, {
          defaultValidate: (s) => !!Sr(s, e),
          protocols: e,
          defaultProtocol: t
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), this.options.openOnClick === !0 && n.push(
      oS({
        type: this.type,
        editor: this.editor,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && n.push(
      iS({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type
      })
    ), n;
  }
}), uS = Object.defineProperty, cS = (n, e) => {
  for (var t in e)
    uS(n, t, { get: e[t], enumerable: !0 });
}, dS = "listItem", bd = "textStyle", wd = /^\s*([-+*])\s$/, Np = on.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(dS, this.editor.getAttributes(bd)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = Ms({
      find: wd,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Ms({
      find: wd,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(bd),
      editor: this.editor
    })), [n];
  }
}), Ip = on.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", yt(this.options.HTMLAttributes, n), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), fS = {};
cS(fS, {
  findListItemPos: () => wa,
  getNextListDepth: () => Nu,
  handleBackspace: () => Al,
  handleDelete: () => Dl,
  hasListBefore: () => Rp,
  hasListItemAfter: () => hS,
  hasListItemBefore: () => $p,
  listItemHasSubList: () => Lp,
  nextListIsDeeper: () => Bp,
  nextListIsHigher: () => Fp
});
var wa = (n, e) => {
  const { $from: t } = e.selection, r = xt(n, e.schema);
  let s = null, a = t.depth, o = t.pos, i = null;
  for (; a > 0 && i === null; )
    s = t.node(a), s.type === r ? i = a : (a -= 1, o -= 1);
  return i === null ? null : { $pos: e.doc.resolve(o), depth: i };
}, Nu = (n, e) => {
  const t = wa(n, e);
  if (!t)
    return !1;
  const [, r] = $k(e, n, t.$pos.pos + 4);
  return r;
}, Rp = (n, e, t) => {
  const { $anchor: r } = n.selection, s = Math.max(0, r.pos - 2), a = n.doc.resolve(s).node();
  return !(!a || !t.includes(a.type.name));
}, $p = (n, e) => {
  var t;
  const { $anchor: r } = e.selection, s = e.doc.resolve(r.pos - 2);
  return !(s.index() === 0 || ((t = s.nodeBefore) == null ? void 0 : t.type.name) !== n);
}, Lp = (n, e, t) => {
  if (!t)
    return !1;
  const r = xt(n, e.schema);
  let s = !1;
  return t.descendants((a) => {
    a.type === r && (s = !0);
  }), s;
}, Al = (n, e, t) => {
  if (n.commands.undoInputRule())
    return !0;
  if (n.state.selection.from !== n.state.selection.to)
    return !1;
  if (!yr(n.state, e) && Rp(n.state, e, t)) {
    const { $anchor: i } = n.state.selection, l = n.state.doc.resolve(i.before() - 1), u = [];
    l.node().descendants((f, h) => {
      f.type.name === e && u.push({ node: f, pos: h });
    });
    const c = u.at(-1);
    if (!c)
      return !1;
    const d = n.state.doc.resolve(l.start() + c.pos + 1);
    return n.chain().cut({ from: i.start() - 1, to: i.end() + 1 }, d.end()).joinForward().run();
  }
  if (!yr(n.state, e) || !zk(n.state))
    return !1;
  const r = wa(e, n.state);
  if (!r)
    return !1;
  const a = n.state.doc.resolve(r.$pos.pos - 2).node(r.depth), o = Lp(e, n.state, a);
  return $p(e, n.state) && !o ? n.commands.joinItemBackward() : n.chain().liftListItem(e).run();
}, Bp = (n, e) => {
  const t = Nu(n, e), r = wa(n, e);
  return !r || !t ? !1 : t > r.depth;
}, Fp = (n, e) => {
  const t = Nu(n, e), r = wa(n, e);
  return !r || !t ? !1 : t < r.depth;
}, Dl = (n, e) => {
  if (!yr(n.state, e) || !Fk(n.state, e))
    return !1;
  const { selection: t } = n.state, { $from: r, $to: s } = t;
  return !t.empty && r.sameParent(s) ? !1 : Bp(e, n.state) ? n.chain().focus(n.state.selection.from + 4).lift(e).joinBackward().run() : Fp(e, n.state) ? n.chain().joinForward().joinBackward().run() : n.commands.joinItemForward();
}, hS = (n, e) => {
  var t;
  const { $anchor: r } = e.selection, s = e.doc.resolve(r.pos - r.parentOffset - 2);
  return !(s.index() === s.parent.childCount - 1 || ((t = s.nodeAfter) == null ? void 0 : t.type.name) !== n);
}, zp = Je.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          n.state.schema.nodes[t] !== void 0 && Dl(n, t) && (e = !0);
        }), e;
      },
      "Mod-Delete": ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          n.state.schema.nodes[t] !== void 0 && Dl(n, t) && (e = !0);
        }), e;
      },
      Backspace: ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: r }) => {
          n.state.schema.nodes[t] !== void 0 && Al(n, t, r) && (e = !0);
        }), e;
      },
      "Mod-Backspace": ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: r }) => {
          n.state.schema.nodes[t] !== void 0 && Al(n, t, r) && (e = !0);
        }), e;
      }
    };
  }
}), pS = "listItem", kd = "textStyle", xd = /^(\d+)\.\s$/, Vp = on.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", yt(this.options.HTMLAttributes, t), 0] : ["ol", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(pS, this.editor.getAttributes(kd)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = Ms({
      find: xd,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = Ms({
      find: xd,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(kd) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [n];
  }
}), mS = /^\s*(\[([( |x])?\])\s$/, gS = on.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (n) => {
          const e = n.getAttribute("data-checked");
          return e === "" || e === "true";
        },
        renderHTML: (n) => ({
          "data-checked": n.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "li",
      yt(this.options.HTMLAttributes, e, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: n.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  addKeyboardShortcuts() {
    const n = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...n,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : n;
  },
  addNodeView() {
    return ({ node: n, HTMLAttributes: e, getPos: t, editor: r }) => {
      const s = document.createElement("li"), a = document.createElement("label"), o = document.createElement("span"), i = document.createElement("input"), l = document.createElement("div"), u = (c) => {
        var d, f;
        i.ariaLabel = ((f = (d = this.options.a11y) == null ? void 0 : d.checkboxLabel) == null ? void 0 : f.call(d, c, i.checked)) || `Task item checkbox for ${c.textContent || "empty task item"}`;
      };
      return u(n), a.contentEditable = "false", i.type = "checkbox", i.addEventListener("mousedown", (c) => c.preventDefault()), i.addEventListener("change", (c) => {
        if (!r.isEditable && !this.options.onReadOnlyChecked) {
          i.checked = !i.checked;
          return;
        }
        const { checked: d } = c.target;
        r.isEditable && typeof t == "function" && r.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: f }) => {
          const h = t();
          if (typeof h != "number")
            return !1;
          const p = f.doc.nodeAt(h);
          return f.setNodeMarkup(h, void 0, {
            ...p == null ? void 0 : p.attrs,
            checked: d
          }), !0;
        }).run(), !r.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(n, d) || (i.checked = !i.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([c, d]) => {
        s.setAttribute(c, d);
      }), s.dataset.checked = n.attrs.checked, i.checked = n.attrs.checked, a.append(i, o), s.append(a, l), Object.entries(e).forEach(([c, d]) => {
        s.setAttribute(c, d);
      }), {
        dom: s,
        contentDOM: l,
        update: (c) => c.type !== this.type ? !1 : (s.dataset.checked = c.attrs.checked, i.checked = c.attrs.checked, u(c), !0)
      };
    };
  },
  addInputRules() {
    return [
      Ms({
        find: mS,
        type: this.type,
        getAttributes: (n) => ({
          checked: n[n.length - 1] === "x"
        })
      })
    ];
  }
}), yS = on.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", yt(this.options.HTMLAttributes, n, { "data-type": this.name }), 0];
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: n }) => n.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
Je.create({
  name: "listKit",
  addExtensions() {
    const n = [];
    return this.options.bulletList !== !1 && n.push(Np.configure(this.options.bulletList)), this.options.listItem !== !1 && n.push(Ip.configure(this.options.listItem)), this.options.listKeymap !== !1 && n.push(zp.configure(this.options.listKeymap)), this.options.orderedList !== !1 && n.push(Vp.configure(this.options.orderedList)), this.options.taskItem !== !1 && n.push(gS.configure(this.options.taskItem)), this.options.taskList !== !1 && n.push(yS.configure(this.options.taskList)), n;
  }
});
var vS = on.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), bS = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, wS = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, kS = xr.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      xs({
        find: bS,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Wr({
        find: wS,
        type: this.type
      })
    ];
  }
}), xS = on.create({
  name: "text",
  group: "inline"
}), MS = xr.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function SS(n = {}) {
  return new dt({
    view(e) {
      return new TS(e, n);
    }
  });
}
class TS {
  constructor(e, t) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = t.width) !== null && r !== void 0 ? r : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((s) => {
      let a = (o) => {
        this[s](o);
      };
      return e.dom.addEventListener(s, a), { name: s, handler: a };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, r, s = this.editorView.dom, a = s.getBoundingClientRect(), o = a.width / s.offsetWidth, i = a.height / s.offsetHeight;
    if (t) {
      let d = e.nodeBefore, f = e.nodeAfter;
      if (d || f) {
        let h = this.editorView.nodeDOM(this.cursorPos - (d ? d.nodeSize : 0));
        if (h) {
          let p = h.getBoundingClientRect(), g = d ? p.bottom : p.top;
          d && f && (g = (g + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let y = this.width / 2 * i;
          r = { left: p.left, right: p.right, top: g - y, bottom: g + y };
        }
      }
    }
    if (!r) {
      let d = this.editorView.coordsAtPos(this.cursorPos), f = this.width / 2 * o;
      r = { left: d.left - f, right: d.left + f, top: d.top, bottom: d.bottom };
    }
    let l = this.editorView.dom.offsetParent;
    this.element || (this.element = l.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let u, c;
    if (!l || l == document.body && getComputedStyle(l).position == "static")
      u = -pageXOffset, c = -pageYOffset;
    else {
      let d = l.getBoundingClientRect(), f = d.width / l.offsetWidth, h = d.height / l.offsetHeight;
      u = d.left - l.scrollLeft * f, c = d.top - l.scrollTop * h;
    }
    this.element.style.left = (r.left - u) / o + "px", this.element.style.top = (r.top - c) / i + "px", this.element.style.width = (r.right - r.left) / o + "px", this.element.style.height = (r.bottom - r.top) / i + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), s = r && r.type.spec.disableDropCursor, a = typeof s == "function" ? s(this.editorView, t, e) : s;
    if (t && !a) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let i = Uf(this.editorView.state.doc, o, this.editorView.dragging.slice);
        i != null && (o = i);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
class ut extends $e {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    return ut.valid(r) ? new ut(r) : $e.near(r);
  }
  content() {
    return me.empty;
  }
  eq(e) {
    return e instanceof ut && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new ut(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Iu(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !CS(e) || !AS(e))
      return !1;
    let r = t.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let s = t.contentMatchAt(e.index()).defaultType;
    return s && s.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, r = !1) {
    e: for (; ; ) {
      if (!r && ut.valid(e))
        return e;
      let s = e.pos, a = null;
      for (let o = e.depth; ; o--) {
        let i = e.node(o);
        if (t > 0 ? e.indexAfter(o) < i.childCount : e.index(o) > 0) {
          a = i.child(t > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        s += t;
        let l = e.doc.resolve(s);
        if (ut.valid(l))
          return l;
      }
      for (; ; ) {
        let o = t > 0 ? a.firstChild : a.lastChild;
        if (!o) {
          if (a.isAtom && !a.isText && !Me.isSelectable(a)) {
            e = e.doc.resolve(s + a.nodeSize * t), r = !1;
            continue e;
          }
          break;
        }
        a = o, s += t;
        let i = e.doc.resolve(s);
        if (ut.valid(i))
          return i;
      }
      return null;
    }
  }
}
ut.prototype.visible = !1;
ut.findFrom = ut.findGapCursorFrom;
$e.jsonID("gapcursor", ut);
class Iu {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Iu(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return ut.valid(t) ? new ut(t) : $e.near(t);
  }
}
function CS(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), r = n.node(e);
    if (t == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let s = r.child(t - 1); ; s = s.lastChild) {
      if (s.childCount == 0 && !s.inlineContent || s.isAtom || s.type.spec.isolating)
        return !0;
      if (s.inlineContent)
        return !1;
    }
  }
  return !0;
}
function AS(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), r = n.node(e);
    if (t == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let s = r.child(t); ; s = s.firstChild) {
      if (s.childCount == 0 && !s.inlineContent || s.isAtom || s.type.spec.isolating)
        return !0;
      if (s.inlineContent)
        return !1;
    }
  }
  return !0;
}
function DS() {
  return new dt({
    props: {
      decorations: _S,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && ut.valid(t) ? new ut(t) : null;
      },
      handleClick: ES,
      handleKeyDown: OS,
      handleDOMEvents: { beforeinput: PS }
    }
  });
}
const OS = Ih({
  ArrowLeft: Ra("horiz", -1),
  ArrowRight: Ra("horiz", 1),
  ArrowUp: Ra("vert", -1),
  ArrowDown: Ra("vert", 1)
});
function Ra(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, s, a) {
    let o = r.selection, i = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof Ie) {
      if (!a.endOfTextblock(t) || i.depth == 0)
        return !1;
      l = !1, i = r.doc.resolve(e > 0 ? i.after() : i.before());
    }
    let u = ut.findGapCursorFrom(i, e, l);
    return u ? (s && s(r.tr.setSelection(new ut(u))), !0) : !1;
  };
}
function ES(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let r = n.state.doc.resolve(e);
  if (!ut.valid(r))
    return !1;
  let s = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return s && s.inside > -1 && Me.isSelectable(n.state.doc.nodeAt(s.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new ut(r))), !0);
}
function PS(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof ut))
    return !1;
  let { $from: t } = n.state.selection, r = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!r)
    return !1;
  let s = te.empty;
  for (let o = r.length - 1; o >= 0; o--)
    s = te.from(r[o].createAndFill(null, s));
  let a = n.state.tr.replace(t.pos, t.pos, new me(s, 0, 0));
  return a.setSelection(Ie.near(a.doc.resolve(t.pos + 1))), n.dispatch(a), !1;
}
function _S(n) {
  if (!(n.selection instanceof ut))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", at.create(n.doc, [Ut.widget(n.selection.head, e, { key: "gapcursor" })]);
}
var Io = 200, Dt = function() {
};
Dt.prototype.append = function(e) {
  return e.length ? (e = Dt.from(e), !this.length && e || e.length < Io && this.leafAppend(e) || this.length < Io && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Dt.prototype.prepend = function(e) {
  return e.length ? Dt.from(e).append(this) : this;
};
Dt.prototype.appendInner = function(e) {
  return new NS(this, e);
};
Dt.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Dt.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Dt.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Dt.prototype.forEach = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length), t <= r ? this.forEachInner(e, t, r, 0) : this.forEachInvertedInner(e, t, r, 0);
};
Dt.prototype.map = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length);
  var s = [];
  return this.forEach(function(a, o) {
    return s.push(e(a, o));
  }, t, r), s;
};
Dt.from = function(e) {
  return e instanceof Dt ? e : e && e.length ? new Hp(e) : Dt.empty;
};
var Hp = /* @__PURE__ */ (function(n) {
  function e(r) {
    n.call(this), this.values = r;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(s, a) {
    return s == 0 && a == this.length ? this : new e(this.values.slice(s, a));
  }, e.prototype.getInner = function(s) {
    return this.values[s];
  }, e.prototype.forEachInner = function(s, a, o, i) {
    for (var l = a; l < o; l++)
      if (s(this.values[l], i + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(s, a, o, i) {
    for (var l = a - 1; l >= o; l--)
      if (s(this.values[l], i + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(s) {
    if (this.length + s.length <= Io)
      return new e(this.values.concat(s.flatten()));
  }, e.prototype.leafPrepend = function(s) {
    if (this.length + s.length <= Io)
      return new e(s.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
})(Dt);
Dt.empty = new Hp([]);
var NS = /* @__PURE__ */ (function(n) {
  function e(t, r) {
    n.call(this), this.left = t, this.right = r, this.length = t.length + r.length, this.depth = Math.max(t.depth, r.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, s, a, o) {
    var i = this.left.length;
    if (s < i && this.left.forEachInner(r, s, Math.min(a, i), o) === !1 || a > i && this.right.forEachInner(r, Math.max(s - i, 0), Math.min(this.length, a) - i, o + i) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, s, a, o) {
    var i = this.left.length;
    if (s > i && this.right.forEachInvertedInner(r, s - i, Math.max(a, i) - i, o + i) === !1 || a < i && this.left.forEachInvertedInner(r, Math.min(s, i), a, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, s) {
    if (r == 0 && s == this.length)
      return this;
    var a = this.left.length;
    return s <= a ? this.left.slice(r, s) : r >= a ? this.right.slice(r - a, s - a) : this.left.slice(r, a).append(this.right.slice(0, s - a));
  }, e.prototype.leafAppend = function(r) {
    var s = this.right.leafAppend(r);
    if (s)
      return new e(this.left, s);
  }, e.prototype.leafPrepend = function(r) {
    var s = this.left.leafPrepend(r);
    if (s)
      return new e(s, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
})(Dt);
const IS = 500;
class vn {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let s, a;
    t && (s = this.remapping(r, this.items.length), a = s.maps.length);
    let o = e.tr, i, l, u = [], c = [];
    return this.items.forEach((d, f) => {
      if (!d.step) {
        s || (s = this.remapping(r, f + 1), a = s.maps.length), a--, c.push(d);
        return;
      }
      if (s) {
        c.push(new An(d.map));
        let h = d.step.map(s.slice(a)), p;
        h && o.maybeStep(h).doc && (p = o.mapping.maps[o.mapping.maps.length - 1], u.push(new An(p, void 0, void 0, u.length + c.length))), a--, p && s.appendMap(p, a);
      } else
        o.maybeStep(d.step);
      if (d.selection)
        return i = s ? d.selection.map(s.slice(a)) : d.selection, l = new vn(this.items.slice(0, r).append(c.reverse().concat(u)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: i };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, r, s) {
    let a = [], o = this.eventCount, i = this.items, l = !s && i.length ? i.get(i.length - 1) : null;
    for (let c = 0; c < e.steps.length; c++) {
      let d = e.steps[c].invert(e.docs[c]), f = new An(e.mapping.maps[c], d, t), h;
      (h = l && l.merge(f)) && (f = h, c ? a.pop() : i = i.slice(0, i.length - 1)), a.push(f), t && (o++, t = void 0), s || (l = f);
    }
    let u = o - r.depth;
    return u > $S && (i = RS(i, u), o -= u), new vn(i.append(a), o);
  }
  remapping(e, t) {
    let r = new na();
    return this.items.forEach((s, a) => {
      let o = s.mirrorOffset != null && a - s.mirrorOffset >= e ? r.maps.length - s.mirrorOffset : void 0;
      r.appendMap(s.map, o);
    }, e, t), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new vn(this.items.append(e.map((t) => new An(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let r = [], s = Math.max(0, this.items.length - t), a = e.mapping, o = e.steps.length, i = this.eventCount;
    this.items.forEach((f) => {
      f.selection && i--;
    }, s);
    let l = t;
    this.items.forEach((f) => {
      let h = a.getMirror(--l);
      if (h == null)
        return;
      o = Math.min(o, h);
      let p = a.maps[h];
      if (f.step) {
        let g = e.steps[h].invert(e.docs[h]), y = f.selection && f.selection.map(a.slice(l + 1, h));
        y && i++, r.push(new An(p, g, y));
      } else
        r.push(new An(p));
    }, s);
    let u = [];
    for (let f = t; f < o; f++)
      u.push(new An(a.maps[f]));
    let c = this.items.slice(0, s).append(u).append(r), d = new vn(c, i);
    return d.emptyItemCount() > IS && (d = d.compress(this.items.length - r.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), r = t.maps.length, s = [], a = 0;
    return this.items.forEach((o, i) => {
      if (i >= e)
        s.push(o), o.selection && a++;
      else if (o.step) {
        let l = o.step.map(t.slice(r)), u = l && l.getMap();
        if (r--, u && t.appendMap(u, r), l) {
          let c = o.selection && o.selection.map(t.slice(r));
          c && a++;
          let d = new An(u.invert(), l, c), f, h = s.length - 1;
          (f = s.length && s[h].merge(d)) ? s[h] = f : s.push(d);
        }
      } else o.map && r--;
    }, this.items.length, 0), new vn(Dt.from(s.reverse()), a);
  }
}
vn.empty = new vn(Dt.empty, 0);
function RS(n, e) {
  let t;
  return n.forEach((r, s) => {
    if (r.selection && e-- == 0)
      return t = s, !1;
  }), n.slice(t);
}
class An {
  constructor(e, t, r, s) {
    this.map = e, this.step = t, this.selection = r, this.mirrorOffset = s;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new An(t.getMap().invert(), t, this.selection);
    }
  }
}
class tr {
  constructor(e, t, r, s, a) {
    this.done = e, this.undone = t, this.prevRanges = r, this.prevTime = s, this.prevComposition = a;
  }
}
const $S = 20;
function LS(n, e, t, r) {
  let s = t.getMeta(Br), a;
  if (s)
    return s.historyState;
  t.getMeta(zS) && (n = new tr(n.done, n.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (o && o.getMeta(Br))
    return o.getMeta(Br).redo ? new tr(n.done.addTransform(t, void 0, r, Va(e)), n.undone, Md(t.mapping.maps), n.prevTime, n.prevComposition) : new tr(n.done, n.undone.addTransform(t, void 0, r, Va(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let i = t.getMeta("composition"), l = n.prevTime == 0 || !o && n.prevComposition != i && (n.prevTime < (t.time || 0) - r.newGroupDelay || !BS(t, n.prevRanges)), u = o ? Yi(n.prevRanges, t.mapping) : Md(t.mapping.maps);
    return new tr(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, r, Va(e)), vn.empty, u, t.time, i ?? n.prevComposition);
  } else return (a = t.getMeta("rebased")) ? new tr(n.done.rebased(t, a), n.undone.rebased(t, a), Yi(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new tr(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), Yi(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function BS(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((r, s) => {
    for (let a = 0; a < e.length; a += 2)
      r <= e[a + 1] && s >= e[a] && (t = !0);
  }), t;
}
function Md(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((r, s, a, o) => e.push(a, o));
  return e;
}
function Yi(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let r = 0; r < n.length; r += 2) {
    let s = e.map(n[r], 1), a = e.map(n[r + 1], -1);
    s <= a && t.push(s, a);
  }
  return t;
}
function FS(n, e, t) {
  let r = Va(e), s = Br.get(e).spec.config, a = (t ? n.undone : n.done).popEvent(e, r);
  if (!a)
    return null;
  let o = a.selection.resolve(a.transform.doc), i = (t ? n.done : n.undone).addTransform(a.transform, e.selection.getBookmark(), s, r), l = new tr(t ? i : a.remaining, t ? a.remaining : i, null, 0, -1);
  return a.transform.setSelection(o).setMeta(Br, { redo: t, historyState: l });
}
let Wi = !1, Sd = null;
function Va(n) {
  let e = n.plugins;
  if (Sd != e) {
    Wi = !1, Sd = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        Wi = !0;
        break;
      }
  }
  return Wi;
}
const Br = new _t("history"), zS = new _t("closeHistory");
function VS(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new dt({
    key: Br,
    state: {
      init() {
        return new tr(vn.empty, vn.empty, null, 0, -1);
      },
      apply(e, t, r) {
        return LS(t, r, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let r = t.inputType, s = r == "historyUndo" ? Wp : r == "historyRedo" ? jp : null;
          return s ? (t.preventDefault(), s(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function Yp(n, e) {
  return (t, r) => {
    let s = Br.getState(t);
    if (!s || (n ? s.undone : s.done).eventCount == 0)
      return !1;
    if (r) {
      let a = FS(s, t, n);
      a && r(e ? a.scrollIntoView() : a);
    }
    return !0;
  };
}
const Wp = Yp(!1, !0), jp = Yp(!0, !0);
var HS = Je.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (n) => n.length,
      wordCounter: (n) => n.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (n) => {
      const e = (n == null ? void 0 : n.node) || this.editor.state.doc;
      if (((n == null ? void 0 : n.mode) || this.options.mode) === "textSize") {
        const r = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(r);
      }
      return e.nodeSize;
    }, this.storage.words = (n) => {
      const e = (n == null ? void 0 : n.node) || this.editor.state.doc, t = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let n = !1;
    return [
      new dt({
        key: new _t("characterCount"),
        appendTransaction: (e, t, r) => {
          if (n)
            return;
          const s = this.options.limit;
          if (s == null || s === 0) {
            n = !0;
            return;
          }
          const a = this.storage.characters({ node: r.doc });
          if (a > s) {
            const o = a - s, i = 0, l = o;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${s} characters. Content was automatically trimmed.`
            );
            const u = r.tr.deleteRange(i, l);
            return n = !0, u;
          }
          n = !0;
        },
        filterTransaction: (e, t) => {
          const r = this.options.limit;
          if (!e.docChanged || r === 0 || r === null || r === void 0)
            return !0;
          const s = this.storage.characters({ node: t.doc }), a = this.storage.characters({ node: e.doc });
          if (a <= r || s > r && a > r && a <= s)
            return !0;
          if (s > r && a > r && a > s || !e.getMeta("paste"))
            return !1;
          const i = e.selection.$head.pos, l = a - r, u = i - l, c = i;
          return e.deleteRange(u, c), !(this.storage.characters({ node: e.doc }) > r);
        }
      })
    ];
  }
}), YS = Je.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [SS(this.options)];
  }
});
Je.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new dt({
        key: new _t("focus"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const { isEditable: t, isFocused: r } = this.editor, { anchor: s } = e, a = [];
            if (!t || !r)
              return at.create(n, []);
            let o = 0;
            this.options.mode === "deepest" && n.descendants((l, u) => {
              if (l.isText)
                return;
              if (!(s >= u && s <= u + l.nodeSize - 1))
                return !1;
              o += 1;
            });
            let i = 0;
            return n.descendants((l, u) => {
              if (l.isText || !(s >= u && s <= u + l.nodeSize - 1))
                return !1;
              if (i += 1, this.options.mode === "deepest" && o - i > 0 || this.options.mode === "shallowest" && i > 1)
                return this.options.mode === "deepest";
              a.push(
                Ut.node(u, u + l.nodeSize, {
                  class: this.options.className
                })
              );
            }), at.create(n, a);
          }
        }
      })
    ];
  }
});
var WS = Je.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [DS()];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = je(xe(n, "allowGapCursor", t))) != null ? e : null
    };
  }
});
Je.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new dt({
        key: new _t("placeholder"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const t = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = e, s = [];
            if (!t)
              return null;
            const a = this.editor.isEmpty;
            return n.descendants((o, i) => {
              const l = r >= i && r <= i + o.nodeSize, u = !o.isLeaf && Qo(o);
              if ((l || !this.options.showOnlyCurrent) && u) {
                const c = [this.options.emptyNodeClass];
                a && c.push(this.options.emptyEditorClass);
                const d = Ut.node(i, i + o.nodeSize, {
                  class: c.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: o,
                    pos: i,
                    hasAnchor: l
                  }) : this.options.placeholder
                });
                s.push(d);
              }
              return this.options.includeChildren;
            }), at.create(n, s);
          }
        }
      })
    ];
  }
});
Je.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: n, options: e } = this;
    return [
      new dt({
        key: new _t("selection"),
        props: {
          decorations(t) {
            return t.selection.empty || n.isFocused || !n.isEditable || ap(t.selection) || n.view.dragging ? null : at.create(t.doc, [
              Ut.inline(t.selection.from, t.selection.to, {
                class: e.className
              })
            ]);
          }
        }
      })
    ];
  }
});
function Td({ types: n, node: e }) {
  return e && Array.isArray(n) && n.includes(e.type) || (e == null ? void 0 : e.type) === n;
}
var jS = Je.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var n;
    const e = new _t(this.name), t = ((n = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : n.name) || this.options.node || "paragraph", r = Object.entries(this.editor.schema.nodes).map(([, s]) => s).filter((s) => (this.options.notAfter || []).concat(t).includes(s.name));
    return [
      new dt({
        key: e,
        appendTransaction: (s, a, o) => {
          const { doc: i, tr: l, schema: u } = o, c = e.getState(o), d = i.content.size, f = u.nodes[t];
          if (c)
            return l.insert(d, f.create());
        },
        state: {
          init: (s, a) => {
            const o = a.tr.doc.lastChild;
            return !Td({ node: o, types: r });
          },
          apply: (s, a) => {
            if (!s.docChanged || s.getMeta("__uniqueIDTransaction"))
              return a;
            const o = s.doc.lastChild;
            return !Td({ node: o, types: r });
          }
        }
      })
    ];
  }
}), US = Je.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => Wp(n, e),
      redo: () => ({ state: n, dispatch: e }) => jp(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [VS(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), qS = Je.create({
  name: "starterKit",
  addExtensions() {
    var n, e, t, r;
    const s = [];
    return this.options.bold !== !1 && s.push(xM.configure(this.options.bold)), this.options.blockquote !== !1 && s.push(yM.configure(this.options.blockquote)), this.options.bulletList !== !1 && s.push(Np.configure(this.options.bulletList)), this.options.code !== !1 && s.push(TM.configure(this.options.code)), this.options.codeBlock !== !1 && s.push(DM.configure(this.options.codeBlock)), this.options.document !== !1 && s.push(OM.configure(this.options.document)), this.options.dropcursor !== !1 && s.push(YS.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && s.push(WS.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && s.push(EM.configure(this.options.hardBreak)), this.options.heading !== !1 && s.push(PM.configure(this.options.heading)), this.options.undoRedo !== !1 && s.push(US.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && s.push(_M.configure(this.options.horizontalRule)), this.options.italic !== !1 && s.push(LM.configure(this.options.italic)), this.options.listItem !== !1 && s.push(Ip.configure(this.options.listItem)), this.options.listKeymap !== !1 && s.push(zp.configure((n = this.options) == null ? void 0 : n.listKeymap)), this.options.link !== !1 && s.push(lS.configure((e = this.options) == null ? void 0 : e.link)), this.options.orderedList !== !1 && s.push(Vp.configure(this.options.orderedList)), this.options.paragraph !== !1 && s.push(vS.configure(this.options.paragraph)), this.options.strike !== !1 && s.push(kS.configure(this.options.strike)), this.options.text !== !1 && s.push(xS.configure(this.options.text)), this.options.underline !== !1 && s.push(MS.configure((t = this.options) == null ? void 0 : t.underline)), this.options.trailingNode !== !1 && s.push(jS.configure((r = this.options) == null ? void 0 : r.trailingNode)), s;
  }
}), KS = qS, GS = Je.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (n) => {
              const e = n.style.textAlign;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (n) => n.textAlign ? { style: `text-align: ${n.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (n) => ({ commands: e }) => this.options.alignments.includes(n) ? this.options.types.map((t) => e.updateAttributes(t, { textAlign: n })).every((t) => t) : !1,
      unsetTextAlign: () => ({ commands: n }) => this.options.types.map((e) => n.resetAttributes(e, "textAlign")).every((e) => e),
      toggleTextAlign: (n) => ({ editor: e, commands: t }) => this.options.alignments.includes(n) ? e.isActive({ textAlign: n }) ? t.unsetTextAlign() : t.setTextAlign(n) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), JS = GS, QS = (n) => {
  if (!n.children.length)
    return;
  const e = n.querySelectorAll("span");
  e && e.forEach((t) => {
    var r, s;
    const a = t.getAttribute("style"), o = (s = (r = t.parentElement) == null ? void 0 : r.closest("span")) == null ? void 0 : s.getAttribute("style");
    t.setAttribute("style", `${o};${a}`);
  });
}, Up = xr.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (n) => n.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && QS(n), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", yt(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (n) => ({ commands: e }) => e.toggleMark(this.name, n),
      removeEmptyTextStyle: () => ({ tr: n }) => {
        const { selection: e } = n;
        return n.doc.nodesBetween(e.from, e.to, (t, r) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((s) => s.type === this.type).some((s) => Object.values(s.attrs).some((a) => !!a)) || n.removeMark(r, r + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), qp = Je.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (n) => {
              var e;
              return (e = n.style.backgroundColor) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.backgroundColor ? {
              style: `background-color: ${n.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (n) => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: n }).run(),
      unsetBackgroundColor: () => ({ chain: n }) => n().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), Kp = Je.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (n) => {
              var e;
              return (e = n.style.color) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.color ? {
              style: `color: ${n.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (n) => ({ chain: e }) => e().setMark("textStyle", { color: n }).run(),
      unsetColor: () => ({ chain: n }) => n().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), XS = Je.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (n) => n.style.fontFamily,
            renderHTML: (n) => n.fontFamily ? {
              style: `font-family: ${n.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (n) => ({ chain: e }) => e().setMark("textStyle", { fontFamily: n }).run(),
      unsetFontFamily: () => ({ chain: n }) => n().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), ZS = Je.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (n) => n.style.fontSize,
            renderHTML: (n) => n.fontSize ? {
              style: `font-size: ${n.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (n) => ({ chain: e }) => e().setMark("textStyle", { fontSize: n }).run(),
      unsetFontSize: () => ({ chain: n }) => n().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), eT = Je.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            parseHTML: (n) => n.style.lineHeight,
            renderHTML: (n) => n.lineHeight ? {
              style: `line-height: ${n.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (n) => ({ chain: e }) => e().setMark("textStyle", { lineHeight: n }).run(),
      unsetLineHeight: () => ({ chain: n }) => n().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run()
    };
  }
});
Je.create({
  name: "textStyleKit",
  addExtensions() {
    const n = [];
    return this.options.backgroundColor !== !1 && n.push(qp.configure(this.options.backgroundColor)), this.options.color !== !1 && n.push(Kp.configure(this.options.color)), this.options.fontFamily !== !1 && n.push(XS.configure(this.options.fontFamily)), this.options.fontSize !== !1 && n.push(ZS.configure(this.options.fontSize)), this.options.lineHeight !== !1 && n.push(eT.configure(this.options.lineHeight)), this.options.textStyle !== !1 && n.push(Up.configure(this.options.textStyle)), n;
  }
});
const tT = { class: "border border-mid-neutral-50 rounded-lg bg-light-neutral-200" }, nT = { class: "divide-x divide-slate-200 flex items-center" }, rT = ["onClick"], sT = { class: "flex flex-col min-w-30 text-black" }, aT = ["onClick"], oT = ["onClick"], iT = ["onClick"], lT = ["onClick"], uT = { class: "flex items-center px-2" }, cT = ["onClick"], dT = { class: "flex flex-wrap gap-1 p-2 w-45 bg-white" }, fT = ["onClick"], hT = ["onClick"], pT = ["onClick"], mT = { class: "flex flex-wrap gap-1 p-2 w-45 bg-white" }, gT = ["onClick"], yT = ["onClick"], vT = { class: "flex items-center px-2" }, bT = { class: "flex items-center px-2" }, wT = { class: "px-5 py-3 bg-white border-mid-neutral-50 border-y" }, kT = { class: "p-4 flex justify-between" }, FC = /* @__PURE__ */ Fe({
  __name: "Editor",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(n) {
    function e(i) {
      a.value && (i ? a.value.chain().focus().setBackgroundColor(i).run() : a.value.chain().focus().unsetBackgroundColor().run());
    }
    const t = [
      "#000000",
      "#e60000",
      "#ff9900",
      "#ffff00",
      "#008a00",
      "#0066cc",
      "#9933ff",
      "#ffffff",
      "#facccc",
      "#ffebcc",
      "#ffffcc",
      "#cce8cc",
      "#cce0f5",
      "#ebd6ff",
      "#bbbbbb",
      "#f06666",
      "#ffc266",
      "#ffff66",
      "#66b966",
      "#66a3e0",
      "#c285ff",
      "#888888",
      "#a10000",
      "#b26b00",
      "#b2b200",
      "#006100",
      "#0047b2",
      "#6b24b2",
      "#444444",
      "#5c0000",
      "#663d00",
      "#666600",
      "#003700",
      "#002966",
      "#3d1466"
    ];
    function r(i) {
      a.value && (i ? a.value.chain().focus().setColor(i).run() : a.value.chain().focus().unsetColor().run());
    }
    const s = nn(n, "modelValue"), a = mM({
      content: s.value,
      extensions: [
        KS,
        Up,
        Kp,
        qp,
        JS.configure({ types: ["heading", "paragraph"] }),
        HS
      ],
      onUpdate: ({ editor: i }) => {
        s.value = i.getHTML();
      },
      editorProps: {
        attributes: {
          class: "focus:outline-none "
        }
      }
    });
    Ol(() => {
      var i, l;
      ((i = a.value) == null ? void 0 : i.getHTML()) !== s.value && (s.value = (l = a.value) == null ? void 0 : l.getHTML());
    });
    const o = G(() => a != null && a.value ? a.value.isActive("heading", { level: 1 }) ? "Heading 1" : a.value.isActive("heading", { level: 2 }) ? "Heading 2" : a.value.isActive("heading", { level: 3 }) ? "Heading 3" : "Paragraph" : "Paragraph");
    return (i, l) => {
      var u, c, d, f, h, p, g, y, v, C;
      return T(), N("div", tT, [
        O("div", nT, [
          O("div", null, [
            Qe($a, {
              placement: "bottom",
              offset: [0, 4],
              arrow: !1
            }, {
              activator: Ae(({ show: M }) => [
                O("button", {
                  class: "py-3 px-2 flex items-center justify-between font-semibold w-30",
                  onClick: M
                }, [
                  wt(Ce(o.value) + " ", 1),
                  l[9] || (l[9] = O("span", { class: "material-symbols-outlined" }, " expand_more", -1))
                ], 8, rT)
              ]),
              content: Ae(({ hide: M }) => {
                var S, D, I, x;
                return [
                  O("div", sT, [
                    O("button", {
                      class: pe(["py-2 px-3 text-left hover:bg-slate-100 rounded", {
                        "bg-slate-200 font-semibold": (S = b(a)) == null ? void 0 : S.isActive("paragraph")
                      }]),
                      onClick: () => {
                        var k;
                        (k = b(a)) == null || k.chain().focus().setParagraph().run(), M();
                      }
                    }, " Paragraph ", 10, aT),
                    O("button", {
                      class: pe(["py-2 px-3 text-left hover:bg-slate-100 rounded", {
                        "bg-slate-200 font-semibold": (D = b(a)) == null ? void 0 : D.isActive("heading", {
                          level: 1
                        })
                      }]),
                      onClick: () => {
                        var k;
                        (k = b(a)) == null || k.chain().focus().toggleHeading({ level: 1 }).run(), M();
                      }
                    }, " Heading 1 ", 10, oT),
                    O("button", {
                      class: pe(["py-2 px-3 text-left hover:bg-slate-100 rounded", {
                        "bg-slate-200 font-semibold": (I = b(a)) == null ? void 0 : I.isActive("heading", {
                          level: 2
                        })
                      }]),
                      onClick: () => {
                        var k;
                        (k = b(a)) == null || k.chain().focus().toggleHeading({ level: 2 }).run(), M();
                      }
                    }, " Heading 2 ", 10, iT),
                    O("button", {
                      class: pe(["py-2 px-3 text-left hover:bg-slate-100 rounded", {
                        "bg-slate-200 font-semibold": (x = b(a)) == null ? void 0 : x.isActive("heading", {
                          level: 3
                        })
                      }]),
                      onClick: () => {
                        var k;
                        (k = b(a)) == null || k.chain().focus().toggleHeading({ level: 3 }).run(), M();
                      }
                    }, " Heading 3 ", 10, lT)
                  ])
                ];
              }),
              _: 1
            })
          ]),
          O("div", uT, [
            Qe($a, {
              placement: "bottom",
              offset: [0, 4],
              arrow: !1
            }, {
              activator: Ae(({ show: M }) => {
                var S, D;
                return [
                  O("button", {
                    class: pe(["py-3 px-2 flex items-center cursor-pointer", {
                      "bg-slate-200": ((S = b(a)) == null ? void 0 : S.isActive("textStyle")) && ((D = b(a)) == null ? void 0 : D.getAttributes("textStyle").color)
                    }]),
                    onClick: M
                  }, l[10] || (l[10] = [
                    O("span", { class: "material-symbols-outlined" }, " format_color_text", -1)
                  ]), 10, cT)
                ];
              }),
              content: Ae(({ hide: M }) => [
                O("div", dT, [
                  (T(), N(Ee, null, Ye(t, (S) => O("button", {
                    key: S,
                    style: Zt({ background: S }),
                    class: "w-6 h-6 rounded border border-gray-300 hover:border-black",
                    onClick: () => {
                      r(S), M();
                    }
                  }, null, 12, fT)), 64)),
                  O("button", {
                    class: "w-6 h-6 rounded border border-gray-300 flex items-center justify-center",
                    onClick: () => {
                      r(null), M();
                    }
                  }, l[11] || (l[11] = [
                    O("span", { class: "material-symbols-outlined text-xs" }, "format_color_reset", -1)
                  ]), 8, hT)
                ])
              ]),
              _: 1
            }),
            Qe($a, {
              placement: "bottom",
              offset: [0, 4],
              arrow: !1
            }, {
              activator: Ae(({ show: M }) => {
                var S, D;
                return [
                  O("button", {
                    class: pe(["py-3 px-2 flex items-center cursor-pointer", {
                      "bg-slate-200": ((S = b(a)) == null ? void 0 : S.isActive("textStyle")) && ((D = b(a)) == null ? void 0 : D.getAttributes("textStyle").backgroundColor)
                    }]),
                    onClick: M
                  }, l[12] || (l[12] = [
                    O("span", { class: "material-symbols-outlined" }, " format_ink_highlighter ", -1)
                  ]), 10, pT)
                ];
              }),
              content: Ae(({ hide: M }) => [
                O("div", mT, [
                  (T(), N(Ee, null, Ye(t, (S) => O("button", {
                    key: S,
                    style: Zt({ background: S }),
                    class: "w-6 h-6 rounded border border-gray-300 hover:border-black",
                    onClick: () => {
                      e(S), M();
                    }
                  }, null, 12, gT)), 64)),
                  O("button", {
                    class: "w-6 h-6 rounded border border-gray-300 flex items-center justify-center",
                    onClick: () => {
                      e(null), M();
                    }
                  }, l[13] || (l[13] = [
                    O("span", { class: "material-symbols-outlined text-xs" }, "format_color_reset", -1)
                  ]), 8, yT)
                ])
              ]),
              _: 1
            }),
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (u = b(a)) == null ? void 0 : u.isActive("bold") }]),
              onClick: l[0] || (l[0] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().toggleBold().run();
              })
            }, l[14] || (l[14] = [
              O("span", { class: "material-symbols-outlined" }, " format_bold ", -1)
            ]), 2),
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (c = b(a)) == null ? void 0 : c.isActive("italic") }]),
              onClick: l[1] || (l[1] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().toggleItalic().run();
              })
            }, l[15] || (l[15] = [
              O("span", { class: "material-symbols-outlined" }, " format_italic ", -1)
            ]), 2),
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (d = b(a)) == null ? void 0 : d.isActive("underline") }]),
              onClick: l[2] || (l[2] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().toggleUnderline().run();
              })
            }, l[16] || (l[16] = [
              O("span", { class: "material-symbols-outlined" }, " format_underlined ", -1)
            ]), 2),
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (f = b(a)) == null ? void 0 : f.isActive("strike") }]),
              onClick: l[3] || (l[3] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().toggleStrike().run();
              })
            }, l[17] || (l[17] = [
              O("span", { class: "material-symbols-outlined" }, " strikethrough_s ", -1)
            ]), 2)
          ]),
          O("div", vT, [
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (h = b(a)) == null ? void 0 : h.isActive({ textAlign: "left" }) }]),
              onClick: l[4] || (l[4] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().setTextAlign("left").run();
              })
            }, l[18] || (l[18] = [
              O("span", { class: "material-symbols-outlined" }, " format_align_left ", -1)
            ]), 2),
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (p = b(a)) == null ? void 0 : p.isActive({ textAlign: "center" }) }]),
              onClick: l[5] || (l[5] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().setTextAlign("center").run();
              })
            }, l[19] || (l[19] = [
              O("span", { class: "material-symbols-outlined" }, " format_align_center ", -1)
            ]), 2),
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (g = b(a)) == null ? void 0 : g.isActive({ textAlign: "right" }) }]),
              onClick: l[6] || (l[6] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().setTextAlign("right").run();
              })
            }, l[20] || (l[20] = [
              O("span", { class: "material-symbols-outlined" }, " format_align_right ", -1)
            ]), 2)
          ]),
          O("div", bT, [
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (y = b(a)) == null ? void 0 : y.isActive("orderedList") }]),
              onClick: l[7] || (l[7] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().toggleOrderedList().run();
              })
            }, l[21] || (l[21] = [
              O("span", { class: "material-symbols-outlined" }, " format_list_numbered ", -1)
            ]), 2),
            O("button", {
              class: pe(["py-3 px-2 flex items-center", { "bg-slate-200": (v = b(a)) == null ? void 0 : v.isActive("bulletList") }]),
              onClick: l[8] || (l[8] = (M) => {
                var S;
                return (S = b(a)) == null ? void 0 : S.chain().focus().toggleBulletList().run();
              })
            }, l[22] || (l[22] = [
              O("span", { class: "material-symbols-outlined" }, " format_list_bulleted ", -1)
            ]), 2)
          ])
        ]),
        O("div", wT, [
          Qe(b(pM), { editor: b(a) }, null, 8, ["editor"])
        ]),
        O("div", kT, [
          l[23] || (l[23] = O("div", null, null, -1)),
          O("div", null, "Word count: " + Ce(((C = b(a)) == null ? void 0 : C.storage.characterCount.words()) ?? 0), 1)
        ])
      ]);
    };
  }
}), xT = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" }, MT = ["onClick"], ST = {
  class: "basis-0 box-border content-stretch flex gap-2.5 grow items-center justify-start min-h-px min-w-px p-0 relative shrink-0",
  "data-name": "Option"
}, TT = {
  class: "relative shrink-0 w-8 h-8",
  "data-name": "Country"
}, CT = ["src", "alt"], AT = { class: "block leading-[1.4] whitespace-pre" }, DT = { class: "bg-white relative rounded shrink-0 w-4 h-4 flex items-center justify-center ml-auto overflow-clip" }, OT = {
  key: 0,
  class: "material-symbols-outlined text-white text-lg leading-none"
}, zC = /* @__PURE__ */ Fe({
  __name: "CountriesSelector",
  props: {
    modelValue: {
      default: []
    },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(n) {
    const e = nn(n, "modelValue");
    function t(r) {
      e.value = e.value.includes(r) ? e.value.filter((s) => s !== r) : [...e.value, r];
    }
    return (r, s) => (T(), N("div", xT, [
      (T(!0), N(Ee, null, Ye(b(gm), (a) => (T(), N("button", {
        key: a.code,
        type: "button",
        onClick: (o) => t(a.code),
        class: pe([
          "box-border text-left content-stretch cursor-pointer flex items-start justify-start p-0 relative w-full group",
          e.value.includes(a.code) ? "z-10" : ""
        ]),
        "data-name": "Checkbox options"
      }, [
        O("div", {
          class: pe([
            "basis-0 box-border content-stretch flex gap-2.5 grow  items-center justify-start min-h-px min-w-px px-5 py-4 relative rounded-lg shrink-0 bg-white border transition-colors",
            e.value.includes(a.code) ? "border-primary-500 text-primary-500" : "border-mid-neutral-50 text-slate-800",
            "hover:border-primary-500 focus:border-primary-500"
          ]),
          "data-name": "checkbox options"
        }, [
          O("div", {
            "aria-hidden": "true",
            class: pe([
              "absolute border border-solid inset-0 pointer-events-none rounded-lg",
              e.value.includes(a.code) ? "border-primary-500" : "border-mid-neutral-50"
            ])
          }, null, 2),
          O("div", ST, [
            O("div", TT, [
              O("img", {
                src: `https://flagcdn.com/w80/${a.code}.png`,
                alt: a.name,
                class: "block max-w-none w-8 h-8 rounded-full object-cover object-center"
              }, null, 8, CT)
            ]),
            O("div", {
              class: pe([
                "basis-0 font-medium grow leading-none min-h-px min-w-px not-italic overflow-ellipsis overflow-hidden relative shrink-0 text-sm text-nowrap",
                e.value.includes(a.code) ? "text-primary-500" : "text-slate-800"
              ])
            }, [
              O("p", AT, Ce(a.name), 1)
            ], 2)
          ]),
          O("div", DT, [
            O("span", {
              class: pe([
                "w-4 h-4 rounded border flex items-center justify-center transition-colors",
                e.value.includes(a.code) ? "bg-primary-500 border-primary-500" : "bg-white border-mid-neutral-100",
                "group-hover:border-primary-500 group-focus:border-primary-500"
              ])
            }, [
              e.value.includes(a.code) ? (T(), N("span", OT, " check_small ")) : H("", !0)
            ], 2)
          ])
        ], 2)
      ], 10, MT))), 128))
    ]));
  }
}), ET = ["for"], PT = {
  key: 0,
  class: "text-red-600"
}, _T = ["id"], NT = {
  key: 1,
  class: "relative"
}, IT = { class: "absolute z-10 bg-white border border-gray-300 rounded-md shadow-md mt-1 w-full max-h-150 overflow-auto" }, RT = ["onClick", "title"], VC = /* @__PURE__ */ Fe({
  __name: "Combobox",
  props: /* @__PURE__ */ Ot({
    items: {},
    canAdd: { type: Boolean },
    label: {},
    infoTooltipText: {},
    isRequired: { type: Boolean },
    display: { type: Function }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ot(["addItem"], ["update:modelValue"]),
  setup(n, { expose: e, emit: t }) {
    const r = qr(), s = t, a = W(""), o = W(!1), i = W(-1), l = nn(n, "modelValue"), u = Ui("containerRef"), c = dm(), d = G(() => n.items.find((x) => x.id === l.value));
    $t(d, (x) => {
      x ? a.value = n.display(x) : a.value = "";
    });
    const f = G(
      () => [...c.value].filter((x) => x.el).sort((x, k) => x.index - k.index)
    ), h = Ui("inputRef"), p = G(() => n.items.filter(
      (x) => n.display(x).toLowerCase().includes(a.value.toLowerCase())
    )), g = G(() => n.canAdd && a.value.trim().length > 0 && !n.items.some(
      (x) => n.display(x).toLowerCase() === a.value.toLowerCase()
    ));
    function y() {
      var x;
      o.value = !0, (x = h.value) == null || x.select();
    }
    async function v(x) {
      u.value && !u.value.contains(x.relatedTarget) && (o.value = !1, i.value = -1);
    }
    function C(x) {
      var k, _, E;
      if (o.value && (x.key.length === 1 || x.key === "Backspace") && !x.ctrlKey && !x.metaKey) {
        (k = h.value) == null || k.focus(), i.value = -1;
        return;
      }
      o.value && f.value.length > 0 && (["ArrowDown", "ArrowUp"].includes(x.key) && x.preventDefault(), x.key === "ArrowDown" ? (i.value = (i.value + 1) % f.value.length, M()) : x.key === "ArrowUp" ? i.value <= 0 ? ((_ = h.value) == null || _.focus(), i.value = -1) : (i.value = (i.value - 1 + f.value.length) % f.value.length, M()) : x.key === "Escape" && (o.value = !1, i.value = -1, (E = h.value) == null || E.blur()));
    }
    async function M() {
      var x, k, _, E;
      await kt(), (x = f.value) != null && x[i.value] && ((E = (_ = (k = f.value) == null ? void 0 : k[i.value]) == null ? void 0 : _.el) == null || E.focus());
    }
    function S(x) {
      s("addItem", x), o.value = !1, i.value = -1;
    }
    async function D(x) {
      a.value = n.display(x), i.value = -1, o.value = !1, l.value !== x.id && (l.value = x.id);
    }
    function I() {
      l.value = "", a.value = "", i.value = -1, o.value = !1;
    }
    return e({
      clear: I
    }), (x, k) => {
      const _ = da("tooltip");
      return T(), N("div", {
        ref: "containerRef",
        onFocusin: y,
        onFocusout: v,
        onKeydown: C
      }, [
        x.label ? (T(), N("label", {
          key: 0,
          for: b(r),
          class: "flex gap-0.5 text-sm font-medium items-center leading-5 text-dark-neutral-500"
        }, [
          wt(Ce(x.label) + " ", 1),
          x.isRequired ? (T(), N("span", PT, "*")) : H("", !0),
          x.infoTooltipText ? pt((T(), Ne(b(ds), {
            key: 1,
            class: "w-5 h-5 fill-neutral-400 text-white"
          }, null, 512)), [
            [_, x.infoTooltipText]
          ]) : H("", !0)
        ], 8, ET)) : H("", !0),
        pt(O("input", {
          class: "border border-gray-300 rounded-md py-2 px-4 w-full",
          placeholder: "search",
          id: b(r),
          "onUpdate:modelValue": k[0] || (k[0] = (E) => a.value = E),
          onInput: k[1] || (k[1] = () => {
            o.value = !0, i.value = -1;
          }),
          ref: "inputRef"
        }, null, 40, _T), [
          [Ss, a.value]
        ]),
        o.value ? (T(), N("div", NT, [
          O("div", IT, [
            g.value ? (T(), N("button", {
              key: 0,
              class: "py-2 px-4 hover:bg-gray-100 flex items-center gap-1 focus:bg-primary-500 focus:text-white focus:outline-none w-full text-left",
              onClick: k[2] || (k[2] = (E) => S(a.value)),
              ref: (E) => b(c).set({
                index: 0,
                el: E
              })
            }, [
              k[3] || (k[3] = O("span", { class: "material-symbols-outlined !text-xl" }, "add", -1)),
              O("span", null, Ce(a.value), 1)
            ], 512)) : H("", !0),
            (T(!0), N(Ee, null, Ye(p.value, (E, ne) => (T(), N("button", {
              key: E.id,
              class: "p-2 truncate hover:bg-gray-100 focus:bg-primary-500 focus:text-white focus:outline-none w-full text-left",
              onClick: (de) => D(E),
              ref_for: !0,
              ref: (de) => b(c).set({
                index: g.value ? ne + 1 : ne,
                el: de
              }),
              title: x.display(E)
            }, Ce(x.display(E)), 9, RT))), 128))
          ])
        ])) : H("", !0)
      ], 544);
    };
  }
}), $T = { class: "flex items-center gap-3" }, LT = ["checked"], BT = ["for"], HC = /* @__PURE__ */ Fe({
  __name: "CheckboxInput",
  props: /* @__PURE__ */ Ot({
    label: {}
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(n) {
    const e = qr(), t = nn(n, "modelValue");
    return (r, s) => (T(), N("div", $T, [
      O("input", {
        type: "checkbox",
        checked: t.value,
        onChange: s[0] || (s[0] = (a) => t.value = a.target.checked),
        class: "h-4 w-4 rounded border-mid-neutral-300 cursor-pointer",
        style: { "accent-color": "var(--color-primary-500)" }
      }, null, 40, LT),
      r.label ? (T(), N("label", {
        key: 0,
        for: b(e),
        class: "text-sm text-dark-neutral-700 font-semibold cursor-pointer"
      }, Ce(r.label), 9, BT)) : H("", !0)
    ]));
  }
}), FT = {
  key: 0,
  class: "text-dark-neutral-500"
}, zT = {
  key: 1,
  class: "text-mid-neutral-100"
}, VT = {
  key: 0,
  class: "fixed top-0 right-0 h-full w-[500px] bg-white shadow-2xl z-50 flex flex-col"
}, HT = { class: "flex items-center justify-between px-5 py-4 border-b border-mid-neutral-50" }, YT = { class: "text-lg font-semibold text-dark-neutral-500" }, WT = { class: "flex items-center gap-2 mx-5 mt-4 px-4 py-3 border-2 border-dashed border-blue-400 text-blue-600 rounded-lg text-sm bg-blue-400/10" }, jT = { class: "px-5 py-4" }, UT = { class: "relative" }, qT = { class: "flex-1 overflow-y-auto py-4" }, KT = ["onClick"], GT = { class: "flex-1 pr-4" }, JT = { class: "text-primary-500 text-sm font-medium mb-1" }, QT = { class: "font-semibold text-dark-neutral-500 mb-1" }, XT = { class: "text-sm text-mid-neutral-100 leading-relaxed" }, ZT = { class: "mt-1 flex-shrink-0" }, eC = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-white"
}, tC = {
  key: 0,
  class: "border-b border-mid-neutral-50 my-2"
}, nC = {
  key: 0,
  class: "text-center py-8 text-mid-neutral-100 px-5"
}, rC = /* @__PURE__ */ Fe({
  __name: "ImdrfCodeSelector",
  props: /* @__PURE__ */ Ot({
    codes: {},
    title: {},
    placeholder: { default: "Select code" },
    currentLevel: { default: 1 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ot(["settings-click"], ["update:modelValue"]),
  setup(n, { emit: e }) {
    const t = n, r = e, s = nn(n, "modelValue"), a = W(!1), o = W(""), i = G(() => {
      let d = t.codes.filter((f) => f.level === t.currentLevel);
      if (o.value) {
        const f = o.value.toLowerCase();
        d = d.filter(
          (h) => h.code.toLowerCase().includes(f) || h.title.toLowerCase().includes(f) || h.description.toLowerCase().includes(f)
        );
      }
      return d;
    });
    function l() {
      a.value = !0;
    }
    function u() {
      a.value = !1, o.value = "";
    }
    function c(d) {
      s.value = d, u();
    }
    return (d, f) => (T(), N("div", null, [
      fe(d.$slots, "trigger", {
        openModal: l,
        selectedCode: s.value
      }, () => [
        O("div", {
          class: "flex items-center justify-between gap-2 px-4 py-3 bg-white border border-mid-neutral-50 rounded-lg cursor-pointer hover:border-primary-500 transition-colors min-w-[300px]",
          onClick: l
        }, [
          s.value ? (T(), N("span", FT, Ce(s.value.code) + " - " + Ce(s.value.title), 1)) : (T(), N("span", zT, Ce(d.placeholder), 1)),
          f[2] || (f[2] = O("span", { class: "material-symbols-outlined text-mid-neutral-100" }, "auto_awesome", -1))
        ])
      ], !0),
      (T(), Ne(El, { to: "body" }, [
        Qe(_n, { name: "fade" }, {
          default: Ae(() => [
            a.value ? (T(), N("div", {
              key: 0,
              class: "fixed inset-0 bg-black/30 z-50",
              onClick: u
            })) : H("", !0)
          ]),
          _: 1
        }),
        Qe(_n, { name: "slide" }, {
          default: Ae(() => [
            a.value ? (T(), N("div", VT, [
              O("div", HT, [
                O("h3", YT, Ce(d.title), 1),
                O("div", { class: "flex items-center gap-3" }, [
                  f[4] || (f[4] = O("button", { class: "flex items-center gap-2 px-4 py-2 bg-[#22C55E] text-white rounded-lg hover:bg-[#16A34A] transition-colors text-sm font-medium" }, [
                    wt(" Auto Suggest "),
                    O("span", { class: "material-symbols-outlined text-base" }, "auto_awesome")
                  ], -1)),
                  O("button", {
                    class: "w-8 h-8 flex items-center justify-center text-mid-neutral-100 hover:text-dark-neutral-500 hover:bg-light-neutral-200 rounded-lg transition-colors",
                    onClick: u
                  }, f[3] || (f[3] = [
                    O("span", { class: "material-symbols-outlined" }, "close", -1)
                  ]))
                ])
              ]),
              O("div", WT, [
                f[7] || (f[7] = O("span", { class: "material-symbols-outlined text-lg text-blue-600" }, "info", -1)),
                O("span", null, [
                  f[5] || (f[5] = wt(" Categorization limited to ", -1)),
                  O("strong", null, "level " + Ce(d.currentLevel), 1),
                  f[6] || (f[6] = wt(". ", -1)),
                  O("a", {
                    href: "#",
                    class: "text-blue-600 underline hover:text-blue-800",
                    onClick: f[0] || (f[0] = Qt((h) => r("settings-click"), ["prevent"]))
                  }, "Check settings.")
                ])
              ]),
              O("div", jT, [
                O("div", UT, [
                  f[8] || (f[8] = O("span", { class: "material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-mid-neutral-100" }, " search ", -1)),
                  pt(O("input", {
                    "onUpdate:modelValue": f[1] || (f[1] = (h) => o.value = h),
                    type: "text",
                    placeholder: "Enter Keyword...",
                    class: "w-full pl-10 pr-4 py-2.5 border border-mid-neutral-50 rounded-lg focus:outline-none focus:border-primary-500 text-sm"
                  }, null, 512), [
                    [Ss, o.value]
                  ])
                ])
              ]),
              f[9] || (f[9] = O("div", { class: "mx-5 border-t border-mid-neutral-50" }, null, -1)),
              O("div", qT, [
                (T(!0), N(Ee, null, Ye(i.value, (h, p) => {
                  var g, y;
                  return T(), N(Ee, {
                    key: h.code
                  }, [
                    O("div", {
                      class: "flex items-start justify-between cursor-pointer group px-5 py-3 hover:bg-gray-100 transition-colors",
                      onClick: (v) => c(h)
                    }, [
                      O("div", GT, [
                        O("div", JT, " Level " + Ce(h.level), 1),
                        O("div", QT, Ce(h.code) + " - " + Ce(h.title), 1),
                        O("div", XT, Ce(h.description), 1)
                      ]),
                      O("div", ZT, [
                        O("div", {
                          class: pe([
                            "w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors",
                            ((g = s.value) == null ? void 0 : g.code) === h.code ? "border-primary-500 bg-primary-500" : "border-mid-neutral-100 group-hover:border-primary-300"
                          ])
                        }, [
                          ((y = s.value) == null ? void 0 : y.code) === h.code ? (T(), N("div", eC)) : H("", !0)
                        ], 2)
                      ])
                    ], 8, KT),
                    p < i.value.length - 1 ? (T(), N("div", tC)) : H("", !0)
                  ], 64);
                }), 128)),
                i.value.length === 0 ? (T(), N("div", nC, ' No codes found matching "' + Ce(o.value) + '" ', 1)) : H("", !0)
              ])
            ])) : H("", !0)
          ]),
          _: 1
        })
      ]))
    ]));
  }
}), YC = /* @__PURE__ */ _l(rC, [["__scopeId", "data-v-3beaf20f"]]), sC = {
  key: 0,
  class: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] bg-white shadow-2xl z-50 rounded-xl flex flex-col max-h-[80vh]"
}, aC = { class: "flex-1 overflow-y-auto p-6" }, oC = { class: "flex items-center gap-2 px-4 py-3 bg-light-neutral-200 rounded-lg mb-6" }, iC = { class: "text-sm text-dark-neutral-500" }, lC = { class: "text-sm text-mid-neutral-100" }, uC = { class: "space-y-4" }, cC = { class: "flex items-center gap-4" }, dC = ["value"], fC = { class: "flex items-center gap-4" }, hC = ["value"], pC = {
  key: 0,
  class: "mt-6"
}, mC = { class: "text-sm font-medium text-dark-neutral-500 mb-3" }, gC = { class: "border border-mid-neutral-50 rounded-lg overflow-hidden" }, yC = { class: "w-full text-sm" }, vC = { class: "px-4 py-2 text-dark-neutral-500" }, bC = { class: "px-4 py-2 text-dark-neutral-500 truncate max-w-[200px]" }, wC = { class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-mid-neutral-50" }, kC = ["disabled"], xC = /* @__PURE__ */ Fe({
  __name: "ExcelImportModal",
  emits: ["import"],
  setup(n, { emit: e }) {
    const t = e, r = W(null), s = W(!1), a = W(""), o = W([]), i = W([]), l = Ts({
      reference: "",
      title: ""
    }), u = G(() => l.reference && l.title && i.value.length > 0), c = G(() => i.value.slice(0, 5));
    function d(M, S) {
      const D = l[S];
      if (!D) return "";
      const I = M[D];
      return I != null ? String(I) : "";
    }
    function f() {
      var M;
      (M = r.value) == null || M.click();
    }
    function h(M) {
      const S = M.split(/\r?\n/).filter((x) => x.trim());
      if (S.length === 0) return { headers: [], data: [] };
      const D = p(S[0]), I = [];
      for (let x = 1; x < S.length; x++) {
        const k = p(S[x]), _ = {};
        D.forEach((E, ne) => {
          E && k[ne] !== void 0 && (_[E] = k[ne]);
        }), Object.keys(_).length > 0 && I.push(_);
      }
      return { headers: D, data: I };
    }
    function p(M) {
      const S = [];
      let D = "", I = !1;
      for (let x = 0; x < M.length; x++) {
        const k = M[x], _ = M[x + 1];
        I ? k === '"' && _ === '"' ? (D += '"', x++) : k === '"' ? I = !1 : D += k : k === '"' ? I = !0 : k === "," ? (S.push(D.trim()), D = "") : D += k;
      }
      return S.push(D.trim()), S;
    }
    async function g(M) {
      var x;
      const S = M.target, D = (x = S.files) == null ? void 0 : x[0];
      if (!D) return;
      a.value = D.name;
      const I = D.name.toLowerCase().endsWith(".csv");
      try {
        let k = [], _ = [];
        if (I) {
          const ne = await D.text(), de = h(ne);
          k = de.headers, _ = de.data;
        } else {
          const ne = await D.arrayBuffer(), de = new fm.Workbook();
          await de.xlsx.load(ne);
          const be = de.worksheets[0];
          if (!be) {
            console.error("No worksheet found");
            return;
          }
          be.getRow(1).eachCell((F, $) => {
            const U = F.value;
            k[$ - 1] = U != null ? String(U) : `Column ${$}`;
          }), k = k.filter(Boolean), be.eachRow((F, $) => {
            if ($ === 1) return;
            const U = {};
            F.eachCell((ue, q) => {
              const ie = k[q - 1];
              ie && (U[ie] = ue.value);
            }), Object.keys(U).length > 0 && _.push(U);
          });
        }
        o.value = k, i.value = _;
        const E = k.map((ne) => ne.toLowerCase());
        E.includes("reference") && (l.reference = k[E.indexOf("reference")]), E.includes("title") && (l.title = k[E.indexOf("title")]), s.value = !0;
      } catch (k) {
        console.error("Error parsing file:", k);
      }
      S.value = "";
    }
    function y() {
      s.value = !1, v();
    }
    function v() {
      a.value = "", o.value = [], i.value = [], l.reference = "", l.title = "";
    }
    function C() {
      const M = i.value.map((S) => ({
        reference: d(S, "reference"),
        title: d(S, "title")
      }));
      t("import", M), y();
    }
    return $t(
      () => [l.reference, l.title],
      () => {
      }
    ), (M, S) => (T(), N("div", null, [
      O("button", {
        class: "flex items-center gap-2 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors font-medium",
        onClick: f
      }, S[2] || (S[2] = [
        O("span", { class: "material-symbols-outlined text-base" }, "upload_file", -1),
        wt(" Import Excel ", -1)
      ])),
      O("input", {
        ref_key: "fileInputRef",
        ref: r,
        type: "file",
        accept: ".xlsx,.xls,.csv",
        class: "hidden",
        onChange: g
      }, null, 544),
      (T(), Ne(El, { to: "body" }, [
        Qe(_n, { name: "fade" }, {
          default: Ae(() => [
            s.value ? (T(), N("div", {
              key: 0,
              class: "fixed inset-0 bg-black/30 z-50",
              onClick: y
            })) : H("", !0)
          ]),
          _: 1
        }),
        Qe(_n, { name: "slide" }, {
          default: Ae(() => [
            s.value ? (T(), N("div", sC, [
              O("div", { class: "flex items-center justify-between px-6 py-4 border-b border-mid-neutral-50" }, [
                S[4] || (S[4] = O("h3", { class: "text-lg font-semibold text-dark-neutral-500" }, " Map Excel Columns ", -1)),
                O("button", {
                  class: "w-8 h-8 flex items-center justify-center text-mid-neutral-100 hover:text-dark-neutral-500 hover:bg-light-neutral-200 rounded-lg transition-colors",
                  onClick: y
                }, S[3] || (S[3] = [
                  O("span", { class: "material-symbols-outlined" }, "close", -1)
                ]))
              ]),
              O("div", aC, [
                S[11] || (S[11] = O("p", { class: "text-sm text-mid-neutral-400 mb-4" }, " Map the columns from your Excel file to the complaint fields. ", -1)),
                O("div", oC, [
                  S[5] || (S[5] = O("span", { class: "material-symbols-outlined text-primary-500" }, "description", -1)),
                  O("span", iC, Ce(a.value), 1),
                  O("span", lC, "(" + Ce(o.value.length) + " columns found)", 1)
                ]),
                O("div", uC, [
                  O("div", cC, [
                    S[7] || (S[7] = O("label", { class: "w-32 text-sm font-medium text-dark-neutral-500" }, "Reference", -1)),
                    pt(O("select", {
                      "onUpdate:modelValue": S[0] || (S[0] = (D) => l.reference = D),
                      class: "flex-1 px-4 py-2.5 border border-mid-neutral-50 rounded-lg focus:outline-none focus:border-primary-500 text-sm bg-white"
                    }, [
                      S[6] || (S[6] = O("option", { value: "" }, "-- Select Column --", -1)),
                      (T(!0), N(Ee, null, Ye(o.value, (D) => (T(), N("option", {
                        key: D,
                        value: D
                      }, Ce(D), 9, dC))), 128))
                    ], 512), [
                      [ji, l.reference]
                    ])
                  ]),
                  O("div", fC, [
                    S[9] || (S[9] = O("label", { class: "w-32 text-sm font-medium text-dark-neutral-500" }, "Title", -1)),
                    pt(O("select", {
                      "onUpdate:modelValue": S[1] || (S[1] = (D) => l.title = D),
                      class: "flex-1 px-4 py-2.5 border border-mid-neutral-50 rounded-lg focus:outline-none focus:border-primary-500 text-sm bg-white"
                    }, [
                      S[8] || (S[8] = O("option", { value: "" }, "-- Select Column --", -1)),
                      (T(!0), N(Ee, null, Ye(o.value, (D) => (T(), N("option", {
                        key: D,
                        value: D
                      }, Ce(D), 9, hC))), 128))
                    ], 512), [
                      [ji, l.title]
                    ])
                  ])
                ]),
                c.value.length > 0 ? (T(), N("div", pC, [
                  O("h4", mC, " Preview (first " + Ce(c.value.length) + " rows) ", 1),
                  O("div", gC, [
                    O("table", yC, [
                      S[10] || (S[10] = O("thead", null, [
                        O("tr", { class: "bg-light-neutral-200" }, [
                          O("th", { class: "px-4 py-2 text-left text-dark-neutral-500 font-medium" }, " Reference "),
                          O("th", { class: "px-4 py-2 text-left text-dark-neutral-500 font-medium" }, " Title ")
                        ])
                      ], -1)),
                      O("tbody", null, [
                        (T(!0), N(Ee, null, Ye(c.value, (D, I) => (T(), N("tr", {
                          key: I,
                          class: "border-t border-mid-neutral-50"
                        }, [
                          O("td", vC, Ce(d(D, "reference") || "-"), 1),
                          O("td", bC, Ce(d(D, "title") || "-"), 1)
                        ]))), 128))
                      ])
                    ])
                  ])
                ])) : H("", !0)
              ]),
              O("div", wC, [
                O("button", {
                  class: "px-4 py-2 text-sm font-medium rounded-lg bg-mid-neutral-300 text-white",
                  onClick: y
                }, " Cancel "),
                O("button", {
                  class: "px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed",
                  disabled: !u.value,
                  onClick: C
                }, " Import " + Ce(i.value.length) + " complaints ", 9, kC)
              ])
            ])) : H("", !0)
          ]),
          _: 1
        })
      ]))
    ]));
  }
}), WC = /* @__PURE__ */ _l(xC, [["__scopeId", "data-v-58e49ead"]]);
export {
  HC as CheckboxInput,
  VC as Combobox,
  zC as CountriesSelector,
  LC as DateTimeInput,
  FC as Editor,
  WC as ExcelImportModal,
  RC as ExpansionPanel,
  $a as FloatingMenu,
  OC as FloatingTextInput,
  IC as ImageAnnotator,
  YC as ImdrfCodeSelector,
  _C as NumberInput,
  $C as RadioGroup,
  sg as RadioInput,
  NC as SelectInput,
  DC as Switch,
  EC as TextInput,
  PC as TextareaInput
};
//# sourceMappingURL=index.js.map
